import * as React from 'react';
import React__default, { createContext, useContext, createElement, Fragment, useRef, useLayoutEffect, forwardRef, useState, useCallback, Component, useMemo, useEffect } from 'react';
import w$1, { createPortal } from 'react-dom';
import { jsx, jsxs } from 'react/jsx-runtime';
import o$1, { css, keyframes, createGlobalStyle } from 'styled-components';
import I from 'crypto';
import { VictoryChart, VictoryAxis, VictoryLabel, VictoryLine, VictoryScatter } from 'victory';
import require$$1 from 'http';
import require$$2 from 'https';
import require$$0 from 'url';
import require$$3 from 'stream';
import require$$4 from 'assert';
import require$$8 from 'zlib';
import require$$1$1 from 'util';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$3 = function (d, b) {
    extendStatics$3 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$3(d, b);
};

function __extends$3(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$3(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function () {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray$2(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var A$1 = function (e, t) { return A$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) { e.__proto__ = t; } || function (e, t) { for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]); }, A$1(e, t) }; var k$1 = function () { return k$1 = Object.assign || function (e) { for (var t, n = 1, o = arguments.length; n < o; n++)for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]); return e }, k$1.apply(this, arguments) }; function O(e, t) { var n = {}; for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]); if (null != e && "function" == typeof Object.getOwnPropertySymbols) { var r = 0; for (o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]); } return n } function T(e, t, n) { if (n || 2 === arguments.length) for (var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]); return e.concat(o || Array.prototype.slice.call(t)) } function E(e, t) { return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e } var S, B, G, N, P, R, M, L = "#FFFFFF", X = "#000000", V = "transparent", W = "#FCFCFC", H = "#FAFAFA", F = "#F2F2F2", D = "#E9E9E9", z$1 = "#E6E6E6", j = "#DDDDDD", Z = "#D8D8D8", Y = "#D9D9D9", J = "#C6C7C8", U = "#A6A8A9", Q = "#9C9E9F", K = "#9B9B9B", q$1 = "#7B7C7E", $ = "#333333", ee = "#1A1A1A", te = "#EBF8FF", ne = "#009EE0", oe = "#0079BA", re$1 = "#C2D9E5", ie = "#BEE1F4", ae = "#9464A3", le = "#B197C3", se = "#E20031", ce = "#DE002B", pe = "#6AB023", ue = "#E3006E", de = { name: "Default", colors: { titles: "#272727", labels: X, subtleLabels: q$1, values: "#4A4A4A", primary: oe, primaryHover: ne, alternative: te, alternativeHover: ie }, buttonHover: { backgroundColor: "transparent", backgroundColorActive: F, backgroundColorHover: F }, card: { border: z$1, background: L, titleColor: $, cardHeader: { background: z$1 }, cardBody: { background: L, color: $ } }, buttons: { minWidth: "80px", height: "30px", padding: "5px 10px", paddingForLargeRadius: "5px 15px", borderRadius: "4px", fontSize: "15px", fontWeight: "normal", letterSpacing: "-0.4px", disabled: { backgroundColor: J, color: L }, primary: { backgroundColor: oe, backgroundColorFocus: ne, backgroundColorHover: ne, color: L, colorHover: L }, secondary: { backgroundColor: te, backgroundColorFocus: te, backgroundColorHover: ie, color: oe, colorHover: oe }, tertiary: { backgroundColor: J, backgroundColorFocus: J, backgroundColorHover: J, color: L, colorHover: L }, inverse: { backgroundColor: "transparent", backgroundColorHover: ne, borderColor: oe, borderColorHover: ne, borderWidth: "1px", color: oe, colorHover: L }, warning: { backgroundColor: se, backgroundColorFocus: se, backgroundColorHover: "#B50027", color: L, colorHover: L }, buttonGrid: { height: 30, button: { color: Q, colorActive: oe, backgroundColor: W, backgroundColorActive: L, backgroundColorHover: L, borderColor: z$1 }, label: { color: Q, colorActive: oe, colorDanger: ce, backgroundColorActive: L, backgroundColorDanger: L, borderColor: z$1, borderColorActive: oe, borderColorDanger: ce } }, buttonWrapper: { gutter: "24px" } }, dotMenu: { color: Q }, hr: { borderColor: z$1, borderStyle: "solid", borderWidth: "1px" }, column: { flex: "1", alignContent: "flex-start", alignItems: "flex-start", justifyContent: "flex-start" }, row: { flex: "auto", alignContent: "flex-start", alignItems: "flex-start", justifyContent: "flex-start", gutter: 24, column: { padding: "0 5px" } }, messageBlock: { color: L, backgroundColor: $, borderRadius: "4px", padding: "12px 16px", icon: { backgroundColor: L, color: $ } }, pagination: { color: q$1, buttonColor: L, buttonShadowColor: X, activeColor: X, disabledColor: J }, formElements: { textFieldRich: { padding: "12px 16px", fontSize: "14px", toolbar: { borderColor: z$1 } }, radioButton: { color: q$1, colorDisabled: J, backgroundColor: L, backgroundColorHover: H, border: J, borderHover: Q, dotColorActive: oe, dotColorDisabled: J }, toggle: { borderRadius: "10px", width: "40px", height: "20px", color: q$1, colorDisabled: J, toggler: { width: "14px", height: "14px", margin: "3px" }, checked: { backgroundColor: L, borderColor: oe, togglerColor: oe, disabled: { backgroundColor: F, borderColor: z$1, togglerColor: ne }, hover: { backgroundColor: L, borderColor: ne, togglerColor: ne } }, unchecked: { backgroundColor: L, borderColor: Q, togglerColor: Q, disabled: { backgroundColor: F, borderColor: z$1, togglerColor: J }, hover: { backgroundColor: L, borderColor: q$1, togglerColor: q$1 } } } }, loader: { color: ne, backgroundColor: te }, subtleLink: { color: Q, colorHover: X }, tabNav: { color: q$1, colorActive: $, border: oe, borderHover: F }, navDropdown: { width: "160px", padding: "10px 24px", backgroundColor: L, borderColor: z$1, color: q$1, colorHover: X, fontSize: "16px", dropdown: { padding: "12px 0", backgroundColor: L, color: q$1, colorHover: X } }, icons: { plusDotIcon: { backgroundColor: te, color: oe, margin: "0", size: 22 }, dragAndDrop: Z, kpiModeIcons: { available: oe, notAvailable: K, backgroundAvailable: te, backgroundNotAvailable: Z } }, removableLabel: { backgroundColor: F, color: X, fontSize: "12px", closeButton: { fill: K, backgroundColor: F } }, tagList: { margin: "-4px 0", item: { height: "26px", margin: "4px 8px 4px 0", padding: "4px 8px", backgroundColor: H, boxShadow: "0 2px 4px 0 ".concat("rgba(0,0,0,0.05)"), color: $, borderRadius: "13px", fontSize: "15px", close: { fill: K } } }, graph: { graphAxisStrokeColor: j, graphAxisGridStrokeColor: F, graphAxisLabelColor: U, graphGridBorder: z$1, graphDataScatterColor: ae, graphDataLineColor: le }, tooltip: { toolTip: W, toolTipColor: $, toolTipBorder: z$1, toolTipShadow: X, toolTipTrigger: J, toolTipTriggerBorderColor: F, toolTipTriggerBackgroundColor: F, toolTipTriggerColor: L, toolTipTriggerColor9C: Q, toolTipLink: X } }; o$1.button(S || (S = E(["\n    padding: 0;\n\n    appearance: none;\n    background-color: transparent;\n    border: 0 none;\n\n    &:focus {\n        outline: none;\n    }\n\n    cursor: ", ";\n"], ["\n    padding: 0;\n\n    appearance: none;\n    background-color: transparent;\n    border: 0 none;\n\n    &:focus {\n        outline: none;\n    }\n\n    cursor: ", ";\n"])), (function (e) { return e.onClick ? "pointer" : "default" })); var be = o$1.div(B || (B = E(["\n    display: flex;\n    flex:  ", ";\n    align-content ", ";\n    align-items ", ";\n    justify-content ", ";\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex:  ", ";\n    align-content ", ";\n    align-items ", ";\n    justify-content ", ";\n    flex-direction: column;\n"])), (function (e) { var t = e.flex; return null != t ? t : de.column.flex }), (function (e) { var t = e.alignContent; return null != t ? t : de.column.alignContent }), (function (e) { var t = e.alignItems; return null != t ? t : de.column.alignItems }), (function (e) { var t = e.justifyContent; return null != t ? t : de.column.justifyContent })), ge = o$1.div(G || (G = E(["\n    display: flex;\n    flex: ", ";\n    align-content ", ";\n    align-items ", ";\n    justify-content ", ";\n    flex-direction: row;\n\n    ", ";\n\n    ", "\n\n    width: 100%;\n\n    margin: 10px auto;\n\n    -webkit-margin-collapse: separate;\n\n    &:first-child {\n        margin-top: 0;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n"], ["\n    display: flex;\n    flex: ", ";\n    align-content ", ";\n    align-items ", ";\n    justify-content ", ";\n    flex-direction: row;\n\n    ", ";\n\n    ", "\n\n    width: 100%;\n\n    margin: 10px auto;\n\n    -webkit-margin-collapse: separate;\n\n    &:first-child {\n        margin-top: 0;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n"])), (function (e) { var t = e.flex; return null != t ? t : de.row.flex }), (function (e) { var t = e.alignContent; return null != t ? t : de.row.alignContent }), (function (e) { var t = e.alignItems; return null != t ? t : de.row.alignItems }), (function (e) { var t = e.justifyContent; return null != t ? t : de.row.justifyContent }), (function (e) { var t = e.gutter; return "\n        > ".concat(be, " {\n            padding: 0 ").concat((null != t ? t : de.row.gutter) / 2, "px;\n\n            &:first-child {\n                padding-left: 0;\n            }\n\n            &:last-child {\n                padding-right: 0;\n            }\n        }\n    ") }), (function (e) { return e.padded && "\n            > ".concat(be, " {\n                padding: ").concat(de.row.column.padding, ";\n            }\n    ") })), he = o$1.div(N || (N = E(["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    height: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    height: 100%;\n"]))), me = o$1.div(P || (P = E(["\n    position: relative;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    overflow: auto;\n"], ["\n    position: relative;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    overflow: auto;\n"]))), ve = o$1.div(R || (R = E(["\n    position: relative;\n    display: flex;\n    flex: 0;\n    justify-content: flex-start;\n    align-items: center;\n    align-content: center;\n"], ["\n    position: relative;\n    display: flex;\n    flex: 0;\n    justify-content: flex-start;\n    align-items: center;\n    align-content: center;\n"]))), ye = { children: null }, xe = function (t) { return void 0 === t && (t = ye), jsx(he, k$1({}, t, { children: t.children }), void 0) }, we = function (t) { return void 0 === t && (t = ye), jsx(me, k$1({}, t, { children: t.children }), void 0) }, Ce = function (t) { return void 0 === t && (t = ye), jsx(ve, k$1({}, t, { children: t.children }), void 0) }, Ie = de.buttonHover, Ae = o$1.button(M || (M = E(["\n    padding: 4px 6px;\n    min-height: 34px;\n\n    border: 0 none;\n    border-radius: 4px;\n\n    cursor: pointer;\n\n    background-color: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    &:focus {\n        outline: none;\n    }\n"], ["\n    padding: 4px 6px;\n    min-height: 34px;\n\n    border: 0 none;\n    border-radius: 4px;\n\n    cursor: pointer;\n\n    background-color: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    &:focus {\n        outline: none;\n    }\n"])), (function (e) { return e.active ? Ie.backgroundColorActive : Ie.backgroundColor }), Ie.backgroundColorHover), Oe = { container: "ui-loading-dots" }, Te = function (n) { var o = n.width, r = n.height, i = n.duration, a = n.beginStepSize; return jsxs("svg", k$1({ "data-testid": Oe.container, width: o, height: r, viewBox: "0 0 60 20", style: { fill: "currentColor" } }, { children: [jsx("circle", k$1({ cx: "25%", cy: "10", r: "4" }, { children: jsx("animate", { attributeName: "opacity", dur: "".concat(null != i ? i : 1, "s"), values: "0;1;0", repeatCount: "indefinite", begin: a }, void 0) }), void 0), jsx("circle", k$1({ cx: "50%", cy: "10", r: "4" }, { children: jsx("animate", { attributeName: "opacity", dur: "".concat(null != i ? i : 1, "s"), values: "0;1;0", repeatCount: "indefinite", begin: 2 * (null != a ? a : .1) }, void 0) }), void 0), jsx("circle", k$1({ cx: "75%", cy: "10", r: "4" }, { children: jsx("animate", { attributeName: "opacity", dur: "".concat(null != i ? i : 1, "s"), values: "0;1;0", repeatCount: "indefinite", begin: 3 * (null != a ? a : .1) }, void 0) }), void 0)] }), void 0) }; Te.defaultProps = { beginStepSize: .1, duration: 1, height: 20, width: 40 }; var Ee = { black: X, white: L, defaultColor: $, defaultBoldColor: X, defaultSubtleColor: Q, defaultSubtleColor7B: q$1, defaultSubtleColorFA: H, defaultBackground: L, defaultBorder: z$1, defaultWarningColor: se, defaultSuccessColor: pe, defaultIconColor: J, loginLayout: L, loginLayoutShadow: X, disabledBorder: F, disabledInputColor: Q, disabledInputSelectColor: H, disabledPlaceholder: J, checkboxLabelColor: q$1, checkboxLabelDisabledColor: J, radiobuttonActive: oe, radiobuttonBackground: L, radiobuttonBorder: J, radiobuttonLabelColor: q$1, radiobuttonHoverBorder: Q, radiobuttonHoverBackground: H, radiobuttonLabelDisabledColor: J, buttonDisabled: J, buttonDisabledColor: L, buttonPrimary: oe, buttonPrimaryColor: L, buttonPrimaryHover: ne, buttonPrimaryHoverColor: L, buttonPrimaryFocus: ne, buttonSecondary: te, buttonSecondaryColor: oe, buttonSecondaryHover: te, buttonSecondaryHoverColor: oe, buttonTertiary: J, buttonTertiaryColor: L, buttonTertiaryHover: J, buttonTertiaryHoverColor: L, buttonWarning: ce, buttonWarningColor: L, buttonWarningHover: ce, buttonWarningHoverColor: L, buttonInverse: oe, buttonInverseColor: oe, buttonInverseHover: ne, buttonInverseHoverColor: L, buttonGridActiveColor: oe, buttonGridColor: Q, buttonGrid: W, buttonGridActive: L, buttonGridBorder: z$1, buttonGridLabelDanger: se, buttonGridLabel: z$1, buttonHover: V, buttonActiveHover: F, searchButtonBackground: te, buildingBlockButtonPrimary: oe, buildingBlockButtonSecondary: H, buildingBlockButtonSecondaryColor: Q, modalContent: L, modalOverlay: X, modalCloseColor: q$1, modalTitle: ee, loaderSecondary: te, loaderPrimary: ne, sidebarLayoutSidebar: H, sidebarLayoutMain: L, sidebarLayoutSidebarSubcontent: F, sidebarLayoutResponsiveTitle: oe, sidebarLayoutResponsiveCaretColor: oe, tabNavColor: q$1, tabNavActiveColor: $, tabNavBorder: oe, tabNavHoverBorder: F, toolTip: W, toolTipColor: $, toolTipBorder: z$1, toolTipShadow: X, toolTipTrigger: J, toolTipTriggerBorderColor: F, toolTipTriggerBackgroundColor: F, toolTipTriggerColor: L, toolTipTriggerColor9C: Q, toolTipLink: X, dotMenu: Q, tableBackground: L, tableColor: $, tableBorder: z$1, tableHeader: F, tableHeaderColor: q$1, tableExpanded: W, tableRowHover: H, tableRowDisabledBackgroundColor: H, tableSubtleBorder: F, tableSubtleColor: q$1, tableSubtleHeader: H, tableSubtleHeaderColor: Q, tableSubtleTitleColor: q$1, paginationColor: q$1, paginationButton: L, paginationButtonShadow: X, paginationActiveColor: X, sliderTextColor: q$1, sliderOffsideBackgroudColor: D, sliderTackBackgroudColor: re$1, sliderHandle: oe, sliderHandleDisabled: Q, sliderTackBackgroudColorDisabled: z$1, defaultBuildingBlockBorder: z$1, defaultBuildingBlockBackground: F, defaultBuildingBlockDivider: J, collapsibleBlockHeader: q$1, collapsibleBlockHeaderBackground: F, dropdownMenuGroupLabelColor: J, graphAxisStrokeColor: j, graphAxisGridStrokeColor: F, graphAxisLabelColor: U, graphGridBorder: z$1, graphDataScatterColor: ae, graphDataLineColor: le, statusColorActive: oe, statusColorInactive: J, removableLabelCloseButtonFill: K, removableLabelBackground: F, removableLabelFontColor: X, notificationDotColor: ue }, Be = de.buttons, Ge = css(Le || (Le = E(["\n    width: ", ";\n    min-width: ", ";\n    height: ", ";\n    padding: ", ";\n    border: 0;\n    border-radius: 4px;\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n    text-align: center;\n    cursor: ", ";\n    transition: all ease 0.25s;\n    white-space: nowrap;\n    &:focus {\n        transition: none;\n        outline: none;\n        border-radius: ", ";\n        box-shadow: 0 0 4px 1px ", ";\n    }\n"], ["\n    width: ", ";\n    min-width: ", ";\n    height: ", ";\n    padding: ", ";\n    border: 0;\n    border-radius: 4px;\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n    text-align: center;\n    cursor: ", ";\n    transition: all ease 0.25s;\n    white-space: nowrap;\n    &:focus {\n        transition: none;\n        outline: none;\n        border-radius: ", ";\n        box-shadow: 0 0 4px 1px ", ";\n    }\n"])), (function (e) { return e.inline ? "auto" : "100%" }), Be.minWidth, Be.height, Be.padding, Be.fontSize, Be.fontWeight, Be.letterSpacing, (function (e) { return e.disabled ? "not-allowed" : "pointer" }), (function (e) { var t = e.borderRadius; return null != t ? t : "4px" }), Ee.buttonPrimaryFocus), Ne = css(Xe || (Xe = E(["\n    ", "\n"], ["\n    ", "\n"])), (function (e) { var t = e.disabled, n = e.loading; return t && !n ? "\n        background-color: ".concat(Be.disabled.backgroundColor, ";\n        color: ").concat(Be.disabled.color, ";\n    ") : "" })), Pe = o$1.button(Ve || (Ve = E(["\n    ", "\n\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n\n    ", "\n"], ["\n    ", "\n\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n\n    ", "\n"])), Ge, Be.primary.backgroundColor, Be.primary.color, Ne, (function (e) { var t = e.disabled, n = e.hoverBackgroundColor, o = e.hoverTextColor, r = e.loading; return t || r ? "" : "\n        &:hover {\n            background-color: ".concat(null != n ? n : Be.primary.backgroundColorHover, ";\n            color: ").concat(null != o ? o : Be.primary.colorHover, ";\n        }\n    ") })), Re = o$1.button(We || (We = E(["\n    ", "\n\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n\n    ", "\n"], ["\n    ", "\n\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n\n    ", "\n"])), Ge, Be.secondary.backgroundColor, Be.secondary.color, Ne, (function (e) { var t = e.disabled, n = e.hoverBackgroundColor, o = e.hoverTextColor, r = e.loading; return t || r ? "" : "\n        &:hover {\n            background-color: ".concat(null != n ? n : Be.secondary.backgroundColorHover, ";\n            color: ").concat(null != o ? o : Be.secondary.colorHover, ";\n        }\n    ") })); o$1.button(He || (He = E(["\n    width: ", ";\n    min-width: ", ";\n    height: ", ";\n    padding: ", ";\n    border: 0;\n    border-radius: 4px;\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n    text-align: center;\n    cursor: ", ";\n    transition: all ease 0.25s;\n    white-space: nowrap;\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n\n    ", "\n"], ["\n    width: ", ";\n    min-width: ", ";\n    height: ", ";\n    padding: ", ";\n    border: 0;\n    border-radius: 4px;\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n    text-align: center;\n    cursor: ", ";\n    transition: all ease 0.25s;\n    white-space: nowrap;\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n\n    ", "\n"])), (function (e) { return e.inline ? "auto" : "100%" }), Be.minWidth, Be.height, Be.padding, Be.fontSize, Be.fontWeight, Be.letterSpacing, (function (e) { return e.disabled ? "not-allowed" : "pointer" }), Be.tertiary.backgroundColor, Be.tertiary.color, Ne, (function (e) { var t = e.disabled, n = e.hoverBackgroundColor, o = e.hoverTextColor, r = e.loading; return t || r ? "" : "\n        &:hover {\n            background-color: ".concat(null != n ? n : Be.tertiary.backgroundColorHover, ";\n            color: ").concat(null != o ? o : Be.tertiary.colorHover, ";\n        }\n    ") })); o$1.button(Fe || (Fe = E(["\n    ", "\n\n    background-color: ", ";\n    border: ", " solid ", ";\n    color: ", ";\n\n    ", "\n"], ["\n    ", "\n\n    background-color: ", ";\n    border: ", " solid ", ";\n    color: ", ";\n\n    ", "\n"])), Ge, Be.inverse.backgroundColor, Be.inverse.borderWidth, Be.inverse.borderColor, Be.inverse.color, (function (e) { var t = e.disabled, n = e.hoverBackgroundColor, o = e.hoverBorderColor, r = e.hoverTextColor, i = e.loading; return t || i ? "" : "\n        &:hover {\n            background-color: ".concat(null != n ? n : Be.inverse.backgroundColorHover, ";\n            border-color:  ").concat(null != o ? o : Be.inverse.borderColorHover, ";\n            color:  ").concat(null != r ? r : Be.inverse.colorHover, ";\n        }\n    ") })); var Le, Xe, Ve, We, He, Fe, De; o$1.button(De || (De = E(["\n    ", "\n\n    background-color: ", ";\n\n    color: ", ";\n\n    ", "\n"], ["\n    ", "\n\n    background-color: ", ";\n\n    color: ", ";\n\n    ", "\n"])), Ge, Be.warning.backgroundColor, Be.warning.color, (function (e) { var t = e.disabled, n = e.hoverBackgroundColor, o = e.hoverTextColor, r = e.loading; return t || r ? "" : "\n        &:hover {\n            background-color: ".concat(null != n ? n : Be.warning.backgroundColorHover, ";\n            color: ").concat(null != o ? o : Be.warning.colorHover, ";\n        }\n\n        &:focus {\n            border-radius: 4px;\n            box-shadow: 0 0 4px 1px ").concat(Be.warning.backgroundColorFocus, ";\n        }\n    ") })); var je = function (n) { var o = n.text, r = n.disabled, i = n.onClick, a = n.loading, l = n.icon, c = n.testId, p = O(n, ["text", "disabled", "onClick", "loading", "icon", "testId"]); return jsx(Pe, k$1({ disabled: r || a, onClick: i, "data-testid": null != c ? c : "primary_button", inline: !0 }, p, { children: a ? jsx(Te, {}, void 0) : jsxs(React__default.Fragment, { children: [null != l ? l : null, o] }, void 0) }), void 0) }, Ze = { backgroundColor: void 0, borderRadius: void 0, disabled: !1, hoverBackgroundColor: void 0, hoverTextColor: void 0, inline: !0, loading: !1, nowrap: !0, onClick: void 0, style: {}, text: "Click", textColor: void 0, icon: void 0 }, Ye = function (n) { var o = n.text, r = n.disabled, i = n.onClick, a = n.loading, l = n.icon, c = n.testId, p = O(n, ["text", "disabled", "onClick", "loading", "icon", "testId"]); return jsx(Re, k$1({ disabled: r || a, onClick: i, "data-testid": null != c ? c : "secondary_button", inline: !0 }, p, { children: a ? jsx(Te, {}, void 0) : jsxs(React__default.Fragment, { children: [null != l ? l : null, o] }, void 0) }), void 0) }; Ye.defaultProps = Ze; var Qe, Ke, qe, $e, et, tt, nt, ot, rt, it, at, lt, st, ct, pt, ut, dt, ft, bt, gt, ht, mt, vt, yt, xt, wt, Ct, It, At, kt, Ot, Et = { MOBILE: "350px", SMALL: "768px", MEDIUM: "1024px", LARGE: "1280px", XLARGE: "1440px" }, Gt = "\n    color: ".concat(de.colors.values, ";\n    font-family: Helvetica;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0px;\n"), Nt = o$1.div(Qe || (Qe = E(["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n"], ["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n"]))); o$1(Nt)(Ke || (Ke = E(["\n    flex-direction: column;\n"], ["\n    flex-direction: column;\n"]))); var Rt = o$1.div(qe || (qe = E([""], [""]))), Mt = o$1.div($e || ($e = E(["\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    align-items: center;\n"], ["\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    align-items: center;\n"]))); o$1.div(et || (et = E(["\n    display: flex;\n    align-items: center;\n"], ["\n    display: flex;\n    align-items: center;\n"]))); o$1.div(tt || (tt = E(["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n"], ["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n"]))); o$1.div(nt || (nt = E(["\n    overflow-y: auto;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    /* overflow-x: hidden; */\n"], ["\n    overflow-y: auto;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    /* overflow-x: hidden; */\n"]))); var Wt = o$1.h1(ot || (ot = E(["\n    color: ", ";\n    font-family: Helvetica;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23px;\n    letter-spacing: 0px;\n    &:first-child {\n        margin-top: 0;\n    }\n    &:last-child {\n        margin-bottom: 0;\n    }\n"], ["\n    color: ", ";\n    font-family: Helvetica;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23px;\n    letter-spacing: 0px;\n    &:first-child {\n        margin-top: 0;\n    }\n    &:last-child {\n        margin-bottom: 0;\n    }\n"])), Ee.black); o$1(Wt)(rt || (rt = E(["\n    margin-bottom: 16px;\n"], ["\n    margin-bottom: 16px;\n"]))); o$1.h2(it || (it = E(["\n    color: ", ";\n    font-family: Helvetica;\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: 0px;\n    line-height: 20px;\n    margin: 0;\n"], ["\n    color: ", ";\n    font-family: Helvetica;\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: 0px;\n    line-height: 20px;\n    margin: 0;\n"])), Ee.black); o$1.h3(at || (at = E(["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 16px;\n    margin: 0;\n"], ["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 16px;\n    margin: 0;\n"])), de.colors.titles); var zt = o$1.p(lt || (lt = E(["\n    ", "\n"], ["\n    ", "\n"])), Gt); o$1.p(st || (st = E(["\n    color: ", ";\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 17px;\n    letter-spacing: 0px;\n"], ["\n    color: ", ";\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 17px;\n    letter-spacing: 0px;\n"])), (function (e) { var t = e.textColor; return null != t ? t : q$1 })); var Zt = o$1.p(ct || (ct = E(["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 13px;\n    line-height: 26px;\n    margin: 0;\n    display: flex;\n    align-items: center;\n"], ["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 13px;\n    line-height: 26px;\n    margin: 0;\n    display: flex;\n    align-items: center;\n"])), de.colors.subtleLabels), Yt = o$1.p(pt || (pt = E(["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n    margin: 8px 0;\n"], ["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n    margin: 8px 0;\n"])), de.colors.labels); o$1.p(ut || (ut = E(["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 16px;\n    text-align: left;\n"], ["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 16px;\n    text-align: left;\n"])), de.colors.labels); o$1.p(dt || (dt = E(["\n    font-family: Helvetica;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0px;\n    text-align: left;\n"], ["\n    font-family: Helvetica;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0px;\n    text-align: left;\n"]))); var Ut = o$1.div(ft || (ft = E(["\n    display: flex;\n    border-radius: 50%;\n    padding: 4px;\n\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    svg {\n        display: block;\n    }\n\n    cursor: pointer;\n"], ["\n    display: flex;\n    border-radius: 50%;\n    padding: 4px;\n\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    svg {\n        display: block;\n    }\n\n    cursor: pointer;\n"])), Ee.removableLabelBackground, Ee.removableLabelCloseButtonFill); o$1.div(bt || (bt = E(["\n    padding: 20px 90px 0;\n\n    @media (max-width: ", ") {\n        padding: 20px 0 0;\n    }\n"], ["\n    padding: 20px 90px 0;\n\n    @media (max-width: ", ") {\n        padding: 20px 0 0;\n    }\n"])), Et.SMALL); o$1(zt)(gt || (gt = E(["\n    white-space: pre-line;\n"], ["\n    white-space: pre-line;\n"]))); o$1(Mt)(ht || (ht = E(["\n    gap: 6px;\n\n    & > * {\n        flex: 1;\n    }\n"], ["\n    gap: 6px;\n\n    & > * {\n        flex: 1;\n    }\n"]))); o$1.div(mt || (mt = E(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"]))); o$1(Ut)(vt || (vt = E([""], [""]))); o$1.div(yt || (yt = E(["\n    display: flex;\n    flex-direction: column;\n    height: fit-content;\n    width: 100%;\n\n    border-radius: 4px;\n    border: 1px solid ", ";\n    background-color: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    height: fit-content;\n    width: 100%;\n\n    border-radius: 4px;\n    border: 1px solid ", ";\n    background-color: ", ";\n"])), de.card.border, de.card.background); o$1.div(xt || (xt = E(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    height: 40px;\n    padding-left: 20px;\n    padding-right: 10px;\n\n    background-color: ", ";\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    height: 40px;\n    padding-left: 20px;\n    padding-right: 10px;\n\n    background-color: ", ";\n"])), de.card.cardHeader.background); o$1.h3(wt || (wt = E(["\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 19px;\n    color: ", ";\n\n    margin: 0;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 19px;\n    color: ", ";\n\n    margin: 0;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"])), de.card.titleColor); o$1.div(Ct || (Ct = E(["\n    display: flex;\n    flex-direction: column;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 4px;\n\n    > textarea {\n        font-size: 13px;\n    }\n\n    > span {\n        // input text as a renderString\n        color: ", ";\n    }\n\n    > label {\n        // checkbox\n        margin: 24px 4px 4px 4px;\n        font-size: 13px;\n    }\n\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 4px;\n\n    > textarea {\n        font-size: 13px;\n    }\n\n    > span {\n        // input text as a renderString\n        color: ", ";\n    }\n\n    > label {\n        // checkbox\n        margin: 24px 4px 4px 4px;\n        font-size: 13px;\n    }\n\n    ", "\n"])), de.card.cardBody.background, de.card.cardBody.color, de.card.cardBody.color, (function (e) { return e.hasHorizontalRule && "\n        border-top: 1px solid ".concat(de.card.border, ";\n    ") })); o$1.p(It || (It = E(["\n    margin: 0;\n    margin-bottom: 4px;\n    font-size: 13px;\n    color: ", ";\n"], ["\n    margin: 0;\n    margin-bottom: 4px;\n    font-size: 13px;\n    color: ", ";\n"])), de.colors.primary), o$1.div(At || (At = E(["\n    display: flex;\n    flex-direction: column;\n\n    & + & {\n        margin-top: 16px;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n\n    & + & {\n        margin-top: 16px;\n    }\n"]))), o$1.p(kt || (kt = E(["\n    font-size: 13px;\n    color: ", ";\n    margin: 0;\n    margin-bottom: 4px;\n"], ["\n    font-size: 13px;\n    color: ", ";\n    margin: 0;\n    margin-bottom: 4px;\n"])), de.colors.primary), o$1.p(Ot || (Ot = E(["\n    font-size: 12px;\n    color: ", ";\n    margin: 0;\n"], ["\n    font-size: 12px;\n    color: ", ";\n    margin: 0;\n"])), de.colors.values); var ln, sn, cn, pn, un, dn, fn, bn, gn, hn, yn = o$1.label(ln || (ln = E(["\n    color: ", ";\n\n    font-size: 12px;\n\n    cursor: ", ";\n\n    > span {\n        vertical-align: sub;\n        &:first-child {\n            margin-right: 10px;\n        }\n    }\n\n    user-select: none;\n"], ["\n    color: ", ";\n\n    font-size: 12px;\n\n    cursor: ", ";\n\n    > span {\n        vertical-align: sub;\n        &:first-child {\n            margin-right: 10px;\n        }\n    }\n\n    user-select: none;\n"])), (function (e) { return e.disabled ? de.formElements.toggle.color : de.formElements.toggle.colorDisabled }), (function (e) { return e.disabled ? "default" : "pointer" })), xn = o$1.span(sn || (sn = E(["\n    height: 14px;\n    width: 14px;\n    background-size: cover;\n    display: inline-block;\n\n    cursor: ", ";\n\n    ", ":hover & {\n        ", ";\n        ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    height: 14px;\n    width: 14px;\n    background-size: cover;\n    display: inline-block;\n\n    cursor: ", ";\n\n    ", ":hover & {\n        ", ";\n        ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n"])), (function (e) { return e.disabled ? "default" : "pointer" }), yn, (function (e) { var t = e.disabled, n = e.checked; return !t && n ? "\n            background-image: url(".concat("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABGdBTUEAALGPC/xhBQAAA75JREFUWAntmFlsTFEYx//V6aal7bSUKkYXdMG0pQ8NIaaqjVYlaqdaLQ/CgxDxICHxJOFBLGlEF7uQWCq1pPQBiSLToiFVGSnVRSmjs3R045zL3My9mXvvTDszMsmcl3u+5Xzfb757vnNuxutMecVvuMEY5QaMDKLbgMosK1pcVGgp/vd5WUUly+A2FfWAsu/MQRNPRR1USDbMf6to9btvWHulEQNDtt03nOOJxXfy5IHmO/IvvYapfxCjvLxwYXUSeYondXlFH7VokXf+JQNJ0S6/6kDx9TeQqqtLQetafyLnbAOMfYOc8lWq27H9VhNHxxdcBlrfrkN2ZQN0vwb4DIxc+qwVu6qbrdqo0iWgjV/0yCyvh7a3XxCEGiKCfAXtTgdt+mpERpka3cY+QQhqOKCKwb6FCkEfm0DpCVJy4y1qP/wQDGTNoPneCxWB7NKLQ+4lgAdV0dZCsDpJUNqN226+RdmLNiw/14AnH7XsYrHJp58mLD6jRnuPScwNO9On4PDSOFEfapQE3VHVxEBSZwPp1mWka59/7qGi4GjX/WIgP2l7BX2oYWtaFI7lzBD1MRtFQffcfY9Tda1mX+bZYxpAVkU9XnboOXqz0GXoZ163pttoVll9FqREojQvHhLnPLtWEHR/jQZHH7ewjpaTH6R7l5Sr8abLYKlGN9HTxmni6TlORFg9ewLKVyZK3kaW6wRByc0mOr4Z+hio5n+V05JK0yOosVMnui4vYTwukivTWyI+P4gg6KGMGOxeoOD7c+ROshdVpGFed+qZw7y+TXzvZk0Px9V1syGTutg5Wf4Koh8lR7LjYBoYxMmn3H1qGecz6e7kE3UYkvgKWhwjx42Nc+Brbyn/JROsqBnmeO5MFM+bZBatPqUg5ytCUVWQDH+ZZDqr8alSciXdSqdXJGCDcqJgEDFD2uRgVG9ORqCPZCqxMNKgdDXdUmdXJSF/VoRoML5RGTkG94pSMNbPm2+yW7b5Z9KtdWnNLOTGj7MpSWJEEGq2pCLUX7QNbIpFnWwGpc4+pLTX1s9BZlwYFQXH9PBAPChORfhoH0Efew12gdLgfqS0NzcpsShabjXXNHkAHpakYoLIJ5vVhRJKu0FpvADSvbcLlEifGsIJPznEH7UlcxE11o+jd4QwLFCaOMjXG3cKkzE3KpjhmEjgKKSCwDpjDBuUwgT7yXCfdHVGbBgekj0ZS167s8aIW1IeICPdneIsPjbuiCrKRnHBxAPq6CJ7KuroinK63vI/c0cnGmk8z6sfaQX56/8AITP9eOMkbcQAAAAASUVORK5CYII=", ");\n        ") : "" }), (function (e) { var t = e.disabled, n = e.checked; return t || n ? "" : "\n            background-image: url(".concat("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABGdBTUEAALGPC/xhBQAAAJlJREFUWAnt2EEKwjAARFEr3rLiyURB6jkVinzS/QcJ/Kwmm2F42WW5P56f0wTnPMHGfeI0Qy+j6O26jte/59f2ZsM0og3lzaSQqARJTaJQSCFRCZKaRKGQQqISJDWJQiGFRCVIahKFQgqJSpDUJAqFFBKVIKlJFAopJCpBUpMoFFJIVIKkJlEopHD4wx//zKV+raan1yh/RV9q2ggbxHEPUAAAAABJRU5ErkJggg==", ");\n        ") }), (function (e) { return e.checked ? "\n        background-image: url(".concat("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABGdBTUEAALGPC/xhBQAAA7xJREFUWAntmFlIVFEYx//muKXlWi5ZTW6llXu2UBSOmZJmkO1li9ZD1EMU0UNQ0FNQD9GCRJm2WBSkGbbg8lCRY+FYimKGYZpLljW5jmudc3Muc4e5987ozIQw5+Webznf95vvnu+cy1i9KZP/wSQYUyYBI4M4aUAlmhVdvmyppvjf52XycpZh0lTUAsq+MyNNLBU1UiHZMP+tooUff2Db/WoMj+p333COJxbfxJPihp9Iza2CamgEU6yscGfLIvIUTmr2ir5sVCLl9nsGkqLd+9CG9Ec1EKurWUHlzb+RlFOJvsERTvmyK1px6HEdR6ctmA1U0dqNxOxKdA8MazMwcmZ5M44W1uu0UaVZQKu/9SA+SwFl/xAvCDV4Otny2k0OWve9D3E3KtDZN8gLQQ2nZf44uVrK66MXKD1BMvJqUfr5F28gXYaGn/2QEciOHmHIEwTwjMxPVwhWJwpKu/Fgfi1uvGvBhluVeP1FyS4WmjT9ViH2egVau1RCbjiyYg7OrQsU9KFGUdDDBXUMJHXuJd26nnTt269dVOQdrd0DDGSTsp/XhxoOxPjiYtJ8QR+1URD0+LNPuCpvVvsyzy7VMBJuKvC+rYejVwsdvUPM627o7FOrdD7TIn2QmRIMkXOeXcsLeqqoARdeNbKOmpNfpHvXZlWgpqNXU41OoqeNU6el5zgRYUuoF7I2LRS9jTTX8YKSm01w/OgdZKDqxyqnJJWmR1B1e7fgupSQmbhLrkxrkfjaQXhBz8b549gqqbY/R24ne1FGGqaqvYc5zBUtwns3IcgDD7aHQiJ2sXOy/BMEP0rOJwZCNTyCK2XcfaoZ5yvp7ojLcoyKfAXF+rshb1cYbA0t5Vgy3oqqYS4lL0D6kllqUedTDHKl1BUFaRGwl4im0xmfKkVX0q10bWMIdoZ78wYRMsTMdkbhngg42oimEgojDkpX0y2Vs3kRUhd7CgbTNob7TMPzfZGYbmetbTJY1vtn0q2Vu3UxkoNn6JVkoacTivZHwdVesA30ikWd9AalzjaktA93hCE+0J2KvCPIwxHF6VHwmGrD62OowSBQGtyOlDZ/dzjW+LnpzDXPzQElGVHwEvhk07lQRGkwKI3nQLr3SVo4Vsx14YSf7WKP0oxo+E634+iNIYwLlCZ2srXG070RiPZ1Zji8CRyFlBJYU4xxg1IYZzsJXpCujgtwRwnZkwHktZtqTLgl3RwkpLsjTcXHxp1QRdkoZphYQI1dZEtFjV1RTtdr/mdu7EQTjWd59ROtoPb6vzgz/nB7WdmLAAAAAElFTkSuQmCC", ");\n    ") : "" }), (function (e) { return e.checked ? "" : "\n        background-image: url(".concat("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABGdBTUEAALGPC/xhBQAAAJpJREFUWAnt2DEKAjEARFFXPNHq/Uu1cL2SwiKfbP9BAj/VpBmGly7L/fH8nCY45wk27hOnGXoZRW/Xdbz+Pb+2NxumEW0obyaFRCVIahKFQgqJSpDUJAqFFBKVIKlJFAopJCpBUpMoFFJIVIKkJlEopJCoBElNolBIIVEJkppEoZBCohIkNYlCIYXDH/74Zy71azU9vUb5K/oCgdoJE/h+KWoAAAAASUVORK5CYII=", ");\n    ") }), (function (e) { return e.disabled ? "\n        opacity: .5\n    " : "" })), wn = o$1.input(cn || (cn = E(["\n    display: none;\n"], ["\n    display: none;\n"]))), Cn = { checkboxInput: "ui-component-checkbox-hidden-input" }, In = function (n) { var o = n.checked, r = n.disabled, i = void 0 !== r && r, a = n.label, l = void 0 === a ? "" : a, s = n.labelRenderer, c = void 0 === s ? null : s, p = n.onClickHandler, u = n.name, d = void 0 === u ? "checkbox" : u, f = n.styles; return jsxs(yn, k$1({ disabled: i, style: f }, { children: [jsx(xn, { checked: o, disabled: i }, void 0), l, null == c ? void 0 : c(o), jsx(wn, { checked: o, "data-testid": Cn.checkboxInput, id: d, name: d, type: "checkbox", onChange: i ? void 0 : p }, d)] }), d) }; o$1(Rt)(pn || (pn = E(["\n    max-height: ", ";\n    transition: max-height 0.5s;\n    transition-timing-function: ease-in-out;\n    will-change: max-height;\n    overflow: hidden;\n    overflow: ", ";\n"], ["\n    max-height: ", ";\n    transition: max-height 0.5s;\n    transition-timing-function: ease-in-out;\n    will-change: max-height;\n    overflow: hidden;\n    overflow: ", ";\n"])), (function (e) { return e.open ? "100%" : "0px" }), (function (e) { return e.open ? "visible" : "hidden" })); o$1(Rt)(un || (un = E(["\n    border-top: 1px solid ", ";\n    margin: 12px 0;\n"], ["\n    border-top: 1px solid ", ";\n    margin: 12px 0;\n"])), Ee.defaultBorder); o$1.button(dn || (dn = E(["\n    border: 0;\n    background-color: transparent;\n    cursor: ", ";\n    width: 100%;\n    margin: 0;\n    padding: 0;\n"], ["\n    border: 0;\n    background-color: transparent;\n    cursor: ", ";\n    width: 100%;\n    margin: 0;\n    padding: 0;\n"])), (function (e) { return e.disabled ? "not-allowed" : "pointer" })); o$1.div(fn || (fn = E(["\n    border: 0;\n    background-color: transparent;\n"], ["\n    border: 0;\n    background-color: transparent;\n"]))); o$1.h4(bn || (bn = E(["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    margin: 0 0 0 16px;\n"], ["\n    color: ", ";\n    font-family: Helvetica;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    margin: 0 0 0 16px;\n"])), de.colors.labels); var Sn = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAA6ElEQVR4AWKgOgB0ToYgFQVBFAUREdGOTaPZbMeOHey9aTX/ZPgzc2d220t+Xmc7Fos9mn4w6IIvrPMssuGPDy/cdgbmzt4dx/GIBS/DMBwvgtcsEwkaQx9DGMAhiz67Kwvecs6nO+FSyr5Ai4OVBNuU0vlOuLW2R8CTuzL03eGLcBU2Sw5+kuBDVS9DWFRXMzwbyFd/wOme4AFnm12HMMFuiWVas04E3ETs7wD0i6QfCAXYHQuCleLQNQ7dhzcJzvrPhwuq4d4COOuAqHwEdOULxZvNicOvP/UWXS06gn+cA4Y9BFlifQMrFL5t8PgrLgAAAABJRU5ErkJggg==", Bn = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAA1UlEQVR4AWIgC6xatYpnzvwFFzdv3gxonQ5BIgrCII6LiIhix3bVarfbwQ72Hs02o+G+mf93bztyHbxsxx5NBoOu8MJ6wWTZDW/7D2ZnZ0+HgMinMG0tz9M0nXVBKeVC5j3MT5CvwEkXASuZj4Aq58tutzvqon2cS5GfQdYQz621wy6yy1WYr3BWOTdDJUC5FvktU0U+DiJu/kqozul+CAXcrpVzyHOwuVsO9CP1L92vVaYGsNzDAav4N43++KAOjU8kYZrMm7bb86HRGR72H+n4YOnzC+cxvghEtPcSAAAAAElFTkSuQmCC", Gn = o$1.span(gn || (gn = E(["\n    display: inline-block;\n    margin: ", ";\n\n    ", "\n\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n"], ["\n    display: inline-block;\n    margin: ", ";\n\n    ", "\n\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n"])), (function (e) { var t = e.margin; return null != t ? t : "auto" }), (function (e) { var t = e.black, n = e.grey, o = e.blue, r = e.down, i = e.up, a = e.left, l = e.right, s = ""; return (i || r) && (s += "\n                width: 10px;\n                height: 8px;\n            "), (a || l) && (s += "\n                width: 8px;\n                height: 10px;\n            "), i && t && (s += "background-image: url(".concat("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAA5UlEQVR4AcWSLwjCQBTGh4iIaGdNo3W3fzCEVTvXwd6bsmZeMmsP9mJnxWKPJoPBCS7o98Ez7FDnXzz44O3e7/3uNmb9ZbmuO2K+IvM8b6yUOiEF6slHMkhS5IjbFRSy5t7LoiRJahicIzlklGhG6txxnAWZp2RxHNcxuERyud3w2mNNIUOGbJWsCXAlNzn4vj8wGe6xR4YsZ27KoijqAMhEtg+CQN07mD0yIs1Qt0qA1rqBzY3IdmEY9q2KRYaszBQlKR6myBnNLcDuI5Hx+j3OcBZZm6eliP3Gr2VDOsO3bFu/WBcwyl5BNldHdgAAAABJRU5ErkJggg==", ");")), r && t && (s += "background-image: url(".concat("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAA5UlEQVR4AcVQK8jCYBS9/PyIiHZsGq379oIhrNr5Oth7U9bMS2btwV7WsVjs0bRgcIIGPQcu4gNlQ8UDh13ueXD3yVcQhmHPGJOC7apZZlzXncZx3LxeTsAThA3KO1ISvu93mWEWXF0Ea20NizXEPb45Ly75V7lmjmDjxhBFUQviUg3bIAiMPAE1euhlRssegXeow5Bp6Q6/1L/3cEdNyzJm5BVg+IdxARYIMjQQBWfsCpIeeqUMkiT5Q2jGoF5rSZ0Lx3Hm9EhVIJzqlXx0koWpvAPP80YoObAQ81g+AVw4JOUXOAN1mV5B+OmA3QAAAABJRU5ErkJggg==", ");")), a && n && (s += "background-image: url(".concat(Sn, ");")), l && n && (s += "background-image: url(".concat(Bn, ");")), r && o && (s += "background-image: url(".concat("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAeCAMAAABQZB20AAAAPFBMVEUAAAAAebsAfb4AgNUAersAerwAer8AebsAersAersAeboAeroAebsAerwAgLwAeroAersAerwAesIAebqNr1mUAAAAE3RSTlMA7C8GtH0w8ZTaw7JpUyLTrXkZYwb47wAAAIxJREFUOMuNy0kSg0AMA0AxWTxAIIv//9f45oOKkvrewGuN/YTreMc2UCvLMsz1yBI/YM1+1ipfILKfuXICe/YzVx7AufQz1wfl2c9b9xvouYufXvz8xU8vfnrpx0s/vfjpxU8s/Xix0c9f/HjpR8t8tLw3aVlPLPF6ySeWfL3818t/tPzXy39bzOv1B8DoHdpZ8wBVAAAAAElFTkSuQmCC", ");")), s })), Nn = function (t) { return jsx(Gn, k$1({}, t), void 0) }; o$1.div(hn || (hn = E(["\n    display: block;\n    color: ", ";\n    letter-spacing: 1px;\n    font-size: 24px;\n    line-height: 1;\n"], ["\n    display: block;\n    color: ", ";\n    letter-spacing: 1px;\n    font-size: 24px;\n    line-height: 1;\n"])), Ee.dotMenu); function Hn(e) { if (e.__esModule) return e; var t = Object.defineProperty({}, "__esModule", { value: !0 }); return Object.keys(e).forEach((function (n) { var o = Object.getOwnPropertyDescriptor(e, n); Object.defineProperty(t, n, o.get ? o : { enumerable: !0, get: function () { return e[n] } }); })), t } var Fn = function () { if ("undefined" != typeof Map) return Map; function e(e, t) { var n = -1; return e.some((function (e, o) { return e[0] === t && (n = o, !0) })), n } return function () { function t() { this.__entries__ = []; } return Object.defineProperty(t.prototype, "size", { get: function () { return this.__entries__.length }, enumerable: !0, configurable: !0 }), t.prototype.get = function (t) { var n = e(this.__entries__, t), o = this.__entries__[n]; return o && o[1] }, t.prototype.set = function (t, n) { var o = e(this.__entries__, t); ~o ? this.__entries__[o][1] = n : this.__entries__.push([t, n]); }, t.prototype.delete = function (t) { var n = this.__entries__, o = e(n, t); ~o && n.splice(o, 1); }, t.prototype.has = function (t) { return !!~e(this.__entries__, t) }, t.prototype.clear = function () { this.__entries__.splice(0); }, t.prototype.forEach = function (e, t) { void 0 === t && (t = null); for (var n = 0, o = this.__entries__; n < o.length; n++) { var r = o[n]; e.call(t, r[1], r[0]); } }, t }() }(), Dn = "undefined" != typeof window && "undefined" != typeof document && window.document === document, zn = "undefined" != typeof global && global.Math === Math ? global : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(), jn = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(zn) : function (e) { return setTimeout((function () { return e(Date.now()) }), 1e3 / 60) }; var Zn = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Yn = "undefined" != typeof MutationObserver, _n = function () { function e() { this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t) { var n = !1, o = !1, r = 0; function i() { n && (n = !1, e()), o && l(); } function a() { jn(i); } function l() { var e = Date.now(); if (n) { if (e - r < 2) return; o = !0; } else n = !0, o = !1, setTimeout(a, t); r = e; } return l }(this.refresh.bind(this), 20); } return e.prototype.addObserver = function (e) { ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_(); }, e.prototype.removeObserver = function (e) { var t = this.observers_, n = t.indexOf(e); ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_(); }, e.prototype.refresh = function () { this.updateObservers_() && this.refresh(); }, e.prototype.updateObservers_ = function () { var e = this.observers_.filter((function (e) { return e.gatherActive(), e.hasActive() })); return e.forEach((function (e) { return e.broadcastActive() })), e.length > 0 }, e.prototype.connect_ = function () { Dn && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Yn ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, { attributes: !0, childList: !0, characterData: !0, subtree: !0 })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0); }, e.prototype.disconnect_ = function () { Dn && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1); }, e.prototype.onTransitionEnd_ = function (e) { var t = e.propertyName, n = void 0 === t ? "" : t; Zn.some((function (e) { return !!~n.indexOf(e) })) && this.refresh(); }, e.getInstance = function () { return this.instance_ || (this.instance_ = new e), this.instance_ }, e.instance_ = null, e }(), Jn = function (e, t) { for (var n = 0, o = Object.keys(t); n < o.length; n++) { var r = o[n]; Object.defineProperty(e, r, { value: t[r], enumerable: !1, writable: !1, configurable: !0 }); } return e }, Un = function (e) { return e && e.ownerDocument && e.ownerDocument.defaultView || zn }, Qn = no(0, 0, 0, 0); function Kn(e) { return parseFloat(e) || 0 } function qn(e) { for (var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n]; return t.reduce((function (t, n) { return t + Kn(e["border-" + n + "-width"]) }), 0) } function $n(e) { var t = e.clientWidth, n = e.clientHeight; if (!t && !n) return Qn; var o = Un(e).getComputedStyle(e), r = function (e) { for (var t = {}, n = 0, o = ["top", "right", "bottom", "left"]; n < o.length; n++) { var r = o[n], i = e["padding-" + r]; t[r] = Kn(i); } return t }(o), i = r.left + r.right, a = r.top + r.bottom, l = Kn(o.width), s = Kn(o.height); if ("border-box" === o.boxSizing && (Math.round(l + i) !== t && (l -= qn(o, "left", "right") + i), Math.round(s + a) !== n && (s -= qn(o, "top", "bottom") + a)), !function (e) { return e === Un(e).document.documentElement }(e)) { var c = Math.round(l + i) - t, p = Math.round(s + a) - n; 1 !== Math.abs(c) && (l -= c), 1 !== Math.abs(p) && (s -= p); } return no(r.left, r.top, l, s) } var eo = "undefined" != typeof SVGGraphicsElement ? function (e) { return e instanceof Un(e).SVGGraphicsElement } : function (e) { return e instanceof Un(e).SVGElement && "function" == typeof e.getBBox }; function to(e) { return Dn ? eo(e) ? function (e) { var t = e.getBBox(); return no(0, 0, t.width, t.height) }(e) : $n(e) : Qn } function no(e, t, n, o) { return { x: e, y: t, width: n, height: o } } var oo = function () { function e(e) { this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = no(0, 0, 0, 0), this.target = e; } return e.prototype.isActive = function () { var e = to(this.target); return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight }, e.prototype.broadcastRect = function () { var e = this.contentRect_; return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e }, e }(), ro = function (e, t) { var n = function (e) { var t = e.x, n = e.y, o = e.width, r = e.height, i = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, a = Object.create(i.prototype); return Jn(a, { x: t, y: n, width: o, height: r, top: n, right: t + o, bottom: r + n, left: t }), a }(t); Jn(this, { target: e, contentRect: n }); }, io = function () { function e(e, t, n) { if (this.activeObservations_ = [], this.observations_ = new Fn, "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function."); this.callback_ = e, this.controller_ = t, this.callbackCtx_ = n; } return e.prototype.observe = function (e) { if (!arguments.length) throw new TypeError("1 argument required, but only 0 present."); if ("undefined" != typeof Element && Element instanceof Object) { if (!(e instanceof Un(e).Element)) throw new TypeError('parameter 1 is not of type "Element".'); var t = this.observations_; t.has(e) || (t.set(e, new oo(e)), this.controller_.addObserver(this), this.controller_.refresh()); } }, e.prototype.unobserve = function (e) { if (!arguments.length) throw new TypeError("1 argument required, but only 0 present."); if ("undefined" != typeof Element && Element instanceof Object) { if (!(e instanceof Un(e).Element)) throw new TypeError('parameter 1 is not of type "Element".'); var t = this.observations_; t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this)); } }, e.prototype.disconnect = function () { this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this); }, e.prototype.gatherActive = function () { var e = this; this.clearActive(), this.observations_.forEach((function (t) { t.isActive() && e.activeObservations_.push(t); })); }, e.prototype.broadcastActive = function () { if (this.hasActive()) { var e = this.callbackCtx_, t = this.activeObservations_.map((function (e) { return new ro(e.target, e.broadcastRect()) })); this.callback_.call(e, t, e), this.clearActive(); } }, e.prototype.clearActive = function () { this.activeObservations_.splice(0); }, e.prototype.hasActive = function () { return this.activeObservations_.length > 0 }, e }(), ao = "undefined" != typeof WeakMap ? new WeakMap : new Fn, lo = function e(t) { if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function."); if (!arguments.length) throw new TypeError("1 argument required, but only 0 present."); var n = _n.getInstance(), o = new io(t, n, this); ao.set(this, o); };["observe", "unobserve", "disconnect"].forEach((function (e) { lo.prototype[e] = function () { var t; return (t = ao.get(this))[e].apply(t, arguments) }; })); var so, co, po, uo, fo, bo, go, ho, mo = void 0 !== zn.ResizeObserver ? zn.ResizeObserver : lo, vo = React__default; (so = Hn(Object.freeze({ __proto__: null, default: mo }))) && "object" == typeof so && "default" in so ? so.default : so; "undefined" != typeof window && window.document && window.document.createElement ? vo.useLayoutEffect : vo.useEffect; o$1.hr(co || (co = E(["\n    width: 100%;\n    height: 1px;\n    border: 0;\n    /* No clue why, but the HR does not appear in the sidebar without that next line */\n    border-bottom: 1px solid transparent;\n"], ["\n    width: 100%;\n    height: 1px;\n    border: 0;\n    /* No clue why, but the HR does not appear in the sidebar without that next line */\n    border-bottom: 1px solid transparent;\n"]))); var ko = css(po || (po = E(["\n    width: 100%;\n    min-height: 30px;\n    padding: 5px 16px;\n\n    font-size: 12px;\n    color: ", ";\n    &::placeholder {\n        color: ", ";\n    }\n\n    background-color: ", ";\n    border-radius: 4px;\n    border: 1px solid\n        ", ";\n\n    box-sizing: border-box;\n\n    &:focus {\n        outline: none;\n        border-color: ", ";\n    }\n"], ["\n    width: 100%;\n    min-height: 30px;\n    padding: 5px 16px;\n\n    font-size: 12px;\n    color: ", ";\n    &::placeholder {\n        color: ", ";\n    }\n\n    background-color: ", ";\n    border-radius: 4px;\n    border: 1px solid\n        ", ";\n\n    box-sizing: border-box;\n\n    &:focus {\n        outline: none;\n        border-color: ", ";\n    }\n"])), (function (e) { return e.disabled ? Ee.disabledInputColor : Ee.defaultColor }), (function (e) { return e.disabled ? Ee.disabledPlaceholder : Ee.disabledInputColor }), (function (e) { return e.disabled ? Ee.disabledBorder : Ee.defaultBackground }), (function (e) { return e.disabled ? Ee.disabledBorder : Ee.defaultBorder }), Ee.buttonPrimaryHover), Oo = o$1.span(uo || (uo = E(["\n    font-size: inherit;\n    color: ", ";\n"], ["\n    font-size: inherit;\n    color: ", ";\n"])), Ee.defaultColor); o$1.input(fo || (fo = E(["\n    ", ";\n"], ["\n    ", ";\n"])), ko); o$1.div(bo || (bo = E(["\n    display: flex;\n\n    margin-right: ", ";\n    margin-left: ", ";\n    border-radius: 50%;\n\n    padding: 4px;\n\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    cursor: ", ";\n\n    svg {\n        display: block;\n    }\n"], ["\n    display: flex;\n\n    margin-right: ", ";\n    margin-left: ", ";\n    border-radius: 50%;\n\n    padding: 4px;\n\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    cursor: ", ";\n\n    svg {\n        display: block;\n    }\n"])), (function (e) { return "left" === e.position ? "12px" : "0px" }), (function (e) { return "right" === e.position ? "12px" : "0px" }), Ee.removableLabelBackground, Ee.removableLabelCloseButtonFill, (function (e) { return e.onClick ? "pointer" : "default" })); o$1.input(go || (go = E(["\n    ", "\n"], ["\n    ", "\n"])), ko); o$1.div(ho || (ho = E(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    width: 100%;\n\n    margin-bottom: 8px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    width: 100%;\n\n    margin-bottom: 8px;\n"]))); function Mo() { return Mo = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var n = arguments[t]; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]); } return e }, Mo.apply(this, arguments) } var Lo = function () { function e(e) { var t = this; this._insertTag = function (e) { var n; n = 0 === t.tags.length ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, n), t.tags.push(e); }, this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null; } var t = e.prototype; return t.hydrate = function (e) { e.forEach(this._insertTag); }, t.insert = function (e) { this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) { var t = document.createElement("style"); return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t }(this)); var t = this.tags[this.tags.length - 1]; if ("production" !== process.env.NODE_ENV) { var n = 64 === e.charCodeAt(0) && 105 === e.charCodeAt(1); n && this._alreadyInsertedOrderInsensitiveRule && console.error("You're attempting to insert the following rule:\n" + e + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !n; } if (this.isSpeedy) { var o = function (e) { if (e.sheet) return e.sheet; for (var t = 0; t < document.styleSheets.length; t++)if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t] }(t); try { o.insertRule(e, o.cssRules.length); } catch (t) { "production" === process.env.NODE_ENV || /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(e) || console.error('There was a problem inserting the following rule: "' + e + '"', t); } } else t.appendChild(document.createTextNode(e)); this.ctr++; }, t.flush = function () { this.tags.forEach((function (e) { return e.parentNode && e.parentNode.removeChild(e) })), this.tags = [], this.ctr = 0, "production" !== process.env.NODE_ENV && (this._alreadyInsertedOrderInsensitiveRule = !1); }, e }(), Xo = "-ms-", Vo = "-moz-", Wo = "-webkit-", Ho = Math.abs, Fo = String.fromCharCode, Do = Object.assign; function zo(e) { return e.trim() } function jo(e, t, n) { return e.replace(t, n) } function Zo(e, t) { return e.indexOf(t) } function Yo(e, t) { return 0 | e.charCodeAt(t) } function _o(e, t, n) { return e.slice(t, n) } function Jo(e) { return e.length } function Uo(e) { return e.length } function Qo(e, t) { return t.push(e), e } var Ko = 1, qo = 1, $o = 0, er = 0, tr = 0, nr = ""; function or(e, t, n, o, r, i, a) { return { value: e, root: t, parent: n, type: o, props: r, children: i, line: Ko, column: qo, length: a, return: "" } } function rr(e, t) { return Do(or("", null, null, "", null, null, 0), e, { length: -e.length }, t) } function ir() { return tr = er > 0 ? Yo(nr, --er) : 0, qo--, 10 === tr && (qo = 1, Ko--), tr } function ar() { return tr = er < $o ? Yo(nr, er++) : 0, qo++, 10 === tr && (qo = 1, Ko++), tr } function lr() { return Yo(nr, er) } function sr() { return er } function cr(e, t) { return _o(nr, e, t) } function pr(e) { switch (e) { case 0: case 9: case 10: case 13: case 32: return 5; case 33: case 43: case 44: case 47: case 62: case 64: case 126: case 59: case 123: case 125: return 4; case 58: return 3; case 34: case 39: case 40: case 91: return 2; case 41: case 93: return 1 }return 0 } function ur(e) { return Ko = qo = 1, $o = Jo(nr = e), er = 0, [] } function dr(e) { return nr = "", e } function fr(e) { return zo(cr(er - 1, hr(91 === e ? e + 2 : 40 === e ? e + 1 : e))) } function br(e) { for (; (tr = lr()) && tr < 33;)ar(); return pr(e) > 2 || pr(tr) > 3 ? "" : " " } function gr(e, t) { for (; --t && ar() && !(tr < 48 || tr > 102 || tr > 57 && tr < 65 || tr > 70 && tr < 97);); return cr(e, sr() + (t < 6 && 32 == lr() && 32 == ar())) } function hr(e) { for (; ar();)switch (tr) { case e: return er; case 34: case 39: 34 !== e && 39 !== e && hr(tr); break; case 40: 41 === e && hr(e); break; case 92: ar(); }return er } function mr(e, t) { for (; ar() && e + tr !== 57 && (e + tr !== 84 || 47 !== lr());); return "/*" + cr(t, er - 1) + "*" + Fo(47 === e ? e : ar()) } function vr(e) { for (; !pr(lr());)ar(); return cr(e, er) } function yr(e) { return dr(xr("", null, null, null, [""], e = ur(e), 0, [0], e)) } function xr(e, t, n, o, r, i, a, l, s) { for (var c = 0, p = 0, u = a, d = 0, f = 0, b = 0, g = 1, h = 1, m = 1, v = 0, y = "", x = r, w = i, C = o, I = y; h;)switch (b = v, v = ar()) { case 40: if (108 != b && 58 == I.charCodeAt(u - 1)) { -1 != Zo(I += jo(fr(v), "&", "&\f"), "&\f") && (m = -1); break } case 34: case 39: case 91: I += fr(v); break; case 9: case 10: case 13: case 32: I += br(b); break; case 92: I += gr(sr() - 1, 7); continue; case 47: switch (lr()) { case 42: case 47: Qo(Cr(mr(ar(), sr()), t, n), s); break; default: I += "/"; }break; case 123 * g: l[c++] = Jo(I) * m; case 125 * g: case 59: case 0: switch (v) { case 0: case 125: h = 0; case 59 + p: f > 0 && Jo(I) - u && Qo(f > 32 ? Ir(I + ";", o, n, u - 1) : Ir(jo(I, " ", "") + ";", o, n, u - 2), s); break; case 59: I += ";"; default: if (Qo(C = wr(I, t, n, c, p, r, l, y, x = [], w = [], u), i), 123 === v) if (0 === p) xr(I, t, C, C, x, i, u, l, w); else switch (d) { case 100: case 109: case 115: xr(e, C, C, o && Qo(wr(e, C, C, 0, 0, r, l, y, r, x = [], u), w), r, w, u, l, o ? x : w); break; default: xr(I, C, C, C, [""], w, 0, l, w); } }c = p = f = 0, g = m = 1, y = I = "", u = a; break; case 58: u = 1 + Jo(I), f = b; default: if (g < 1) if (123 == v) --g; else if (125 == v && 0 == g++ && 125 == ir()) continue; switch (I += Fo(v), v * g) { case 38: m = p > 0 ? 1 : (I += "\f", -1); break; case 44: l[c++] = (Jo(I) - 1) * m, m = 1; break; case 64: 45 === lr() && (I += fr(ar())), d = lr(), p = u = Jo(y = I += vr(sr())), v++; break; case 45: 45 === b && 2 == Jo(I) && (g = 0); } }return i } function wr(e, t, n, o, r, i, a, l, s, c, p) { for (var u = r - 1, d = 0 === r ? i : [""], f = Uo(d), b = 0, g = 0, h = 0; b < o; ++b)for (var m = 0, v = _o(e, u + 1, u = Ho(g = a[b])), y = e; m < f; ++m)(y = zo(g > 0 ? d[m] + " " + v : jo(v, /&\f/g, d[m]))) && (s[h++] = y); return or(e, t, n, 0 === r ? "rule" : l, s, c, p) } function Cr(e, t, n) { return or(e, t, n, "comm", Fo(tr), _o(e, 2, -2), 0) } function Ir(e, t, n, o) { return or(e, t, n, "decl", _o(e, 0, o), _o(e, o + 1, -1), o) } function Ar(e, t) { switch (function (e, t) { return (((t << 2 ^ Yo(e, 0)) << 2 ^ Yo(e, 1)) << 2 ^ Yo(e, 2)) << 2 ^ Yo(e, 3) }(e, t)) { case 5103: return Wo + "print-" + e + e; case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921: case 5572: case 6356: case 5844: case 3191: case 6645: case 3005: case 6391: case 5879: case 5623: case 6135: case 4599: case 4855: case 4215: case 6389: case 5109: case 5365: case 5621: case 3829: return Wo + e + e; case 5349: case 4246: case 4810: case 6968: case 2756: return Wo + e + Vo + e + Xo + e + e; case 6828: case 4268: return Wo + e + Xo + e + e; case 6165: return Wo + e + Xo + "flex-" + e + e; case 5187: return Wo + e + jo(e, /(\w+).+(:[^]+)/, "-webkit-box-$1$2-ms-flex-$1$2") + e; case 5443: return Wo + e + Xo + "flex-item-" + jo(e, /flex-|-self/, "") + e; case 4675: return Wo + e + Xo + "flex-line-pack" + jo(e, /align-content|flex-|-self/, "") + e; case 5548: return Wo + e + Xo + jo(e, "shrink", "negative") + e; case 5292: return Wo + e + Xo + jo(e, "basis", "preferred-size") + e; case 6060: return Wo + "box-" + jo(e, "-grow", "") + Wo + e + Xo + jo(e, "grow", "positive") + e; case 4554: return Wo + jo(e, /([^-])(transform)/g, "$1-webkit-$2") + e; case 6187: return jo(jo(jo(e, /(zoom-|grab)/, Wo + "$1"), /(image-set)/, Wo + "$1"), e, "") + e; case 5495: case 3959: return jo(e, /(image-set\([^]*)/, Wo + "$1$`$1"); case 4968: return jo(jo(e, /(.+:)(flex-)?(.*)/, "-webkit-box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + Wo + e + e; case 4095: case 3583: case 4068: case 2532: return jo(e, /(.+)-inline(.+)/, Wo + "$1$2") + e; case 8116: case 7059: case 5753: case 5535: case 5445: case 5701: case 4933: case 4677: case 5533: case 5789: case 5021: case 4765: if (Jo(e) - 1 - t > 6) switch (Yo(e, t + 1)) { case 109: if (45 !== Yo(e, t + 4)) break; case 102: return jo(e, /(.+:)(.+)-([^]+)/, "$1-webkit-$2-$3$1" + Vo + (108 == Yo(e, t + 3) ? "$3" : "$2-$3")) + e; case 115: return ~Zo(e, "stretch") ? Ar(jo(e, "stretch", "fill-available"), t) + e : e }break; case 4949: if (115 !== Yo(e, t + 1)) break; case 6444: switch (Yo(e, Jo(e) - 3 - (~Zo(e, "!important") && 10))) { case 107: return jo(e, ":", ":" + Wo) + e; case 101: return jo(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Wo + (45 === Yo(e, 14) ? "inline-" : "") + "box$3$1" + Wo + "$2$3$1" + Xo + "$2box$3") + e }break; case 5936: switch (Yo(e, t + 11)) { case 114: return Wo + e + Xo + jo(e, /[svh]\w+-[tblr]{2}/, "tb") + e; case 108: return Wo + e + Xo + jo(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e; case 45: return Wo + e + Xo + jo(e, /[svh]\w+-[tblr]{2}/, "lr") + e }return Wo + e + Xo + e + e }return e } function kr(e, t) { for (var n = "", o = Uo(e), r = 0; r < o; r++)n += t(e[r], r, e, t) || ""; return n } function Or(e, t, n, o) { switch (e.type) { case "@import": case "decl": return e.return = e.return || e.value; case "comm": return ""; case "@keyframes": return e.return = e.value + "{" + kr(e.children, o) + "}"; case "rule": e.value = e.props.join(","); }return Jo(n = kr(e.children, o)) ? e.return = e.value + "{" + n + "}" : "" } function Tr(e) { var t = Uo(e); return function (n, o, r, i) { for (var a = "", l = 0; l < t; l++)a += e[l](n, o, r, i) || ""; return a } } function Er(e) { var t = Object.create(null); return function (n) { return void 0 === t[n] && (t[n] = e(n)), t[n] } } var Sr, Br, Gr = function (e, t, n) { for (var o = 0, r = 0; o = r, r = lr(), 38 === o && 12 === r && (t[n] = 1), !pr(r);)ar(); return cr(e, er) }, Nr = function (e, t) { return dr(function (e, t) { var n = -1, o = 44; do { switch (pr(o)) { case 0: 38 === o && 12 === lr() && (t[n] = 1), e[n] += Gr(er - 1, t, n); break; case 2: e[n] += fr(o); break; case 4: if (44 === o) { e[++n] = 58 === lr() ? "&\f" : "", t[n] = e[n].length; break } default: e[n] += Fo(o); } } while (o = ar()); return e }(ur(e), t)) }, Pr = new WeakMap, Rr = function (e) { if ("rule" === e.type && e.parent && !(e.length < 1)) { for (var t = e.value, n = e.parent, o = e.column === n.column && e.line === n.line; "rule" !== n.type;)if (!(n = n.parent)) return; if ((1 !== e.props.length || 58 === t.charCodeAt(0) || Pr.get(n)) && !o) { Pr.set(e, !0); for (var r = [], i = Nr(t, r), a = n.props, l = 0, s = 0; l < i.length; l++)for (var c = 0; c < a.length; c++, s++)e.props[s] = r[l] ? i[l].replace(/&\f/g, a[c]) : a[c] + " " + i[l]; } } }, Mr = function (e) { if ("decl" === e.type) { var t = e.value; 108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (e.return = "", e.value = ""); } }, Lr = function (e) { return 105 === e.type.charCodeAt(1) && 64 === e.type.charCodeAt(0) }, Xr = function (e) { e.type = "", e.value = "", e.return = "", e.children = "", e.props = ""; }, Vr = function (e, t, n) { Lr(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Xr(e)) : function (e, t) { for (var n = e - 1; n >= 0; n--)if (!Lr(t[n])) return !0; return !1 }(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Xr(e))); }, Wr = "undefined" != typeof document, Hr = Wr ? void 0 : (Sr = function () { return Er((function () { var e = {}; return function (t) { return e[t] } })) }, Br = new WeakMap, function (e) { if (Br.has(e)) return Br.get(e); var t = Sr(e); return Br.set(e, t), t }), Fr = [function (e, t, n, o) { if (e.length > -1 && !e.return) switch (e.type) { case "decl": e.return = Ar(e.value, e.length); break; case "@keyframes": return kr([rr(e, { value: jo(e.value, "@", "@" + Wo) })], o); case "rule": if (e.length) return function (e, t) { return e.map(t).join("") }(e.props, (function (t) { switch (function (e, t) { return (e = t.exec(e)) ? e[0] : e }(t, /(::plac\w+|:read-\w+)/)) { case ":read-only": case ":read-write": return kr([rr(e, { props: [jo(t, /:(read-\w+)/, ":-moz-$1")] })], o); case "::placeholder": return kr([rr(e, { props: [jo(t, /:(plac\w+)/, ":-webkit-input-$1")] }), rr(e, { props: [jo(t, /:(plac\w+)/, ":-moz-$1")] }), rr(e, { props: [jo(t, /:(plac\w+)/, Xo + "input-$1")] })], o) }return "" })) } }], Dr = function (e) { var t = e.key; if ("production" !== process.env.NODE_ENV && !t) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements."); if (Wr && "css" === t) { var n = document.querySelectorAll("style[data-emotion]:not([data-s])"); Array.prototype.forEach.call(n, (function (e) { -1 !== e.getAttribute("data-emotion").indexOf(" ") && (document.head.appendChild(e), e.setAttribute("data-s", "")); })); } var o = e.stylisPlugins || Fr; if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed'); var r, i, a = {}, l = []; Wr && (r = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), (function (e) { for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++)a[t[n]] = !0; l.push(e); }))); var s, c = [Rr, Mr]; if ("production" !== process.env.NODE_ENV && c.push(function (e) { return function (t, n, o) { if ("rule" === t.type) { var r, i = t.value.match(/(:first|:nth|:nth-last)-child/g); if (i && !0 !== e.compat) { var a = n > 0 ? o[n - 1] : null; if (a && function (e) { return !!e && "comm" === e.type && e.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1 }((r = a.children).length ? r[r.length - 1] : null)) return; i.forEach((function (e) { console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".'); })); } } } }({ get compat() { return m.compat } }), Vr), Wr) { var p, u = [Or, "production" !== process.env.NODE_ENV ? function (e) { e.root || (e.return ? p.insert(e.return) : e.value && "comm" !== e.type && p.insert(e.value + "{}")); } : (s = function (e) { p.insert(e); }, function (e) { e.root || (e = e.return) && s(e); })], d = Tr(c.concat(o, u)); i = function (e, t, n, o) { p = n, "production" !== process.env.NODE_ENV && void 0 !== t.map && (p = { insert: function (e) { n.insert(e + t.map); } }), kr(yr(e ? e + "{" + t.styles + "}" : t.styles), d), o && (m.inserted[t.name] = !0); }; } else { var f = [Or], b = Tr(c.concat(o, f)), g = Hr(o)(t), h = function (e, t) { var n = t.name; return void 0 === g[n] && (g[n] = kr(yr(e ? e + "{" + t.styles + "}" : t.styles), b)), g[n] }; i = function (e, t, n, o) { var r = t.name, i = h(e, t); return void 0 === m.compat ? (o && (m.inserted[r] = !0), "development" === process.env.NODE_ENV && void 0 !== t.map ? i + t.map : i) : o ? void (m.inserted[r] = i) : i }; } var m = { key: t, sheet: new Lo({ key: t, container: r, nonce: e.nonce, speedy: e.speedy, prepend: e.prepend, insertionPoint: e.insertionPoint }), nonce: e.nonce, inserted: a, registered: {}, insert: i }; return m.sheet.hydrate(l), m }, zr = { exports: {} }, jr = {}, Zr = "function" == typeof Symbol && Symbol.for, Yr = Zr ? Symbol.for("react.element") : 60103, _r = Zr ? Symbol.for("react.portal") : 60106, Jr = Zr ? Symbol.for("react.fragment") : 60107, Ur = Zr ? Symbol.for("react.strict_mode") : 60108, Qr = Zr ? Symbol.for("react.profiler") : 60114, Kr = Zr ? Symbol.for("react.provider") : 60109, qr = Zr ? Symbol.for("react.context") : 60110, $r = Zr ? Symbol.for("react.async_mode") : 60111, ei = Zr ? Symbol.for("react.concurrent_mode") : 60111, ti = Zr ? Symbol.for("react.forward_ref") : 60112, ni = Zr ? Symbol.for("react.suspense") : 60113, oi = Zr ? Symbol.for("react.suspense_list") : 60120, ri = Zr ? Symbol.for("react.memo") : 60115, ii = Zr ? Symbol.for("react.lazy") : 60116, ai = Zr ? Symbol.for("react.block") : 60121, li = Zr ? Symbol.for("react.fundamental") : 60117, si = Zr ? Symbol.for("react.responder") : 60118, ci = Zr ? Symbol.for("react.scope") : 60119; function pi(e) { if ("object" == typeof e && null !== e) { var t = e.$$typeof; switch (t) { case Yr: switch (e = e.type) { case $r: case ei: case Jr: case Qr: case Ur: case ni: return e; default: switch (e = e && e.$$typeof) { case qr: case ti: case ii: case ri: case Kr: return e; default: return t } }case _r: return t } } } function ui(e) { return pi(e) === ei } jr.AsyncMode = $r, jr.ConcurrentMode = ei, jr.ContextConsumer = qr, jr.ContextProvider = Kr, jr.Element = Yr, jr.ForwardRef = ti, jr.Fragment = Jr, jr.Lazy = ii, jr.Memo = ri, jr.Portal = _r, jr.Profiler = Qr, jr.StrictMode = Ur, jr.Suspense = ni, jr.isAsyncMode = function (e) { return ui(e) || pi(e) === $r }, jr.isConcurrentMode = ui, jr.isContextConsumer = function (e) { return pi(e) === qr }, jr.isContextProvider = function (e) { return pi(e) === Kr }, jr.isElement = function (e) { return "object" == typeof e && null !== e && e.$$typeof === Yr }, jr.isForwardRef = function (e) { return pi(e) === ti }, jr.isFragment = function (e) { return pi(e) === Jr }, jr.isLazy = function (e) { return pi(e) === ii }, jr.isMemo = function (e) { return pi(e) === ri }, jr.isPortal = function (e) { return pi(e) === _r }, jr.isProfiler = function (e) { return pi(e) === Qr }, jr.isStrictMode = function (e) { return pi(e) === Ur }, jr.isSuspense = function (e) { return pi(e) === ni }, jr.isValidElementType = function (e) { return "string" == typeof e || "function" == typeof e || e === Jr || e === ei || e === Qr || e === Ur || e === ni || e === oi || "object" == typeof e && null !== e && (e.$$typeof === ii || e.$$typeof === ri || e.$$typeof === Kr || e.$$typeof === qr || e.$$typeof === ti || e.$$typeof === li || e.$$typeof === si || e.$$typeof === ci || e.$$typeof === ai) }, jr.typeOf = pi; var di = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */"production" !== process.env.NODE_ENV && function () { var e = "function" == typeof Symbol && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119; function y(e) { if ("object" == typeof e && null !== e) { var d = e.$$typeof; switch (d) { case t: var g = e.type; switch (g) { case s: case c: case o: case i: case r: case u: return g; default: var h = g && g.$$typeof; switch (h) { case l: case p: case b: case f: case a: return h; default: return d } }case n: return d } } } var x = s, w = c, C = l, I = a, A = t, k = p, O = o, T = b, E = f, S = n, B = i, G = r, N = u, P = !1; function R(e) { return y(e) === c } di.AsyncMode = x, di.ConcurrentMode = w, di.ContextConsumer = C, di.ContextProvider = I, di.Element = A, di.ForwardRef = k, di.Fragment = O, di.Lazy = T, di.Memo = E, di.Portal = S, di.Profiler = B, di.StrictMode = G, di.Suspense = N, di.isAsyncMode = function (e) { return P || (P = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(e) || y(e) === s }, di.isConcurrentMode = R, di.isContextConsumer = function (e) { return y(e) === l }, di.isContextProvider = function (e) { return y(e) === a }, di.isElement = function (e) { return "object" == typeof e && null !== e && e.$$typeof === t }, di.isForwardRef = function (e) { return y(e) === p }, di.isFragment = function (e) { return y(e) === o }, di.isLazy = function (e) { return y(e) === b }, di.isMemo = function (e) { return y(e) === f }, di.isPortal = function (e) { return y(e) === n }, di.isProfiler = function (e) { return y(e) === i }, di.isStrictMode = function (e) { return y(e) === r }, di.isSuspense = function (e) { return y(e) === u }, di.isValidElementType = function (e) { return "string" == typeof e || "function" == typeof e || e === o || e === c || e === i || e === r || e === u || e === d || "object" == typeof e && null !== e && (e.$$typeof === b || e.$$typeof === f || e.$$typeof === a || e.$$typeof === l || e.$$typeof === p || e.$$typeof === h || e.$$typeof === m || e.$$typeof === v || e.$$typeof === g) }, di.typeOf = y; }(), "production" === process.env.NODE_ENV ? zr.exports = jr : zr.exports = di; var fi = zr.exports, bi = {}; bi[fi.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, bi[fi.Memo] = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }; var gi = "undefined" != typeof document; function hi(e, t, n) { var o = ""; return n.split(" ").forEach((function (n) { void 0 !== e[n] ? t.push(e[n] + ";") : o += n + " "; })), o } var mi = function (e, t, n) { var o = e.key + "-" + t.name; if ((!1 === n || !1 === gi && void 0 !== e.compat) && void 0 === e.registered[o] && (e.registered[o] = t.styles), void 0 === e.inserted[t.name]) { var r = "", i = t; do { var a = e.insert(t === i ? "." + o : "", i, e.sheet, !0); gi || void 0 === a || (r += a), i = i.next; } while (void 0 !== i); if (!gi && 0 !== r.length) return r } }; var vi = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 }, yi = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences", xi = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", wi = /[A-Z]|^ms/g, Ci = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Ii = function (e) { return 45 === e.charCodeAt(1) }, Ai = function (e) { return null != e && "boolean" != typeof e }, ki = Er((function (e) { return Ii(e) ? e : e.replace(wi, "-$&").toLowerCase() })), Oi = function (e, t) { switch (e) { case "animation": case "animationName": if ("string" == typeof t) return t.replace(Ci, (function (e, t, n) { return Mi = { name: t, styles: n, next: Mi }, t })) }return 1 === vi[e] || Ii(e) || "number" != typeof t || 0 === t ? t : t + "px" }; if ("production" !== process.env.NODE_ENV) { var Ti = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Ei = ["normal", "none", "initial", "inherit", "unset"], Si = Oi, Bi = /^-ms-/, Gi = /-(.)/g, Ni = {}; Oi = function (e, t) { if ("content" === e && ("string" != typeof t || -1 === Ei.indexOf(t) && !Ti.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0)))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`"); var n = Si(e, t); return "" === n || Ii(e) || -1 === e.indexOf("-") || void 0 !== Ni[e] || (Ni[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(Bi, "ms-").replace(Gi, (function (e, t) { return t.toUpperCase() })) + "?")), n }; } function Pi(e, t, n) { if (null == n) return ""; if (void 0 !== n.__emotion_styles) { if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === n.toString()) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin."); return n } switch (typeof n) { case "boolean": return ""; case "object": if (1 === n.anim) return Mi = { name: n.name, styles: n.styles, next: Mi }, n.name; if (void 0 !== n.styles) { var o = n.next; if (void 0 !== o) for (; void 0 !== o;)Mi = { name: o.name, styles: o.styles, next: Mi }, o = o.next; var r = n.styles + ";"; return "production" !== process.env.NODE_ENV && void 0 !== n.map && (r += n.map), r } return function (e, t, n) { var o = ""; if (Array.isArray(n)) for (var r = 0; r < n.length; r++)o += Pi(e, t, n[r]) + ";"; else for (var i in n) { var a = n[i]; if ("object" != typeof a) null != t && void 0 !== t[a] ? o += i + "{" + t[a] + "}" : Ai(a) && (o += ki(i) + ":" + Oi(i, a) + ";"); else { if ("NO_COMPONENT_SELECTOR" === i && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin."); if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) { var l = Pi(e, t, a); switch (i) { case "animation": case "animationName": o += ki(i) + ":" + l + ";"; break; default: "production" !== process.env.NODE_ENV && "undefined" === i && console.error(xi), o += i + "{" + l + "}"; } } else for (var s = 0; s < a.length; s++)Ai(a[s]) && (o += ki(i) + ":" + Oi(i, a[s]) + ";"); } } return o }(e, t, n); case "function": if (void 0 !== e) { var i = Mi, a = n(e); return Mi = i, Pi(e, t, a) } "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`"); break; case "string": if ("production" !== process.env.NODE_ENV) { var l = [], s = n.replace(Ci, (function (e, t, n) { var o = "animation" + l.length; return l.push("const " + o + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + o + "}" })); l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + s + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + s + "`"); } }if (null == t) return n; var c = t[n]; return void 0 !== c ? c : n } var Ri, Mi, Li = /label:\s*([^\s;\n{]+)\s*(;|$)/g; "production" !== process.env.NODE_ENV && (Ri = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g); var Xi = function (e, t, n) { if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0]; var o = !0, r = ""; Mi = void 0; var i, a = e[0]; null == a || void 0 === a.raw ? (o = !1, r += Pi(n, t, a)) : ("production" !== process.env.NODE_ENV && void 0 === a[0] && console.error(yi), r += a[0]); for (var l = 1; l < e.length; l++)r += Pi(n, t, e[l]), o && ("production" !== process.env.NODE_ENV && void 0 === a[l] && console.error(yi), r += a[l]); "production" !== process.env.NODE_ENV && (r = r.replace(Ri, (function (e) { return i = e, "" }))), Li.lastIndex = 0; for (var s, c = ""; null !== (s = Li.exec(r));)c += "-" + s[1]; var p = function (e) { for (var t, n = 0, o = 0, r = e.length; r >= 4; ++o, r -= 4)t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(o) | (255 & e.charCodeAt(++o)) << 8 | (255 & e.charCodeAt(++o)) << 16 | (255 & e.charCodeAt(++o)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16); switch (r) { case 3: n ^= (255 & e.charCodeAt(o + 2)) << 16; case 2: n ^= (255 & e.charCodeAt(o + 1)) << 8; case 1: n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(o))) + (59797 * (n >>> 16) << 16); }return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36) }(r) + c; return "production" !== process.env.NODE_ENV ? { name: p, styles: r, map: i, next: Mi, toString: function () { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)." } } : { name: p, styles: r, next: Mi } }, Vi = "undefined" != typeof document, Wi = {}.hasOwnProperty, Hi = createContext("undefined" != typeof HTMLElement ? Dr({ key: "css" }) : null); "production" !== process.env.NODE_ENV && (Hi.displayName = "EmotionCacheContext"), Hi.Provider; var Fi = function (e) { return forwardRef((function (t, n) { var o = useContext(Hi); return e(t, o, n) })) }; Vi || (Fi = function (e) { return function (t) { var n = useContext(Hi); return null === n ? (n = Dr({ key: "css" }), createElement(Hi.Provider, { value: n }, e(t, n))) : e(t, n) } }); var Di = createContext({}); "production" !== process.env.NODE_ENV && (Di.displayName = "EmotionThemeContext"); var zi = function (e) { var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(e); if (t) { var n = t[1].split("."); return n[n.length - 1] } if (t = /^([A-Za-z0-9$.]+)@/.exec(e)) return t[1] }, ji = new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Zi = function (e) { return e.replace(/\$/g, "-") }, Yi = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", _i = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Ji = function (e, t) { if ("production" !== process.env.NODE_ENV && "string" == typeof t.css && -1 !== t.css.indexOf(":")) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`"); var n = {}; for (var o in t) Wi.call(t, o) && (n[o] = t[o]); if (n[Yi] = e, "production" !== process.env.NODE_ENV && t.css && ("object" != typeof t.css || "string" != typeof t.css.name || -1 === t.css.name.indexOf("-"))) { var r = function (e) { if (e) for (var t = e.split("\n"), n = 0; n < t.length; n++) { var o = zi(t[n]); if (o) { if (ji.has(o)) break; if (/^[A-Z]/.test(o)) return Zi(o) } } }((new Error).stack); r && (n[_i] = r); } return n }, Ui = function () { return null }, Qi = Fi((function (e, t, n) { var o = e.css; "string" == typeof o && void 0 !== t.registered[o] && (o = t.registered[o]); var r = e[Yi], i = [o], a = ""; "string" == typeof e.className ? a = hi(t.registered, i, e.className) : null != e.className && (a = e.className + " "); var l = Xi(i, void 0, useContext(Di)); if ("production" !== process.env.NODE_ENV && -1 === l.name.indexOf("-")) { var s = e[_i]; s && (l = Xi([l, "label:" + s + ";"])); } var c = mi(t, l, "string" == typeof r); a += t.key + "-" + l.name; var p = {}; for (var f in e) !Wi.call(e, f) || "css" === f || f === Yi || "production" !== process.env.NODE_ENV && f === _i || (p[f] = e[f]); p.ref = n, p.className = a; var g = createElement(r, p), h = createElement(Ui, null); if (!Vi && void 0 !== c) { for (var m, v = l.name, y = l.next; void 0 !== y;)v += " " + y.name, y = y.next; h = createElement("style", ((m = {})["data-emotion"] = t.key + " " + v, m.dangerouslySetInnerHTML = { __html: c }, m.nonce = t.sheet.nonce, m)); } return createElement(Fragment, null, h, g) })); "production" !== process.env.NODE_ENV && (Qi.displayName = "EmotionCssPropInternal"); var Ki = function (e, t) { var n = arguments; if (null == t || !Wi.call(t, "css")) return createElement.apply(void 0, n); var o = n.length, r = new Array(o); r[0] = Qi, r[1] = Ji(e, t); for (var i = 2; i < o; i++)r[i] = n[i]; return createElement.apply(null, r) }, qi = !1, $i = Fi((function (e, t) { "production" === process.env.NODE_ENV || qi || !e.className && !e.css || (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), qi = !0); var n = e.styles, o = Xi([n], void 0, useContext(Di)); if (!Vi) { for (var r, i = o.name, a = o.styles, l = o.next; void 0 !== l;)i += " " + l.name, a += l.styles, l = l.next; var s = !0 === t.compat, c = t.insert("", { name: i, styles: a }, t.sheet, s); return s ? null : createElement("style", ((r = {})["data-emotion"] = t.key + "-global " + i, r.dangerouslySetInnerHTML = { __html: c }, r.nonce = t.sheet.nonce, r)) } var p = useRef(); return useLayoutEffect((function () { var e = t.key + "-global", n = new Lo({ key: e, nonce: t.sheet.nonce, container: t.sheet.container, speedy: t.sheet.isSpeedy }), r = !1, i = document.querySelector('style[data-emotion="' + e + " " + o.name + '"]'); return t.sheet.tags.length && (n.before = t.sheet.tags[0]), null !== i && (r = !0, i.setAttribute("data-emotion", e), n.hydrate([i])), p.current = [n, r], function () { n.flush(); } }), [t]), useLayoutEffect((function () { var e = p.current, n = e[0]; if (e[1]) e[1] = !1; else { if (void 0 !== o.next && mi(t, o.next, !0), n.tags.length) { var r = n.tags[n.tags.length - 1].nextElementSibling; n.before = r, n.flush(); } t.insert("", o, n, !1); } }), [t, o.name]), null })); function ea() { for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n]; return Xi(t) } "production" !== process.env.NODE_ENV && ($i.displayName = "EmotionGlobal"); var ta = function e(t) { for (var n = t.length, o = 0, r = ""; o < n; o++) { var i = t[o]; if (null != i) { var a = void 0; switch (typeof i) { case "boolean": break; case "object": if (Array.isArray(i)) a = e(i); else for (var l in "production" !== process.env.NODE_ENV && void 0 !== i.styles && void 0 !== i.name && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "", i) i[l] && l && (a && (a += " "), a += l); break; default: a = i; }a && (r && (r += " "), r += a); } } return r }; function na(e, t, n) { var o = [], r = hi(e, o, n); return o.length < 2 ? n : r + t(o) } var oa = function () { return null }, ra = Fi((function (e, t) { var n = "", o = "", r = !1, i = function () { if (r && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render"); for (var e = arguments.length, i = new Array(e), a = 0; a < e; a++)i[a] = arguments[a]; var l = Xi(i, t.registered); if (Vi) mi(t, l, !1); else { var s = mi(t, l, !1); void 0 !== s && (n += s); } return Vi || (o += " " + l.name), t.key + "-" + l.name }, a = { css: i, cx: function () { if (r && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render"); for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++)n[o] = arguments[o]; return na(t.registered, i, ta(n)) }, theme: useContext(Di) }, l = e.children(a); r = !0; var s, c = createElement(oa, null); Vi || 0 === n.length || (c = createElement("style", ((s = {})["data-emotion"] = t.key + " " + o.substring(1), s.dangerouslySetInnerHTML = { __html: n }, s.nonce = t.sheet.nonce, s))); return createElement(Fragment, null, c, l) })); if ("production" !== process.env.NODE_ENV && (ra.displayName = "EmotionClassNames"), "production" !== process.env.NODE_ENV) { var ia = "undefined" != typeof document, aa = "undefined" != typeof jest; if (ia && !aa) { var la = "undefined" != typeof globalThis ? globalThis : ia ? window : global, sa = "__EMOTION_REACT_" + "11.7.1".split(".")[0] + "__"; la[sa] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), la[sa] = !0; } } function ca(e, t) { if (null == e) return {}; var n, o, r = function (e, t) { if (null == e) return {}; var n, o, r = {}, i = Object.keys(e); for (o = 0; o < i.length; o++)n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]); return r }(e, t); if (Object.getOwnPropertySymbols) { var i = Object.getOwnPropertySymbols(e); for (o = 0; o < i.length; o++)n = i[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]); } return r } function pa(e) { return pa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e }, pa(e) } function ua(e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") } function da(e, t) { for (var n = 0; n < t.length; n++) { var o = t[n]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o); } } function fa(e, t, n) { return t && da(e.prototype, t), n && da(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e } function ba(e, t) { return ba = Object.setPrototypeOf || function (e, t) { return e.__proto__ = t, e }, ba(e, t) } function ga(e, t) { if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function"); e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ba(e, t); } function ha(e, t, n) { return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e } function ma(e, t, n) { return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e } function va(e, t) { var n = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); t && (o = o.filter((function (t) { return Object.getOwnPropertyDescriptor(e, t).enumerable }))), n.push.apply(n, o); } return n } function ya(e) { for (var t = 1; t < arguments.length; t++) { var n = null != arguments[t] ? arguments[t] : {}; t % 2 ? va(Object(n), !0).forEach((function (t) { ma(e, t, n[t]); })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : va(Object(n)).forEach((function (t) { Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t)); })); } return e } function xa(e) { return xa = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) { return e.__proto__ || Object.getPrototypeOf(e) }, xa(e) } function wa(e, t) { return !t || "object" != typeof t && "function" != typeof t ? function (e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e }(e) : t } function Ca(e) { var t = function () { if ("undefined" == typeof Reflect || !Reflect.construct) return !1; if (Reflect.construct.sham) return !1; if ("function" == typeof Proxy) return !0; try { return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0 } catch (e) { return !1 } }(); return function () { var n, o = xa(e); if (t) { var r = xa(this).constructor; n = Reflect.construct(o, arguments, r); } else n = o.apply(this, arguments); return wa(this, n) } } var Ia = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Aa = function () { }; function ka(e, t) { return t ? "-" === t[0] ? e + t : e + "__" + t : e } function Oa(e, t, n) { var o = [n]; if (t && e) for (var r in t) t.hasOwnProperty(r) && t[r] && o.push("".concat(ka(e, r))); return o.filter((function (e) { return e })).map((function (e) { return String(e).trim() })).join(" ") } var Ta = function (e) { return t = e, Array.isArray(t) ? e.filter(Boolean) : "object" === pa(e) && null !== e ? [e] : []; var t; }, Ea = function (e) { return e.className, e.clearValue, e.cx, e.getStyles, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, ya({}, ca(e, Ia)) }; function Sa(e) { return [document.documentElement, document.body, window].indexOf(e) > -1 } function Ba(e) { return Sa(e) ? window.pageYOffset : e.scrollTop } function Ga(e, t) { Sa(e) ? window.scrollTo(0, t) : e.scrollTop = t; } function Na(e, t, n, o) { return n * ((e = e / o - 1) * e * e + 1) + t } function Pa(e, t) { var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 200, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Aa, r = Ba(e), i = t - r, a = 10, l = 0; function s() { var t = Na(l += a, r, i, n); Ga(e, t), l < n ? window.requestAnimationFrame(s) : o(e); } s(); } function Ra() { try { return document.createEvent("TouchEvent"), !0 } catch (e) { return !1 } } var Ma = !1, La = { get passive() { return Ma = !0 } }, Xa = "undefined" != typeof window ? window : {}; Xa.addEventListener && Xa.removeEventListener && (Xa.addEventListener("p", Aa, La), Xa.removeEventListener("p", Aa, !1)); var Va = Ma; function Wa(e) { return null != e } function Ha(e, t, n) { return e ? t : n } function Fa(e) { var t = e.maxHeight, n = e.menuEl, o = e.minHeight, r = e.placement, i = e.shouldScroll, a = e.isFixedPosition, l = e.theme.spacing, s = function (e) { var t = getComputedStyle(e), n = "absolute" === t.position, o = /(auto|scroll)/; if ("fixed" === t.position) return document.documentElement; for (var r = e; r = r.parentElement;)if (t = getComputedStyle(r), (!n || "static" !== t.position) && o.test(t.overflow + t.overflowY + t.overflowX)) return r; return document.documentElement }(n), c = { placement: "bottom", maxHeight: t }; if (!n || !n.offsetParent) return c; var p = s.getBoundingClientRect().height, u = n.getBoundingClientRect(), d = u.bottom, f = u.height, b = u.top, g = n.offsetParent.getBoundingClientRect().top, h = window.innerHeight, m = Ba(s), v = parseInt(getComputedStyle(n).marginBottom, 10), y = parseInt(getComputedStyle(n).marginTop, 10), x = g - y, w = h - b, C = x + m, I = p - m - b, A = d - h + m + v, k = m + b - y, O = 160; switch (r) { case "auto": case "bottom": if (w >= f) return { placement: "bottom", maxHeight: t }; if (I >= f && !a) return i && Pa(s, A, O), { placement: "bottom", maxHeight: t }; if (!a && I >= o || a && w >= o) return i && Pa(s, A, O), { placement: "bottom", maxHeight: a ? w - v : I - v }; if ("auto" === r || a) { var T = t, E = a ? x : C; return E >= o && (T = Math.min(E - v - l.controlHeight, t)), { placement: "top", maxHeight: T } } if ("bottom" === r) return i && Ga(s, A), { placement: "bottom", maxHeight: t }; break; case "top": if (x >= f) return { placement: "top", maxHeight: t }; if (C >= f && !a) return i && Pa(s, k, O), { placement: "top", maxHeight: t }; if (!a && C >= o || a && x >= o) { var S = t; return (!a && C >= o || a && x >= o) && (S = a ? x - y : C - y), i && Pa(s, k, O), { placement: "top", maxHeight: S } } return { placement: "bottom", maxHeight: t }; default: throw new Error('Invalid placement provided "'.concat(r, '".')) }return c } var Da = function (e) { return "auto" === e ? "bottom" : e }, za = createContext({ getPortalPlacement: null }), ja = function (e) { ga(n, Component); var t = Ca(n); function n() { var e; ua(this, n); for (var o = arguments.length, r = new Array(o), i = 0; i < o; i++)r[i] = arguments[i]; return (e = t.call.apply(t, [this].concat(r))).state = { maxHeight: e.props.maxMenuHeight, placement: null }, e.context = void 0, e.getPlacement = function (t) { var n = e.props, o = n.minMenuHeight, r = n.maxMenuHeight, i = n.menuPlacement, a = n.menuPosition, l = n.menuShouldScrollIntoView, s = n.theme; if (t) { var c = "fixed" === a, p = Fa({ maxHeight: r, menuEl: t, minHeight: o, placement: i, shouldScroll: l && !c, isFixedPosition: c, theme: s }), u = e.context.getPortalPlacement; u && u(p), e.setState(p); } }, e.getUpdatedProps = function () { var t = e.props.menuPlacement, n = e.state.placement || Da(t); return ya(ya({}, e.props), {}, { placement: n, maxHeight: e.state.maxHeight }) }, e } return fa(n, [{ key: "render", value: function () { return (0, this.props.children)({ ref: this.getPlacement, placerProps: this.getUpdatedProps() }) } }]), n }(); ja.contextType = za; var Za = function (e) { var t = e.theme, n = t.spacing.baseUnit; return { color: t.colors.neutral40, padding: "".concat(2 * n, "px ").concat(3 * n, "px"), textAlign: "center" } }, Ya = Za, _a$3 = Za, Ja = function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerProps; return Ki("div", Mo({ css: r("noOptionsMessage", e), className: o({ "menu-notice": !0, "menu-notice--no-options": !0 }, n) }, i), t) }; Ja.defaultProps = { children: "No options" }; var Ua = function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerProps; return Ki("div", Mo({ css: r("loadingMessage", e), className: o({ "menu-notice": !0, "menu-notice--loading": !0 }, n) }, i), t) }; Ua.defaultProps = { children: "Loading..." }; var Qa, Ka = function (e) { ga(n, Component); var t = Ca(n); function n() { var e; ua(this, n); for (var o = arguments.length, r = new Array(o), i = 0; i < o; i++)r[i] = arguments[i]; return (e = t.call.apply(t, [this].concat(r))).state = { placement: null }, e.getPortalPlacement = function (t) { var n = t.placement; n !== Da(e.props.menuPlacement) && e.setState({ placement: n }); }, e } return fa(n, [{ key: "render", value: function () { var e = this.props, t = e.appendTo, n = e.children, o = e.className, r = e.controlElement, i = e.cx, a = e.innerProps, l = e.menuPlacement, s = e.menuPosition, c = e.getStyles, p = "fixed" === s; if (!t && !p || !r) return null; var u = this.state.placement || Da(l), d = function (e) { var t = e.getBoundingClientRect(); return { bottom: t.bottom, height: t.height, left: t.left, right: t.right, top: t.top, width: t.width } }(r), f = p ? 0 : window.pageYOffset, b = d[u] + f, g = Ki("div", Mo({ css: c("menuPortal", { offset: b, position: s, rect: d }), className: i({ "menu-portal": !0 }, o) }, a), n); return Ki(za.Provider, { value: { getPortalPlacement: this.getPortalPlacement } }, t ? createPortal(g, t) : g) } }]), n }(), qa = ["size"]; var $a, el, tl = "production" === process.env.NODE_ENV ? { name: "8mmkcg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0" } : { name: "tj5bde-Svg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: function () { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)." } }, nl = function (e) { var t = e.size, n = ca(e, qa); return Ki("svg", Mo({ height: t, width: t, viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", css: tl }, n)) }, ol = function (e) { return Ki(nl, Mo({ size: 20 }, e), Ki("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" })) }, rl = function (e) { return Ki(nl, Mo({ size: 20 }, e), Ki("path", { d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" })) }, il = function (e) { var t = e.isFocused, n = e.theme, o = n.spacing.baseUnit, r = n.colors; return { label: "indicatorContainer", color: t ? r.neutral60 : r.neutral20, display: "flex", padding: 2 * o, transition: "color 150ms", ":hover": { color: t ? r.neutral80 : r.neutral40 } } }, al = il, ll = il, sl = function () { var e = ea.apply(void 0, arguments), t = "animation-" + e.name; return { name: t, styles: "@keyframes " + t + "{" + e.styles + "}", anim: 1, toString: function () { return "_EMO_" + this.name + "_" + this.styles + "_EMO_" } } }(Qa || ($a = ["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"], el || (el = $a.slice(0)), Qa = Object.freeze(Object.defineProperties($a, { raw: { value: Object.freeze(el) } })))), cl = function (e) { var t = e.delay, n = e.offset; return Ki("span", { css: ea({ animation: "".concat(sl, " 1s ease-in-out ").concat(t, "ms infinite;"), backgroundColor: "currentColor", borderRadius: "1em", display: "inline-block", marginLeft: n ? "1em" : void 0, height: "1em", verticalAlign: "top", width: "1em" }, "production" === process.env.NODE_ENV ? "" : ";label:LoadingDot;", "production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") }) }, pl = function (e) { var t = e.className, n = e.cx, o = e.getStyles, r = e.innerProps, i = e.isRtl; return Ki("div", Mo({ css: o("loadingIndicator", e), className: n({ indicator: !0, "loading-indicator": !0 }, t) }, r), Ki(cl, { delay: 0, offset: i }), Ki(cl, { delay: 160, offset: !0 }), Ki(cl, { delay: 320, offset: !i })) }; pl.defaultProps = { size: 4 }; var ul = ["data"], dl = ["innerRef", "isDisabled", "isHidden", "inputClassName"], fl = { gridArea: "1 / 2", font: "inherit", minWidth: "2px", border: 0, margin: 0, outline: 0, padding: 0 }, bl = { flex: "1 1 auto", display: "inline-grid", gridArea: "1 / 1 / 2 / 3", gridTemplateColumns: "0 min-content", "&:after": ya({ content: 'attr(data-value) " "', visibility: "hidden", whiteSpace: "pre" }, fl) }, gl = function (e) { return ya({ label: "input", color: "inherit", background: 0, opacity: e ? 0 : 1, width: "100%" }, fl) }, hl = function (e) { var t = e.children, n = e.innerProps; return Ki("div", n, t) }; var ml = { ClearIndicator: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerProps; return Ki("div", Mo({ css: r("clearIndicator", e), className: o({ indicator: !0, "clear-indicator": !0 }, n) }, i), t || Ki(ol, null)) }, Control: function (e) { var t = e.children, n = e.cx, o = e.getStyles, r = e.className, i = e.isDisabled, a = e.isFocused, l = e.innerRef, s = e.innerProps, c = e.menuIsOpen; return Ki("div", Mo({ ref: l, css: o("control", e), className: n({ control: !0, "control--is-disabled": i, "control--is-focused": a, "control--menu-is-open": c }, r) }, s), t) }, DropdownIndicator: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerProps; return Ki("div", Mo({ css: r("dropdownIndicator", e), className: o({ indicator: !0, "dropdown-indicator": !0 }, n) }, i), t || Ki(rl, null)) }, DownChevron: rl, CrossIcon: ol, Group: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.Heading, a = e.headingProps, l = e.innerProps, s = e.label, c = e.theme, p = e.selectProps; return Ki("div", Mo({ css: r("group", e), className: o({ group: !0 }, n) }, l), Ki(i, Mo({}, a, { selectProps: p, theme: c, getStyles: r, cx: o }), s), Ki("div", null, t)) }, GroupHeading: function (e) { var t = e.getStyles, n = e.cx, o = e.className, r = Ea(e); r.data; var i = ca(r, ul); return Ki("div", Mo({ css: t("groupHeading", e), className: n({ "group-heading": !0 }, o) }, i)) }, IndicatorsContainer: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.innerProps, i = e.getStyles; return Ki("div", Mo({ css: i("indicatorsContainer", e), className: o({ indicators: !0 }, n) }, r), t) }, IndicatorSeparator: function (e) { var t = e.className, n = e.cx, o = e.getStyles, r = e.innerProps; return Ki("span", Mo({}, r, { css: o("indicatorSeparator", e), className: n({ "indicator-separator": !0 }, t) })) }, Input: function (e) { var t = e.className, n = e.cx, o = e.getStyles, r = e.value, i = Ea(e), a = i.innerRef, l = i.isDisabled, s = i.isHidden, c = i.inputClassName, p = ca(i, dl); return Ki("div", { className: n({ "input-container": !0 }, t), css: o("input", e), "data-value": r || "" }, Ki("input", Mo({ className: n({ input: !0 }, c), ref: a, style: gl(s), disabled: l }, p))) }, LoadingIndicator: pl, Menu: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerRef, a = e.innerProps; return Ki("div", Mo({ css: r("menu", e), className: o({ menu: !0 }, n), ref: i }, a), t) }, MenuList: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerProps, a = e.innerRef, l = e.isMulti; return Ki("div", Mo({ css: r("menuList", e), className: o({ "menu-list": !0, "menu-list--is-multi": l }, n), ref: a }, i), t) }, MenuPortal: Ka, LoadingMessage: Ua, NoOptionsMessage: Ja, MultiValue: function (e) { var t = e.children, n = e.className, o = e.components, r = e.cx, i = e.data, a = e.getStyles, l = e.innerProps, s = e.isDisabled, c = e.removeProps, p = e.selectProps, u = o.Container, d = o.Label, f = o.Remove; return Ki(ra, null, (function (o) { var b = o.css, g = o.cx; return Ki(u, { data: i, innerProps: ya({ className: g(b(a("multiValue", e)), r({ "multi-value": !0, "multi-value--is-disabled": s }, n)) }, l), selectProps: p }, Ki(d, { data: i, innerProps: { className: g(b(a("multiValueLabel", e)), r({ "multi-value__label": !0 }, n)) }, selectProps: p }, t), Ki(f, { data: i, innerProps: ya({ className: g(b(a("multiValueRemove", e)), r({ "multi-value__remove": !0 }, n)), "aria-label": "Remove ".concat(t || "option") }, c), selectProps: p })) })) }, MultiValueContainer: hl, MultiValueLabel: hl, MultiValueRemove: function (e) { var t = e.children, n = e.innerProps; return Ki("div", Mo({ role: "button" }, n), t || Ki(ol, { size: 14 })) }, Option: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.isDisabled, a = e.isFocused, l = e.isSelected, s = e.innerRef, c = e.innerProps; return Ki("div", Mo({ css: r("option", e), className: o({ option: !0, "option--is-disabled": i, "option--is-focused": a, "option--is-selected": l }, n), ref: s, "aria-disabled": i }, c), t) }, Placeholder: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerProps; return Ki("div", Mo({ css: r("placeholder", e), className: o({ placeholder: !0 }, n) }, i), t) }, SelectContainer: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.innerProps, a = e.isDisabled, l = e.isRtl; return Ki("div", Mo({ css: r("container", e), className: o({ "--is-disabled": a, "--is-rtl": l }, n) }, i), t) }, SingleValue: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.getStyles, i = e.isDisabled, a = e.innerProps; return Ki("div", Mo({ css: r("singleValue", e), className: o({ "single-value": !0, "single-value--is-disabled": i }, n) }, a), t) }, ValueContainer: function (e) { var t = e.children, n = e.className, o = e.cx, r = e.innerProps, i = e.isMulti, a = e.getStyles, l = e.hasValue; return Ki("div", Mo({ css: a("valueContainer", e), className: o({ "value-container": !0, "value-container--is-multi": i, "value-container--has-value": l }, n) }, r), t) } }; function vl(e, t) { (null == t || t > e.length) && (t = e.length); for (var n = 0, o = new Array(t); n < t; n++)o[n] = e[n]; return o } function yl(e, t) { if (e) { if ("string" == typeof e) return vl(e, t); var n = Object.prototype.toString.call(e).slice(8, -1); return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? vl(e, t) : void 0 } } function xl(e, t) { return function (e) { if (Array.isArray(e)) return e }(e) || function (e, t) { var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]; if (null != n) { var o, r, i = [], a = !0, l = !1; try { for (n = n.call(e); !(a = (o = n.next()).done) && (i.push(o.value), !t || i.length !== t); a = !0); } catch (e) { l = !0, r = e; } finally { try { a || null == n.return || n.return(); } finally { if (l) throw r } } return i } }(e, t) || yl(e, t) || function () { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.") }() } var wl = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"]; function Cl(e) { return function (e) { if (Array.isArray(e)) return vl(e) }(e) || function (e) { if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e) }(e) || yl(e) || function () { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.") }() } var Il = Number.isNaN || function (e) { return "number" == typeof e && e != e }; function Al(e, t) { if (e.length !== t.length) return !1; for (var n = 0; n < e.length; n++)if (o = e[n], r = t[n], !(o === r || Il(o) && Il(r))) return !1; var o, r; return !0 } for (var kl = "production" === process.env.NODE_ENV ? { name: "7pg0cj-a11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap" } : { name: "1f43avz-a11yText-A11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */", toString: function () { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)." } }, Ol = function (e) { return Ki("span", Mo({ css: kl }, e)) }, Tl = { guidance: function (e) { var t = e.isSearchable, n = e.isMulti, o = e.isDisabled, r = e.tabSelectsValue; switch (e.context) { case "menu": return "Use Up and Down to choose options".concat(o ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(r ? ", press Tab to select the option and exit the menu" : "", "."); case "input": return "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : ""); case "value": return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value"; default: return "" } }, onChange: function (e) { var t = e.action, n = e.label, o = void 0 === n ? "" : n, r = e.labels, i = e.isDisabled; switch (t) { case "deselect-option": case "pop-value": case "remove-value": return "option ".concat(o, ", deselected."); case "clear": return "All selected options have been cleared."; case "initial-input-focus": return "option".concat(r.length > 1 ? "s" : "", " ").concat(r.join(","), ", selected."); case "select-option": return "option ".concat(o, i ? " is disabled. Select another option." : ", selected."); default: return "" } }, onFocus: function (e) { var t = e.context, n = e.focused, o = e.options, r = e.label, i = void 0 === r ? "" : r, a = e.selectValue, l = e.isDisabled, s = e.isSelected, c = function (e, t) { return e && e.length ? "".concat(e.indexOf(t) + 1, " of ").concat(e.length) : "" }; if ("value" === t && a) return "value ".concat(i, " focused, ").concat(c(a, n), "."); if ("menu" === t) { var p = l ? " disabled" : "", u = "".concat(s ? "selected" : "focused").concat(p); return "option ".concat(i, " ").concat(u, ", ").concat(c(o, n), ".") } return "" }, onFilter: function (e) { var t = e.inputValue, n = e.resultsMessage; return "".concat(n).concat(t ? " for search term " + t : "", ".") } }, El = function (e) { var t = e.ariaSelection, n = e.focusedOption, o = e.focusedValue, r = e.focusableOptions, i = e.isFocused, a = e.selectValue, l = e.selectProps, s = e.id, c = l.ariaLiveMessages, p = l.getOptionLabel, u = l.inputValue, d = l.isMulti, f = l.isOptionDisabled, g = l.isSearchable, h = l.menuIsOpen, m = l.options, v = l.screenReaderStatus, x = l.tabSelectsValue, w = l["aria-label"], C = l["aria-live"], I = useMemo((function () { return ya(ya({}, Tl), c || {}) }), [c]), A = useMemo((function () { var e, n = ""; if (t && I.onChange) { var o = t.option, r = t.options, i = t.removedValue, l = t.removedValues, s = t.value, c = i || o || (e = s, Array.isArray(e) ? null : e), u = c ? p(c) : "", d = r || l || void 0, b = d ? d.map(p) : [], g = ya({ isDisabled: c && f(c, a), label: u, labels: b }, t); n = I.onChange(g); } return n }), [t, I, f, a, p]), k = useMemo((function () { var e = "", t = n || o, r = !!(n && a && a.includes(n)); if (t && I.onFocus) { var i = { focused: t, label: p(t), isDisabled: f(t, a), isSelected: r, options: m, context: t === n ? "menu" : "value", selectValue: a }; e = I.onFocus(i); } return e }), [n, o, p, f, I, m, a]), O = useMemo((function () { var e = ""; if (h && m.length && I.onFilter) { var t = v({ count: r.length }); e = I.onFilter({ inputValue: u, resultsMessage: t }); } return e }), [r, u, h, I, m, v]), T = useMemo((function () { var e = ""; if (I.guidance) { var t = o ? "value" : h ? "menu" : "input"; e = I.guidance({ "aria-label": w, context: t, isDisabled: n && f(n, a), isMulti: d, isSearchable: g, tabSelectsValue: x }); } return e }), [w, n, o, d, f, g, h, I, a, x]), E = "".concat(k, " ").concat(O, " ").concat(T), S = Ki(Fragment, null, Ki("span", { id: "aria-selection" }, A), Ki("span", { id: "aria-context" }, E)), B = "initial-input-focus" === (null == t ? void 0 : t.action); return Ki(Fragment, null, Ki(Ol, { id: s }, B && S), Ki(Ol, { "aria-live": C, "aria-atomic": "false", "aria-relevant": "additions text" }, i && !B && S)) }, Sl = [{ base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" }, { base: "AA", letters: "Ꜳ" }, { base: "AE", letters: "ÆǼǢ" }, { base: "AO", letters: "Ꜵ" }, { base: "AU", letters: "Ꜷ" }, { base: "AV", letters: "ꜸꜺ" }, { base: "AY", letters: "Ꜽ" }, { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" }, { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" }, { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ" }, { base: "DZ", letters: "ǱǄ" }, { base: "Dz", letters: "ǲǅ" }, { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" }, { base: "F", letters: "FⒻＦḞƑꝻ" }, { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" }, { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" }, { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" }, { base: "J", letters: "JⒿＪĴɈ" }, { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" }, { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" }, { base: "LJ", letters: "Ǉ" }, { base: "Lj", letters: "ǈ" }, { base: "M", letters: "MⓂＭḾṀṂⱮƜ" }, { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" }, { base: "NJ", letters: "Ǌ" }, { base: "Nj", letters: "ǋ" }, { base: "O", letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ" }, { base: "OI", letters: "Ƣ" }, { base: "OO", letters: "Ꝏ" }, { base: "OU", letters: "Ȣ" }, { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" }, { base: "Q", letters: "QⓆＱꝖꝘɊ" }, { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" }, { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" }, { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" }, { base: "TZ", letters: "Ꜩ" }, { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" }, { base: "V", letters: "VⓋＶṼṾƲꝞɅ" }, { base: "VY", letters: "Ꝡ" }, { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" }, { base: "X", letters: "XⓍＸẊẌ" }, { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" }, { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" }, { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" }, { base: "aa", letters: "ꜳ" }, { base: "ae", letters: "æǽǣ" }, { base: "ao", letters: "ꜵ" }, { base: "au", letters: "ꜷ" }, { base: "av", letters: "ꜹꜻ" }, { base: "ay", letters: "ꜽ" }, { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" }, { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" }, { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" }, { base: "dz", letters: "ǳǆ" }, { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" }, { base: "f", letters: "fⓕｆḟƒꝼ" }, { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" }, { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" }, { base: "hv", letters: "ƕ" }, { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" }, { base: "j", letters: "jⓙｊĵǰɉ" }, { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" }, { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" }, { base: "lj", letters: "ǉ" }, { base: "m", letters: "mⓜｍḿṁṃɱɯ" }, { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" }, { base: "nj", letters: "ǌ" }, { base: "o", letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ" }, { base: "oi", letters: "ƣ" }, { base: "ou", letters: "ȣ" }, { base: "oo", letters: "ꝏ" }, { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" }, { base: "q", letters: "qⓠｑɋꝗꝙ" }, { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" }, { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" }, { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" }, { base: "tz", letters: "ꜩ" }, { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" }, { base: "v", letters: "vⓥｖṽṿʋꝟʌ" }, { base: "vy", letters: "ꝡ" }, { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" }, { base: "x", letters: "xⓧｘẋẍ" }, { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" }, { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" }], Bl = new RegExp("[" + Sl.map((function (e) { return e.letters })).join("") + "]", "g"), Gl = {}, Nl = 0; Nl < Sl.length; Nl++)for (var Pl = Sl[Nl], Rl = 0; Rl < Pl.letters.length; Rl++)Gl[Pl.letters[Rl]] = Pl.base; var Ml = function (e) { return e.replace(Bl, (function (e) { return Gl[e] })) }, Ll = function (e, t) { var n; void 0 === t && (t = Al); var o, r = [], i = !1; return function () { for (var a = [], l = 0; l < arguments.length; l++)a[l] = arguments[l]; return i && n === this && t(a, r) || (o = e.apply(this, a), i = !0, n = this, r = a), o } }(Ml), Xl = function (e) { return e.replace(/^\s+|\s+$/g, "") }, Vl = function (e) { return "".concat(e.label, " ").concat(e.value) }, Wl = ["innerRef"]; function Hl(e) { var t = e.innerRef, n = ca(e, Wl); return Ki("input", Mo({ ref: t }, n, { css: ea({ label: "dummyInput", background: 0, border: 0, caretColor: "transparent", fontSize: "inherit", gridArea: "1 / 1 / 2 / 3", outline: 0, padding: 0, width: 1, color: "transparent", left: -100, opacity: 0, position: "relative", transform: "scale(.01)" }, "production" === process.env.NODE_ENV ? "" : ";label:DummyInput;", "production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNNIiwiZmlsZSI6IkR1bW15SW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4ucHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */") })) } var Fl = ["boxSizing", "height", "overflow", "paddingRight", "position"], Dl = { boxSizing: "border-box", overflow: "hidden", position: "relative", height: "100%" }; function zl(e) { e.preventDefault(); } function jl(e) { e.stopPropagation(); } function Zl() { var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight; 0 === e ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1); } function Yl() { return "ontouchstart" in window || navigator.maxTouchPoints } var _l = !("undefined" == typeof window || !window.document || !window.document.createElement), Jl = 0, Ul = { capture: !1, passive: !1 }; var Ql = function () { return document.activeElement && document.activeElement.blur() }, Kl = "production" === process.env.NODE_ENV ? { name: "1kfdb0e", styles: "position:fixed;left:0;bottom:0;right:0;top:0" } : { name: "bp8cua-ScrollManager", styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: function () { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)." } }; function ql(e) { var t = e.children, n = e.lockEnabled, o = e.captureEnabled, r = function (e) { var t = e.isEnabled, n = e.onBottomArrive, o = e.onBottomLeave, r = e.onTopArrive, i = e.onTopLeave, a = useRef(!1), l = useRef(!1), s = useRef(0), c = useRef(null), p = useCallback((function (e, t) { if (null !== c.current) { var s = c.current, p = s.scrollTop, u = s.scrollHeight, d = s.clientHeight, f = c.current, b = t > 0, g = u - d - p, h = !1; g > t && a.current && (o && o(e), a.current = !1), b && l.current && (i && i(e), l.current = !1), b && t > g ? (n && !a.current && n(e), f.scrollTop = u, h = !0, a.current = !0) : !b && -t > p && (r && !l.current && r(e), f.scrollTop = 0, h = !0, l.current = !0), h && function (e) { e.preventDefault(), e.stopPropagation(); }(e); } }), [n, o, r, i]), u = useCallback((function (e) { p(e, e.deltaY); }), [p]), d = useCallback((function (e) { s.current = e.changedTouches[0].clientY; }), []), f = useCallback((function (e) { var t = s.current - e.changedTouches[0].clientY; p(e, t); }), [p]), b = useCallback((function (e) { if (e) { var t = !!Va && { passive: !1 }; e.addEventListener("wheel", u, t), e.addEventListener("touchstart", d, t), e.addEventListener("touchmove", f, t); } }), [f, d, u]), h = useCallback((function (e) { e && (e.removeEventListener("wheel", u, !1), e.removeEventListener("touchstart", d, !1), e.removeEventListener("touchmove", f, !1)); }), [f, d, u]); return useEffect((function () { if (t) { var e = c.current; return b(e), function () { h(e); } } }), [t, b, h]), function (e) { c.current = e; } }({ isEnabled: void 0 === o || o, onBottomArrive: e.onBottomArrive, onBottomLeave: e.onBottomLeave, onTopArrive: e.onTopArrive, onTopLeave: e.onTopLeave }), i = function (e) { var t = e.isEnabled, n = e.accountForScrollbars, o = void 0 === n || n, r = useRef({}), i = useRef(null), a = useCallback((function (e) { if (_l) { var t = document.body, n = t && t.style; if (o && Fl.forEach((function (e) { var t = n && n[e]; r.current[e] = t; })), o && Jl < 1) { var i = parseInt(r.current.paddingRight, 10) || 0, a = document.body ? document.body.clientWidth : 0, l = window.innerWidth - a + i || 0; Object.keys(Dl).forEach((function (e) { var t = Dl[e]; n && (n[e] = t); })), n && (n.paddingRight = "".concat(l, "px")); } t && Yl() && (t.addEventListener("touchmove", zl, Ul), e && (e.addEventListener("touchstart", Zl, Ul), e.addEventListener("touchmove", jl, Ul))), Jl += 1; } }), [o]), l = useCallback((function (e) { if (_l) { var t = document.body, n = t && t.style; Jl = Math.max(Jl - 1, 0), o && Jl < 1 && Fl.forEach((function (e) { var t = r.current[e]; n && (n[e] = t); })), t && Yl() && (t.removeEventListener("touchmove", zl, Ul), e && (e.removeEventListener("touchstart", Zl, Ul), e.removeEventListener("touchmove", jl, Ul))); } }), [o]); return useEffect((function () { if (t) { var e = i.current; return a(e), function () { l(e); } } }), [t, a, l]), function (e) { i.current = e; } }({ isEnabled: n }); return Ki(Fragment, null, n && Ki("div", { onClick: Ql, css: Kl }), t((function (e) { r(e), i(e); }))) } var $l, es = { clearIndicator: ll, container: function (e) { var t = e.isDisabled; return { label: "container", direction: e.isRtl ? "rtl" : void 0, pointerEvents: t ? "none" : void 0, position: "relative" } }, control: function (e) { var t = e.isDisabled, n = e.isFocused, o = e.theme, r = o.colors, i = o.borderRadius, a = o.spacing; return { label: "control", alignItems: "center", backgroundColor: t ? r.neutral5 : r.neutral0, borderColor: t ? r.neutral10 : n ? r.primary : r.neutral20, borderRadius: i, borderStyle: "solid", borderWidth: 1, boxShadow: n ? "0 0 0 1px ".concat(r.primary) : void 0, cursor: "default", display: "flex", flexWrap: "wrap", justifyContent: "space-between", minHeight: a.controlHeight, outline: "0 !important", position: "relative", transition: "all 100ms", "&:hover": { borderColor: n ? r.primary : r.neutral30 } } }, dropdownIndicator: al, group: function (e) { var t = e.theme.spacing; return { paddingBottom: 2 * t.baseUnit, paddingTop: 2 * t.baseUnit } }, groupHeading: function (e) { var t = e.theme.spacing; return { label: "group", color: "#999", cursor: "default", display: "block", fontSize: "75%", fontWeight: 500, marginBottom: "0.25em", paddingLeft: 3 * t.baseUnit, paddingRight: 3 * t.baseUnit, textTransform: "uppercase" } }, indicatorsContainer: function () { return { alignItems: "center", alignSelf: "stretch", display: "flex", flexShrink: 0 } }, indicatorSeparator: function (e) { var t = e.isDisabled, n = e.theme, o = n.spacing.baseUnit, r = n.colors; return { label: "indicatorSeparator", alignSelf: "stretch", backgroundColor: t ? r.neutral10 : r.neutral20, marginBottom: 2 * o, marginTop: 2 * o, width: 1 } }, input: function (e) { var t = e.isDisabled, n = e.value, o = e.theme, r = o.spacing, i = o.colors; return ya({ margin: r.baseUnit / 2, paddingBottom: r.baseUnit / 2, paddingTop: r.baseUnit / 2, visibility: t ? "hidden" : "visible", color: i.neutral80, transform: n ? "translateZ(0)" : "" }, bl) }, loadingIndicator: function (e) { var t = e.isFocused, n = e.size, o = e.theme, r = o.colors, i = o.spacing.baseUnit; return { label: "loadingIndicator", color: t ? r.neutral60 : r.neutral20, display: "flex", padding: 2 * i, transition: "color 150ms", alignSelf: "center", fontSize: n, lineHeight: 1, marginRight: n, textAlign: "center", verticalAlign: "middle" } }, loadingMessage: _a$3, menu: function (e) { var t, n = e.placement, o = e.theme, r = o.borderRadius, i = o.spacing, a = o.colors; return ha(t = { label: "menu" }, function (e) { return e ? { bottom: "top", top: "bottom" }[e] : "bottom" }(n), "100%"), ha(t, "backgroundColor", a.neutral0), ha(t, "borderRadius", r), ha(t, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), ha(t, "marginBottom", i.menuGutter), ha(t, "marginTop", i.menuGutter), ha(t, "position", "absolute"), ha(t, "width", "100%"), ha(t, "zIndex", 1), t }, menuList: function (e) { var t = e.maxHeight, n = e.theme.spacing.baseUnit; return { maxHeight: t, overflowY: "auto", paddingBottom: n, paddingTop: n, position: "relative", WebkitOverflowScrolling: "touch" } }, menuPortal: function (e) { var t = e.rect, n = e.offset, o = e.position; return { left: t.left, position: o, top: n, width: t.width, zIndex: 1 } }, multiValue: function (e) { var t = e.theme, n = t.spacing, o = t.borderRadius; return { label: "multiValue", backgroundColor: t.colors.neutral10, borderRadius: o / 2, display: "flex", margin: n.baseUnit / 2, minWidth: 0 } }, multiValueLabel: function (e) { var t = e.theme, n = t.borderRadius, o = t.colors, r = e.cropWithEllipsis; return { borderRadius: n / 2, color: o.neutral80, fontSize: "85%", overflow: "hidden", padding: 3, paddingLeft: 6, textOverflow: r || void 0 === r ? "ellipsis" : void 0, whiteSpace: "nowrap" } }, multiValueRemove: function (e) { var t = e.theme, n = t.spacing, o = t.borderRadius, r = t.colors; return { alignItems: "center", borderRadius: o / 2, backgroundColor: e.isFocused ? r.dangerLight : void 0, display: "flex", paddingLeft: n.baseUnit, paddingRight: n.baseUnit, ":hover": { backgroundColor: r.dangerLight, color: r.danger } } }, noOptionsMessage: Ya, option: function (e) { var t = e.isDisabled, n = e.isFocused, o = e.isSelected, r = e.theme, i = r.spacing, a = r.colors; return { label: "option", backgroundColor: o ? a.primary : n ? a.primary25 : "transparent", color: t ? a.neutral20 : o ? a.neutral0 : "inherit", cursor: "default", display: "block", fontSize: "inherit", padding: "".concat(2 * i.baseUnit, "px ").concat(3 * i.baseUnit, "px"), width: "100%", userSelect: "none", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)", ":active": { backgroundColor: t ? void 0 : o ? a.primary : a.primary50 } } }, placeholder: function (e) { var t = e.theme, n = t.spacing; return { label: "placeholder", color: t.colors.neutral50, gridArea: "1 / 1 / 2 / 3", marginLeft: n.baseUnit / 2, marginRight: n.baseUnit / 2 } }, singleValue: function (e) { var t = e.isDisabled, n = e.theme, o = n.spacing, r = n.colors; return { label: "singleValue", color: t ? r.neutral40 : r.neutral80, gridArea: "1 / 1 / 2 / 3", marginLeft: o.baseUnit / 2, marginRight: o.baseUnit / 2, maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, valueContainer: function (e) { var t = e.theme.spacing, n = e.isMulti, o = e.hasValue, r = e.selectProps.controlShouldRenderValue; return { alignItems: "center", display: n && o && r ? "flex" : "grid", flex: 1, flexWrap: "wrap", padding: "".concat(t.baseUnit / 2, "px ").concat(2 * t.baseUnit, "px"), WebkitOverflowScrolling: "touch", position: "relative", overflow: "hidden" } } }, ts = { borderRadius: 4, colors: { primary: "#2684FF", primary75: "#4C9AFF", primary50: "#B2D4FF", primary25: "#DEEBFF", danger: "#DE350B", dangerLight: "#FFBDAD", neutral0: "hsl(0, 0%, 100%)", neutral5: "hsl(0, 0%, 95%)", neutral10: "hsl(0, 0%, 90%)", neutral20: "hsl(0, 0%, 80%)", neutral30: "hsl(0, 0%, 70%)", neutral40: "hsl(0, 0%, 60%)", neutral50: "hsl(0, 0%, 50%)", neutral60: "hsl(0, 0%, 40%)", neutral70: "hsl(0, 0%, 30%)", neutral80: "hsl(0, 0%, 20%)", neutral90: "hsl(0, 0%, 10%)" }, spacing: { baseUnit: 4, controlHeight: 38, menuGutter: 8 } }, ns = { "aria-live": "polite", backspaceRemovesValue: !0, blurInputOnSelect: Ra(), captureMenuScroll: !Ra(), closeMenuOnSelect: !0, closeMenuOnScroll: !1, components: {}, controlShouldRenderValue: !0, escapeClearsValue: !1, filterOption: function (e, t) { if (e.data.__isNew__) return !0; var n = ya({ ignoreCase: !0, ignoreAccents: !0, stringify: Vl, trim: !0, matchFrom: "any" }, $l), o = n.ignoreCase, r = n.ignoreAccents, i = n.stringify, a = n.trim, l = n.matchFrom, s = a ? Xl(t) : t, c = a ? Xl(i(e)) : i(e); return o && (s = s.toLowerCase(), c = c.toLowerCase()), r && (s = Ll(s), c = Ml(c)), "start" === l ? c.substr(0, s.length) === s : c.indexOf(s) > -1 }, formatGroupLabel: function (e) { return e.label }, getOptionLabel: function (e) { return e.label }, getOptionValue: function (e) { return e.value }, isDisabled: !1, isLoading: !1, isMulti: !1, isRtl: !1, isSearchable: !0, isOptionDisabled: function (e) { return !!e.isDisabled }, loadingMessage: function () { return "Loading..." }, maxMenuHeight: 300, minMenuHeight: 140, menuIsOpen: !1, menuPlacement: "bottom", menuPosition: "absolute", menuShouldBlockScroll: !1, menuShouldScrollIntoView: !function () { try { return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) } catch (e) { return !1 } }(), noOptionsMessage: function () { return "No options" }, openMenuOnFocus: !1, openMenuOnClick: !0, options: [], pageSize: 5, placeholder: "Select...", screenReaderStatus: function (e) { var t = e.count; return "".concat(t, " result").concat(1 !== t ? "s" : "", " available") }, styles: {}, tabIndex: 0, tabSelectsValue: !0 }; function os(e, t, n, o) { return { type: "option", data: t, isDisabled: cs(e, t, n), isSelected: ps(e, t, n), label: ls(e, t), value: ss(e, t), index: o } } function rs(e, t) { return e.options.map((function (n, o) { if ("options" in n) { var r = n.options.map((function (n, o) { return os(e, n, t, o) })).filter((function (t) { return as(e, t) })); return r.length > 0 ? { type: "group", data: n, options: r, index: o } : void 0 } var i = os(e, n, t, o); return as(e, i) ? i : void 0 })).filter(Wa) } function is(e) { return e.reduce((function (e, t) { return "group" === t.type ? e.push.apply(e, Cl(t.options.map((function (e) { return e.data })))) : e.push(t.data), e }), []) } function as(e, t) { var n = e.inputValue, o = void 0 === n ? "" : n, r = t.data, i = t.isSelected, a = t.label, l = t.value; return (!ds(e) || !i) && us(e, { label: a, value: l, data: r }, o) } var ls = function (e, t) { return e.getOptionLabel(t) }, ss = function (e, t) { return e.getOptionValue(t) }; function cs(e, t, n) { return "function" == typeof e.isOptionDisabled && e.isOptionDisabled(t, n) } function ps(e, t, n) { if (n.indexOf(t) > -1) return !0; if ("function" == typeof e.isOptionSelected) return e.isOptionSelected(t, n); var o = ss(e, t); return n.some((function (t) { return ss(e, t) === o })) } function us(e, t, n) { return !e.filterOption || e.filterOption(t, n) } var ds = function (e) { var t = e.hideSelectedOptions, n = e.isMulti; return void 0 === t ? n : t }, fs = 1, bs = function (e) { ga(n, Component); var t = Ca(n); function n(e) { var o; return ua(this, n), (o = t.call(this, e)).state = { ariaSelection: null, focusedOption: null, focusedValue: null, inputIsHidden: !1, isFocused: !1, selectValue: [], clearFocusValueOnUpdate: !1, prevWasFocused: !1, inputIsHiddenAfterUpdate: void 0, prevProps: void 0 }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.instancePrefix = "", o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.controlRef = null, o.getControlRef = function (e) { o.controlRef = e; }, o.focusedOptionRef = null, o.getFocusedOptionRef = function (e) { o.focusedOptionRef = e; }, o.menuListRef = null, o.getMenuListRef = function (e) { o.menuListRef = e; }, o.inputRef = null, o.getInputRef = function (e) { o.inputRef = e; }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function (e, t) { var n = o.props, r = n.onChange, i = n.name; t.name = i, o.ariaOnChange(e, t), r(e, t); }, o.setValue = function (e, t, n) { var r = o.props, i = r.closeMenuOnSelect, a = r.isMulti, l = r.inputValue; o.onInputChange("", { action: "set-value", prevInputValue: l }), i && (o.setState({ inputIsHiddenAfterUpdate: !a }), o.onMenuClose()), o.setState({ clearFocusValueOnUpdate: !0 }), o.onChange(e, { action: t, option: n }); }, o.selectOption = function (e) { var t = o.props, n = t.blurInputOnSelect, r = t.isMulti, i = t.name, a = o.state.selectValue, l = r && o.isOptionSelected(e, a), s = o.isOptionDisabled(e, a); if (l) { var c = o.getOptionValue(e); o.setValue(a.filter((function (e) { return o.getOptionValue(e) !== c })), "deselect-option", e); } else { if (s) return void o.ariaOnChange(e, { action: "select-option", option: e, name: i }); r ? o.setValue([].concat(Cl(a), [e]), "select-option", e) : o.setValue(e, "select-option"); } n && o.blurInput(); }, o.removeValue = function (e) { var t = o.props.isMulti, n = o.state.selectValue, r = o.getOptionValue(e), i = n.filter((function (e) { return o.getOptionValue(e) !== r })), a = Ha(t, i, i[0] || null); o.onChange(a, { action: "remove-value", removedValue: e }), o.focusInput(); }, o.clearValue = function () { var e = o.state.selectValue; o.onChange(Ha(o.props.isMulti, [], null), { action: "clear", removedValues: e }); }, o.popValue = function () { var e = o.props.isMulti, t = o.state.selectValue, n = t[t.length - 1], r = t.slice(0, t.length - 1), i = Ha(e, r, r[0] || null); o.onChange(i, { action: "pop-value", removedValue: n }); }, o.getValue = function () { return o.state.selectValue }, o.cx = function () { for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n]; return Oa.apply(void 0, [o.props.classNamePrefix].concat(t)) }, o.getOptionLabel = function (e) { return ls(o.props, e) }, o.getOptionValue = function (e) { return ss(o.props, e) }, o.getStyles = function (e, t) { var n = es[e](t); n.boxSizing = "border-box"; var r = o.props.styles[e]; return r ? r(n, t) : n }, o.getElementId = function (e) { return "".concat(o.instancePrefix, "-").concat(e) }, o.getComponents = function () { return e = o.props, ya(ya({}, ml), e.components); var e; }, o.buildCategorizedOptions = function () { return rs(o.props, o.state.selectValue) }, o.getCategorizedOptions = function () { return o.props.menuIsOpen ? o.buildCategorizedOptions() : [] }, o.buildFocusableOptions = function () { return is(o.buildCategorizedOptions()) }, o.getFocusableOptions = function () { return o.props.menuIsOpen ? o.buildFocusableOptions() : [] }, o.ariaOnChange = function (e, t) { o.setState({ ariaSelection: ya({ value: e }, t) }); }, o.onMenuMouseDown = function (e) { 0 === e.button && (e.stopPropagation(), e.preventDefault(), o.focusInput()); }, o.onMenuMouseMove = function (e) { o.blockOptionHover = !1; }, o.onControlMouseDown = function (e) { var t = o.props.openMenuOnClick; o.state.isFocused ? o.props.menuIsOpen ? "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && o.onMenuClose() : t && o.openMenu("first") : (t && (o.openAfterFocus = !0), o.focusInput()), "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && e.preventDefault(); }, o.onDropdownIndicatorMouseDown = function (e) { if (!(e && "mousedown" === e.type && 0 !== e.button || o.props.isDisabled)) { var t = o.props, n = t.isMulti, r = t.menuIsOpen; o.focusInput(), r ? (o.setState({ inputIsHiddenAfterUpdate: !n }), o.onMenuClose()) : o.openMenu("first"), e.preventDefault(), e.stopPropagation(); } }, o.onClearIndicatorMouseDown = function (e) { e && "mousedown" === e.type && 0 !== e.button || (o.clearValue(), e.preventDefault(), e.stopPropagation(), o.openAfterFocus = !1, "touchend" === e.type ? o.focusInput() : setTimeout((function () { return o.focusInput() }))); }, o.onScroll = function (e) { "boolean" == typeof o.props.closeMenuOnScroll ? e.target instanceof HTMLElement && Sa(e.target) && o.props.onMenuClose() : "function" == typeof o.props.closeMenuOnScroll && o.props.closeMenuOnScroll(e) && o.props.onMenuClose(); }, o.onCompositionStart = function () { o.isComposing = !0; }, o.onCompositionEnd = function () { o.isComposing = !1; }, o.onTouchStart = function (e) { var t = e.touches, n = t && t.item(0); n && (o.initialTouchX = n.clientX, o.initialTouchY = n.clientY, o.userIsDragging = !1); }, o.onTouchMove = function (e) { var t = e.touches, n = t && t.item(0); if (n) { var r = Math.abs(n.clientX - o.initialTouchX), i = Math.abs(n.clientY - o.initialTouchY); o.userIsDragging = r > 5 || i > 5; } }, o.onTouchEnd = function (e) { o.userIsDragging || (o.controlRef && !o.controlRef.contains(e.target) && o.menuListRef && !o.menuListRef.contains(e.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0); }, o.onControlTouchEnd = function (e) { o.userIsDragging || o.onControlMouseDown(e); }, o.onClearIndicatorTouchEnd = function (e) { o.userIsDragging || o.onClearIndicatorMouseDown(e); }, o.onDropdownIndicatorTouchEnd = function (e) { o.userIsDragging || o.onDropdownIndicatorMouseDown(e); }, o.handleInputChange = function (e) { var t = o.props.inputValue, n = e.currentTarget.value; o.setState({ inputIsHiddenAfterUpdate: !1 }), o.onInputChange(n, { action: "input-change", prevInputValue: t }), o.props.menuIsOpen || o.onMenuOpen(); }, o.onInputFocus = function (e) { o.props.onFocus && o.props.onFocus(e), o.setState({ inputIsHiddenAfterUpdate: !1, isFocused: !0 }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1; }, o.onInputBlur = function (e) { var t = o.props.inputValue; o.menuListRef && o.menuListRef.contains(document.activeElement) ? o.inputRef.focus() : (o.props.onBlur && o.props.onBlur(e), o.onInputChange("", { action: "input-blur", prevInputValue: t }), o.onMenuClose(), o.setState({ focusedValue: null, isFocused: !1 })); }, o.onOptionHover = function (e) { o.blockOptionHover || o.state.focusedOption === e || o.setState({ focusedOption: e }); }, o.shouldHideSelectedOptions = function () { return ds(o.props) }, o.onKeyDown = function (e) { var t = o.props, n = t.isMulti, r = t.backspaceRemovesValue, i = t.escapeClearsValue, a = t.inputValue, l = t.isClearable, s = t.isDisabled, c = t.menuIsOpen, p = t.onKeyDown, u = t.tabSelectsValue, d = t.openMenuOnFocus, f = o.state, b = f.focusedOption, g = f.focusedValue, h = f.selectValue; if (!(s || "function" == typeof p && (p(e), e.defaultPrevented))) { switch (o.blockOptionHover = !0, e.key) { case "ArrowLeft": if (!n || a) return; o.focusValue("previous"); break; case "ArrowRight": if (!n || a) return; o.focusValue("next"); break; case "Delete": case "Backspace": if (a) return; if (g) o.removeValue(g); else { if (!r) return; n ? o.popValue() : l && o.clearValue(); } break; case "Tab": if (o.isComposing) return; if (e.shiftKey || !c || !u || !b || d && o.isOptionSelected(b, h)) return; o.selectOption(b); break; case "Enter": if (229 === e.keyCode) break; if (c) { if (!b) return; if (o.isComposing) return; o.selectOption(b); break } return; case "Escape": c ? (o.setState({ inputIsHiddenAfterUpdate: !1 }), o.onInputChange("", { action: "menu-close", prevInputValue: a }), o.onMenuClose()) : l && i && o.clearValue(); break; case " ": if (a) return; if (!c) { o.openMenu("first"); break } if (!b) return; o.selectOption(b); break; case "ArrowUp": c ? o.focusOption("up") : o.openMenu("last"); break; case "ArrowDown": c ? o.focusOption("down") : o.openMenu("first"); break; case "PageUp": if (!c) return; o.focusOption("pageup"); break; case "PageDown": if (!c) return; o.focusOption("pagedown"); break; case "Home": if (!c) return; o.focusOption("first"); break; case "End": if (!c) return; o.focusOption("last"); break; default: return }e.preventDefault(); } }, o.instancePrefix = "react-select-" + (o.props.instanceId || ++fs), o.state.selectValue = Ta(e.value), o } return fa(n, [{ key: "componentDidMount", value: function () { this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(); } }, { key: "componentDidUpdate", value: function (e) { var t, n, o, r, i, a = this.props, l = a.isDisabled, s = a.menuIsOpen, c = this.state.isFocused; (c && !l && e.isDisabled || c && s && !e.menuIsOpen) && this.focusInput(), c && l && !e.isDisabled && this.setState({ isFocused: !1 }, this.onMenuClose), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (t = this.menuListRef, n = this.focusedOptionRef, o = t.getBoundingClientRect(), r = n.getBoundingClientRect(), i = n.offsetHeight / 3, r.bottom + i > o.bottom ? Ga(t, Math.min(n.offsetTop + n.clientHeight - t.offsetHeight + i, t.scrollHeight)) : r.top - i < o.top && Ga(t, Math.max(n.offsetTop - i, 0)), this.scrollToFocusedOptionOnUpdate = !1); } }, { key: "componentWillUnmount", value: function () { this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0); } }, { key: "onMenuOpen", value: function () { this.props.onMenuOpen(); } }, { key: "onMenuClose", value: function () { this.onInputChange("", { action: "menu-close", prevInputValue: this.props.inputValue }), this.props.onMenuClose(); } }, { key: "onInputChange", value: function (e, t) { this.props.onInputChange(e, t); } }, { key: "focusInput", value: function () { this.inputRef && this.inputRef.focus(); } }, { key: "blurInput", value: function () { this.inputRef && this.inputRef.blur(); } }, { key: "openMenu", value: function (e) { var t = this, n = this.state, o = n.selectValue, r = n.isFocused, i = this.buildFocusableOptions(), a = "first" === e ? 0 : i.length - 1; if (!this.props.isMulti) { var l = i.indexOf(o[0]); l > -1 && (a = l); } this.scrollToFocusedOptionOnUpdate = !(r && this.menuListRef), this.setState({ inputIsHiddenAfterUpdate: !1, focusedValue: null, focusedOption: i[a] }, (function () { return t.onMenuOpen() })); } }, { key: "focusValue", value: function (e) { var t = this.state, n = t.selectValue, o = t.focusedValue; if (this.props.isMulti) { this.setState({ focusedOption: null }); var r = n.indexOf(o); o || (r = -1); var i = n.length - 1, a = -1; if (n.length) { switch (e) { case "previous": a = 0 === r ? 0 : -1 === r ? i : r - 1; break; case "next": r > -1 && r < i && (a = r + 1); }this.setState({ inputIsHidden: -1 !== a, focusedValue: n[a] }); } } } }, { key: "focusOption", value: function () { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "first", t = this.props.pageSize, n = this.state.focusedOption, o = this.getFocusableOptions(); if (o.length) { var r = 0, i = o.indexOf(n); n || (i = -1), "up" === e ? r = i > 0 ? i - 1 : o.length - 1 : "down" === e ? r = (i + 1) % o.length : "pageup" === e ? (r = i - t) < 0 && (r = 0) : "pagedown" === e ? (r = i + t) > o.length - 1 && (r = o.length - 1) : "last" === e && (r = o.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({ focusedOption: o[r], focusedValue: null }); } } }, { key: "getTheme", value: function () { return this.props.theme ? "function" == typeof this.props.theme ? this.props.theme(ts) : ya(ya({}, ts), this.props.theme) : ts } }, { key: "getCommonProps", value: function () { var e = this.clearValue, t = this.cx, n = this.getStyles, o = this.getValue, r = this.selectOption, i = this.setValue, a = this.props, l = a.isMulti, s = a.isRtl, c = a.options; return { clearValue: e, cx: t, getStyles: n, getValue: o, hasValue: this.hasValue(), isMulti: l, isRtl: s, options: c, selectOption: r, selectProps: a, setValue: i, theme: this.getTheme() } } }, { key: "hasValue", value: function () { return this.state.selectValue.length > 0 } }, { key: "hasOptions", value: function () { return !!this.getFocusableOptions().length } }, { key: "isClearable", value: function () { var e = this.props, t = e.isClearable, n = e.isMulti; return void 0 === t ? n : t } }, { key: "isOptionDisabled", value: function (e, t) { return cs(this.props, e, t) } }, { key: "isOptionSelected", value: function (e, t) { return ps(this.props, e, t) } }, { key: "filterOption", value: function (e, t) { return us(this.props, e, t) } }, { key: "formatOptionLabel", value: function (e, t) { if ("function" == typeof this.props.formatOptionLabel) { var n = this.props.inputValue, o = this.state.selectValue; return this.props.formatOptionLabel(e, { context: t, inputValue: n, selectValue: o }) } return this.getOptionLabel(e) } }, { key: "formatGroupLabel", value: function (e) { return this.props.formatGroupLabel(e) } }, { key: "startListeningComposition", value: function () { document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1)); } }, { key: "stopListeningComposition", value: function () { document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd)); } }, { key: "startListeningToTouch", value: function () { document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1)); } }, { key: "stopListeningToTouch", value: function () { document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd)); } }, { key: "renderInput", value: function () { var e = this.props, t = e.isDisabled, n = e.isSearchable, o = e.inputId, r = e.inputValue, i = e.tabIndex, a = e.form, s = e.menuIsOpen, c = this.getComponents().Input, p = this.state, u = p.inputIsHidden, d = p.ariaSelection, f = this.commonProps, b = o || this.getElementId("input"), g = ya(ya({ "aria-autocomplete": "list", "aria-expanded": s, "aria-haspopup": !0, "aria-controls": this.getElementId("listbox"), "aria-owns": this.getElementId("listbox"), "aria-errormessage": this.props["aria-errormessage"], "aria-invalid": this.props["aria-invalid"], "aria-label": this.props["aria-label"], "aria-labelledby": this.props["aria-labelledby"], role: "combobox" }, !n && { "aria-readonly": !0 }), this.hasValue() ? "initial-input-focus" === (null == d ? void 0 : d.action) && { "aria-describedby": this.getElementId("live-region") } : { "aria-describedby": this.getElementId("placeholder") }); return n ? React.createElement(c, Mo({}, f, { autoCapitalize: "none", autoComplete: "off", autoCorrect: "off", id: b, innerRef: this.getInputRef, isDisabled: t, isHidden: u, onBlur: this.onInputBlur, onChange: this.handleInputChange, onFocus: this.onInputFocus, spellCheck: "false", tabIndex: i, form: a, type: "text", value: r }, g)) : React.createElement(Hl, Mo({ id: b, innerRef: this.getInputRef, onBlur: this.onInputBlur, onChange: Aa, onFocus: this.onInputFocus, disabled: t, tabIndex: i, inputMode: "none", form: a, value: "" }, g)) } }, { key: "renderPlaceholderOrValue", value: function () { var e = this, t = this.getComponents(), n = t.MultiValue, o = t.MultiValueContainer, r = t.MultiValueLabel, i = t.MultiValueRemove, a = t.SingleValue, s = t.Placeholder, c = this.commonProps, p = this.props, u = p.controlShouldRenderValue, d = p.isDisabled, f = p.isMulti, b = p.inputValue, g = p.placeholder, h = this.state, m = h.selectValue, v = h.focusedValue, y = h.isFocused; if (!this.hasValue() || !u) return b ? null : React.createElement(s, Mo({}, c, { key: "placeholder", isDisabled: d, isFocused: y, innerProps: { id: this.getElementId("placeholder") } }), g); if (f) return m.map((function (t, a) { var s = t === v, p = "".concat(e.getOptionLabel(t), "-").concat(e.getOptionValue(t)); return React.createElement(n, Mo({}, c, { components: { Container: o, Label: r, Remove: i }, isFocused: s, isDisabled: d, key: p, index: a, removeProps: { onClick: function () { return e.removeValue(t) }, onTouchEnd: function () { return e.removeValue(t) }, onMouseDown: function (e) { e.preventDefault(), e.stopPropagation(); } }, data: t }), e.formatOptionLabel(t, "value")) })); if (b) return null; var x = m[0]; return React.createElement(a, Mo({}, c, { data: x, isDisabled: d }), this.formatOptionLabel(x, "value")) } }, { key: "renderClearIndicator", value: function () { var e = this.getComponents().ClearIndicator, t = this.commonProps, n = this.props, o = n.isDisabled, r = n.isLoading, i = this.state.isFocused; if (!this.isClearable() || !e || o || !this.hasValue() || r) return null; var a = { onMouseDown: this.onClearIndicatorMouseDown, onTouchEnd: this.onClearIndicatorTouchEnd, "aria-hidden": "true" }; return React.createElement(e, Mo({}, t, { innerProps: a, isFocused: i })) } }, { key: "renderLoadingIndicator", value: function () { var e = this.getComponents().LoadingIndicator, t = this.commonProps, n = this.props, o = n.isDisabled, r = n.isLoading, i = this.state.isFocused; if (!e || !r) return null; return React.createElement(e, Mo({}, t, { innerProps: { "aria-hidden": "true" }, isDisabled: o, isFocused: i })) } }, { key: "renderIndicatorSeparator", value: function () { var e = this.getComponents(), t = e.DropdownIndicator, n = e.IndicatorSeparator; if (!t || !n) return null; var o = this.commonProps, r = this.props.isDisabled, i = this.state.isFocused; return React.createElement(n, Mo({}, o, { isDisabled: r, isFocused: i })) } }, { key: "renderDropdownIndicator", value: function () { var e = this.getComponents().DropdownIndicator; if (!e) return null; var t = this.commonProps, n = this.props.isDisabled, o = this.state.isFocused, r = { onMouseDown: this.onDropdownIndicatorMouseDown, onTouchEnd: this.onDropdownIndicatorTouchEnd, "aria-hidden": "true" }; return React.createElement(e, Mo({}, t, { innerProps: r, isDisabled: n, isFocused: o })) } }, { key: "renderMenu", value: function () { var e = this, t = this.getComponents(), n = t.Group, o = t.GroupHeading, r = t.Menu, i = t.MenuList, a = t.MenuPortal, s = t.LoadingMessage, c = t.NoOptionsMessage, p = t.Option, u = this.commonProps, d = this.state.focusedOption, f = this.props, b = f.captureMenuScroll, g = f.inputValue, h = f.isLoading, m = f.loadingMessage, v = f.minMenuHeight, y = f.maxMenuHeight, x = f.menuIsOpen, w = f.menuPlacement, C = f.menuPosition, I = f.menuPortalTarget, A = f.menuShouldBlockScroll, k = f.menuShouldScrollIntoView, O = f.noOptionsMessage, T = f.onMenuScrollToTop, E = f.onMenuScrollToBottom; if (!x) return null; var S, B = function (t, n) { var o = t.type, r = t.data, i = t.isDisabled, a = t.isSelected, s = t.label, c = t.value, f = d === r, b = i ? void 0 : function () { return e.onOptionHover(r) }, g = i ? void 0 : function () { return e.selectOption(r) }, h = "".concat(e.getElementId("option"), "-").concat(n), m = { id: h, onClick: g, onMouseMove: b, onMouseOver: b, tabIndex: -1 }; return React.createElement(p, Mo({}, u, { innerProps: m, data: r, isDisabled: i, isSelected: a, key: h, label: s, type: o, value: c, isFocused: f, innerRef: f ? e.getFocusedOptionRef : void 0 }), e.formatOptionLabel(t.data, "menu")) }; if (this.hasOptions()) S = this.getCategorizedOptions().map((function (t) { if ("group" === t.type) { var r = t.data, i = t.options, a = t.index, s = "".concat(e.getElementId("group"), "-").concat(a), c = "".concat(s, "-heading"); return React.createElement(n, Mo({}, u, { key: s, data: r, options: i, Heading: o, headingProps: { id: c, data: t.data }, label: e.formatGroupLabel(t.data) }), t.options.map((function (e) { return B(e, "".concat(a, "-").concat(e.index)) }))) } if ("option" === t.type) return B(t, "".concat(t.index)) })); else if (h) { var G = m({ inputValue: g }); if (null === G) return null; S = React.createElement(s, u, G); } else { var N = O({ inputValue: g }); if (null === N) return null; S = React.createElement(c, u, N); } var P = { minMenuHeight: v, maxMenuHeight: y, menuPlacement: w, menuPosition: C, menuShouldScrollIntoView: k }, R = React.createElement(ja, Mo({}, u, P), (function (t) { var n = t.ref, o = t.placerProps, a = o.placement, s = o.maxHeight; return React.createElement(r, Mo({}, u, P, { innerRef: n, innerProps: { onMouseDown: e.onMenuMouseDown, onMouseMove: e.onMenuMouseMove, id: e.getElementId("listbox") }, isLoading: h, placement: a }), React.createElement(ql, { captureEnabled: b, onTopArrive: T, onBottomArrive: E, lockEnabled: A }, (function (t) { return React.createElement(i, Mo({}, u, { innerRef: function (n) { e.getMenuListRef(n), t(n); }, isLoading: h, maxHeight: s, focusedOption: d }), S) }))) })); return I || "fixed" === C ? React.createElement(a, Mo({}, u, { appendTo: I, controlElement: this.controlRef, menuPlacement: w, menuPosition: C }), R) : R } }, { key: "renderFormField", value: function () { var e = this, t = this.props, n = t.delimiter, o = t.isDisabled, r = t.isMulti, i = t.name, a = this.state.selectValue; if (i && !o) { if (r) { if (n) { var s = a.map((function (t) { return e.getOptionValue(t) })).join(n); return React.createElement("input", { name: i, type: "hidden", value: s }) } var c = a.length > 0 ? a.map((function (t, n) { return React.createElement("input", { key: "i-".concat(n), name: i, type: "hidden", value: e.getOptionValue(t) }) })) : React.createElement("input", { name: i, type: "hidden" }); return React.createElement("div", null, c) } var p = a[0] ? this.getOptionValue(a[0]) : ""; return React.createElement("input", { name: i, type: "hidden", value: p }) } } }, { key: "renderLiveRegion", value: function () { var e = this.commonProps, t = this.state, n = t.ariaSelection, o = t.focusedOption, r = t.focusedValue, i = t.isFocused, a = t.selectValue, s = this.getFocusableOptions(); return React.createElement(El, Mo({}, e, { id: this.getElementId("live-region"), ariaSelection: n, focusedOption: o, focusedValue: r, isFocused: i, selectValue: a, focusableOptions: s })) } }, { key: "render", value: function () { var e = this.getComponents(), t = e.Control, n = e.IndicatorsContainer, o = e.SelectContainer, r = e.ValueContainer, i = this.props, a = i.className, s = i.id, c = i.isDisabled, p = i.menuIsOpen, u = this.state.isFocused, d = this.commonProps = this.getCommonProps(); return React.createElement(o, Mo({}, d, { className: a, innerProps: { id: s, onKeyDown: this.onKeyDown }, isDisabled: c, isFocused: u }), this.renderLiveRegion(), React.createElement(t, Mo({}, d, { innerRef: this.getControlRef, innerProps: { onMouseDown: this.onControlMouseDown, onTouchEnd: this.onControlTouchEnd }, isDisabled: c, isFocused: u, menuIsOpen: p }), React.createElement(r, Mo({}, d, { isDisabled: c }), this.renderPlaceholderOrValue(), this.renderInput()), React.createElement(n, Mo({}, d, { isDisabled: c }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField()) } }], [{ key: "getDerivedStateFromProps", value: function (e, t) { var n = t.prevProps, o = t.clearFocusValueOnUpdate, r = t.inputIsHiddenAfterUpdate, i = t.ariaSelection, a = t.isFocused, l = t.prevWasFocused, s = e.options, c = e.value, p = e.menuIsOpen, u = e.inputValue, d = e.isMulti, f = Ta(c), b = {}; if (n && (c !== n.value || s !== n.options || p !== n.menuIsOpen || u !== n.inputValue)) { var g = p ? function (e, t) { return is(rs(e, t)) }(e, f) : [], h = o ? function (e, t) { var n = e.focusedValue, o = e.selectValue.indexOf(n); if (o > -1) { if (t.indexOf(n) > -1) return n; if (o < t.length) return t[o] } return null }(t, f) : null, m = function (e, t) { var n = e.focusedOption; return n && t.indexOf(n) > -1 ? n : t[0] }(t, g); b = { selectValue: f, focusedOption: m, focusedValue: h, clearFocusValueOnUpdate: !1 }; } var v = null != r && e !== n ? { inputIsHidden: r, inputIsHiddenAfterUpdate: void 0 } : {}, y = i, x = a && l; return a && !x && (y = { value: Ha(d, f, f[0] || null), options: f, action: "initial-input-focus" }, x = !l), "initial-input-focus" === (null == i ? void 0 : i.action) && (y = null), ya(ya(ya({}, b), v), {}, { prevProps: e, ariaSelection: y, prevWasFocused: x }) } }]), n }(); bs.defaultProps = ns; var gs, hs, ms, vs, ys, xs, ws, Cs, Is, As, ks, Os, Ts, Es, Ss, Bs, Gs, Ns, Ps, Rs, Ms = forwardRef((function (e, t) { var n = function (e) { var t = e.defaultInputValue, n = void 0 === t ? "" : t, o = e.defaultMenuIsOpen, r = void 0 !== o && o, i = e.defaultValue, a = void 0 === i ? null : i, l = e.inputValue, s = e.menuIsOpen, p = e.onChange, u = e.onInputChange, d = e.onMenuClose, f = e.onMenuOpen, b = e.value, g = ca(e, wl), h = xl(useState(void 0 !== l ? l : n), 2), m = h[0], y = h[1], x = xl(useState(void 0 !== s ? s : r), 2), w = x[0], C = x[1], I = xl(useState(void 0 !== b ? b : a), 2), A = I[0], k = I[1], O = useCallback((function (e, t) { "function" == typeof p && p(e, t), k(e); }), [p]), T = useCallback((function (e, t) { var n; "function" == typeof u && (n = u(e, t)), y(void 0 !== n ? n : e); }), [u]), E = useCallback((function () { "function" == typeof f && f(), C(!0); }), [f]), S = useCallback((function () { "function" == typeof d && d(), C(!1); }), [d]), B = void 0 !== l ? l : m, G = void 0 !== s ? s : w, N = void 0 !== b ? b : A; return ya(ya({}, g), {}, { inputValue: B, menuIsOpen: G, onChange: O, onInputChange: T, onMenuClose: S, onMenuOpen: E, value: N }) }(e); return React.createElement(bs, Mo({ ref: t }, n)) })), Ls = Ms, Vs = function () { return jsx(Nn, { margin: "0 0 0 5px", down: !0, black: !0 }, void 0) }, Ws = function (t) { var n, o, r = t.noOptionsMessage, i = t.readOnly, a = t.hideDropdownIndicator, l = t.selectedOption, s = t.styles, c = t.testId, p = O(t, ["noOptionsMessage", "readOnly", "hideDropdownIndicator", "selectedOption", "styles", "testId"]); return i ? jsx(Oo, { children: null !== (n = null == l ? void 0 : l.label) && void 0 !== n ? n : "—" }, void 0) : jsx(Ls, k$1({ "data-testid": c, theme: function (e) { return k$1(k$1({}, e), { borderRadius: 0 }) }, components: { DropdownIndicator: a ? null : Vs }, noOptionsMessage: r, styles: (o = s, void 0 === o && (o = {}), { container: function (e) { return k$1(k$1({}, e), { width: "100%", fontSize: "12px", fontFamily: "inherit" }) }, control: function (e, t) { var n = t.isFocused, o = t.isDisabled; return k$1(k$1({}, e), { minHeight: "30px", backgroundColor: o ? Ee.disabledInputSelectColor : Ee.defaultBackground, border: "1px solid ".concat(Ee.defaultBorder), borderRadius: "4px", paddingLeft: "16px", boxShadow: "none", zIndex: 2, borderBottomRightRadius: n ? "0px" : "4px", borderBottomLeftRadius: n ? "0px" : "4px", overflow: "hidden", textOverflow: "ellipsis", "&:hover": { border: "1px solid ".concat(Ee.defaultBorder), cursor: "text" } }) }, placeholder: function (e) { return k$1(k$1({}, e), { color: Ee.disabledInputColor }) }, valueContainer: function (e) { var t; return k$1(k$1({}, e), { position: "relative", width: "calc(100% - 30px)", padding: "0px", color: Ee.disabledInputColor, fontSize: null !== (t = o.valueContainerFontSize) && void 0 !== t ? t : "12px" }) }, indicatorSeparator: function () { return { display: "none" } }, indicatorsContainer: function (e) { return k$1(k$1({}, e), { marginRight: "10px" }) }, clearIndicator: function (e) { return k$1(k$1({}, e), { padding: "4px", "&:hover": { cursor: "pointer" } }) }, dropdownIndicator: function (e) { return k$1(k$1({}, e), { padding: "7px", "&:hover": { cursor: "pointer" } }) }, option: function (e, t) { var n; return t.isFocused && (n = Ee.tableRowHover), t.isSelected && (n = Ee.buttonSecondary), k$1(k$1({}, e), { paddingLeft: "18px", color: Ee.defaultColor, backgroundColor: n, cursor: "pointer", borderRight: "0.5px solid ".concat(Ee.defaultBorder), boxShadow: "none", overflow: "hidden", textOverflow: "ellipsis" }) }, menu: function (e) { return k$1(k$1({}, e), { borderTopLeftRadius: "0px", borderTopRightRadius: "0px", marginTop: "-1px", border: "0.5px solid ".concat(Ee.defaultBorder), boxShadow: "none", zIndex: 99 }) } }) }, p), void 0) }; o$1(Yt)(gs || (gs = E(["\n    bottom-padding: ", ";\n"], ["\n    bottom-padding: ", ";\n"])), (function (e) { return e.bottomPadding })); o$1(Zt)(hs || (hs = E(["\n    bottom-padding: ", ";\n"], ["\n    bottom-padding: ", ";\n"])), (function (e) { return e.bottomPadding })); var js = { RESPONSIVE_SIDEBAR: { collapsedHeight: "58px" } }; o$1.div(ms || (ms = E(["\n    display: flex;\n    flex-direction: row;\n\n    flex: 1;\n\n    height: 100%;\n"], ["\n    display: flex;\n    flex-direction: row;\n\n    flex: 1;\n\n    height: 100%;\n"]))); o$1.div(vs || (vs = E(["\n    display: flex;\n    flex: 3;\n    flex-direction: column;\n    overflow-y: auto;\n\n    ", "\n"], ["\n    display: flex;\n    flex: 3;\n    flex-direction: column;\n    overflow-y: auto;\n\n    ", "\n"])), (function (e) { return e.fullWidth && "\n        align-items: center;\n    " })); o$1.div(ys || (ys = E(["\n    position: relative;\n"], ["\n    position: relative;\n"]))); o$1.div(xs || (xs = E(["\n    display: flex;\n    width: ", ";\n    height: 100%;\n    flex-direction: column;\n\n    background-color: ", ";\n    border-right: 1px solid ", ";\n\n    overflow: hidden;\n\n    transition: width 0.5s;\n    transition-timing-function: ease-in-out;\n    will-change: width;\n\n    box-sizing: border-box;\n\n    ", "\n"], ["\n    display: flex;\n    width: ", ";\n    height: 100%;\n    flex-direction: column;\n\n    background-color: ", ";\n    border-right: 1px solid ", ";\n\n    overflow: hidden;\n\n    transition: width 0.5s;\n    transition-timing-function: ease-in-out;\n    will-change: width;\n\n    box-sizing: border-box;\n\n    ", "\n"])), (function (e) { return e.sidebarWidth }), Ee.sidebarLayoutSidebar, Ee.defaultBorder, (function (e) { return e.responsive && "\n        @media (max-width: ".concat(e.responsiveMaxDeviceWidth, ") {\n            border-top: 1px solid ").concat(Ee.defaultBorder, ";\n            border-left: none;\n            border-right: none;\n\n            height: 100% !important;\n            width: 100%;\n            max-width: 100%;\n\n            position: fixed;\n            top: ").concat(e.open ? "0px" : "calc(100% - ".concat(js.RESPONSIVE_SIDEBAR.collapsedHeight, ")"), ";\n            left: 0;\n            z-index: 50;\n\n            transition: top 0.5s;\n            transition-timing-function: ease-in-out;\n            will-change: top;\n        }\n    ") })); o$1.div(ws || (ws = E(["\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    overflow-x: hidden;\n    padding: ", ";\n"], ["\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    overflow-x: hidden;\n    padding: ", ";\n"])), (function (e) { return e.flush ? "0" : "24px" })); o$1.div(Cs || (Cs = E(["\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    width: ", ";\n    @media (max-width: ", ") {\n        width: 100% !important;\n    }\n\n    overflow-x: hidden;\n\n    padding: ", ";\n"], ["\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    width: ", ";\n    @media (max-width: ", ") {\n        width: 100% !important;\n    }\n\n    overflow-x: hidden;\n\n    padding: ", ";\n"])), (function (e) { var t = e.minWidth; return null != t ? t : "100%" }), (function (e) { return e.responsiveMaxDeviceWidth }), (function (e) { return e.flush ? "0" : "24px" })); o$1.div(Is || (Is = E(["\n    display: flex;\n    align-items: flex-end;\n    flex: 1;\n"], ["\n    display: flex;\n    align-items: flex-end;\n    flex: 1;\n"]))); o$1.div(As || (As = E(["\n    width: 100%;\n\n    padding: 20px 24px;\n\n    border-bottom: 1px solid ", ";\n\n    &:last-child {\n        border-bottom: 0;\n    }\n\n    box-sizing: border-box;\n"], ["\n    width: 100%;\n\n    padding: 20px 24px;\n\n    border-bottom: 1px solid ", ";\n\n    &:last-child {\n        border-bottom: 0;\n    }\n\n    box-sizing: border-box;\n"])), Ee.defaultBorder); o$1.div(ks || (ks = E(["\n    display: flex;\n    flex-direction: column;\n\n    background-color: ", ";\n    flex-shrink: 0;\n"], ["\n    display: flex;\n    flex-direction: column;\n\n    background-color: ", ";\n    flex-shrink: 0;\n"])), Ee.sidebarLayoutSidebar); o$1.div(Os || (Os = E(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    cursor: ", ";\n    color: ", ";\n\n    width: 100%;\n    padding: 20px 24px;\n    border-bottom: 1px solid ", ";\n\n    &:hover {\n        color: ", ";\n    }\n\n    box-sizing: border-box;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    cursor: ", ";\n    color: ", ";\n\n    width: 100%;\n    padding: 20px 24px;\n    border-bottom: 1px solid ", ";\n\n    &:hover {\n        color: ", ";\n    }\n\n    box-sizing: border-box;\n"])), (function (e) { return e.onClick ? "pointer" : "initial" }), (function (e) { return e.active ? Ee.black : Ee.defaultSubtleColor7B }), Ee.defaultBorder, (function (e) { var t = e.active; return e.onClick || t ? Ee.black : Ee.defaultSubtleColor7B })); o$1.h1(Ts || (Ts = E(["\n    font-size: 20px;\n    font-weight: normal;\n"], ["\n    font-size: 20px;\n    font-weight: normal;\n"]))); o$1.div(Es || (Es = E(["\n    display: flex;\n    flex-direction: column;\n\n    background-color: ", ";\n    padding: 24px;\n    border-bottom: 1px solid ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n\n    background-color: ", ";\n    padding: 24px;\n    border-bottom: 1px solid ", ";\n"])), Ee.sidebarLayoutSidebarSubcontent, Ee.defaultBorder); o$1.div(Ss || (Ss = E(["\n    display: none;\n    @media (max-width: ", ") {\n        display: block;\n    }\n"], ["\n    display: none;\n    @media (max-width: ", ") {\n        display: block;\n    }\n"])), (function (e) { return e.responsiveMaxDeviceWidth })); o$1.div(Bs || (Bs = E(["\n    display: block;\n    @media (max-width: ", ") {\n        display: none;\n    }\n"], ["\n    display: block;\n    @media (max-width: ", ") {\n        display: none;\n    }\n"])), (function (e) { return e.responsiveMaxDeviceWidth })); o$1.div(Gs || (Gs = E(["\n    position: absolute;\n    z-index: 5;\n    top: ", ";\n    left: ", ";\n\n    box-shadow: rgba(9, 30, 66, 0.08) 0px 0px 0px 1px, rgba(9, 30, 66, 0.08) 0px 2px 4px 1px;\n    color: rgb(107, 119, 140);\n    cursor: pointer;\n    height: 24px;\n    width: 24px;\n    transform: translate(-50%);\n    background: 0px center white;\n    border-radius: 50%;\n\n    transition: all 0.5s;\n    transition-timing-function: ease-in-out;\n    will-change: all;\n\n    > span {\n        margin: 8px;\n    }\n\n    ", "\n"], ["\n    position: absolute;\n    z-index: 5;\n    top: ", ";\n    left: ", ";\n\n    box-shadow: rgba(9, 30, 66, 0.08) 0px 0px 0px 1px, rgba(9, 30, 66, 0.08) 0px 2px 4px 1px;\n    color: rgb(107, 119, 140);\n    cursor: pointer;\n    height: 24px;\n    width: 24px;\n    transform: translate(-50%);\n    background: 0px center white;\n    border-radius: 50%;\n\n    transition: all 0.5s;\n    transition-timing-function: ease-in-out;\n    will-change: all;\n\n    > span {\n        margin: 8px;\n    }\n\n    ", "\n"])), (function (e) { var t = e.top; return null != t ? t : "20px" }), (function (e) { var t = e.leftOffset; return null != t ? t : "300px" }), (function (e) { return e.responsive && "\n        @media (max-width: ".concat(e.responsiveMaxDeviceWidth, ") {\n            position: inherit;\n\n            height: auto;\n            width: auto;\n\n            box-shadow: none;\n            transform: rotate(").concat(e.open ? "0" : "180", "deg);\n\n            color: ").concat(Ee.sidebarLayoutResponsiveCaretColor, ";\n\n            transition: top 0.5s;\n            transition-timing-function: ease-in-out;\n            will-change: top;\n\n            > span {\n                width: 18px;\n                height: 11px;\n                margin: 0px 12px 1px 12px;\n            }\n        }\n    ") })); o$1.div(Ns || (Ns = E(["\n    ", "\n"], ["\n    ", "\n"])), (function (e) { return e.responsive && "\n        @media (max-width: ".concat(e.responsiveMaxDeviceWidth, ") {\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n\n            margin: 10px;\n            padding: 7px 10px;\n            font-size: 18px;\n            line-height: 20px;\n\n            background-color: ").concat(Ee.white, ";\n            border: 1px solid ").concat(Ee.defaultBorder, ";\n            box-shadow: 3px 2px 1px 1px ").concat(Ee.disabledBorder, ";\n            border-radius: 30px;\n\n            color: ").concat(Ee.sidebarLayoutResponsiveTitle, ";\n            font-size: 18px;\n        }\n    ") })); o$1.div(Ps || (Ps = E(["\n    display: none;\n\n    ", "\n"], ["\n    display: none;\n\n    ", "\n"])), (function (e) { return e.responsive && "\n        @media (max-width: ".concat(e.responsiveMaxDeviceWidth, ") {\n            display: flex;\n            align-items: center;\n        }\n    ") })); o$1.div(Rs || (Rs = E(["\n    min-width: 60px;\n    background-color: ", ";\n    padding: 5px;\n    border: 1px solid ", ";\n    border-radius: 3px;\n    flex: 1;\n"], ["\n    min-width: 60px;\n    background-color: ", ";\n    padding: 5px;\n    border: 1px solid ", ";\n    border-radius: 3px;\n    flex: 1;\n"])), L, Y); var dc, fc, hc = keyframes(dc || (dc = E(["\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n"], ["\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n"]))), mc = o$1.span(fc || (fc = E(["\n    display: inline-block;\n    width: ", "!important;\n    height: ", "!important;\n\n    margin: 0 auto;\n\n    border: ", " solid ", ";\n    border-radius: 50%;\n    border-top: ", " solid ", ";\n\n    animation: ", " ", " linear infinite;\n"], ["\n    display: inline-block;\n    width: ", "!important;\n    height: ", "!important;\n\n    margin: 0 auto;\n\n    border: ", " solid ", ";\n    border-radius: 50%;\n    border-top: ", " solid ", ";\n\n    animation: ", " ", " linear infinite;\n"])), (function (e) { return e.size }), (function (e) { return e.size }), (function (e) { return e.width }), de.loader.backgroundColor, (function (e) { return e.width }), de.loader.color, hc, (function (e) { return e.speed })), vc = function (t) { var n = t.loading, o = void 0 !== n && n, r = t.speed, i = void 0 === r ? "2s" : r, a = t.size, l = void 0 === a ? "50px" : a, s = t.title, c = void 0 === s ? "Loading" : s, p = t.width; return o ? jsx(mc, { speed: i, size: l, title: c, width: void 0 === p ? "5px" : p }, void 0) : null }, xc = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator, wc = function () { for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)if (xc && navigator.userAgent.indexOf(e[t]) >= 0) return 1; return 0 }(); var Cc = xc && window.Promise ? function (e) { var t = !1; return function () { t || (t = !0, window.Promise.resolve().then((function () { t = !1, e(); }))); } } : function (e) { var t = !1; return function () { t || (t = !0, setTimeout((function () { t = !1, e(); }), wc)); } }; function Ic(e) { return e && "[object Function]" === {}.toString.call(e) } function Ac(e, t) { if (1 !== e.nodeType) return []; var n = e.ownerDocument.defaultView.getComputedStyle(e, null); return t ? n[t] : n } function kc(e) { return "HTML" === e.nodeName ? e : e.parentNode || e.host } function Oc(e) { if (!e) return document.body; switch (e.nodeName) { case "HTML": case "BODY": return e.ownerDocument.body; case "#document": return e.body }var t = Ac(e), n = t.overflow, o = t.overflowX, r = t.overflowY; return /(auto|scroll|overlay)/.test(n + r + o) ? e : Oc(kc(e)) } function Tc(e) { return e && e.referenceNode ? e.referenceNode : e } var Ec = xc && !(!window.MSInputMethodContext || !document.documentMode), Sc = xc && /MSIE 10/.test(navigator.userAgent); function Bc(e) { return 11 === e ? Ec : 10 === e ? Sc : Ec || Sc } function Gc(e) { if (!e) return document.documentElement; for (var t = Bc(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;)n = (e = e.nextElementSibling).offsetParent; var o = n && n.nodeName; return o && "BODY" !== o && "HTML" !== o ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === Ac(n, "position") ? Gc(n) : n : e ? e.ownerDocument.documentElement : document.documentElement } function Nc(e) { return null !== e.parentNode ? Nc(e.parentNode) : e } function Pc(e, t) { if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement; var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, o = n ? e : t, r = n ? t : e, i = document.createRange(); i.setStart(o, 0), i.setEnd(r, 0); var a, l, s = i.commonAncestorContainer; if (e !== s && t !== s || o.contains(r)) return "BODY" === (l = (a = s).nodeName) || "HTML" !== l && Gc(a.firstElementChild) !== a ? Gc(s) : s; var c = Nc(e); return c.host ? Pc(c.host, t) : Pc(e, Nc(t).host) } function Rc(e) { var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top", n = "top" === t ? "scrollTop" : "scrollLeft", o = e.nodeName; if ("BODY" === o || "HTML" === o) { var r = e.ownerDocument.documentElement, i = e.ownerDocument.scrollingElement || r; return i[n] } return e[n] } function Mc(e, t) { var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], o = Rc(t, "top"), r = Rc(t, "left"), i = n ? -1 : 1; return e.top += o * i, e.bottom += o * i, e.left += r * i, e.right += r * i, e } function Lc(e, t) { var n = "x" === t ? "Left" : "Top", o = "Left" === n ? "Right" : "Bottom"; return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + o + "Width"]) } function Xc(e, t, n, o) { return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], Bc(10) ? parseInt(n["offset" + e]) + parseInt(o["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(o["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0) } function Vc(e) { var t = e.body, n = e.documentElement, o = Bc(10) && getComputedStyle(n); return { height: Xc("Height", t, n, o), width: Xc("Width", t, n, o) } } var Wc = function (e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") }, Hc = function () { function e(e, t) { for (var n = 0; n < t.length; n++) { var o = t[n]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o); } } return function (t, n, o) { return n && e(t.prototype, n), o && e(t, o), t } }(), Fc = function (e, t, n) { return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e }, Dc = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var n = arguments[t]; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]); } return e }; function zc(e) { return Dc({}, e, { right: e.left + e.width, bottom: e.top + e.height }) } function jc(e) { var t = {}; try { if (Bc(10)) { t = e.getBoundingClientRect(); var n = Rc(e, "top"), o = Rc(e, "left"); t.top += n, t.left += o, t.bottom += n, t.right += o; } else t = e.getBoundingClientRect(); } catch (e) { } var r = { left: t.left, top: t.top, width: t.right - t.left, height: t.bottom - t.top }, i = "HTML" === e.nodeName ? Vc(e.ownerDocument) : {}, a = i.width || e.clientWidth || r.width, l = i.height || e.clientHeight || r.height, s = e.offsetWidth - a, c = e.offsetHeight - l; if (s || c) { var p = Ac(e); s -= Lc(p, "x"), c -= Lc(p, "y"), r.width -= s, r.height -= c; } return zc(r) } function Zc(e, t) { var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], o = Bc(10), r = "HTML" === t.nodeName, i = jc(e), a = jc(t), l = Oc(e), s = Ac(t), c = parseFloat(s.borderTopWidth), p = parseFloat(s.borderLeftWidth); n && r && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0)); var u = zc({ top: i.top - a.top - c, left: i.left - a.left - p, width: i.width, height: i.height }); if (u.marginTop = 0, u.marginLeft = 0, !o && r) { var d = parseFloat(s.marginTop), f = parseFloat(s.marginLeft); u.top -= c - d, u.bottom -= c - d, u.left -= p - f, u.right -= p - f, u.marginTop = d, u.marginLeft = f; } return (o && !n ? t.contains(l) : t === l && "BODY" !== l.nodeName) && (u = Mc(u, t)), u } function Yc(e) { var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = e.ownerDocument.documentElement, o = Zc(e, n), r = Math.max(n.clientWidth, window.innerWidth || 0), i = Math.max(n.clientHeight, window.innerHeight || 0), a = t ? 0 : Rc(n), l = t ? 0 : Rc(n, "left"), s = { top: a - o.top + o.marginTop, left: l - o.left + o.marginLeft, width: r, height: i }; return zc(s) } function _c$1(e) { var t = e.nodeName; if ("BODY" === t || "HTML" === t) return !1; if ("fixed" === Ac(e, "position")) return !0; var n = kc(e); return !!n && _c$1(n) } function Jc(e) { if (!e || !e.parentElement || Bc()) return document.documentElement; for (var t = e.parentElement; t && "none" === Ac(t, "transform");)t = t.parentElement; return t || document.documentElement } function Uc(e, t, n, o) { var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], i = { top: 0, left: 0 }, a = r ? Jc(e) : Pc(e, Tc(t)); if ("viewport" === o) i = Yc(a, r); else { var l = void 0; "scrollParent" === o ? "BODY" === (l = Oc(kc(t))).nodeName && (l = e.ownerDocument.documentElement) : l = "window" === o ? e.ownerDocument.documentElement : o; var s = Zc(l, a, r); if ("HTML" !== l.nodeName || _c$1(a)) i = s; else { var c = Vc(e.ownerDocument), p = c.height, u = c.width; i.top += s.top - s.marginTop, i.bottom = p + s.top, i.left += s.left - s.marginLeft, i.right = u + s.left; } } var d = "number" == typeof (n = n || 0); return i.left += d ? n : n.left || 0, i.top += d ? n : n.top || 0, i.right -= d ? n : n.right || 0, i.bottom -= d ? n : n.bottom || 0, i } function Qc(e) { return e.width * e.height } function Kc(e, t, n, o, r) { var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0; if (-1 === e.indexOf("auto")) return e; var a = Uc(n, o, i, r), l = { top: { width: a.width, height: t.top - a.top }, right: { width: a.right - t.right, height: a.height }, bottom: { width: a.width, height: a.bottom - t.bottom }, left: { width: t.left - a.left, height: a.height } }, s = Object.keys(l).map((function (e) { return Dc({ key: e }, l[e], { area: Qc(l[e]) }) })).sort((function (e, t) { return t.area - e.area })), c = s.filter((function (e) { var t = e.width, o = e.height; return t >= n.clientWidth && o >= n.clientHeight })), p = c.length > 0 ? c[0].key : s[0].key, u = e.split("-")[1]; return p + (u ? "-" + u : "") } function qc(e, t, n) { var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, r = o ? Jc(t) : Pc(t, Tc(n)); return Zc(n, r, o) } function $c(e) { var t = e.ownerDocument.defaultView.getComputedStyle(e), n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0), o = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0); return { width: e.offsetWidth + o, height: e.offsetHeight + n } } function ep(e) { var t = { left: "right", right: "left", bottom: "top", top: "bottom" }; return e.replace(/left|right|bottom|top/g, (function (e) { return t[e] })) } function tp(e, t, n) { n = n.split("-")[0]; var o = $c(e), r = { width: o.width, height: o.height }, i = -1 !== ["right", "left"].indexOf(n), a = i ? "top" : "left", l = i ? "left" : "top", s = i ? "height" : "width", c = i ? "width" : "height"; return r[a] = t[a] + t[s] / 2 - o[s] / 2, r[l] = n === l ? t[l] - o[c] : t[ep(l)], r } function np(e, t) { return Array.prototype.find ? e.find(t) : e.filter(t)[0] } function op(e, t, n) { var o = void 0 === n ? e : e.slice(0, function (e, t, n) { if (Array.prototype.findIndex) return e.findIndex((function (e) { return e[t] === n })); var o = np(e, (function (e) { return e[t] === n })); return e.indexOf(o) }(e, "name", n)); return o.forEach((function (e) { e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!"); var n = e.function || e.fn; e.enabled && Ic(n) && (t.offsets.popper = zc(t.offsets.popper), t.offsets.reference = zc(t.offsets.reference), t = n(t, e)); })), t } function rp() { if (!this.state.isDestroyed) { var e = { instance: this, styles: {}, arrowStyles: {}, attributes: {}, flipped: !1, offsets: {} }; e.offsets.reference = qc(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = Kc(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = tp(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = op(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e)); } } function ip(e, t) { return e.some((function (e) { var n = e.name; return e.enabled && n === t })) } function ap(e) { for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), o = 0; o < t.length; o++) { var r = t[o], i = r ? "" + r + n : e; if (void 0 !== document.body.style[i]) return i } return null } function lp() { return this.state.isDestroyed = !0, ip(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[ap("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this } function sp(e) { var t = e.ownerDocument; return t ? t.defaultView : window } function cp(e, t, n, o) { var r = "BODY" === e.nodeName, i = r ? e.ownerDocument.defaultView : e; i.addEventListener(t, n, { passive: !0 }), r || cp(Oc(i.parentNode), t, n, o), o.push(i); } function pp(e, t, n, o) { n.updateBound = o, sp(e).addEventListener("resize", n.updateBound, { passive: !0 }); var r = Oc(e); return cp(r, "scroll", n.updateBound, n.scrollParents), n.scrollElement = r, n.eventsEnabled = !0, n } function up() { this.state.eventsEnabled || (this.state = pp(this.reference, this.options, this.state, this.scheduleUpdate)); } function dp() { var e, t; this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, sp(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach((function (e) { e.removeEventListener("scroll", t.updateBound); })), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t)); } function fp(e) { return "" !== e && !isNaN(parseFloat(e)) && isFinite(e) } function bp(e, t) { Object.keys(t).forEach((function (n) { var o = ""; -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && fp(t[n]) && (o = "px"), e.style[n] = t[n] + o; })); } var gp = xc && /Firefox/i.test(navigator.userAgent); function hp(e, t, n) { var o = np(e, (function (e) { return e.name === t })), r = !!o && e.some((function (e) { return e.name === n && e.enabled && e.order < o.order })); if (!r) { var i = "`" + t + "`", a = "`" + n + "`"; console.warn(a + " modifier is required by " + i + " modifier in order to work, be sure to include it before " + i + "!"); } return r } var mp = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], vp = mp.slice(3); function yp(e) { var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = vp.indexOf(e), o = vp.slice(n + 1).concat(vp.slice(0, n)); return t ? o.reverse() : o } var xp = "flip", wp = "clockwise", Cp = "counterclockwise"; function Ip(e, t, n, o) { var r = [0, 0], i = -1 !== ["right", "left"].indexOf(o), a = e.split(/(\+|\-)/).map((function (e) { return e.trim() })), l = a.indexOf(np(a, (function (e) { return -1 !== e.search(/,|\s/) }))); a[l] && -1 === a[l].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead."); var s = /\s*,\s*|\s+/, c = -1 !== l ? [a.slice(0, l).concat([a[l].split(s)[0]]), [a[l].split(s)[1]].concat(a.slice(l + 1))] : [a]; return c = c.map((function (e, o) { var r = (1 === o ? !i : i) ? "height" : "width", a = !1; return e.reduce((function (e, t) { return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, a = !0, e) : a ? (e[e.length - 1] += t, a = !1, e) : e.concat(t) }), []).map((function (e) { return function (e, t, n, o) { var r = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), i = +r[1], a = r[2]; if (!i) return e; if (0 === a.indexOf("%")) { return zc("%p" === a ? n : o)[t] / 100 * i } if ("vh" === a || "vw" === a) return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * i; return i }(e, r, t, n) })) })), c.forEach((function (e, t) { e.forEach((function (n, o) { fp(n) && (r[t] += n * ("-" === e[o - 1] ? -1 : 1)); })); })), r } var Ap, kp = { shift: { order: 100, enabled: !0, fn: function (e) { var t = e.placement, n = t.split("-")[0], o = t.split("-")[1]; if (o) { var r = e.offsets, i = r.reference, a = r.popper, l = -1 !== ["bottom", "top"].indexOf(n), s = l ? "left" : "top", c = l ? "width" : "height", p = { start: Fc({}, s, i[s]), end: Fc({}, s, i[s] + i[c] - a[c]) }; e.offsets.popper = Dc({}, a, p[o]); } return e } }, offset: { order: 200, enabled: !0, fn: function (e, t) { var n = t.offset, o = e.placement, r = e.offsets, i = r.popper, a = r.reference, l = o.split("-")[0], s = void 0; return s = fp(+n) ? [+n, 0] : Ip(n, i, a, l), "left" === l ? (i.top += s[0], i.left -= s[1]) : "right" === l ? (i.top += s[0], i.left += s[1]) : "top" === l ? (i.left += s[0], i.top -= s[1]) : "bottom" === l && (i.left += s[0], i.top += s[1]), e.popper = i, e }, offset: 0 }, preventOverflow: { order: 300, enabled: !0, fn: function (e, t) { var n = t.boundariesElement || Gc(e.instance.popper); e.instance.reference === n && (n = Gc(n)); var o = ap("transform"), r = e.instance.popper.style, i = r.top, a = r.left, l = r[o]; r.top = "", r.left = "", r[o] = ""; var s = Uc(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed); r.top = i, r.left = a, r[o] = l, t.boundaries = s; var c = t.priority, p = e.offsets.popper, u = { primary: function (e) { var n = p[e]; return p[e] < s[e] && !t.escapeWithReference && (n = Math.max(p[e], s[e])), Fc({}, e, n) }, secondary: function (e) { var n = "right" === e ? "left" : "top", o = p[n]; return p[e] > s[e] && !t.escapeWithReference && (o = Math.min(p[n], s[e] - ("right" === e ? p.width : p.height))), Fc({}, n, o) } }; return c.forEach((function (e) { var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary"; p = Dc({}, p, u[t](e)); })), e.offsets.popper = p, e }, priority: ["left", "right", "top", "bottom"], padding: 5, boundariesElement: "scrollParent" }, keepTogether: { order: 400, enabled: !0, fn: function (e) { var t = e.offsets, n = t.popper, o = t.reference, r = e.placement.split("-")[0], i = Math.floor, a = -1 !== ["top", "bottom"].indexOf(r), l = a ? "right" : "bottom", s = a ? "left" : "top", c = a ? "width" : "height"; return n[l] < i(o[s]) && (e.offsets.popper[s] = i(o[s]) - n[c]), n[s] > i(o[l]) && (e.offsets.popper[s] = i(o[l])), e } }, arrow: { order: 500, enabled: !0, fn: function (e, t) { var n; if (!hp(e.instance.modifiers, "arrow", "keepTogether")) return e; var o = t.element; if ("string" == typeof o) { if (!(o = e.instance.popper.querySelector(o))) return e } else if (!e.instance.popper.contains(o)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e; var r = e.placement.split("-")[0], i = e.offsets, a = i.popper, l = i.reference, s = -1 !== ["left", "right"].indexOf(r), c = s ? "height" : "width", p = s ? "Top" : "Left", u = p.toLowerCase(), d = s ? "left" : "top", f = s ? "bottom" : "right", b = $c(o)[c]; l[f] - b < a[u] && (e.offsets.popper[u] -= a[u] - (l[f] - b)), l[u] + b > a[f] && (e.offsets.popper[u] += l[u] + b - a[f]), e.offsets.popper = zc(e.offsets.popper); var g = l[u] + l[c] / 2 - b / 2, h = Ac(e.instance.popper), m = parseFloat(h["margin" + p]), v = parseFloat(h["border" + p + "Width"]), y = g - e.offsets.popper[u] - m - v; return y = Math.max(Math.min(a[c] - b, y), 0), e.arrowElement = o, e.offsets.arrow = (Fc(n = {}, u, Math.round(y)), Fc(n, d, ""), n), e }, element: "[x-arrow]" }, flip: { order: 600, enabled: !0, fn: function (e, t) { if (ip(e.instance.modifiers, "inner")) return e; if (e.flipped && e.placement === e.originalPlacement) return e; var n = Uc(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed), o = e.placement.split("-")[0], r = ep(o), i = e.placement.split("-")[1] || "", a = []; switch (t.behavior) { case xp: a = [o, r]; break; case wp: a = yp(o); break; case Cp: a = yp(o, !0); break; default: a = t.behavior; }return a.forEach((function (l, s) { if (o !== l || a.length === s + 1) return e; o = e.placement.split("-")[0], r = ep(o); var c = e.offsets.popper, p = e.offsets.reference, u = Math.floor, d = "left" === o && u(c.right) > u(p.left) || "right" === o && u(c.left) < u(p.right) || "top" === o && u(c.bottom) > u(p.top) || "bottom" === o && u(c.top) < u(p.bottom), f = u(c.left) < u(n.left), b = u(c.right) > u(n.right), g = u(c.top) < u(n.top), h = u(c.bottom) > u(n.bottom), m = "left" === o && f || "right" === o && b || "top" === o && g || "bottom" === o && h, v = -1 !== ["top", "bottom"].indexOf(o), y = !!t.flipVariations && (v && "start" === i && f || v && "end" === i && b || !v && "start" === i && g || !v && "end" === i && h), x = !!t.flipVariationsByContent && (v && "start" === i && b || v && "end" === i && f || !v && "start" === i && h || !v && "end" === i && g), w = y || x; (d || m || w) && (e.flipped = !0, (d || m) && (o = a[s + 1]), w && (i = function (e) { return "end" === e ? "start" : "start" === e ? "end" : e }(i)), e.placement = o + (i ? "-" + i : ""), e.offsets.popper = Dc({}, e.offsets.popper, tp(e.instance.popper, e.offsets.reference, e.placement)), e = op(e.instance.modifiers, e, "flip")); })), e }, behavior: "flip", padding: 5, boundariesElement: "viewport", flipVariations: !1, flipVariationsByContent: !1 }, inner: { order: 700, enabled: !1, fn: function (e) { var t = e.placement, n = t.split("-")[0], o = e.offsets, r = o.popper, i = o.reference, a = -1 !== ["left", "right"].indexOf(n), l = -1 === ["top", "left"].indexOf(n); return r[a ? "left" : "top"] = i[n] - (l ? r[a ? "width" : "height"] : 0), e.placement = ep(t), e.offsets.popper = zc(r), e } }, hide: { order: 800, enabled: !0, fn: function (e) { if (!hp(e.instance.modifiers, "hide", "preventOverflow")) return e; var t = e.offsets.reference, n = np(e.instance.modifiers, (function (e) { return "preventOverflow" === e.name })).boundaries; if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) { if (!0 === e.hide) return e; e.hide = !0, e.attributes["x-out-of-boundaries"] = ""; } else { if (!1 === e.hide) return e; e.hide = !1, e.attributes["x-out-of-boundaries"] = !1; } return e } }, computeStyle: { order: 850, enabled: !0, fn: function (e, t) { var n = t.x, o = t.y, r = e.offsets.popper, i = np(e.instance.modifiers, (function (e) { return "applyStyle" === e.name })).gpuAcceleration; void 0 !== i && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"); var a = void 0 !== i ? i : t.gpuAcceleration, l = Gc(e.instance.popper), s = jc(l), c = { position: r.position }, p = function (e, t) { var n = e.offsets, o = n.popper, r = n.reference, i = Math.round, a = Math.floor, l = function (e) { return e }, s = i(r.width), c = i(o.width), p = -1 !== ["left", "right"].indexOf(e.placement), u = -1 !== e.placement.indexOf("-"), d = t ? p || u || s % 2 == c % 2 ? i : a : l, f = t ? i : l; return { left: d(s % 2 == 1 && c % 2 == 1 && !u && t ? o.left - 1 : o.left), top: f(o.top), bottom: f(o.bottom), right: d(o.right) } }(e, window.devicePixelRatio < 2 || !gp), u = "bottom" === n ? "top" : "bottom", d = "right" === o ? "left" : "right", f = ap("transform"), b = void 0, g = void 0; if (g = "bottom" === u ? "HTML" === l.nodeName ? -l.clientHeight + p.bottom : -s.height + p.bottom : p.top, b = "right" === d ? "HTML" === l.nodeName ? -l.clientWidth + p.right : -s.width + p.right : p.left, a && f) c[f] = "translate3d(" + b + "px, " + g + "px, 0)", c[u] = 0, c[d] = 0, c.willChange = "transform"; else { var h = "bottom" === u ? -1 : 1, m = "right" === d ? -1 : 1; c[u] = g * h, c[d] = b * m, c.willChange = u + ", " + d; } var v = { "x-placement": e.placement }; return e.attributes = Dc({}, v, e.attributes), e.styles = Dc({}, c, e.styles), e.arrowStyles = Dc({}, e.offsets.arrow, e.arrowStyles), e }, gpuAcceleration: !0, x: "bottom", y: "right" }, applyStyle: { order: 900, enabled: !0, fn: function (e) { var t, n; return bp(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach((function (e) { !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e); })), e.arrowElement && Object.keys(e.arrowStyles).length && bp(e.arrowElement, e.arrowStyles), e }, onLoad: function (e, t, n, o, r) { var i = qc(r, t, e, n.positionFixed), a = Kc(n.placement, i, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding); return t.setAttribute("x-placement", a), bp(t, { position: n.positionFixed ? "fixed" : "absolute" }), n }, gpuAcceleration: void 0 } }, Op = { placement: "bottom", positionFixed: !1, eventsEnabled: !0, removeOnDestroy: !1, onCreate: function () { }, onUpdate: function () { }, modifiers: kp }, Tp = function () { function e(t, n) { var o = this, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}; Wc(this, e), this.scheduleUpdate = function () { return requestAnimationFrame(o.update) }, this.update = Cc(this.update.bind(this)), this.options = Dc({}, e.Defaults, r), this.state = { isDestroyed: !1, isCreated: !1, scrollParents: [] }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(Dc({}, e.Defaults.modifiers, r.modifiers)).forEach((function (t) { o.options.modifiers[t] = Dc({}, e.Defaults.modifiers[t] || {}, r.modifiers ? r.modifiers[t] : {}); })), this.modifiers = Object.keys(this.options.modifiers).map((function (e) { return Dc({ name: e }, o.options.modifiers[e]) })).sort((function (e, t) { return e.order - t.order })), this.modifiers.forEach((function (e) { e.enabled && Ic(e.onLoad) && e.onLoad(o.reference, o.popper, o.options, e, o.state); })), this.update(); var i = this.options.eventsEnabled; i && this.enableEventListeners(), this.state.eventsEnabled = i; } return Hc(e, [{ key: "update", value: function () { return rp.call(this) } }, { key: "destroy", value: function () { return lp.call(this) } }, { key: "enableEventListeners", value: function () { return up.call(this) } }, { key: "disableEventListeners", value: function () { return dp.call(this) } }]), e }(); Tp.Utils = ("undefined" != typeof window ? window : global).PopperUtils, Tp.placements = mp, Tp.Defaults = Op, Ap = function (e, t, n) { return function (e) { var t = {}; function n(o) { if (t[o]) return t[o].exports; var r = t[o] = { i: o, l: !1, exports: {} }; return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports } return n.m = e, n.c = t, n.i = function (e) { return e }, n.d = function (e, t, o) { n.o(e, t) || Object.defineProperty(e, t, { configurable: !1, enumerable: !0, get: o }); }, n.n = function (e) { var t = e && e.__esModule ? function () { return e.default } : function () { return e }; return n.d(t, "a", t), t }, n.o = function (e, t) { return Object.prototype.hasOwnProperty.call(e, t) }, n.p = "", n(n.s = 15) }([function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }); var o = t.Browser = {}; "undefined" != typeof window && (o.SUPPORTED = "requestAnimationFrame" in window, o.SUPPORTS_TOUCH = "ontouchstart" in window, o.touch = !1, o.dynamicInputDetection = !0, o.iOS = function () { return /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream }), t.Store = [], t.Selectors = { POPPER: ".tippy-popper", TOOLTIP: ".tippy-tooltip", CONTENT: ".tippy-tooltip-content", CIRCLE: "[x-circle]", ARROW: "[x-arrow]", TOOLTIPPED_EL: "[data-tooltipped]", CONTROLLER: "[data-tippy-controller]" }; var r = t.Defaults = { html: !1, position: "top", animation: "shift", animateFill: !0, arrow: !1, arrowSize: "regular", delay: 0, trigger: "mouseenter focus", duration: 350, interactive: !1, interactiveBorder: 2, theme: "dark", size: "regular", distance: 10, offset: 0, hideOnClick: !0, multiple: !1, followCursor: !1, inertia: !1, flipDuration: 350, sticky: !1, stickyDuration: 200, appendTo: function () { return document.body }, zIndex: 9999, touchHold: !1, performance: !1, dynamicTitle: !1, useContext: !1, reactInstance: void 0, popperOptions: {}, open: void 0, onRequestClose: function () { } }; t.DefaultsKeys = o.SUPPORTED && Object.keys(r); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { for (var t = [!1, "webkit"], n = e.charAt(0).toUpperCase() + e.slice(1), o = 0; o < t.length; o++) { var r = t[o], i = r ? "" + r + n : e; if (void 0 !== window.document.body.style[i]) return i } return null }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t) { return Array.prototype.find ? e.find(t) : e.filter(t)[0] }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { return e.replace(/-.+/, "") }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t) { return (Element.prototype.closest || function (e) { for (var t = this; t;) { if (o.matches.call(t, e)) return t; t = t.parentElement; } }).call(e, t) }; var o = n(8); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { window.requestAnimationFrame((function () { setTimeout(e, 0); })); }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { return { tooltip: e.querySelector(o.Selectors.TOOLTIP), circle: e.querySelector(o.Selectors.CIRCLE), content: e.querySelector(o.Selectors.CONTENT) } }; var o = n(0); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { return "visible" === e.style.visibility }; }, function (e, t, n) { function o(e) { for (var t = (this.document || this.ownerDocument).querySelectorAll(e), n = t.length; --n >= 0 && t.item(n) !== this;); return n > -1 } Object.defineProperty(t, "__esModule", { value: !0 }), t.matches = "undefined" == typeof window ? o : Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || o; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }); var o = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var n = arguments[t]; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]); } return e }, r = function () { function e(e, t) { for (var n = 0; n < t.length; n++) { var o = t[n]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o); } } return function (t, n, o) { return n && e(t.prototype, n), o && e(t, o), t } }(), i = n(13), a = c(i), l = c(n(30)), s = n(0); function c(e) { return e && e.__esModule ? e : { default: e } } var p = function (e) { return e.stopPropagation() }, u = { html: null, position: "top", animation: "shift", animateFill: !0, arrow: !1, delay: 0, hideDelay: 0, trigger: "mouseenter focus", duration: 375, hideDuration: 375, interactive: !1, interactiveBorder: 2, theme: "dark", offset: 0, hideOnClick: !0, multiple: !1, followCursor: !1, inertia: !1, popperOptions: {}, onShow: function () { }, onShown: function () { }, onHide: function () { }, onHidden: function () { }, disabled: !1, arrowSize: "regular", size: "regular", className: "", style: {}, distance: 10, onRequestClose: function () { }, sticky: !1, stickyDuration: 200, tag: "div", touchHold: !1, unmountHTMLWhenHide: !1, zIndex: 9999 }, d = Object.keys(u), f = function (e) { function t(e) { !function (e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") }(this, t); var n = function (e, t) { if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return !t || "object" != typeof t && "function" != typeof t ? e : t }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)); return n.initTippy = n._initTippy.bind(n), n.destroyTippy = n._destroyTippy.bind(n), n.updateTippy = n._updateTippy.bind(n), n.updateReactDom = n._updateReactDom.bind(n), n.showTooltip = n._showTooltip.bind(n), n.hideTooltip = n._hideTooltip.bind(n), n.updateSettings = n._updateSettings.bind(n), n.state = { reactDOMValue: null }, n } return function (e, t) { if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t); e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t); }(t, e), r(t, [{ key: "componentDidMount", value: function () { "undefined" != typeof window && "undefined" != typeof document && this.initTippy(); } }, { key: "componentWillUnmount", value: function () { "undefined" != typeof window && "undefined" != typeof document && this.destroyTippy(); } }, { key: "componentDidUpdate", value: function (e) { var t = this; if ("undefined" != typeof window && "undefined" != typeof document) { if (!1 === this.props.disabled && !0 === e.disabled) return this.updateSettings("disabled", !1), this.destroyTippy(), void this.initTippy(); if (!0 === this.props.disabled && !1 === e.disabled) return this.updateSettings("disabled", !0), void this.destroyTippy(); !0 !== this.props.open || e.open || (this.updateSettings("open", !0), setTimeout((function () { t.showTooltip(); }), 0)), !1 === this.props.open && !0 === e.open && (this.updateSettings("open", !1), this.hideTooltip()), this.props.html !== e.html && this.updateReactDom(), this.props.title !== e.title && this.updateTippy(); var n = function (e, t) { var n = []; return d.forEach((function (o) { e[o] !== t[o] && n.push(o); })), n }(this.props, e); n.forEach((function (e) { t.updateSettings(e, t.props[e]); })); } } }, { key: "_showTooltip", value: function () { if ("undefined" != typeof window && "undefined" != typeof document && this.tippy) { var e = this.tippy.getPopperElement(this.tooltipDOM); this.tippy.show(e, this.props.duration); } } }, { key: "_hideTooltip", value: function () { if ("undefined" != typeof window && "undefined" != typeof document && this.tippy) { var e = this.tippy.getPopperElement(this.tooltipDOM); this.tippy.hide(e, this.props.hideDuration); } } }, { key: "_updateSettings", value: function (e, t) { if ("undefined" != typeof window && "undefined" != typeof document && this.tippy) { var n = this.tippy.getPopperElement(this.tooltipDOM); this.tippy.updateSettings(n, e, t); } } }, { key: "_updateReactDom", value: function () { if ("undefined" != typeof window && "undefined" != typeof document && this.tippy) { this.updateSettings("reactDOM", this.props.html); var e = this.tippy.getPopperElement(this.tooltipDOM); ("visible" === e.style.visibility || this.props.open) && this.tippy.updateForReact(e, this.props.html); } } }, { key: "_updateTippy", value: function () { if ("undefined" != typeof window && "undefined" != typeof document && this.tippy) { var e = this.tippy.getPopperElement(this.tooltipDOM); this.tippy.update(e); } } }, { key: "_initTippy", value: function () { var e = this; "undefined" != typeof window && "undefined" != typeof document && s.Browser.SUPPORTED && (this.props.disabled ? this.tippy = null : (this.props.title && this.tooltipDOM.setAttribute("title", this.props.title), this.tippy = (0, l.default)(this.tooltipDOM, { disabled: this.props.disabled, position: this.props.position, animation: this.props.animation, animateFill: this.props.animateFill, arrow: this.props.arrow, arrowSize: this.props.arrowSize, delay: this.props.delay, hideDelay: this.props.hideDelay, trigger: this.props.trigger, duration: this.props.duration, hideDuration: this.props.hideDuration, interactive: this.props.interactive, interactiveBorder: this.props.interactiveBorder, theme: this.props.theme, offset: this.props.offset, hideOnClick: this.props.hideOnClick, multiple: this.props.multiple, size: this.props.size, followCursor: this.props.followCursor, inertia: this.props.inertia, popperOptions: this.props.popperOptions, onShow: this.props.onShow, onShown: this.props.onShown, onHide: this.props.onHide, onHidden: this.props.onHidden, distance: this.props.distance, reactDOM: this.props.html, setReactDOMValue: function (t) { return e.setState({ reactDOMValue: t }) }, unmountHTMLWhenHide: this.props.unmountHTMLWhenHide, open: this.props.open, sticky: this.props.sticky, stickyDuration: this.props.stickyDuration, tag: this.props.tag, touchHold: this.props.touchHold, onRequestClose: this.props.onRequestClose, useContext: this.props.useContext, reactInstance: this.props.useContext ? this : void 0, performance: !0, html: this.props.rawTemplate ? this.props.rawTemplate : void 0, zIndex: this.props.zIndex }), this.props.open && this.showTooltip())); } }, { key: "_destroyTippy", value: function () { if ("undefined" != typeof window && "undefined" != typeof document && this.tippy) { var e = this.tippy.getPopperElement(this.tooltipDOM); this.updateSettings("open", !1), this.tippy.hide(e, 0), this.tippy.destroy(e), this.tippy = null; } } }, { key: "render", value: function () { var e = this, t = this.props.tag; return a.default.createElement(a.default.Fragment, null, a.default.createElement(t, { ref: function (t) { e.tooltipDOM = t; }, title: this.props.title, className: this.props.className, tabIndex: this.props.tabIndex, style: o({ display: "inline" }, this.props.style) }, this.props.children), this.state.reactDOMValue && a.default.createElement("div", { onClick: p, onContextMenu: p, onDoubleClick: p, onDrag: p, onDragEnd: p, onDragEnter: p, onDragExit: p, onDragLeave: p, onDragOver: p, onDragStart: p, onDrop: p, onMouseDown: p, onMouseEnter: p, onMouseLeave: p, onMouseMove: p, onMouseOver: p, onMouseOut: p, onMouseUp: p, onKeyDown: p, onKeyPress: p, onKeyUp: p, onFocus: p, onBlur: p, onChange: p, onInput: p, onInvalid: p, onSubmit: p }, this.state.reactDOMValue)) } }]), t }(i.Component); f.defaultProps = u, t.default = f; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { var t = this, n = (0, i.default)(o.Store, (function (e) { return e.el === t })); if (n) { var l = n.popper, s = n.settings.offset, c = (0, r.default)(l.getAttribute("x-placement")), p = Math.round(l.offsetWidth / 2), u = Math.round(l.offsetHeight / 2), d = document.documentElement.offsetWidth || document.body.offsetWidth, f = e.pageX, b = e.pageY, g = void 0, h = void 0; switch (c) { case "top": g = f - p + s, h = b - 2.25 * u; break; case "left": g = f - 2 * p - 10, h = b - u + s; break; case "right": g = f + u, h = b - u + s; break; case "bottom": g = f - p + s, h = b + u / 1.5; }var m = f + 5 + p + s > d, v = f - 5 - p + s < 0; "top" !== c && "bottom" !== c || (m && (g = d - 5 - 2 * p), v && (g = 5)), l.style[(0, a.default)("transform")] = "translate3d(" + g + "px, " + h + "px, 0)"; } }; var o = n(0), r = l(n(3)), i = l(n(2)), a = l(n(1)); function l(e) { return e && e.__esModule ? e : { default: e } } l(n(4)); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { return -(e - o.Defaults.distance) + "px" }; var o = n(0); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { var t = e.getAttribute("title"); t && e.setAttribute("data-original-title", t), e.removeAttribute("title"); }; }, function (t, n) { t.exports = e; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }); var o = i(n(13)), r = i(n(9)); function i(e) { return e && e.__esModule ? e : { default: e } } function a(e, t) { var n = {}; for (var o in e) t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]); return n } t.default = function (e) { var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}; return function (n) { var i = a(n, []); return o.default.createElement(r.default, t, o.default.createElement(e, i)) } }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.withTooltip = t.Tooltip = void 0; var o = i(n(9)), r = i(n(14)); function i(e) { return e && e.__esModule ? e : { default: e } } t.Tooltip = o.default, t.withTooltip = r.default; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function () { var e, t = function () { o.Browser.touch = !0, o.Browser.iOS() && document.body.classList.add("tippy-touch"), o.Browser.dynamicInputDetection && window.performance && document.addEventListener("mousemove", n); }, n = (e = void 0, function () { var t = performance.now(); t - e < 20 && (o.Browser.touch = !1, document.removeEventListener("mousemove", n), o.Browser.iOS() || document.body.classList.remove("tippy-touch")), e = t; }); document.addEventListener("click", (function (e) { if (!(e.target instanceof Element)) return (0, r.default)(); var t = (0, i.default)(e.target, o.Selectors.TOOLTIPPED_EL), n = (0, i.default)(e.target, o.Selectors.POPPER); if (n) { var l = (0, a.default)(o.Store, (function (e) { return e.popper === n })); if (!l) return; if (l.settings.interactive) return } if (t) { var s = (0, a.default)(o.Store, (function (e) { return e.el === t })); if (!s) return; var c = s.settings, p = c.hideOnClick, u = c.multiple, d = c.trigger; if (!u && o.Browser.touch || !u && -1 !== d.indexOf("click")) return (0, r.default)(s); if (!0 !== p || -1 !== d.indexOf("click")) return } !(0, i.default)(e.target, o.Selectors.CONTROLLER) && document.querySelector(o.Selectors.POPPER) && (0, r.default)(); })), document.addEventListener("touchstart", t), window.addEventListener("blur", (function (e) { var t = document.activeElement; t && t.blur && l.matches.call(t, o.Selectors.TOOLTIPPED_EL) && t.blur(); })), !o.Browser.SUPPORTS_TOUCH && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) && document.addEventListener("pointerdown", t); }; var o = n(0), r = s(n(25)), i = s(n(4)), a = s(n(2)), l = n(8); function s(e) { return e && e.__esModule ? e : { default: e } } }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t, n) { var i = n.position, a = n.distance, l = n.arrow, s = n.animateFill, c = n.inertia, p = n.animation, u = n.arrowSize, d = n.size, f = n.theme, b = n.html, g = n.zIndex, h = n.interactive, m = document.createElement("div"); m.setAttribute("class", "tippy-popper"), m.setAttribute("role", "tooltip"), m.setAttribute("aria-hidden", "true"), m.setAttribute("id", "tippy-tooltip-" + e), m.style.zIndex = g; var v = document.createElement("div"); if (v.setAttribute("class", "tippy-tooltip tippy-tooltip--" + d + " leave"), v.setAttribute("data-animation", p), f.split(" ").forEach((function (e) { v.classList.add(e + "-theme"); })), l) { var y = document.createElement("div"); y.setAttribute("class", "arrow-" + u), y.setAttribute("x-arrow", ""), v.appendChild(y); } if (s) { v.setAttribute("data-animatefill", ""); var x = document.createElement("div"); x.setAttribute("class", "leave"), x.setAttribute("x-circle", ""), v.appendChild(x); } c && v.setAttribute("data-inertia", ""), h && v.setAttribute("data-interactive", ""); var w = document.createElement("div"); if (w.setAttribute("class", "tippy-tooltip-content"), b) { var C = void 0; b instanceof Element ? (w.appendChild(b), C = "#" + b.id || "tippy-html-template") : (w.innerHTML = document.getElementById(b.replace("#", "")).innerHTML, C = b), m.classList.add("html-template"), h && m.setAttribute("tabindex", "-1"), v.setAttribute("data-template-id", C); } else w.innerHTML = t; return v.style[(0, o.default)(i)] = (0, r.default)(a), v.appendChild(w), m.appendChild(v), m }; var o = i(n(3)), r = i(n(11)); function i(e) { return e && e.__esModule ? e : { default: e } } }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }); var o = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var n = arguments[t]; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]); } return e }; t.default = function (e) { var t = e.el, n = e.popper, p = e.settings, u = p.position, d = p.popperOptions, f = p.offset, b = p.distance, g = p.flipDuration, h = (0, s.default)(n).tooltip, m = o({ placement: u }, d || {}, { modifiers: o({}, d ? d.modifiers : {}, { flip: o({ padding: b + 5 }, d && d.modifiers ? d.modifiers.flip : {}), offset: o({ offset: f }, d && d.modifiers ? d.modifiers.offset : {}) }), onUpdate: function () { var e = h.style; e.top = "", e.bottom = "", e.left = "", e.right = "", e[(0, l.default)(n.getAttribute("x-placement"))] = (0, c.default)(b); } }); if (window.MutationObserver) { var v = n.style, y = new MutationObserver((function () { v[(0, a.default)("transitionDuration")] = "0ms", e.popperInstance.update(), (0, i.default)((function () { v[(0, a.default)("transitionDuration")] = g + "ms"; })); })); y.observe(n, { childList: !0, subtree: !0, characterData: !0 }), e._mutationObserver = y; } return new r.default(t, n, m) }; var r = p(n(38)), i = p(n(5)), a = p(n(1)), l = p(n(3)), s = p(n(6)), c = p(n(11)); function p(e) { return e && e.__esModule ? e : { default: e } } }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { var t = this; return e.reduce((function (e, n) { var c = p, u = (0, l.default)(t.settings.performance ? t.settings : (0, o.default)(n, t.settings)), d = u.html, f = u.reactDOM, b = u.trigger, g = u.touchHold, h = n.getAttribute("title"); if (!h && !d && !f) return e; n.setAttribute("data-tooltipped", ""), n.setAttribute("aria-describedby", "tippy-tooltip-" + c), (0, s.default)(n); var m = (0, r.default)(c, h, u), v = a.default.call(t, n, m, u), y = []; return b.trim().split(" ").forEach((function (e) { return y = y.concat((0, i.default)(e, n, v, g)) })), e.push({ id: c, el: n, popper: m, settings: u, listeners: y, tippyInstance: t }), p++, e }), []) }; var o = c(n(24)), r = c(n(17)), i = c(n(20)), a = c(n(23)), l = c(n(21)), s = c(n(12)); function c(e) { return e && e.__esModule ? e : { default: e } } n(0); var p = 1; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t, n, r) { var i = []; return "manual" === e || (t.addEventListener(e, n.handleTrigger), i.push({ event: e, handler: n.handleTrigger }), "mouseenter" === e && (o.Browser.SUPPORTS_TOUCH && r && (t.addEventListener("touchstart", n.handleTrigger), i.push({ event: "touchstart", handler: n.handleTrigger }), t.addEventListener("touchend", n.handleMouseleave), i.push({ event: "touchend", handler: n.handleMouseleave })), t.addEventListener("mouseleave", n.handleMouseleave), i.push({ event: "mouseleave", handler: n.handleMouseleave })), "focus" === e && (t.addEventListener("blur", n.handleBlur), i.push({ event: "blur", handler: n.handleBlur }))), i }; var o = n(0); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { return e.arrow && (e.animateFill = !1), e.appendTo && "function" == typeof e.appendTo && (e.appendTo = e.appendTo()), e }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { return e instanceof Element ? [e] : Array.isArray(e) ? e : [].slice.call(document.querySelectorAll(e)) }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t, n) { var l = this; n.position; var s = n.delay; n.duration; var c = n.interactive; n.interactiveBorder, n.distance; var p = n.hideOnClick, u = n.trigger, d = n.touchHold; n.touchWait; var f = void 0, b = void 0, g = function () { clearTimeout(f), clearTimeout(b); }, h = function () { if (g(), !(0, r.default)(t)) { var e = Array.isArray(s) ? s[0] : s; s ? f = setTimeout((function () { return l.show(t) }), e) : l.show(t); } }, m = function () { g(); var e = Array.isArray(s) ? s[1] : s; s ? b = setTimeout((function () { return l.hide(t) }), e) : l.hide(t); }; return { handleTrigger: function (n) { var i = "mouseenter" === n.type && o.Browser.SUPPORTS_TOUCH && o.Browser.touch; if (!i || !d) { var a = "click" === n.type, s = "persistent" !== p; a && (0, r.default)(t) && s ? m() : function (e) { l.callbacks.wait ? l.callbacks.wait.call(t, h, e) : h(); }(n), i && o.Browser.iOS() && e.click && e.click(); } }, handleMouseleave: function (r) { if (!("mouseleave" === r.type && o.Browser.SUPPORTS_TOUCH && o.Browser.touch && d)) { if (c) return document.body.addEventListener("mouseleave", m), void document.addEventListener("mousemove", (function r(l) { var s = function () { document.body.removeEventListener("mouseleave", m), document.removeEventListener("mousemove", r), m(); }, c = (0, i.default)(l.target, o.Selectors.TOOLTIPPED_EL), p = (0, i.default)(l.target, o.Selectors.POPPER) === t, d = c === e, f = -1 !== u.indexOf("click"); if (c && c !== e) return s(); p || d || f || (0, a.default)(l, t, n) && s(); })); m(); } }, handleBlur: function (e) { e.relatedTarget && !o.Browser.touch && ((0, i.default)(e.relatedTarget, o.Selectors.POPPER) || m()); } } }; var o = n(0), r = l(n(7)), i = l(n(4)), a = l(n(32)); function l(e) { return e && e.__esModule ? e : { default: e } } }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t) { var n = o.DefaultsKeys.reduce((function (n, o) { var r = e.getAttribute("data-" + o.toLowerCase()) || t[o]; return "false" === r && (r = !1), "true" === r && (r = !0), isFinite(r) && !isNaN(parseFloat(r)) && (r = parseFloat(r)), "string" == typeof r && "[" === r.trim().charAt(0) && (r = JSON.parse(r)), n[o] = r, n }), {}); return Object.assign({}, t, n) }; var o = n(0); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { o.Store.forEach((function (t) { var n = t.popper, o = t.tippyInstance, r = t.settings, i = r.appendTo, a = r.hideOnClick, l = r.trigger; if (i.contains(n)) { var s = !0 === a || -1 !== l.indexOf("focus"), c = !e || n !== e.popper; s && c && (t.settings.onRequestClose(), o.hide(n)); } })); }; var o = n(0); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function e() { return !e.done && (e.done = !0, (0, i.default)(), !0) }; var o, r = n(16), i = (o = r) && o.__esModule ? o : { default: o }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { var t = e.popper, n = e.popperInstance, a = e.settings.stickyDuration; (0, o.default)((function e() { n && n.scheduleUpdate(), t.style[(0, r.default)("transitionDuration")] = a + "ms", (0, i.default)(t) ? window.requestAnimationFrame(e) : t.style[(0, r.default)("transitionDuration")] = ""; })); }; var o = a(n(5)), r = a(n(1)), i = a(n(7)); function a(e) { return e && e.__esModule ? e : { default: e } } }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { var t = e.el, n = e.popper, a = e.settings, l = a.appendTo, s = a.followCursor; l.contains(n) || (l.appendChild(n), e.popperInstance ? (e.popperInstance.update(), s && !o.Browser.touch || e.popperInstance.enableEventListeners()) : e.popperInstance = (0, i.default)(e), s && !o.Browser.touch && (t.addEventListener("mousemove", r.default), e.popperInstance.disableEventListeners())); }; var o = n(0), r = a(n(10)), i = a(n(18)); function a(e) { return e && e.__esModule ? e : { default: e } } a(n(1)); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t, n) { if (!t) return n(); var o = (0, i.default)(e.popper).tooltip, r = !1, a = function (e) { e.target !== o || r || (r = !0, n()); }; o.addEventListener("webkitTransitionEnd", a), o.addEventListener("transitionend", a), clearTimeout(e._transitionendTimeout), e._transitionendTimeout = setTimeout((function () { r || n(); }), t); }, n(0); var o, r = n(6), i = (o = r) && o.__esModule ? o : { default: o }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }); var o = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var n = arguments[t]; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]); } return e }, r = function () { function e(e, t) { for (var n = 0; n < t.length; n++) { var o = t[n]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o); } } return function (t, n, o) { return n && e(t.prototype, n), o && e(t, o), t } }(), i = n(0), a = k(n(39)), l = k(n(26)), s = k(n(5)); k(n(1)); var c = k(n(2)), p = k(n(34)), u = k(n(12)), d = k(n(33)), f = k(n(37)), b = k(n(35)), g = k(n(6)), h = k(n(31)), m = k(n(7)), v = k(n(36)), y = k(n(10)), x = k(n(22)), w = k(n(29)), C = k(n(28)), I = k(n(27)), A = k(n(19)); function k(e) { return e && e.__esModule ? e : { default: e } } function O(e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") } var T = function () { function e(t) { var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}; O(this, e), i.Browser.SUPPORTED && ((0, l.default)(), this.state = { destroyed: !1 }, this.selector = t, this.settings = o({}, i.Defaults, n), (n.show || n.shown || n.hide || n.hidden) && console.warn("Callbacks without the `on` prefix are deprecated (with the exception of `wait`). Use onShow, onShown, onHide, and onHidden instead."), this.callbacks = { wait: n.wait, show: n.onShow || n.show || v.default, shown: n.onShown || n.shown || v.default, hide: n.onHide || n.hide || v.default, hidden: n.onHidden || n.hidden || v.default }, this.store = A.default.call(this, (0, x.default)(t)), i.Store.push.apply(i.Store, this.store)); } return r(e, [{ key: "getPopperElement", value: function (e) { try { return (0, c.default)(this.store, (function (t) { return t.el === e })).popper } catch (e) { console.error("[getPopperElement]: Element passed as the argument does not exist in the instance"); } } }, { key: "getReferenceElement", value: function (e) { try { return (0, c.default)(this.store, (function (t) { return t.popper === e })).el } catch (e) { console.error("[getReferenceElement]: Popper passed as the argument does not exist in the instance"); } } }, { key: "getReferenceData", value: function (e) { return (0, c.default)(this.store, (function (t) { return t.el === e || t.popper === e })) } }, { key: "updateSettings", value: function (e, t, n) { var r = (0, c.default)(this.store, (function (t) { return t.popper === e })); if (r) { var i = o({}, r.settings, function (e, t, n) { return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e }({}, t, n)); r.settings = i; } } }, { key: "updateForReact", value: function (e, t) { var n = e.querySelector(i.Selectors.CONTENT), o = (0, c.default)(this.store, (function (t) { return t.popper === e })); if (o) { var r = o.settings, l = r.useContext, s = r.setReactDOMValue; l ? s(a.default.createPortal(t, n)) : a.default.render(t, n); } } }, { key: "show", value: function (e, t) { var n = this; if (!this.state.destroyed) { var o = (0, c.default)(this.store, (function (t) { return t.popper === e })); if (o) { var r = (0, g.default)(e), a = r.tooltip, l = r.circle, p = r.content; if (document.body.contains(o.el)) { if (this.callbacks.show.call(e), !o.settings || !1 !== o.settings.open) { o.settings.reactDOM && this.updateForReact(e, o.settings.reactDOM); var d = o.el, v = o.settings; v.appendTo; var y = v.sticky, x = v.interactive, A = v.followCursor, k = v.flipDuration, O = v.duration; if (v.dynamicTitle) { var T = d.getAttribute("title"); T && (p.innerHTML = T, (0, u.default)(d)); } var E = void 0 !== t ? t : Array.isArray(O) ? O[0] : O; (0, h.default)([e, a, l], 0), (0, C.default)(o), e.style.visibility = "visible", e.setAttribute("aria-hidden", "false"), (0, s.default)((function () { A && !i.Browser.touch || (o.popperInstance.update(), (0, h.default)([e], k)), (0, h.default)([a, l], E), l && (p.style.opacity = 1), x && d.classList.add("active"), y && (0, I.default)(o), (0, f.default)(a, l), (0, b.default)([a, l], (function (e) { e.contains("tippy-notransition") && e.remove("tippy-notransition"), e.remove("leave"), e.add("enter"); })), (0, w.default)(o, E, (function () { (0, m.default)(e) && !o._onShownFired && (x && e.focus(), a.classList.add("tippy-notransition"), o._onShownFired = !0, n.callbacks.shown.call(e)); })); })); } } else this.destroy(e); } } } }, { key: "hide", value: function (e, t) { var n = this; if (!this.state.destroyed) { this.callbacks.hide.call(e); var o = (0, c.default)(this.store, (function (t) { return t.popper === e })); if (o) { var r = (0, g.default)(e), i = r.tooltip, l = r.circle, s = r.content; if (!1 !== o.settings.disabled || !o || !o.settings.open) { var p = o && o.settings && o.settings.unmountHTMLWhenHide && o.settings.reactDOM, u = o.el, f = o.settings, v = f.appendTo; f.sticky; var x = f.interactive; f.followCursor; var C = f.html, I = f.trigger, A = f.duration, k = void 0 !== t ? t : Array.isArray(A) ? A[1] : A; o._onShownFired = !1, x && u.classList.remove("active"), e.style.visibility = "hidden", e.setAttribute("aria-hidden", "true"), (0, h.default)([i, l, l ? s : null], k), l && (s.style.opacity = 0), (0, b.default)([i, l], (function (e) { e.contains("tippy-tooltip") && e.remove("tippy-notransition"), e.remove("enter"), e.add("leave"); })), C && -1 !== I.indexOf("click") && (0, d.default)(u) && u.focus(), (0, w.default)(o, k, (function () { !(0, m.default)(e) && v.contains(e) && "1" !== getComputedStyle(i).opacity && (u.removeEventListener("mousemove", y.default), o.popperInstance.disableEventListeners(), v.removeChild(e), n.callbacks.hidden.call(e), p && a.default.unmountComponentAtNode(s)); })); } } } } }, { key: "update", value: function (e) { if (!this.state.destroyed) { var t = (0, c.default)(this.store, (function (t) { return t.popper === e })); if (t) { var n = (0, g.default)(e).content, o = t.el, r = t.settings.html; r instanceof Element ? console.warn("Aborted: update() should not be used if `html` is a DOM element") : (n.innerHTML = r ? document.getElementById(r.replace("#", "")).innerHTML : o.getAttribute("title") || o.getAttribute("data-original-title"), r || (0, u.default)(o)); } } } }, { key: "destroy", value: function (e, t) { var n = this; if (!this.state.destroyed) { var o = (0, c.default)(this.store, (function (t) { return t.popper === e })); if (o) { var r = o.el, a = o.popperInstance, l = o.listeners, s = o._mutationObserver; (0, m.default)(e) && this.hide(e, 0), l.forEach((function (e) { return r.removeEventListener(e.event, e.handler) })), r.setAttribute("title", r.getAttribute("data-original-title")), r.removeAttribute("data-original-title"), r.removeAttribute("data-tooltipped"), r.removeAttribute("aria-describedby"), a && a.destroy(), s && s.disconnect(), i.Store.splice((0, p.default)(i.Store, (function (t) { return t.popper === e })), 1), (void 0 === t || t) && (this.store = i.Store.filter((function (e) { return e.tippyInstance === n }))); } } } }, { key: "destroyAll", value: function () { var e = this; if (!this.state.destroyed) { var t = this.store.length; this.store.forEach((function (n, o) { var r = n.popper; e.destroy(r, o === t - 1); })), this.store = null, this.state.destroyed = !0; } } }]), e }(); function E(e, t) { return new T(e, t) } E.Browser = i.Browser, E.Defaults = i.Defaults, E.disableDynamicInputDetection = function () { return i.Browser.dynamicInputDetection = !1 }, E.enableDynamicInputDetection = function () { return i.Browser.dynamicInputDetection = !0 }, t.default = E; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t) { e.forEach((function (e) { if (e) { var n = l.matches.call(e, r.Selectors.CONTENT) ? Math.round(t / 1.3) : t; e.style[(0, a.default)("transitionDuration")] = n + "ms"; } })); }; var o, r = n(0), i = n(1), a = (o = i) && o.__esModule ? o : { default: o }, l = n(8); }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t, n) { if (!t.getAttribute("x-placement")) return !0; var o = e.clientX, r = e.clientY, a = n.interactiveBorder, l = n.distance, s = t.getBoundingClientRect(), c = (0, i.default)(t.getAttribute("x-placement")), p = a + l, u = { top: s.top - r > a, bottom: r - s.bottom > a, left: s.left - o > a, right: o - s.right > a }; switch (c) { case "top": u.top = s.top - r > p; break; case "bottom": u.bottom = r - s.bottom > p; break; case "left": u.left = s.left - o > p; break; case "right": u.right = o - s.right > p; }return u.top || u.bottom || u.left || u.right }; var o, r = n(3), i = (o = r) && o.__esModule ? o : { default: o }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e) { var t = e.getBoundingClientRect(); return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth) }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t) { return Array.prototype.findIndex ? e.findIndex(t) : e.indexOf((0, i.default)(e, t)) }; var o, r = n(2), i = (o = r) && o.__esModule ? o : { default: o }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t) { e.forEach((function (e) { e && t(e.classList); })); }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function () { }; }, function (e, t, n) { Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function (e, t) { t ? window.getComputedStyle(t)[(0, i.default)("transform")] : window.getComputedStyle(e).opacity; }; var o, r = n(1), i = (o = r) && o.__esModule ? o : { default: o }; }, function (e, n) { e.exports = t; }, function (e, t) { e.exports = n; }]) }, Ap(React__default, Hn(Object.freeze({ __proto__: null, default: Tp })), w$1); var Ep, Sp, Bp; createGlobalStyle(Ep || (Ep = E(["\n\n    // Base Styles\n\n    .tippy-popper .tippy-tooltip.base-theme {\n        padding: 0;\n\n        color: ", ";\n        background-color: ", ";\n        /* box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1); */\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-arrow] {\n        border-top: 7px solid ", ";\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-top: 5px solid ", ";\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-top: 10px solid ", ";\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-arrow] {\n        border-bottom: 7px solid ", ";\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-bottom: 5px solid ", ";\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-bottom: 10px solid ", ";\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-arrow] {\n        border-left: 7px solid ", ";\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-left: 5px solid ", ";\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-left: 10px solid ", ";\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow] {\n        border-right: 7px solid ", ";\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow]:after {\n        content: '';\n        top: -8px;\n        left: 0;\n        border-right: 9px solid ", ";\n        border-top: 9px solid transparent;\n        border-bottom: 9px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-right: 5px solid ", ";\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-right: 10px solid ", ';\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper .tippy-tooltip.base-theme[data-animatefill] {\n        background-color: transparent\n    }\n\n    // Base Styles\n\n    .tippy-touch {\n        cursor: pointer!important\n    }\n\n    .tippy-notransition {\n        transition: none!important\n    }\n\n    .tippy-popper {\n        max-width: 400px;\n        -webkit-perspective: 800px;\n        perspective: 800px;\n        z-index: 9999;\n        outline: 0;\n        transition-timing-function: cubic-bezier(.165, .84, .44, 1);\n        pointer-events: none\n    }\n\n    .tippy-popper.html-template {\n        max-width: 96%;\n        max-width: calc(100% - 20px)\n    }\n\n    .tippy-popper[x-placement^=top] [x-arrow] {\n        border-top: 7px solid #333;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent;\n        bottom: -6px;\n        margin: 0 9px\n    }\n\n    .tippy-popper[x-placement^=top] [x-arrow].arrow-small {\n        border-top: 5px solid #333;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent;\n        bottom: -5px\n    }\n\n    .tippy-popper[x-placement^=top] [x-arrow].arrow-big {\n        border-top: 10px solid #333;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent;\n        bottom: -10px\n    }\n\n    .tippy-popper[x-placement^=top] [x-circle] {\n        -webkit-transform-origin: 0 33%;\n        transform-origin: 0 33%\n    }\n\n    .tippy-popper[x-placement^=top] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -55%);\n        transform: scale(1) translate(-50%, -55%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=top] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -50%);\n        transform: scale(.15) translate(-50%, -50%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-arrow] {\n        border-top: 7px solid #fff;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-top: 5px solid #fff;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-top: 10px solid #fff;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-top: 7px solid rgba(0, 0, 0, .7);\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-top: 5px solid rgba(0, 0, 0, .7);\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-top: 10px solid rgba(0, 0, 0, .7);\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=perspective] {\n        -webkit-transform-origin: bottom;\n        transform-origin: bottom\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px) rotateX(0);\n        transform: translateY(-10px) rotateX(0)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) rotateX(90deg);\n        transform: translateY(0) rotateX(90deg)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px);\n        transform: translateY(-10px)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateY(-10px);\n        transform: translateY(-10px)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px);\n        transform: translateY(-10px)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0);\n        transform: translateY(0)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px) scale(1);\n        transform: translateY(-10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) scale(0);\n        transform: translateY(0) scale(0)\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-arrow] {\n        border-bottom: 7px solid #333;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent;\n        top: -6px;\n        margin: 0 9px\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-arrow].arrow-small {\n        border-bottom: 5px solid #333;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent;\n        top: -5px\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-arrow].arrow-big {\n        border-bottom: 10px solid #333;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent;\n        top: -10px\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-circle] {\n        -webkit-transform-origin: 0 -50%;\n        transform-origin: 0 -50%\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -45%);\n        transform: scale(1) translate(-50%, -45%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -5%);\n        transform: scale(.15) translate(-50%, -5%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-arrow] {\n        border-bottom: 7px solid #fff;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-bottom: 5px solid #fff;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-bottom: 10px solid #fff;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-bottom: 7px solid rgba(0, 0, 0, .7);\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-bottom: 5px solid rgba(0, 0, 0, .7);\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-bottom: 10px solid rgba(0, 0, 0, .7);\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=perspective] {\n        -webkit-transform-origin: top;\n        transform-origin: top\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px) rotateX(0);\n        transform: translateY(10px) rotateX(0)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) rotateX(-90deg);\n        transform: translateY(0) rotateX(-90deg)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0);\n        transform: translateY(0)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px) scale(1);\n        transform: translateY(10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) scale(0);\n        transform: translateY(0) scale(0)\n    }\n\n    .tippy-popper[x-placement^=left] [x-arrow] {\n        border-left: 7px solid #333;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent;\n        right: -7px;\n        margin: 6px 0\n    }\n\n    .tippy-popper[x-placement^=left] [x-arrow].arrow-small {\n        border-left: 5px solid #333;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -5px\n    }\n\n    .tippy-popper[x-placement^=left] [x-arrow].arrow-big {\n        border-left: 10px solid #333;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent;\n        right: -10px\n    }\n\n    .tippy-popper[x-placement^=left] [x-circle] {\n        -webkit-transform-origin: 50% 0;\n        transform-origin: 50% 0\n    }\n\n    .tippy-popper[x-placement^=left] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -50%);\n        transform: scale(1) translate(-50%, -50%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=left] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -50%);\n        transform: scale(.15) translate(-50%, -50%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-arrow] {\n        border-left: 7px solid #fff;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-left: 5px solid #fff;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-left: 10px solid #fff;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-left: 7px solid rgba(0, 0, 0, .7);\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-left: 5px solid rgba(0, 0, 0, .7);\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-left: 10px solid rgba(0, 0, 0, .7);\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=perspective] {\n        -webkit-transform-origin: right;\n        transform-origin: right\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px) rotateY(0);\n        transform: translateX(-10px) rotateY(0)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) rotateY(-90deg);\n        transform: translateX(0) rotateY(-90deg)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0);\n        transform: translateX(0)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px) scale(1);\n        transform: translateX(-10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) scale(0);\n        transform: translateX(0) scale(0)\n    }\n\n    .tippy-popper[x-placement^=right] [x-arrow] {\n        border-right: 7px solid #333;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent;\n        left: -7px;\n        margin: 6px 0\n    }\n\n    .tippy-popper[x-placement^=right] [x-arrow].arrow-small {\n        border-right: 5px solid #333;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -5px\n    }\n\n    .tippy-popper[x-placement^=right] [x-arrow].arrow-big {\n        border-right: 10px solid #333;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent;\n        left: -10px\n    }\n\n    .tippy-popper[x-placement^=right] [x-circle] {\n        -webkit-transform-origin: -50% 0;\n        transform-origin: -50% 0\n    }\n\n    .tippy-popper[x-placement^=right] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -50%);\n        transform: scale(1) translate(-50%, -50%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=right] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -50%);\n        transform: scale(.15) translate(-50%, -50%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-arrow] {\n        border-right: 7px solid #fff;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-right: 5px solid #fff;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-right: 10px solid #fff;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-right: 7px solid rgba(0, 0, 0, .7);\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-right: 5px solid rgba(0, 0, 0, .7);\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-right: 10px solid rgba(0, 0, 0, .7);\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=perspective] {\n        -webkit-transform-origin: left;\n        transform-origin: left\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px) rotateY(0);\n        transform: translateX(10px) rotateY(0)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) rotateY(90deg);\n        transform: translateX(0) rotateY(90deg)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0);\n        transform: translateX(0)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px) scale(1);\n        transform: translateX(10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) scale(0);\n        transform: translateX(0) scale(0)\n    }\n\n    .tippy-popper .tippy-tooltip.transparent-theme {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper .tippy-tooltip.transparent-theme[data-animatefill] {\n        background-color: transparent\n    }\n\n    .tippy-popper .tippy-tooltip.light-theme {\n        color: #26323d;\n        box-shadow: 0 4px 20px 4px rgba(0, 20, 60, .1), 0 4px 80px -8px rgba(0, 20, 60, .2);\n        background-color: #fff\n    }\n\n    .tippy-popper .tippy-tooltip.light-theme[data-animatefill] {\n        background-color: transparent\n    }\n\n    .tippy-tooltip {\n        position: relative;\n        color: #fff;\n        border-radius: 4px;\n        font-size: .95rem;\n        padding: .4rem .8rem;\n        text-align: center;\n        will-change: transform;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        background-color: #333\n    }\n\n    .tippy-tooltip--small {\n        padding: .25rem .5rem;\n        font-size: .8rem\n    }\n\n    .tippy-tooltip--big {\n        padding: .6rem 1.2rem;\n        font-size: 1.2rem\n    }\n\n    .tippy-tooltip[data-animatefill] {\n        overflow: hidden;\n        background-color: transparent\n    }\n\n    .tippy-tooltip[data-interactive] {\n        pointer-events: auto\n    }\n\n    .tippy-tooltip[data-inertia] {\n        transition-timing-function: cubic-bezier(.53, 2, .36, .85)\n    }\n\n    .tippy-tooltip [x-arrow] {\n        position: absolute;\n        width: 0;\n        height: 0\n    }\n\n    .tippy-tooltip [x-circle] {\n        position: absolute;\n        will-change: transform;\n        background-color: #333;\n        border-radius: 50%;\n        width: 130%;\n        width: calc(110% + 2rem);\n        left: 50%;\n        top: 50%;\n        z-index: -1;\n        overflow: hidden;\n        transition: all ease\n    }\n\n    .tippy-tooltip [x-circle]:before {\n        content: "";\n        padding-top: 90%;\n        float: left\n    }\n\n    @media (max-width:450px) {\n        .tippy-popper {\n            max-width: 96%;\n            max-width: calc(100% - 20px)\n        }\n    }\n'], ["\n\n    // Base Styles\n\n    .tippy-popper .tippy-tooltip.base-theme {\n        padding: 0;\n\n        color: ", ";\n        background-color: ", ";\n        /* box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1); */\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-arrow] {\n        border-top: 7px solid ", ";\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-top: 5px solid ", ";\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-top: 10px solid ", ";\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-arrow] {\n        border-bottom: 7px solid ", ";\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-bottom: 5px solid ", ";\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-bottom: 10px solid ", ";\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-arrow] {\n        border-left: 7px solid ", ";\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-left: 5px solid ", ";\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-left: 10px solid ", ";\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-circle] {\n        background-color: ", "\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow] {\n        border-right: 7px solid ", ";\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow]:after {\n        content: '';\n        top: -8px;\n        left: 0;\n        border-right: 9px solid ", ";\n        border-top: 9px solid transparent;\n        border-bottom: 9px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow].arrow-small {\n        border-right: 5px solid ", ";\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.base-theme [x-arrow].arrow-big {\n        border-right: 10px solid ", ';\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper .tippy-tooltip.base-theme[data-animatefill] {\n        background-color: transparent\n    }\n\n    // Base Styles\n\n    .tippy-touch {\n        cursor: pointer!important\n    }\n\n    .tippy-notransition {\n        transition: none!important\n    }\n\n    .tippy-popper {\n        max-width: 400px;\n        -webkit-perspective: 800px;\n        perspective: 800px;\n        z-index: 9999;\n        outline: 0;\n        transition-timing-function: cubic-bezier(.165, .84, .44, 1);\n        pointer-events: none\n    }\n\n    .tippy-popper.html-template {\n        max-width: 96%;\n        max-width: calc(100% - 20px)\n    }\n\n    .tippy-popper[x-placement^=top] [x-arrow] {\n        border-top: 7px solid #333;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent;\n        bottom: -6px;\n        margin: 0 9px\n    }\n\n    .tippy-popper[x-placement^=top] [x-arrow].arrow-small {\n        border-top: 5px solid #333;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent;\n        bottom: -5px\n    }\n\n    .tippy-popper[x-placement^=top] [x-arrow].arrow-big {\n        border-top: 10px solid #333;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent;\n        bottom: -10px\n    }\n\n    .tippy-popper[x-placement^=top] [x-circle] {\n        -webkit-transform-origin: 0 33%;\n        transform-origin: 0 33%\n    }\n\n    .tippy-popper[x-placement^=top] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -55%);\n        transform: scale(1) translate(-50%, -55%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=top] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -50%);\n        transform: scale(.15) translate(-50%, -50%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-arrow] {\n        border-top: 7px solid #fff;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-top: 5px solid #fff;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-top: 10px solid #fff;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-top: 7px solid rgba(0, 0, 0, .7);\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-top: 5px solid rgba(0, 0, 0, .7);\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-top: 10px solid rgba(0, 0, 0, .7);\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=perspective] {\n        -webkit-transform-origin: bottom;\n        transform-origin: bottom\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px) rotateX(0);\n        transform: translateY(-10px) rotateX(0)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) rotateX(90deg);\n        transform: translateY(0) rotateX(90deg)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px);\n        transform: translateY(-10px)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateY(-10px);\n        transform: translateY(-10px)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px);\n        transform: translateY(-10px)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0);\n        transform: translateY(0)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateY(-10px) scale(1);\n        transform: translateY(-10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=top] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) scale(0);\n        transform: translateY(0) scale(0)\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-arrow] {\n        border-bottom: 7px solid #333;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent;\n        top: -6px;\n        margin: 0 9px\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-arrow].arrow-small {\n        border-bottom: 5px solid #333;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent;\n        top: -5px\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-arrow].arrow-big {\n        border-bottom: 10px solid #333;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent;\n        top: -10px\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-circle] {\n        -webkit-transform-origin: 0 -50%;\n        transform-origin: 0 -50%\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -45%);\n        transform: scale(1) translate(-50%, -45%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=bottom] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -5%);\n        transform: scale(.15) translate(-50%, -5%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-arrow] {\n        border-bottom: 7px solid #fff;\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-bottom: 5px solid #fff;\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-bottom: 10px solid #fff;\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-bottom: 7px solid rgba(0, 0, 0, .7);\n        border-right: 7px solid transparent;\n        border-left: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-bottom: 5px solid rgba(0, 0, 0, .7);\n        border-right: 5px solid transparent;\n        border-left: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-bottom: 10px solid rgba(0, 0, 0, .7);\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=perspective] {\n        -webkit-transform-origin: top;\n        transform-origin: top\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px) rotateX(0);\n        transform: translateY(10px) rotateX(0)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) rotateX(-90deg);\n        transform: translateY(0) rotateX(-90deg)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0);\n        transform: translateY(0)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateY(10px) scale(1);\n        transform: translateY(10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=bottom] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateY(0) scale(0);\n        transform: translateY(0) scale(0)\n    }\n\n    .tippy-popper[x-placement^=left] [x-arrow] {\n        border-left: 7px solid #333;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent;\n        right: -7px;\n        margin: 6px 0\n    }\n\n    .tippy-popper[x-placement^=left] [x-arrow].arrow-small {\n        border-left: 5px solid #333;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -5px\n    }\n\n    .tippy-popper[x-placement^=left] [x-arrow].arrow-big {\n        border-left: 10px solid #333;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent;\n        right: -10px\n    }\n\n    .tippy-popper[x-placement^=left] [x-circle] {\n        -webkit-transform-origin: 50% 0;\n        transform-origin: 50% 0\n    }\n\n    .tippy-popper[x-placement^=left] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -50%);\n        transform: scale(1) translate(-50%, -50%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=left] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -50%);\n        transform: scale(.15) translate(-50%, -50%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-arrow] {\n        border-left: 7px solid #fff;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-left: 5px solid #fff;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-left: 10px solid #fff;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-left: 7px solid rgba(0, 0, 0, .7);\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-left: 5px solid rgba(0, 0, 0, .7);\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-left: 10px solid rgba(0, 0, 0, .7);\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=perspective] {\n        -webkit-transform-origin: right;\n        transform-origin: right\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px) rotateY(0);\n        transform: translateX(-10px) rotateY(0)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) rotateY(-90deg);\n        transform: translateX(0) rotateY(-90deg)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0);\n        transform: translateX(0)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateX(-10px) scale(1);\n        transform: translateX(-10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=left] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) scale(0);\n        transform: translateX(0) scale(0)\n    }\n\n    .tippy-popper[x-placement^=right] [x-arrow] {\n        border-right: 7px solid #333;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent;\n        left: -7px;\n        margin: 6px 0\n    }\n\n    .tippy-popper[x-placement^=right] [x-arrow].arrow-small {\n        border-right: 5px solid #333;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -5px\n    }\n\n    .tippy-popper[x-placement^=right] [x-arrow].arrow-big {\n        border-right: 10px solid #333;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent;\n        left: -10px\n    }\n\n    .tippy-popper[x-placement^=right] [x-circle] {\n        -webkit-transform-origin: -50% 0;\n        transform-origin: -50% 0\n    }\n\n    .tippy-popper[x-placement^=right] [x-circle].enter {\n        -webkit-transform: scale(1) translate(-50%, -50%);\n        transform: scale(1) translate(-50%, -50%);\n        opacity: 1\n    }\n\n    .tippy-popper[x-placement^=right] [x-circle].leave {\n        -webkit-transform: scale(.15) translate(-50%, -50%);\n        transform: scale(.15) translate(-50%, -50%);\n        opacity: 0\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-circle] {\n        background-color: #fff\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-arrow] {\n        border-right: 7px solid #fff;\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-arrow].arrow-small {\n        border-right: 5px solid #fff;\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.light-theme [x-arrow].arrow-big {\n        border-right: 10px solid #fff;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-circle] {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-arrow] {\n        border-right: 7px solid rgba(0, 0, 0, .7);\n        border-top: 7px solid transparent;\n        border-bottom: 7px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-arrow].arrow-small {\n        border-right: 5px solid rgba(0, 0, 0, .7);\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] .tippy-tooltip.transparent-theme [x-arrow].arrow-big {\n        border-right: 10px solid rgba(0, 0, 0, .7);\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=perspective] {\n        -webkit-transform-origin: left;\n        transform-origin: left\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=perspective].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px) rotateY(0);\n        transform: translateX(10px) rotateY(0)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=perspective].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) rotateY(90deg);\n        transform: translateX(0) rotateY(90deg)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=fade].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=fade].leave {\n        opacity: 0;\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=shift].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=shift].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0);\n        transform: translateX(0)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=scale].enter {\n        opacity: 1;\n        -webkit-transform: translateX(10px) scale(1);\n        transform: translateX(10px) scale(1)\n    }\n\n    .tippy-popper[x-placement^=right] [data-animation=scale].leave {\n        opacity: 0;\n        -webkit-transform: translateX(0) scale(0);\n        transform: translateX(0) scale(0)\n    }\n\n    .tippy-popper .tippy-tooltip.transparent-theme {\n        background-color: rgba(0, 0, 0, .7)\n    }\n\n    .tippy-popper .tippy-tooltip.transparent-theme[data-animatefill] {\n        background-color: transparent\n    }\n\n    .tippy-popper .tippy-tooltip.light-theme {\n        color: #26323d;\n        box-shadow: 0 4px 20px 4px rgba(0, 20, 60, .1), 0 4px 80px -8px rgba(0, 20, 60, .2);\n        background-color: #fff\n    }\n\n    .tippy-popper .tippy-tooltip.light-theme[data-animatefill] {\n        background-color: transparent\n    }\n\n    .tippy-tooltip {\n        position: relative;\n        color: #fff;\n        border-radius: 4px;\n        font-size: .95rem;\n        padding: .4rem .8rem;\n        text-align: center;\n        will-change: transform;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        background-color: #333\n    }\n\n    .tippy-tooltip--small {\n        padding: .25rem .5rem;\n        font-size: .8rem\n    }\n\n    .tippy-tooltip--big {\n        padding: .6rem 1.2rem;\n        font-size: 1.2rem\n    }\n\n    .tippy-tooltip[data-animatefill] {\n        overflow: hidden;\n        background-color: transparent\n    }\n\n    .tippy-tooltip[data-interactive] {\n        pointer-events: auto\n    }\n\n    .tippy-tooltip[data-inertia] {\n        transition-timing-function: cubic-bezier(.53, 2, .36, .85)\n    }\n\n    .tippy-tooltip [x-arrow] {\n        position: absolute;\n        width: 0;\n        height: 0\n    }\n\n    .tippy-tooltip [x-circle] {\n        position: absolute;\n        will-change: transform;\n        background-color: #333;\n        border-radius: 50%;\n        width: 130%;\n        width: calc(110% + 2rem);\n        left: 50%;\n        top: 50%;\n        z-index: -1;\n        overflow: hidden;\n        transition: all ease\n    }\n\n    .tippy-tooltip [x-circle]:before {\n        content: "";\n        padding-top: 90%;\n        float: left\n    }\n\n    @media (max-width:450px) {\n        .tippy-popper {\n            max-width: 96%;\n            max-width: calc(100% - 20px)\n        }\n    }\n'])), Ee.toolTipColor, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip, Ee.toolTip); o$1.div(Sp || (Sp = E(["\n    color: ", ";\n    z-index: 19023902139021;\n\n    p {\n        color: ", ";\n        font-size: 12px;\n    }\n"], ["\n    color: ", ";\n    z-index: 19023902139021;\n\n    p {\n        color: ", ";\n        font-size: 12px;\n    }\n"])), Ee.defaultColor, Ee.defaultColor); o$1.span(Bp || (Bp = E(["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n\n    line-height: ", "px;\n    text-align: center;\n\n    font-size: 12px;\n\n    background-color: ", ";\n    border-radius: 50%;\n\n    color: ", ";\n\n    cursor: pointer;\n"], ["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n\n    line-height: ", "px;\n    text-align: center;\n\n    font-size: 12px;\n\n    background-color: ", ";\n    border-radius: 50%;\n\n    color: ", ";\n\n    cursor: pointer;\n"])), (function (e) { var t = e.size; return null != t ? t : 16 }), (function (e) { var t = e.size; return null != t ? t : 16 }), (function (e) { var t = e.size; return null != t ? t : 16 }), Ee.toolTipTrigger, Ee.toolTipTriggerColor); var Mp, Lp, Xp; o$1.div(Mp || (Mp = E(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    color: ", ";\n    font-size: 11px;\n\n    cursor: pointer;\n    text-decoration: none;\n\n    white-space: nowrap;\n\n    margin-left: 16px;\n\n    > span {\n        margin-right: 5px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    color: ", ";\n    font-size: 11px;\n\n    cursor: pointer;\n    text-decoration: none;\n\n    white-space: nowrap;\n\n    margin-left: 16px;\n\n    > span {\n        margin-right: 5px;\n    }\n"])), Ee.defaultSubtleColor); o$1.div(Lp || (Lp = E(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    border: 1px solid ", ";\n    border-radius: 5px;\n    padding: 4px 0px;\n    background-color: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    border: 1px solid ", ";\n    border-radius: 5px;\n    padding: 4px 0px;\n    background-color: ", ";\n"])), Ee.defaultBorder, Ee.toolTip); o$1.span(Xp || (Xp = E(["\n    padding: 8px 16px;\n    cursor: pointer;\n    text-align: start;\n    background-color: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    padding: 8px 16px;\n    cursor: pointer;\n    text-align: start;\n    background-color: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), Ee.toolTip, Ee.buttonActiveHover); var Zp = { exports: {} }, Yp = Object.getOwnPropertySymbols, _p = Object.prototype.hasOwnProperty, Jp = Object.prototype.propertyIsEnumerable; function Up(e) { if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined"); return Object(e) } var Qp = function () { try { if (!Object.assign) return !1; var e = new String("abc"); if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1; for (var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n; var o = Object.getOwnPropertyNames(t).map((function (e) { return t[e] })); if ("0123456789" !== o.join("")) return !1; var r = {}; return "abcdefghijklmnopqrst".split("").forEach((function (e) { r[e] = e; })), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("") } catch (e) { return !1 } }() ? Object.assign : function (e, t) { for (var n, o, r = Up(e), i = 1; i < arguments.length; i++) { for (var a in n = Object(arguments[i])) _p.call(n, a) && (r[a] = n[a]); if (Yp) { o = Yp(n); for (var l = 0; l < o.length; l++)Jp.call(n, o[l]) && (r[o[l]] = n[o[l]]); } } return r }, Kp = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", qp = Function.call.bind(Object.prototype.hasOwnProperty), $p = function () { }; if ("production" !== process.env.NODE_ENV) { var eu = Kp, tu = {}, nu = qp; $p = function (e) { var t = "Warning: " + e; "undefined" != typeof console && console.error(t); try { throw new Error(t) } catch (e) { } }; } function ou(e, t, n, o, r) { if ("production" !== process.env.NODE_ENV) for (var i in e) if (nu(e, i)) { var a; try { if ("function" != typeof e[i]) { var l = Error((o || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."); throw l.name = "Invariant Violation", l } a = e[i](t, i, o, n, null, eu); } catch (e) { a = e; } if (!a || a instanceof Error || $p((o || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof a + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in tu)) { tu[a.message] = !0; var s = r ? r() : ""; $p("Failed " + n + " type: " + a.message + (null != s ? s : "")); } } } ou.resetWarningCache = function () { "production" !== process.env.NODE_ENV && (tu = {}); }; var ru = ou, iu = zr.exports, au = Qp, lu = Kp, su = qp, cu = ru, pu = function () { }; function uu() { return null } "production" !== process.env.NODE_ENV && (pu = function (e) { var t = "Warning: " + e; "undefined" != typeof console && console.error(t); try { throw new Error(t) } catch (e) { } }); function du() { } function fu() { } fu.resetWarningCache = du; if ("production" !== process.env.NODE_ENV) { var bu = zr.exports; Zp.exports = function (e, t) { var n = "function" == typeof Symbol && Symbol.iterator, o = "<<anonymous>>", r = { array: s("array"), bigint: s("bigint"), bool: s("boolean"), func: s("function"), number: s("number"), object: s("object"), string: s("string"), symbol: s("symbol"), any: l(uu), arrayOf: function (e) { return l((function (t, n, o, r, i) { if ("function" != typeof e) return new a("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside arrayOf."); var l = t[n]; if (!Array.isArray(l)) return new a("Invalid " + r + " `" + i + "` of type `" + u(l) + "` supplied to `" + o + "`, expected an array."); for (var s = 0; s < l.length; s++) { var c = e(l, s, o, r, i + "[" + s + "]", lu); if (c instanceof Error) return c } return null })) }, element: l((function (t, n, o, r, i) { var l = t[n]; return e(l) ? null : new a("Invalid " + r + " `" + i + "` of type `" + u(l) + "` supplied to `" + o + "`, expected a single ReactElement.") })), elementType: l((function (e, t, n, o, r) { var i = e[t]; return iu.isValidElementType(i) ? null : new a("Invalid " + o + " `" + r + "` of type `" + u(i) + "` supplied to `" + n + "`, expected a single ReactElement type.") })), instanceOf: function (e) { return l((function (t, n, r, i, l) { if (!(t[n] instanceof e)) { var s = e.name || o; return new a("Invalid " + i + " `" + l + "` of type `" + ((c = t[n]).constructor && c.constructor.name ? c.constructor.name : o) + "` supplied to `" + r + "`, expected instance of `" + s + "`.") } var c; return null })) }, node: l((function (e, t, n, o, r) { return p(e[t]) ? null : new a("Invalid " + o + " `" + r + "` supplied to `" + n + "`, expected a ReactNode.") })), objectOf: function (e) { return l((function (t, n, o, r, i) { if ("function" != typeof e) return new a("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside objectOf."); var l = t[n], s = u(l); if ("object" !== s) return new a("Invalid " + r + " `" + i + "` of type `" + s + "` supplied to `" + o + "`, expected an object."); for (var c in l) if (su(l, c)) { var p = e(l, c, o, r, i + "." + c, lu); if (p instanceof Error) return p } return null })) }, oneOf: function (e) { if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && pu(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), uu; function t(t, n, o, r, l) { for (var s = t[n], c = 0; c < e.length; c++)if (i(s, e[c])) return null; var p = JSON.stringify(e, (function (e, t) { return "symbol" === d(t) ? String(t) : t })); return new a("Invalid " + r + " `" + l + "` of value `" + String(s) + "` supplied to `" + o + "`, expected one of " + p + ".") } return l(t) }, oneOfType: function (e) { if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && pu("Invalid argument supplied to oneOfType, expected an instance of array."), uu; for (var t = 0; t < e.length; t++) { var n = e[t]; if ("function" != typeof n) return pu("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + f(n) + " at index " + t + "."), uu } return l((function (t, n, o, r, i) { for (var l = [], s = 0; s < e.length; s++) { var c = (0, e[s])(t, n, o, r, i, lu); if (null == c) return null; c.data && su(c.data, "expectedType") && l.push(c.data.expectedType); } return new a("Invalid " + r + " `" + i + "` supplied to `" + o + "`" + (l.length > 0 ? ", expected one of type [" + l.join(", ") + "]" : "") + ".") })) }, shape: function (e) { return l((function (t, n, o, r, i) { var l = t[n], s = u(l); if ("object" !== s) return new a("Invalid " + r + " `" + i + "` of type `" + s + "` supplied to `" + o + "`, expected `object`."); for (var p in e) { var f = e[p]; if ("function" != typeof f) return c(o, r, i, p, d(f)); var b = f(l, p, o, r, i + "." + p, lu); if (b) return b } return null })) }, exact: function (e) { return l((function (t, n, o, r, i) { var l = t[n], s = u(l); if ("object" !== s) return new a("Invalid " + r + " `" + i + "` of type `" + s + "` supplied to `" + o + "`, expected `object`."); var p = au({}, t[n], e); for (var f in p) { var b = e[f]; if (su(e, f) && "function" != typeof b) return c(o, r, i, f, d(b)); if (!b) return new a("Invalid " + r + " `" + i + "` key `" + f + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  ")); var g = b(l, f, o, r, i + "." + f, lu); if (g) return g } return null })) } }; function i(e, t) { return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t } function a(e, t) { this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = ""; } function l(e) { if ("production" !== process.env.NODE_ENV) var n = {}, r = 0; function i(i, l, s, c, p, u, d) { if (c = c || o, u = u || s, d !== lu) { if (t) { var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"); throw f.name = "Invariant Violation", f } if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) { var b = c + ":" + s; !n[b] && r < 3 && (pu("You are manually calling a React.PropTypes validation function for the `" + u + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[b] = !0, r++); } } return null == l[s] ? i ? null === l[s] ? new a("The " + p + " `" + u + "` is marked as required in `" + c + "`, but its value is `null`.") : new a("The " + p + " `" + u + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(l, s, c, p, u) } var l = i.bind(null, !1); return l.isRequired = i.bind(null, !0), l } function s(e) { return l((function (t, n, o, r, i, l) { var s = t[n]; return u(s) !== e ? new a("Invalid " + r + " `" + i + "` of type `" + d(s) + "` supplied to `" + o + "`, expected `" + e + "`.", { expectedType: e }) : null })) } function c(e, t, n, o, r) { return new a((e || "React class") + ": " + t + " type `" + n + "." + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + r + "`.") } function p(t) { switch (typeof t) { case "number": case "string": case "undefined": return !0; case "boolean": return !t; case "object": if (Array.isArray(t)) return t.every(p); if (null === t || e(t)) return !0; var o = function (e) { var t = e && (n && e[n] || e["@@iterator"]); if ("function" == typeof t) return t }(t); if (!o) return !1; var r, i = o.call(t); if (o !== t.entries) { for (; !(r = i.next()).done;)if (!p(r.value)) return !1 } else for (; !(r = i.next()).done;) { var a = r.value; if (a && !p(a[1])) return !1 } return !0; default: return !1 } } function u(e) { var t = typeof e; return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) { return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol) }(t, e) ? "symbol" : t } function d(e) { if (null == e) return "" + e; var t = u(e); if ("object" === t) { if (e instanceof Date) return "date"; if (e instanceof RegExp) return "regexp" } return t } function f(e) { var t = d(e); switch (t) { case "array": case "object": return "an " + t; case "boolean": case "date": case "regexp": return "a " + t; default: return t } } return a.prototype = Error.prototype, r.checkPropTypes = cu, r.resetWarningCache = cu.resetWarningCache, r.PropTypes = r, r }(bu.isElement, !0); } else Zp.exports = function () { function e(e, t, n, o, r, i) { if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== i) { var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"); throw a.name = "Invariant Violation", a } } function t() { return e } e.isRequired = e; var n = { array: e, bigint: e, bool: e, func: e, number: e, object: e, string: e, symbol: e, any: e, arrayOf: t, element: e, elementType: e, instanceOf: t, node: e, objectOf: t, oneOf: t, oneOfType: t, shape: t, exact: t, checkPropTypes: fu, resetWarningCache: du }; return n.PropTypes = n, n }(); var gu = Zp.exports, hu = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], mu = hu.join(","), vu = "undefined" == typeof Element ? function () { } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, yu = function (e) { var t = parseInt(e.getAttribute("tabindex"), 10); return isNaN(t) ? function (e) { return "true" === e.contentEditable }(e) ? 0 : "AUDIO" !== e.nodeName && "VIDEO" !== e.nodeName && "DETAILS" !== e.nodeName || null !== e.getAttribute("tabindex") ? e.tabIndex : 0 : t }, xu = function (e, t) { return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex }, wu = function (e) { return "INPUT" === e.tagName }, Cu = function (e) { return function (e) { return wu(e) && "radio" === e.type }(e) && !function (e) { if (!e.name) return !0; var t, n = e.form || e.ownerDocument, o = function (e) { return n.querySelectorAll('input[type="radio"][name="' + e + '"]') }; if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t = o(window.CSS.escape(e.name)); else try { t = o(e.name); } catch (e) { return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1 } var r = function (e, t) { for (var n = 0; n < e.length; n++)if (e[n].checked && e[n].form === t) return e[n] }(t, e.form); return !r || r === e }(e) }, Iu = function (e, t) { return !(t.disabled || function (e) { return wu(e) && "hidden" === e.type }(t) || function (e, t) { if ("hidden" === getComputedStyle(e).visibility) return !0; var n = vu.call(e, "details>summary:first-of-type") ? e.parentElement : e; if (vu.call(n, "details:not([open]) *")) return !0; if (t && "full" !== t) { if ("non-zero-area" === t) { var o = e.getBoundingClientRect(), r = o.width, i = o.height; return 0 === r && 0 === i } } else for (; e;) { if ("none" === getComputedStyle(e).display) return !0; e = e.parentElement; } return !1 }(t, e.displayCheck) || function (e) { return "DETAILS" === e.tagName && Array.prototype.slice.apply(e.children).some((function (e) { return "SUMMARY" === e.tagName })) }(t) || function (e) { if (wu(e) || "SELECT" === e.tagName || "TEXTAREA" === e.tagName || "BUTTON" === e.tagName) for (var t = e.parentElement; t;) { if ("FIELDSET" === t.tagName && t.disabled) { for (var n = 0; n < t.children.length; n++) { var o = t.children.item(n); if ("LEGEND" === o.tagName) return !o.contains(e) } return !0 } t = t.parentElement; } return !1 }(t)) }, Au = function (e, t) { return !(!Iu(e, t) || Cu(t) || yu(t) < 0) }, ku = function (e, t) { var n = [], o = [], r = function (e, t, n) { var o = Array.prototype.slice.apply(e.querySelectorAll(mu)); return t && vu.call(e, mu) && o.unshift(e), o.filter(n) }(e, (t = t || {}).includeContainer, Au.bind(null, t)); return r.forEach((function (e, t) { var r = yu(e); 0 === r ? n.push(e) : o.push({ documentOrder: t, tabIndex: r, node: e }); })), o.sort(xu).map((function (e) { return e.node })).concat(n) }, Ou = function (e, t) { if (t = t || {}, !e) throw new Error("No node provided"); return !1 !== vu.call(e, mu) && Au(t, e) }, Tu = hu.concat("iframe").join(","), Eu = function (e, t) { if (t = t || {}, !e) throw new Error("No node provided"); return !1 !== vu.call(e, Tu) && Iu(t, e) };
/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
/*!
* focus-trap 6.7.2
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Su(e, t) { var n = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); t && (o = o.filter((function (t) { return Object.getOwnPropertyDescriptor(e, t).enumerable }))), n.push.apply(n, o); } return n } function Bu(e, t, n) { return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e } var Gu, Nu = (Gu = [], { activateTrap: function (e) { if (Gu.length > 0) { var t = Gu[Gu.length - 1]; t !== e && t.pause(); } var n = Gu.indexOf(e); -1 === n || Gu.splice(n, 1), Gu.push(e); }, deactivateTrap: function (e) { var t = Gu.indexOf(e); -1 !== t && Gu.splice(t, 1), Gu.length > 0 && Gu[Gu.length - 1].unpause(); } }), Pu = function (e) { return setTimeout(e, 0) }, Ru = function (e, t) { var n = -1; return e.every((function (e, o) { return !t(e) || (n = o, !1) })), n }, Mu = function (e) { for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o]; return "function" == typeof e ? e.apply(void 0, n) : e }, Lu = function (e) { return e.target.shadowRoot && "function" == typeof e.composedPath ? e.composedPath()[0] : e.target }, Xu = Object.freeze({ __proto__: null, createFocusTrap: function (e, t) { var n, o = (null == t ? void 0 : t.document) || document, r = function (e) { for (var t = 1; t < arguments.length; t++) { var n = null != arguments[t] ? arguments[t] : {}; t % 2 ? Su(Object(n), !0).forEach((function (t) { Bu(e, t, n[t]); })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Su(Object(n)).forEach((function (t) { Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t)); })); } return e }({ returnFocusOnDeactivate: !0, escapeDeactivates: !0, delayInitialFocus: !0 }, t), i = { containers: [], tabbableGroups: [], nodeFocusedBeforeActivation: null, mostRecentlyFocusedNode: null, active: !1, paused: !1, delayInitialFocusTimer: void 0 }, a = function (e, t, n) { return e && void 0 !== e[t] ? e[t] : r[n || t] }, l = function (e) { return !(!e || !i.containers.some((function (t) { return t.contains(e) }))) }, s = function (e) { var t = r[e]; if ("function" == typeof t) { for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)i[a - 1] = arguments[a]; t = t.apply(void 0, i); } if (!t) { if (void 0 === t || !1 === t) return t; throw new Error("`".concat(e, "` was specified but was not a node, or did not return a node")) } var l = t; if ("string" == typeof t && !(l = o.querySelector(t))) throw new Error("`".concat(e, "` as selector refers to no known node")); return l }, c = function () { var e = s("initialFocus"); if (!1 === e) return !1; if (void 0 === e) if (l(o.activeElement)) e = o.activeElement; else { var t = i.tabbableGroups[0]; e = t && t.firstTabbableNode || s("fallbackFocus"); } if (!e) throw new Error("Your focus-trap needs to have at least one focusable element"); return e }, p = function () { if (i.tabbableGroups = i.containers.map((function (e) { var t = ku(e); if (t.length > 0) return { container: e, firstTabbableNode: t[0], lastTabbableNode: t[t.length - 1] } })).filter((function (e) { return !!e })), i.tabbableGroups.length <= 0 && !s("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times") }, u = function e(t) { !1 !== t && t !== o.activeElement && (t && t.focus ? (t.focus({ preventScroll: !!r.preventScroll }), i.mostRecentlyFocusedNode = t, function (e) { return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select }(t) && t.select()) : e(c())); }, d = function (e) { var t = s("setReturnFocus", e); return t || !1 !== t && e }, f = function (e) { var t = Lu(e); l(t) || (Mu(r.clickOutsideDeactivates, e) ? n.deactivate({ returnFocus: r.returnFocusOnDeactivate && !Eu(t) }) : Mu(r.allowOutsideClick, e) || e.preventDefault()); }, b = function (e) { var t = Lu(e), n = l(t); n || t instanceof Document ? n && (i.mostRecentlyFocusedNode = t) : (e.stopImmediatePropagation(), u(i.mostRecentlyFocusedNode || c())); }, g = function (e) { if (function (e) { return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode }(e) && !1 !== Mu(r.escapeDeactivates, e)) return e.preventDefault(), void n.deactivate(); (function (e) { return "Tab" === e.key || 9 === e.keyCode })(e) && function (e) { var t = Lu(e); p(); var n = null; if (i.tabbableGroups.length > 0) { var o = Ru(i.tabbableGroups, (function (e) { return e.container.contains(t) })); if (o < 0) n = e.shiftKey ? i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : i.tabbableGroups[0].firstTabbableNode; else if (e.shiftKey) { var r = Ru(i.tabbableGroups, (function (e) { var n = e.firstTabbableNode; return t === n })); if (r < 0 && (i.tabbableGroups[o].container === t || Eu(t) && !Ou(t)) && (r = o), r >= 0) { var a = 0 === r ? i.tabbableGroups.length - 1 : r - 1; n = i.tabbableGroups[a].lastTabbableNode; } } else { var l = Ru(i.tabbableGroups, (function (e) { var n = e.lastTabbableNode; return t === n })); if (l < 0 && (i.tabbableGroups[o].container === t || Eu(t) && !Ou(t)) && (l = o), l >= 0) { var c = l === i.tabbableGroups.length - 1 ? 0 : l + 1; n = i.tabbableGroups[c].firstTabbableNode; } } } else n = s("fallbackFocus"); n && (e.preventDefault(), u(n)); }(e); }, h = function (e) { if (!Mu(r.clickOutsideDeactivates, e)) { var t = Lu(e); l(t) || Mu(r.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation()); } }, m = function () { if (i.active) return Nu.activateTrap(n), i.delayInitialFocusTimer = r.delayInitialFocus ? Pu((function () { u(c()); })) : u(c()), o.addEventListener("focusin", b, !0), o.addEventListener("mousedown", f, { capture: !0, passive: !1 }), o.addEventListener("touchstart", f, { capture: !0, passive: !1 }), o.addEventListener("click", h, { capture: !0, passive: !1 }), o.addEventListener("keydown", g, { capture: !0, passive: !1 }), n }, v = function () { if (i.active) return o.removeEventListener("focusin", b, !0), o.removeEventListener("mousedown", f, !0), o.removeEventListener("touchstart", f, !0), o.removeEventListener("click", h, !0), o.removeEventListener("keydown", g, !0), n }; return (n = { activate: function (e) { if (i.active) return this; var t = a(e, "onActivate"), n = a(e, "onPostActivate"), r = a(e, "checkCanFocusTrap"); r || p(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = o.activeElement, t && t(); var l = function () { r && p(), m(), n && n(); }; return r ? (r(i.containers.concat()).then(l, l), this) : (l(), this) }, deactivate: function (e) { if (!i.active) return this; clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, v(), i.active = !1, i.paused = !1, Nu.deactivateTrap(n); var t = a(e, "onDeactivate"), o = a(e, "onPostDeactivate"), r = a(e, "checkCanReturnFocus"); t && t(); var l = a(e, "returnFocus", "returnFocusOnDeactivate"), s = function () { Pu((function () { l && u(d(i.nodeFocusedBeforeActivation)), o && o(); })); }; return l && r ? (r(d(i.nodeFocusedBeforeActivation)).then(s, s), this) : (s(), this) }, pause: function () { return i.paused || !i.active || (i.paused = !0, v()), this }, unpause: function () { return i.paused && i.active ? (i.paused = !1, p(), m(), this) : this }, updateContainerElements: function (e) { var t = [].concat(e).filter(Boolean); return i.containers = t.map((function (e) { return "string" == typeof e ? o.querySelector(e) : e })), i.active && p(), this } }).updateContainerElements(e), n } }), Vu = Hn(Xu); function Wu(e) { return Wu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e }, Wu(e) } function Hu(e, t) { for (var n = 0; n < t.length; n++) { var o = t[n]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o); } } function Fu(e, t) { return Fu = Object.setPrototypeOf || function (e, t) { return e.__proto__ = t, e }, Fu(e, t) } function Du(e) { var t = function () { if ("undefined" == typeof Reflect || !Reflect.construct) return !1; if (Reflect.construct.sham) return !1; if ("function" == typeof Proxy) return !0; try { return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0 } catch (e) { return !1 } }(); return function () { var n, o = ju(e); if (t) { var r = ju(this).constructor; n = Reflect.construct(o, arguments, r); } else n = o.apply(this, arguments); return zu(this, n) } } function zu(e, t) { if (t && ("object" === Wu(t) || "function" == typeof t)) return t; if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined"); return function (e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e }(e) } function ju(e) { return ju = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) { return e.__proto__ || Object.getPrototypeOf(e) }, ju(e) } var Zu = React__default, Yu = w$1, _u = Zp.exports, Ju = Vu.createFocusTrap, Uu = function (e) { !function (e, t) { if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function"); e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fu(e, t); }(i, Zu.Component); var t, n, r = Du(i); function i(e) { var t; !function (e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") }(this, i), (t = r.call(this, e)).tailoredFocusTrapOptions = { returnFocusOnDeactivate: !1 }, t.returnFocusOnDeactivate = !0; var n = e.focusTrapOptions; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && ("returnFocusOnDeactivate" !== o ? "onPostDeactivate" !== o ? t.tailoredFocusTrapOptions[o] = n[o] : t.onPostDeactivate = n[o] : t.returnFocusOnDeactivate = !!n[o]); return t.focusTrapElements = e.containerElements || [], t.updatePreviousElement(), t } return t = i, n = [{ key: "getDocument", value: function () { return this.props.focusTrapOptions.document || ("undefined" != typeof document ? document : void 0) } }, { key: "getNodeForOption", value: function (e) { var t = this.tailoredFocusTrapOptions[e]; if (!t) return null; var n, o = t; if ("string" == typeof t && !(o = null === (n = this.getDocument()) || void 0 === n ? void 0 : n.querySelector(t))) throw new Error("`".concat(e, "` refers to no known node")); if ("function" == typeof t && !(o = t())) throw new Error("`".concat(e, "` did not return a node")); return o } }, { key: "getReturnFocusNode", value: function () { var e = this.getNodeForOption("setReturnFocus"); return e || this.previouslyFocusedElement } }, { key: "updatePreviousElement", value: function () { var e = this.getDocument(); e && (this.previouslyFocusedElement = e.activeElement); } }, { key: "deactivateTrap", value: function () { var e = this, t = this.tailoredFocusTrapOptions, n = t.checkCanReturnFocus, o = t.preventScroll, r = void 0 !== o && o; this.focusTrap && this.focusTrap.deactivate({ returnFocus: !1 }); var i = function () { var t = e.getReturnFocusNode(); (null == t ? void 0 : t.focus) && e.returnFocusOnDeactivate && t.focus({ preventScroll: r }), e.onPostDeactivate && e.onPostDeactivate.call(null); }; n ? n(this.getReturnFocusNode()).then(i, i) : i(); } }, { key: "setupFocusTrap", value: function () { if (!this.focusTrap) { var e = this.focusTrapElements.map(Yu.findDOMNode); e.some(Boolean) && (this.focusTrap = this.props._createFocusTrap(e, this.tailoredFocusTrapOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause()); } } }, { key: "componentDidMount", value: function () { this.props.active && this.setupFocusTrap(); } }, { key: "componentDidUpdate", value: function (e) { if (this.focusTrap) { e.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements); var t = !e.active && this.props.active, n = e.active && !this.props.active, o = !e.paused && this.props.paused, r = e.paused && !this.props.paused; if (t && (this.updatePreviousElement(), this.focusTrap.activate()), n) return void this.deactivateTrap(); o && this.focusTrap.pause(), r && this.focusTrap.unpause(); } else e.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap()); } }, { key: "componentWillUnmount", value: function () { this.deactivateTrap(); } }, { key: "render", value: function () { var e = this, t = this.props.children ? Zu.Children.only(this.props.children) : void 0; if (t) { if (t.type && t.type === Zu.Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element."); return Zu.cloneElement(t, { ref: function (n) { var o = e.props.containerElements; t && ("function" == typeof t.ref ? t.ref(n) : t.ref && (t.ref.current = n)), e.focusTrapElements = o || [n]; } }) } return null } }], n && Hu(t.prototype, n), Object.defineProperty(t, "prototype", { writable: !1 }), i }(), Qu = "undefined" == typeof Element ? Function : Element; Uu.propTypes = { active: _u.bool, paused: _u.bool, focusTrapOptions: _u.shape({ document: _u.object, onActivate: _u.func, onPostActivate: _u.func, checkCanFocusTrap: _u.func, onDeactivate: _u.func, onPostDeactivate: _u.func, checkCanReturnFocus: _u.func, initialFocus: _u.oneOfType([_u.instanceOf(Qu), _u.string, _u.func, _u.bool]), fallbackFocus: _u.oneOfType([_u.instanceOf(Qu), _u.string, _u.func]), escapeDeactivates: _u.oneOfType([_u.bool, _u.func]), clickOutsideDeactivates: _u.oneOfType([_u.bool, _u.func]), returnFocusOnDeactivate: _u.bool, setReturnFocus: _u.oneOfType([_u.instanceOf(Qu), _u.string, _u.func]), allowOutsideClick: _u.oneOfType([_u.bool, _u.func]), preventScroll: _u.bool }), containerElements: _u.arrayOf(_u.instanceOf(Qu)), children: _u.oneOfType([_u.element, _u.instanceOf(Qu)]) }, Uu.defaultProps = { active: !0, paused: !1, focusTrapOptions: {}, _createFocusTrap: Ju }; function qu(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e } function $u(e) { return $u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) { return e.__proto__ || Object.getPrototypeOf(e) }, $u(e) } function ed() { if ("undefined" == typeof Reflect || !Reflect.construct) return !1; if (Reflect.construct.sham) return !1; if ("function" == typeof Proxy) return !0; try { return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0 } catch (e) { return !1 } } function td(e, t, n) { return td = ed() ? Reflect.construct : function (e, t, n) { var o = [null]; o.push.apply(o, t); var r = new (Function.bind.apply(e, o)); return n && ba(r, n.prototype), r }, td.apply(null, arguments) } function nd(e) { var t = "function" == typeof Map ? new Map : void 0; return nd = function (e) { if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e; var n; if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== t) { if (t.has(e)) return t.get(e); t.set(e, o); } function o() { return td(e, arguments, $u(this).constructor) } return o.prototype = Object.create(e.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), ba(o, e) }, nd(e) } var od = { 1: "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n", 2: "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n", 3: "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n", 4: "Couldn't generate valid rgb string from %s, it returned %s.\n\n", 5: "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n", 6: "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n", 7: "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n", 8: "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n", 9: "Please provide a number of steps to the modularScale helper.\n\n", 10: "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n", 11: 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n', 12: 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n', 13: 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n', 14: 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n', 15: 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n', 16: "You must provide a template to this method.\n\n", 17: "You passed an unsupported selector state to this method.\n\n", 18: "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n", 19: "fromSize and toSize must be provided as stringified numbers with the same units.\n\n", 20: "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n", 21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 23: "fontFace expects a name of a font-family.\n\n", 24: "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n", 25: "fontFace expects localFonts to be an array.\n\n", 26: "fontFace expects fileFormats to be an array.\n\n", 27: "radialGradient requries at least 2 color-stops to properly render.\n\n", 28: "Please supply a filename to retinaImage() as the first argument.\n\n", 29: "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n", 30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 31: "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n", 32: "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n", 33: "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n", 34: "borderRadius expects a radius value as a string or number as the second argument.\n\n", 35: 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n', 36: "Property must be a string value.\n\n", 37: "Syntax Error at %s.\n\n", 38: "Formula contains a function that needs parentheses at %s.\n\n", 39: "Formula is missing closing parenthesis at %s.\n\n", 40: "Formula has too many closing parentheses at %s.\n\n", 41: "All values in a formula must have the same unit or be unitless.\n\n", 42: "Please provide a number of steps to the modularScale helper.\n\n", 43: "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n", 44: "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n", 45: "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n", 46: "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n", 47: "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n", 48: "fromSize and toSize must be provided as stringified numbers with the same units.\n\n", 49: "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n", 50: "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n", 51: "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n", 52: "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n", 53: "fontFace expects localFonts to be an array.\n\n", 54: "fontFace expects fileFormats to be an array.\n\n", 55: "fontFace expects a name of a font-family.\n\n", 56: "linearGradient requries at least 2 color-stops to properly render.\n\n", 57: "radialGradient requries at least 2 color-stops to properly render.\n\n", 58: "Please supply a filename to retinaImage() as the first argument.\n\n", 59: "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n", 60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 61: "Property must be a string value.\n\n", 62: "borderRadius expects a radius value as a string or number as the second argument.\n\n", 63: 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n', 64: "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n", 65: "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n", 66: "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n", 67: "You must provide a template to this method.\n\n", 68: "You passed an unsupported selector state to this method.\n\n", 69: 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n', 70: 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n', 71: 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n', 72: 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n', 73: "Please provide a valid CSS variable.\n\n", 74: "CSS variable not found and no default was provided.\n\n", 75: "important requires a valid style object, got a %s instead.\n\n", 76: "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n", 77: 'remToPx expects a value in "rem" but you provided it in "%s".\n\n', 78: 'base must be set in "px" or "%" but you set it in "%s".\n' }; function rd() { for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n]; var o, r = t[0], i = []; for (o = 1; o < t.length; o += 1)i.push(t[o]); return i.forEach((function (e) { r = r.replace(/%[a-z]/, e); })), r } var id = function (e) { var t, n; function o(t) { var n; if ("production" === process.env.NODE_ENV) n = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + t + " for more information.") || this; else { for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)r[i - 1] = arguments[i]; n = e.call(this, rd.apply(void 0, [od[t]].concat(r))) || this; } return qu(n) } return n = e, (t = o).prototype = Object.create(n.prototype), t.prototype.constructor = t, ba(t, n), o }(nd(Error)); function ad(e) { return Math.round(255 * e) } function ld(e, t, n) { return ad(e) + "," + ad(t) + "," + ad(n) } function sd(e, t, n, o) { if (void 0 === o && (o = ld), 0 === t) return o(n, n, n); var r = (e % 360 + 360) % 360 / 60, i = (1 - Math.abs(2 * n - 1)) * t, a = i * (1 - Math.abs(r % 2 - 1)), l = 0, s = 0, c = 0; r >= 0 && r < 1 ? (l = i, s = a) : r >= 1 && r < 2 ? (l = a, s = i) : r >= 2 && r < 3 ? (s = i, c = a) : r >= 3 && r < 4 ? (s = a, c = i) : r >= 4 && r < 5 ? (l = a, c = i) : r >= 5 && r < 6 && (l = i, c = a); var p = n - i / 2; return o(l + p, s + p, c + p) } var cd = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "639", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" }; var pd = /^#[a-fA-F0-9]{6}$/, ud = /^#[a-fA-F0-9]{8}$/, dd = /^#[a-fA-F0-9]{3}$/, fd = /^#[a-fA-F0-9]{4}$/, bd = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i, gd = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i, hd = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, md = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i; function vd(e) { if ("string" != typeof e) throw new id(3); var t = function (e) { if ("string" != typeof e) return e; var t = e.toLowerCase(); return cd[t] ? "#" + cd[t] : e }(e); if (t.match(pd)) return { red: parseInt("" + t[1] + t[2], 16), green: parseInt("" + t[3] + t[4], 16), blue: parseInt("" + t[5] + t[6], 16) }; if (t.match(ud)) { var n = parseFloat((parseInt("" + t[7] + t[8], 16) / 255).toFixed(2)); return { red: parseInt("" + t[1] + t[2], 16), green: parseInt("" + t[3] + t[4], 16), blue: parseInt("" + t[5] + t[6], 16), alpha: n } } if (t.match(dd)) return { red: parseInt("" + t[1] + t[1], 16), green: parseInt("" + t[2] + t[2], 16), blue: parseInt("" + t[3] + t[3], 16) }; if (t.match(fd)) { var o = parseFloat((parseInt("" + t[4] + t[4], 16) / 255).toFixed(2)); return { red: parseInt("" + t[1] + t[1], 16), green: parseInt("" + t[2] + t[2], 16), blue: parseInt("" + t[3] + t[3], 16), alpha: o } } var r = bd.exec(t); if (r) return { red: parseInt("" + r[1], 10), green: parseInt("" + r[2], 10), blue: parseInt("" + r[3], 10) }; var i = gd.exec(t.substring(0, 50)); if (i) return { red: parseInt("" + i[1], 10), green: parseInt("" + i[2], 10), blue: parseInt("" + i[3], 10), alpha: parseFloat("" + i[4]) }; var a = hd.exec(t); if (a) { var l = "rgb(" + sd(parseInt("" + a[1], 10), parseInt("" + a[2], 10) / 100, parseInt("" + a[3], 10) / 100) + ")", s = bd.exec(l); if (!s) throw new id(4, t, l); return { red: parseInt("" + s[1], 10), green: parseInt("" + s[2], 10), blue: parseInt("" + s[3], 10) } } var c = md.exec(t.substring(0, 50)); if (c) { var p = "rgb(" + sd(parseInt("" + c[1], 10), parseInt("" + c[2], 10) / 100, parseInt("" + c[3], 10) / 100) + ")", u = bd.exec(p); if (!u) throw new id(4, t, p); return { red: parseInt("" + u[1], 10), green: parseInt("" + u[2], 10), blue: parseInt("" + u[3], 10), alpha: parseFloat("" + c[4]) } } throw new id(5) } var yd = function (e) { return 7 === e.length && e[1] === e[2] && e[3] === e[4] && e[5] === e[6] ? "#" + e[1] + e[3] + e[5] : e }; function xd(e) { var t = e.toString(16); return 1 === t.length ? "0" + t : t } function wd(e, t, n) { if ("number" == typeof e && "number" == typeof t && "number" == typeof n) return yd("#" + xd(e) + xd(t) + xd(n)); if ("object" == typeof e && void 0 === t && void 0 === n) return yd("#" + xd(e.red) + xd(e.green) + xd(e.blue)); throw new id(6) } function Cd(e, t, n) { return function () { var o = n.concat(Array.prototype.slice.call(arguments)); return o.length >= t ? e.apply(this, o) : Cd(e, t, o) } } function Id(e) { return Cd(e, e.length, []) } function Ad(e, t) { if ("transparent" === t) return t; var n, o, r, i = vd(t), a = "number" == typeof i.alpha ? i.alpha : 1; return function (e, t, n, o) { if ("string" == typeof e && "number" == typeof t) { var r = vd(e); return "rgba(" + r.red + "," + r.green + "," + r.blue + "," + t + ")" } if ("number" == typeof e && "number" == typeof t && "number" == typeof n && "number" == typeof o) return o >= 1 ? wd(e, t, n) : "rgba(" + e + "," + t + "," + n + "," + o + ")"; if ("object" == typeof e && void 0 === t && void 0 === n && void 0 === o) return e.alpha >= 1 ? wd(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")"; throw new id(7) }(Mo({}, i, { alpha: (n = 0, o = 1, r = +(100 * a - 100 * parseFloat(e)).toFixed(2) / 100, Math.max(n, Math.min(o, r))) })) } var kd, Od, Td, Ed, Sd, Bd, Gd, Nd, Pd, Rd, Md, Ld, Xd = Id(Ad); createGlobalStyle(kd || (kd = E(["\n    html {\n        overflow: hidden;\n    }\n"], ["\n    html {\n        overflow: hidden;\n    }\n"]))); o$1.div(Od || (Od = E(["\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    min-width: 320px;\n    height: 100%;\n    z-index: 999999;\n    transform: translateZ(0);\n    background-color: ", ";\n    pointer-events: ", ";\n"], ["\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    min-width: 320px;\n    height: 100%;\n    z-index: 999999;\n    transform: translateZ(0);\n    background-color: ", ";\n    pointer-events: ", ";\n"])), (function (e) { return e.overlay ? Xd(.25, Ee.modalOverlay) : "transparent" }), (function (e) { return e.overlay ? "auto" : "none" })); o$1.div(Td || (Td = E(["\n    display: block;\n\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    width: 30px;\n    height: 30px;\n\n    z-index: 5;\n\n    cursor: pointer;\n\n    &:after {\n        content: '×';\n\n        position: absolute;\n        top: 0;\n        left: 0;\n\n        width: 100%;\n        height: 100%;\n\n        text-align: center;\n        font-size: 24px;\n        color: ", ";\n    }\n"], ["\n    display: block;\n\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    width: 30px;\n    height: 30px;\n\n    z-index: 5;\n\n    cursor: pointer;\n\n    &:after {\n        content: '×';\n\n        position: absolute;\n        top: 0;\n        left: 0;\n\n        width: 100%;\n        height: 100%;\n\n        text-align: center;\n        font-size: 24px;\n        color: ", ";\n    }\n"])), Ee.modalCloseColor); o$1.div(Ed || (Ed = E(["\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n    width: 100%;\n    max-width: ", ";\n    height: auto;\n    min-height: 120px;\n    max-height: ", ";\n\n    padding: ", ";\n\n    background-color: ", ";\n    box-shadow: 0 0 10px 3px ", ";\n\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    box-sizing: border-box;\n\n    pointer-events: auto;\n"], ["\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n    width: 100%;\n    max-width: ", ";\n    height: auto;\n    min-height: 120px;\n    max-height: ", ";\n\n    padding: ", ";\n\n    background-color: ", ";\n    box-shadow: 0 0 10px 3px ", ";\n\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    box-sizing: border-box;\n\n    pointer-events: auto;\n"])), (function (e) { var t = e.modalWidth; return null != t ? t : "375px" }), (function (e) { var t = e.modalHeight; return null != t ? t : "calc(100% - 30px)" }), (function (e) { var t = e.padding; return null != t ? t : "24px 0 20px" }), Ee.modalContent, Xd(.9, Ee.modalOverlay)); o$1.div(Sd || (Sd = E(["\n    display: ", ";\n    height: auto;\n    cursor: pointer;\n"], ["\n    display: ", ";\n    height: auto;\n    cursor: pointer;\n"])), (function (e) { return e.inline ? "inline-block" : "block" })); var zd = o$1.div(Bd || (Bd = E(["\n    padding: 0 20px;\n"], ["\n    padding: 0 20px;\n"]))), jd = o$1.div(Gd || (Gd = E(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 30px;\n    > button + button {\n        margin-left: 16px;\n    }\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 30px;\n    > button + button {\n        margin-left: 16px;\n    }\n"]))); o$1(zd)(Nd || (Nd = E([""], [""]))), o$1(jd)(Pd || (Pd = E([""], [""]))), o$1(zd)(Rd || (Rd = E([""], [""]))), o$1(jd)(Md || (Md = E([""], [""]))), o$1.div(Ld || (Ld = E(["\n    margin-top: 30px;\n"], ["\n    margin-top: 30px;\n"]))); var Zd, Yd, _d, Jd, Ud, $d = o$1.div(Zd || (Zd = E(['\n    &::before {\n        content: "[...]";\n        padding-left: ', ";\n        padding-right: ", ";\n"], ['\n    &::before {\n        content: "[...]";\n        padding-left: ', ";\n        padding-right: ", ";\n"])), (function (e) { return e.paddingLeft ? "20px" : "0" }), (function (e) { return e.paddingRight ? "20px" : "0" })), ef = o$1.div(Yd || (Yd = E(["\n    color: ", ";\n    font-size: 14px;\n"], ["\n    color: ", ";\n    font-size: 14px;\n"])), de.pagination.color), tf = o$1.div(_d || (_d = E(["\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    margin: 20px auto;\n\n    ", "\n"], ["\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    margin: 20px auto;\n\n    ", "\n"])), (function (e) { return e.isLoading && "\n        > div {\n            color: ".concat(de.pagination.disabledColor, ";\n            cursor: not-allowed;\n        };\n    ") })), nf = o$1.div(Jd || (Jd = E(["\n    cursor: pointer;\n\n    width: 30px;\n    height: 30px;\n\n    background-color: ", ";\n    background-size: auto 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    ", ";\n"], ["\n    cursor: pointer;\n\n    width: 30px;\n    height: 30px;\n\n    background-color: ", ";\n    background-size: auto 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    ", ";\n"])), de.pagination.buttonColor, (function (e) { var t = e.navigationSense; return "\n        background-image: url(".concat("left" === t ? Sn : Bn, ");\n    ") })), of = o$1.div(Ud || (Ud = E(["\n    cursor: pointer;\n    color: ", ";\n    font-weight: ", ";\n\n    &::before {\n        ", ";\n    }\n"], ["\n    cursor: pointer;\n    color: ", ";\n    font-weight: ", ";\n\n    &::before {\n        ", ";\n    }\n"])), (function (e) { return e.selected ? de.pagination.activeColor : de.pagination.color }), (function (e) { return e.selected ? "bold" : "normal" }), (function (e) { return e.includeSeparator && '\n            content: "-";\n            padding: 0 15px;\n            color: '.concat(de.pagination.color, ";\n\n        ") })), rf = function (n) { var o = n.currentPage, r = n.isLoading, i = n.pagesTotal, a = n.onPageSelection; if (!o || !i) return null; var l = T([], Array(i <= 3 ? i : 3).keys(), !0).map((function (e) { return i <= 3 || o <= Math.floor(1.5) + 1 ? e + 1 : o >= i - Math.floor(1.5) + 0 ? i - Math.floor(1.5) + e - Math.floor(1.5) + 0 : o + e - Math.floor(1.5) + (o <= Math.floor(1.5) ? Math.floor(1.5) : 0) })).map((function (t, n) { return jsx(of, k$1({ selected: t === o, includeSeparator: 0 !== n, onClick: r ? void 0 : a(t, i) }, { children: t }), t) })); return jsxs(tf, k$1({ isLoading: r }, { children: [1 !== o && jsx(nf, { navigationSense: "left", onClick: r ? void 0 : a(o - 1, i) }, void 0), jsx($d, { hidden: i <= 3 || o <= Math.floor(1.5) + 1, paddingRight: !0 }, void 0), i > 1 && l, jsx($d, { hidden: o >= i - Math.floor(1.5) + 0, paddingLeft: !0 }, void 0), o !== i && jsx(nf, { navigationSense: "right", onClick: r ? void 0 : a(o + 1, i) }, void 0)] }), void 0) }; !function (n) { function o() { return null !== n && n.apply(this, arguments) || this } ((function (e, t) { if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null"); function n() { this.constructor = e; } A$1(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n); }))(o, n), o.prototype.render = function () { var n, o, r, i, a; if (!this.props.pagesTotal) return null; var l = "".concat(null !== (n = this.props.summaryPrefix) && void 0 !== n ? n : "", " ").concat(null !== (o = this.props.currentPage) && void 0 !== o ? o : "", " ").concat(null !== (r = this.props.summaryJoinner) && void 0 !== r ? r : "", " ").concat(this.props.pagesTotal); return jsx(ef, { children: jsxs(ge, k$1({ alignItems: "center" }, { children: [jsx(be, { children: l }, void 0), jsx(be, k$1({ flex: "3", justifyContent: "center" }, { children: jsx(rf, { currentPage: null !== (i = this.props.currentPage) && void 0 !== i ? i : 1, isLoading: null !== (a = this.props.isLoading) && void 0 !== a && a, pagesTotal: this.props.pagesTotal, onPageSelection: this.props.onPageSelection }, void 0) }), void 0), jsx(be, {}, void 0)] }), void 0) }, void 0) }, o.defaultProps = { currentPage: 1, isLoading: !1, summaryJoinner: "to", summaryPrefix: "Page" }; }(React__default.PureComponent), o$1.input(af || (af = E(["\n    display: none;\n"], ["\n    display: none;\n"]))); var af, lf, sf, cf, pf, uf, df, ff, bf, gf, hf, mf, vf, yf, xf, wf, Cf, If, Af, kf, Of, Tf, Ef, Sf, Bf, Gf, Nf, Pf, Rf, Mf = o$1.div(lf || (lf = E(["\n    display: flex;\n    flex-direction: ", ";\n    overflow: ", ";\n"], ["\n    display: flex;\n    flex-direction: ", ";\n    overflow: ", ";\n"])), (function (e) { var t = e.flexDirection; return null != t ? t : "column" }), (function (e) { return e.wrapperOverflow })), Lf = o$1.span(sf || (sf = E(["\n    overflow: ", ";\n    text-overflow: ellipsis;\n"], ["\n    overflow: ", ";\n    text-overflow: ellipsis;\n"])), (function (e) { return e.wrapperOverflow })), Xf = o$1.div(cf || (cf = E(["\n    > label,\n    ", " {\n        &:not(:last-child) {\n            margin-bottom: ", ";\n            margin-right: ", ";\n        }\n    }\n\n    display: flex;\n    flex-direction: ", ";\n"], ["\n    > label,\n    ", " {\n        &:not(:last-child) {\n            margin-bottom: ", ";\n            margin-right: ", ";\n        }\n    }\n\n    display: flex;\n    flex-direction: ", ";\n"])), Mf, (function (e) { return "HORIZONTAL" === e.orientation ? "0" : "15px" }), (function (e) { return "HORIZONTAL" === e.orientation ? "15px" : "0" }), (function (e) { return "HORIZONTAL" === e.orientation ? "row" : "column" })), Vf = o$1.div(pf || (pf = E(["\n    display: flex;\n    align-items: center;\n    flex-shrink: 1;\n\n    color: ", ";\n\n    font-size: ", ";\n\n    ", "\n\n    > span {\n        vertical-align: sub;\n        &:first-child {\n            margin-right: 7.5px;\n        }\n    }\n\n    img {\n        padding-top: 2px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    flex-shrink: 1;\n\n    color: ", ";\n\n    font-size: ", ";\n\n    ", "\n\n    > span {\n        vertical-align: sub;\n        &:first-child {\n            margin-right: 7.5px;\n        }\n    }\n\n    img {\n        padding-top: 2px;\n    }\n"])), (function (e) { return e.disabled ? Ee.radiobuttonLabelDisabledColor : Ee.radiobuttonLabelColor }), (function (e) { var t = e.labelFontSize; return null != t ? t : "15px" }), (function (e) { var t = e.labelMinWidth; return t && "min-width: ".concat(t, ";") })), Wf = o$1.span(bf || (bf = E(["\n    position: relative;\n    flex-shrink: 0;\n\n    height: 14px;\n    width: 14px;\n    display: inline-block;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 50%;\n    cursor: ", ";\n\n    &:after {\n        content: '';\n        position: absolute;\n        left: 50%;\n        top: 50%;\n\n        display: block;\n        width: 8px;\n        height: 8px;\n\n        margin-left: -4px;\n        margin-top: -4px;\n\n        border-radius: 50%;\n    }\n    ", ":hover & {\n        ", ";\n\n        ", ";\n    }\n\n    ", ";\n"], ["\n    position: relative;\n    flex-shrink: 0;\n\n    height: 14px;\n    width: 14px;\n    display: inline-block;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 50%;\n    cursor: ", ";\n\n    &:after {\n        content: '';\n        position: absolute;\n        left: 50%;\n        top: 50%;\n\n        display: block;\n        width: 8px;\n        height: 8px;\n\n        margin-left: -4px;\n        margin-top: -4px;\n\n        border-radius: 50%;\n    }\n    ", ":hover & {\n        ", ";\n\n        ", ";\n    }\n\n    ", ";\n"])), Ee.radiobuttonBackground, Ee.radiobuttonBorder, (function (e) { return !e.disabled && "pointer" }), Vf, (function (e) { return !e.disabled && css(uf || (uf = E(["\n                background-color: ", ";\n            "], ["\n                background-color: ", ";\n            "])), Ee.radiobuttonHoverBackground) }), (function (e) { var t = e.checked, n = e.disabled; return t && !n && css(df || (df = E(["\n                &:after {\n                    background-color: ", ";\n                }\n            "], ["\n                &:after {\n                    background-color: ", ";\n                }\n            "])), Ee.radiobuttonActive) }), (function (e) { var t = e.checked, n = e.disabled; return t && css(ff || (ff = E(["\n            &:after {\n                background-color: ", ";\n            }\n        "], ["\n            &:after {\n                background-color: ", ";\n            }\n        "])), n ? Ee.radiobuttonLabelDisabledColor : Ee.radiobuttonActive) })), Hf = function (n) { var o = n.active, r = void 0 !== o && o, i = n.disabled, a = void 0 !== i && i, l = n.label, c = void 0 === l ? "" : l, p = n.onClickHandler, u = void 0 === p ? void 0 : p, d = n.renderSuffix, f = void 0 === d ? null : d, b = n.suffixLocation, g = void 0 === b ? "BOTTOM" : b, h = n.styles, m = n.value, v = void 0 === m ? null : m, y = n.radioButtonRef, x = void 0 === y ? null : y, w = n.wrapperOverflow, C = void 0 === w ? "visible" : w, I = function () { !a && u && u(); }; return jsxs(React__default.Fragment, { children: [c && v && function () { var n = jsxs(Vf, k$1({ disabled: a, onClick: I }, { children: [jsx(Wf, k$1({ checked: r, disabled: a, "data-testid": "radio-button-".concat(v) }, h), void 0), jsx(Lf, k$1({ "data-testid": "radio-button-label-".concat(v), wrapperOverflow: C }, { children: c }), void 0)] }), void 0); return f ? jsxs(Mf, k$1({ ref: x, flexDirection: "RIGHT" === g ? "row" : "column", wrapperOverflow: C }, { children: [n, f(v, r)] }), void 0) : jsx(Mf, k$1({ ref: x, wrapperOverflow: C }, { children: n }), void 0) }(), " "] }, void 0) }, Ff = function (n) { var o = n.disabled, r = void 0 !== o && o, i = n.noOptionsBody, a = void 0 === i ? null : i, l = n.options, s = void 0 === l ? [] : l, c = n.orientation, p = void 0 === c ? "VERTICAL" : c, u = n.readOnly, d = void 0 !== u && u, f = n.renderSuffix, b = void 0 === f ? null : f, g = n.onClick, h = void 0 === g ? void 0 : g, m = n.styles, v = void 0 === m ? {} : m, y = n.suffixLocation, x = void 0 === y ? "BOTTOM" : y, w = n.value, C = void 0 === w ? "" : w, I = n.wrapperOverflow, A = void 0 === I ? "visible" : I, O = s.find((function (e) { return e.value === C })); if (d && O) return jsx(Oo, { children: O.label }, void 0); var T = s.map((function (t) { return jsx(Hf, { radioButtonRef: t.radioButtonRef, active: t.value === C, disabled: r || t.disabled, label: t.label, onClickHandler: r && t.disabled ? null : (n = t.value, function () { h && h(n); }), renderSuffix: b, styles: v, suffixLocation: x, value: t.value, wrapperOverflow: A }, t.label); var n; })); return jsxs(Xf, k$1({ orientation: p }, { children: [T, 0 === s.length ? a : null] }), void 0) }, zf = o$1.tr(gf || (gf = E(["\n    width: 100%;\n    border-bottom: 1px solid ", ";\n\n    background-color: ", ";\n\n    color: ", ";\n\n    ", ";\n"], ["\n    width: 100%;\n    border-bottom: 1px solid ", ";\n\n    background-color: ", ";\n\n    color: ", ";\n\n    ", ";\n"])), Ee.tableBorder, (function (e) { var t = e.disabled, n = e.trBackgroundColor; return t ? Ee.tableRowDisabledBackgroundColor : n || "inherit" }), Ee.tableColor, (function (e) { var t = e.onClick, n = e.trBackgroundColorHover; return t ? "\n        cursor: pointer;\n\n        &:hover {\n            background-color: ".concat(null != n ? n : Ee.tableRowHover, ";\n        }\n    ") : "\n        cursor: default;\n    " })); o$1.thead(hf || (hf = E([""], [""]))); var Zf = o$1.th(mf || (mf = E(["\n    vertical-align: middle;\n    height: 49px;\n\n    padding: ", ";\n\n    background-color: ", ";\n    color: ", ";\n\n    font-size: 14px;\n    font-weight: normal;\n\n    text-align: left;\n\n    &:first-child {\n        padding-left: 20px;\n    }\n\n    box-sizing: border-box;\n"], ["\n    vertical-align: middle;\n    height: 49px;\n\n    padding: ", ";\n\n    background-color: ", ";\n    color: ", ";\n\n    font-size: 14px;\n    font-weight: normal;\n\n    text-align: left;\n\n    &:first-child {\n        padding-left: 20px;\n    }\n\n    box-sizing: border-box;\n"])), (function (e) { return e.flush ? "0 !important" : "10px" }), Ee.tableHeader, (function (e) { var t = e.headerColor; return null != t ? t : Ee.tableHeaderColor })), Yf = o$1.td(vf || (vf = E(["\n    vertical-align: ", ";\n    height: ", ";\n    color: ", ";\n\n    padding: ", ";\n\n    max-width: ", ";\n    word-break: ", ";\n\n    &:first-child {\n        padding-left: 20px;\n    }\n\n    ", " {\n        margin-top: -4px;\n        margin-left: -6px;\n        margin-bottom: -4px;\n    }\n\n    font-size: ", ";\n"], ["\n    vertical-align: ", ";\n    height: ", ";\n    color: ", ";\n\n    padding: ", ";\n\n    max-width: ", ";\n    word-break: ", ";\n\n    &:first-child {\n        padding-left: 20px;\n    }\n\n    ", " {\n        margin-top: -4px;\n        margin-left: -6px;\n        margin-bottom: -4px;\n    }\n\n    font-size: ", ";\n"])), (function (e) { var t = e.tdVerticalAlign; return null != t ? t : "middle" }), (function (e) { var t = e.tdHeight; return null != t ? t : "49px" }), (function (e) { var t = e.tdColor; return null != t ? t : "inherit" }), (function (e) { var t = e.flush, n = e.tdPadding; return t ? "0 !important" : n || "12px" }), (function (e) { var t = e.tdMaxWidth; return null != t ? t : "100%" }), (function (e) { var t = e.tdWordBreak; return null != t ? t : "normal" }), Ae, (function (e) { var t = e.tdFontSize; return null != t ? t : "15px" })); o$1.div(yf || (yf = E(["\n    display: flex;\n    align-items: center;\n\n    min-height: ", ";\n"], ["\n    display: flex;\n    align-items: center;\n\n    min-height: ", ";\n"])), (function (e) { var t = e.minHeight; return null != t ? t : "none" })); o$1.tbody(xf || (xf = E(["\n    > ", " {\n        &:last-child {\n            border-bottom: 0;\n        }\n    }\n"], ["\n    > ", " {\n        &:last-child {\n            border-bottom: 0;\n        }\n    }\n"])), zf); o$1.div(wf || (wf = E(["\n    ", "\n\n    padding: 24px 20px;\n    background-color: ", ";\n"], ["\n    ", "\n\n    padding: 24px 20px;\n    background-color: ", ";\n"])), (function (e) { var t = e.maxHeight; return t && "\n        max-height: ".concat(t, ";\n        overflow: auto;\n    ") }), Ee.tableExpanded); o$1.div(Cf || (Cf = E(["\n    padding: 24px 20px;\n\n    display: flex;\n    justify-content: center;\n"], ["\n    padding: 24px 20px;\n\n    display: flex;\n    justify-content: center;\n"]))); var Kf = o$1.table(If || (If = E(["\n    position: relative;\n    width: 100%;\n\n    background-color: ", ";\n    border-collapse: collapse;\n"], ["\n    position: relative;\n    width: 100%;\n\n    background-color: ", ";\n    border-collapse: collapse;\n"])), Ee.tableBackground); o$1.div(Of || (Of = E(["\n    position: relative;\n    width: 100%;\n\n    border: 1px solid ", ";\n    border-radius 4px;\n\n    ", "\n\n    ", "\n"], ["\n    position: relative;\n    width: 100%;\n\n    border: 1px solid ", ";\n    border-radius 4px;\n\n    ", "\n\n    ", "\n"])), Ee.tableBorder, (function (e) { return e.gridStyling && css(Af || (Af = E(["\n            ", " {\n                ", ", ", " {\n                    border-right: 1px solid ", ";\n\n                    &:last-child {\n                        border-right-width: 0;\n                    }\n                }\n            }\n        "], ["\n            ", " {\n                ", ", ", " {\n                    border-right: 1px solid ", ";\n\n                    &:last-child {\n                        border-right-width: 0;\n                    }\n                }\n            }\n        "])), Kf, Zf, Yf, Ee.tableBorder) }), (function (e) { return e.subtleStyling && css(kf || (kf = E(["\n            border-color: ", ";\n\n            ", " {\n                ", " {\n                    border-color: ", ";\n                }\n\n                ", ", ", " {\n                    font-size: 13px !important;\n                }\n\n                ", " {\n                    background-color: ", ";\n                    color: ", ";\n                }\n\n                ", " {\n                    color: ", ";\n                }\n            }\n        "], ["\n            border-color: ", ";\n\n            ", " {\n                ", " {\n                    border-color: ", ";\n                }\n\n                ", ", ", " {\n                    font-size: 13px !important;\n                }\n\n                ", " {\n                    background-color: ", ";\n                    color: ", ";\n                }\n\n                ", " {\n                    color: ", ";\n                }\n            }\n        "])), Ee.tableSubtleBorder, Kf, zf, Ee.tableSubtleBorder, Zf, Yf, Zf, Ee.tableSubtleHeader, Ee.tableSubtleHeaderColor, Yf, Ee.tableSubtleColor) })); o$1.td(Tf || (Tf = E(["\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    width: 100%;\n    height 100%;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    width: 100%;\n    height 100%;\n"]))); o$1.tr(Ef || (Ef = E(["\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height 100%;\n\n    background-color: ", ";\n\n    z-index: 10;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height 100%;\n\n    background-color: ", ";\n\n    z-index: 10;\n"])), Xd(.25, Ee.tableBackground)); var tb = o$1.span(Sf || (Sf = E(["\n    margin-left: 5px;\n\n    &:after {\n        content: '';\n        opacity: ", ";\n        display: inline-block;\n\n        width: 10px;\n        height: 10px;\n\n        background-position: center;\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    ", ";\n"], ["\n    margin-left: 5px;\n\n    &:after {\n        content: '';\n        opacity: ", ";\n        display: inline-block;\n\n        width: 10px;\n        height: 10px;\n\n        background-position: center;\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    ", ";\n"])), (function (e) { return e.active ? "1 !important;" : "0" }), (function (e) { var t = e.desc, n = "&:after {"; return n += "background-image: url(".concat(t ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAABC0lEQVR4AWIYEDAHUBtZAvUSxVH4PVz70CCSyfShD32G3htUKr7ys5W2BeuzHdceKbj8XQ/uzuqV73zXLBzB+ysyERsl0QKxFFmDsZ/JVCd94iyJFvF6JFm0fVlUrVYbSDR0fMqQaJbNhvGijDZfJALzKVmapk2kuuC4fobVshKGQ3d9KJNaxvG8DBiw78rMrI1Y0znXy/qiV2bx4HMGbVTvAwMWmVdlsrjYzaKrs3NultXOgiAYeGtg9IEBi8zy8nLHEyBJkhYW3Z+emwNwFEVR/78PLjBUZ2dmnetDeyIVC8dZrUqsB2bW+zT6rrQPGWRFbevJaKLBZBzHPf++eCEjFjj1VXb9+4urBs16vP9GVWFHAAAAAElFTkSuQmCC" : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAABDElEQVR4AbSSNULFQBCGcecAdFBSU3MADsBxoKXFI2O7SZcGO0B6XM9Ag0ueyw7uztrY90+04V9GFEWDxGYqjuO+72pVQ2K8JEl6HpIkdgJZaoB8KCL937iRAdWolli2HwquexsSH8zMz+ecPdY7/spTgWNn57ycs6WVlZWuZwAtLfUi8drcvJ9DlnNjzNB7zbSmjLKq0WZvgiLSAcjpvB/kQuJrkXj4JaM5cDVllFXNh4+SpmkLMC96fpghS46sHbmvqQ8smRcEmTLKfull12q1JiC2XgiZszkUGdWtvuZCokiZb/9OxDwVAt68dN0BUE5zv/pHiWQMiIuAVEI24w1/MVBsfUkgzDAQAADU/Lz/F75XjgAAAABJRU5ErkJggg==", ");"), "".concat(n, " }") })); o$1.span(Bf || (Bf = E(["\n    white-space: nowrap;\n\n    &:hover {\n        cursor: pointer;\n\n        ", " {\n            &:after {\n                opacity: 0.5;\n            }\n        }\n    }\n"], ["\n    white-space: nowrap;\n\n    &:hover {\n        cursor: pointer;\n\n        ", " {\n            &:after {\n                opacity: 0.5;\n            }\n        }\n    }\n"])), tb); o$1.div(Gf || (Gf = E(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    width: 100%;\n    height 100%;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    width: 100%;\n    height 100%;\n"]))); o$1.textarea(Nf || (Nf = E(["\n    ", "\n\n    min-height: ", ";\n    padding: 12px 16px;\n    font-family: inherit;\n\n    resize: vertical;\n"], ["\n    ", "\n\n    min-height: ", ";\n    padding: 12px 16px;\n    font-family: inherit;\n\n    resize: vertical;\n"])), ko, (function (e) { var t = e.minHeight; return null != t ? t : "72px" })); o$1.div(Pf || (Pf = E(["\n    margin-top: 4px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    font-size: 14px;\n"], ["\n    margin-top: 4px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    font-size: 14px;\n"]))); o$1(Oo)(Rf || (Rf = E(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), Ee.defaultSubtleColor); function ub() { return I.randomBytes(16) } for (var db = [], fb = 0; fb < 256; ++fb)db[fb] = (fb + 256).toString(16).substr(1); function bb(e, t, n) { var o = t && n || 0; "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null); var r = (e = e || {}).random || (e.rng || ub)(); if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) for (var i = 0; i < 16; ++i)t[o + i] = r[i]; return t || function (e, t) { var n = t || 0, o = db; return [o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]]].join("") }(r) } function gb(e, t) { for (var n = 0; n < t.length; n++) { var o = t[n]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o); } } function hb(e, t, n) { return t && gb(e.prototype, t), n && gb(e, n), e } function mb(e, t, n) { return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e } function vb() { return vb = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var n = arguments[t]; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]); } return e }, vb.apply(this, arguments) } function yb(e, t) { var n = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); t && (o = o.filter((function (t) { return Object.getOwnPropertyDescriptor(e, t).enumerable }))), n.push.apply(n, o); } return n } function xb(e) { for (var t = 1; t < arguments.length; t++) { var n = null != arguments[t] ? arguments[t] : {}; t % 2 ? yb(Object(n), !0).forEach((function (t) { mb(e, t, n[t]); })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yb(Object(n)).forEach((function (t) { Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t)); })); } return e } function wb(e) { return wb = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) { return e.__proto__ || Object.getPrototypeOf(e) }, wb(e) } function Cb(e, t) { return Cb = Object.setPrototypeOf || function (e, t) { return e.__proto__ = t, e }, Cb(e, t) } function Ib(e, t) { return !t || "object" != typeof t && "function" != typeof t ? function (e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e }(e) : t } var Ab = { HIDE: "__react_tooltip_hide_event", REBUILD: "__react_tooltip_rebuild_event", SHOW: "__react_tooltip_show_event" }, kb = function (e, t) { var n; "function" == typeof window.CustomEvent ? n = new window.CustomEvent(e, { detail: t }) : (n = document.createEvent("Event")).initEvent(e, !1, !0, t), window.dispatchEvent(n); }; var Ob = function (e, t) { var n = this.state.show, o = this.props.id, r = this.isCapture(t.currentTarget), i = t.currentTarget.getAttribute("currentItem"); r || t.stopPropagation(), n && "true" === i ? e || this.hideTooltip(t) : (t.currentTarget.setAttribute("currentItem", "true"), Tb(t.currentTarget, this.getTargetArray(o)), this.showTooltip(t)); }, Tb = function (e, t) { for (var n = 0; n < t.length; n++)e !== t[n] ? t[n].setAttribute("currentItem", "false") : t[n].setAttribute("currentItem", "true"); }, Eb = { id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf", set: function (e, t, n) { this.id in e ? e[this.id][t] = n : Object.defineProperty(e, this.id, { configurable: !0, value: mb({}, t, n) }); }, get: function (e, t) { var n = e[this.id]; if (void 0 !== n) return n[t] } }; var Sb = function (e, t, n) { var o = t.respectEffect, r = void 0 !== o && o, i = t.customEvent, a = void 0 !== i && i, l = this.props.id, s = n.target.getAttribute("data-tip") || null, c = n.target.getAttribute("data-for") || null, p = n.target; if (!this.isCustomEvent(p) || a) { var u = null == l && null == c || c === l; if (null != s && (!r || "float" === this.getEffect(p)) && u) { var d = function (e) { var t = {}; for (var n in e) "function" == typeof e[n] ? t[n] = e[n].bind(e) : t[n] = e[n]; return t }(n); d.currentTarget = p, e(d); } } }, Bb = function (e, t) { var n = {}; return e.forEach((function (e) { var o = e.getAttribute(t); o && o.split(" ").forEach((function (e) { return n[e] = !0 })); })), n }, Gb = function () { return document.getElementsByTagName("body")[0] }; function Nb(e, t, n, o, r, i, a) { for (var l = Pb(n), s = l.width, c = l.height, p = Pb(t), u = p.width, d = p.height, f = Rb(e, t, i), b = f.mouseX, g = f.mouseY, h = Mb(i, u, d, s, c), m = Lb(a), v = m.extraOffsetX, y = m.extraOffsetY, x = window.innerWidth, w = window.innerHeight, C = Xb(n), I = C.parentTop, A = C.parentLeft, k = function (e) { var t = h[e].l; return b + t + v }, O = function (e) { var t = h[e].t; return g + t + y }, T = function (e) { return function (e) { var t = h[e].r; return b + t + v }(e) > x }, E = function (e) { return function (e) { var t = h[e].b; return g + t + y }(e) > w }, S = function (e) { return function (e) { return k(e) < 0 }(e) || T(e) || function (e) { return O(e) < 0 }(e) || E(e) }, B = function (e) { return !S(e) }, G = ["top", "bottom", "left", "right"], N = [], P = 0; P < 4; P++) { var R = G[P]; B(R) && N.push(R); } var M, L = !1, X = r !== o; return B(r) && X ? (L = !0, M = r) : N.length > 0 && S(r) && S(o) && (L = !0, M = N[0]), L ? { isNewState: !0, newState: { place: M } } : { isNewState: !1, position: { left: parseInt(k(o) - A, 10), top: parseInt(O(o) - I, 10) } } } var Pb = function (e) { var t = e.getBoundingClientRect(), n = t.height, o = t.width; return { height: parseInt(n, 10), width: parseInt(o, 10) } }, Rb = function (e, t, n) { var o = t.getBoundingClientRect(), r = o.top, i = o.left, a = Pb(t), l = a.width, s = a.height; return "float" === n ? { mouseX: e.clientX, mouseY: e.clientY } : { mouseX: i + l / 2, mouseY: r + s / 2 } }, Mb = function (e, t, n, o, r) { var i, a, l, s; return "float" === e ? (i = { l: -o / 2, r: o / 2, t: -(r + 3 + 2), b: -3 }, l = { l: -o / 2, r: o / 2, t: 15, b: r + 3 + 2 + 12 }, s = { l: -(o + 3 + 2), r: -3, t: -r / 2, b: r / 2 }, a = { l: 3, r: o + 3 + 2, t: -r / 2, b: r / 2 }) : "solid" === e && (i = { l: -o / 2, r: o / 2, t: -(n / 2 + r + 2), b: -n / 2 }, l = { l: -o / 2, r: o / 2, t: n / 2, b: n / 2 + r + 2 }, s = { l: -(o + t / 2 + 2), r: -t / 2, t: -r / 2, b: r / 2 }, a = { l: t / 2, r: o + t / 2 + 2, t: -r / 2, b: r / 2 }), { top: i, bottom: l, left: s, right: a } }, Lb = function (e) { var t = 0, n = 0; for (var o in "[object String]" === Object.prototype.toString.apply(e) && (e = JSON.parse(e.toString().replace(/'/g, '"'))), e) "top" === o ? n -= parseInt(e[o], 10) : "bottom" === o ? n += parseInt(e[o], 10) : "left" === o ? t -= parseInt(e[o], 10) : "right" === o && (t += parseInt(e[o], 10)); return { extraOffsetX: t, extraOffsetY: n } }, Xb = function (e) { for (var t = e; t;) { var n = window.getComputedStyle(t); if ("none" !== n.getPropertyValue("transform") || "transform" === n.getPropertyValue("will-change")) break; t = t.parentElement; } return { parentTop: t && t.getBoundingClientRect().top || 0, parentLeft: t && t.getBoundingClientRect().left || 0 } }; function Vb(e, t, n, o) { if (t) return t; if (null != n) return n; if (null === n) return null; var r = /<br\s*\/?>/; return o && "false" !== o && r.test(e) ? e.split(r).map((function (e, t) { return React__default.createElement("span", { key: t, className: "multi-line" }, e) })) : e } function Wb(e) { var t = {}; return Object.keys(e).filter((function (e) { return /(^aria-\w+$|^role$)/.test(e) })).forEach((function (n) { t[n] = e[n]; })), t } function Hb(e) { var t = e.length; return e.hasOwnProperty ? Array.prototype.slice.call(e) : new Array(t).fill().map((function (t) { return e[t] })) } var Fb = { dark: { text: "#fff", background: "#222", border: "transparent", arrow: "#222" }, success: { text: "#fff", background: "#8DC572", border: "transparent", arrow: "#8DC572" }, warning: { text: "#fff", background: "#F0AD4E", border: "transparent", arrow: "#F0AD4E" }, error: { text: "#fff", background: "#BE6464", border: "transparent", arrow: "#BE6464" }, info: { text: "#fff", background: "#337AB7", border: "transparent", arrow: "#337AB7" }, light: { text: "#222", background: "#fff", border: "transparent", arrow: "#fff" } }; function Db(e, t, n, o) { return function (e, t) { var n = t.text, o = t.background, r = t.border, i = t.arrow; return "\n  \t.".concat(e, " {\n\t    color: ").concat(n, ";\n\t    background: ").concat(o, ";\n\t    border: 1px solid ").concat(r, ";\n  \t}\n\n  \t.").concat(e, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(e, ".place-top::before {\n        border-top: 8px solid ").concat(r, ";\n    }\n    .").concat(e, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(i, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(e, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(e, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(r, ";\n    }\n    .").concat(e, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(i, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(e, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(e, ".place-left::before {\n        border-left: 8px solid ").concat(r, ";\n    }\n    .").concat(e, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(i, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(e, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(e, ".place-right::before {\n        border-right: 8px solid ").concat(r, ";\n    }\n    .").concat(e, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(i, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ") }(e, function (e, t, n) { var o = e.text, r = e.background, i = e.border, a = e.arrow ? e.arrow : e.background, l = function (e) { return Fb[e] ? xb({}, Fb[e]) : void 0 }(t); o && (l.text = o); r && (l.background = r); n && (l.border = i || ("light" === t ? "black" : "white")); a && (l.arrow = a); return l }(t, n, o)) } var zb = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {}; function jb(e, t) { return e(t = { exports: {} }, t.exports), t.exports } var Zb = function (e) { return e && e.Math == Math && e }, Yb = Zb("object" == typeof globalThis && globalThis) || Zb("object" == typeof window && window) || Zb("object" == typeof self && self) || Zb("object" == typeof zb && zb) || function () { return this }() || Function("return this")(), _b$1 = function (e) { try { return !!e() } catch (e) { return !0 } }, Jb = !_b$1((function () { return 7 != Object.defineProperty({}, 1, { get: function () { return 7 } })[1] })), Ub = {}.propertyIsEnumerable, Qb = Object.getOwnPropertyDescriptor, Kb = { f: Qb && !Ub.call({ 1: 2 }, 1) ? function (e) { var t = Qb(this, e); return !!t && t.enumerable } : Ub }, qb = function (e, t) { return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t } }, $b = {}.toString, eg = function (e) { return $b.call(e).slice(8, -1) }, tg = "".split, ng = _b$1((function () { return !Object("z").propertyIsEnumerable(0) })) ? function (e) { return "String" == eg(e) ? tg.call(e, "") : Object(e) } : Object, og = function (e) { if (null == e) throw TypeError("Can't call method on " + e); return e }, rg = function (e) { return ng(og(e)) }, ig = function (e) { return "object" == typeof e ? null !== e : "function" == typeof e }, ag = function (e, t) { if (!ig(e)) return e; var n, o; if (t && "function" == typeof (n = e.toString) && !ig(o = n.call(e))) return o; if ("function" == typeof (n = e.valueOf) && !ig(o = n.call(e))) return o; if (!t && "function" == typeof (n = e.toString) && !ig(o = n.call(e))) return o; throw TypeError("Can't convert object to primitive value") }, lg = function (e) { return Object(og(e)) }, sg = {}.hasOwnProperty, cg = function (e, t) { return sg.call(lg(e), t) }, pg = Yb.document, ug = ig(pg) && ig(pg.createElement), dg = function (e) { return ug ? pg.createElement(e) : {} }, fg = !Jb && !_b$1((function () { return 7 != Object.defineProperty(dg("div"), "a", { get: function () { return 7 } }).a })), bg = Object.getOwnPropertyDescriptor, gg = { f: Jb ? bg : function (e, t) { if (e = rg(e), t = ag(t, !0), fg) try { return bg(e, t) } catch (e) { } if (cg(e, t)) return qb(!Kb.f.call(e, t), e[t]) } }, hg = function (e) { if (!ig(e)) throw TypeError(String(e) + " is not an object"); return e }, mg = Object.defineProperty, vg = { f: Jb ? mg : function (e, t, n) { if (hg(e), t = ag(t, !0), hg(n), fg) try { return mg(e, t, n) } catch (e) { } if ("get" in n || "set" in n) throw TypeError("Accessors not supported"); return "value" in n && (e[t] = n.value), e } }, yg = Jb ? function (e, t, n) { return vg.f(e, t, qb(1, n)) } : function (e, t, n) { return e[t] = n, e }, xg = function (e, t) { try { yg(Yb, e, t); } catch (n) { Yb[e] = t; } return t }, wg = Yb["__core-js_shared__"] || xg("__core-js_shared__", {}), Cg = Function.toString; "function" != typeof wg.inspectSource && (wg.inspectSource = function (e) { return Cg.call(e) }); var Ig, Ag, kg, Og = wg.inspectSource, Tg = Yb.WeakMap, Eg = "function" == typeof Tg && /native code/.test(Og(Tg)), Sg = jb((function (e) { (e.exports = function (e, t) { return wg[e] || (wg[e] = void 0 !== t ? t : {}) })("versions", []).push({ version: "3.12.1", mode: "global", copyright: "© 2021 Denis Pushkarev (zloirock.ru)" }); })), Bg = 0, Gg = Math.random(), Ng = function (e) { return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++Bg + Gg).toString(36) }, Pg = Sg("keys"), Rg = function (e) { return Pg[e] || (Pg[e] = Ng(e)) }, Mg = {}, Lg = Yb.WeakMap; if (Eg || wg.state) { var Xg = wg.state || (wg.state = new Lg), Vg = Xg.get, Wg = Xg.has, Hg = Xg.set; Ig = function (e, t) { if (Wg.call(Xg, e)) throw new TypeError("Object already initialized"); return t.facade = e, Hg.call(Xg, e, t), t }, Ag = function (e) { return Vg.call(Xg, e) || {} }, kg = function (e) { return Wg.call(Xg, e) }; } else { var Fg = Rg("state"); Mg[Fg] = !0, Ig = function (e, t) { if (cg(e, Fg)) throw new TypeError("Object already initialized"); return t.facade = e, yg(e, Fg, t), t }, Ag = function (e) { return cg(e, Fg) ? e[Fg] : {} }, kg = function (e) { return cg(e, Fg) }; } var Dg, zg, jg = { set: Ig, get: Ag, has: kg, enforce: function (e) { return kg(e) ? Ag(e) : Ig(e, {}) }, getterFor: function (e) { return function (t) { var n; if (!ig(t) || (n = Ag(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required"); return n } } }, Zg = jb((function (e) { var t = jg.get, n = jg.enforce, o = String(String).split("String"); (e.exports = function (e, t, r, i) { var a, l = !!i && !!i.unsafe, s = !!i && !!i.enumerable, c = !!i && !!i.noTargetGet; "function" == typeof r && ("string" != typeof t || cg(r, "name") || yg(r, "name", t), (a = n(r)).source || (a.source = o.join("string" == typeof t ? t : ""))), e !== Yb ? (l ? !c && e[t] && (s = !0) : delete e[t], s ? e[t] = r : yg(e, t, r)) : s ? e[t] = r : xg(t, r); })(Function.prototype, "toString", (function () { return "function" == typeof this && t(this).source || Og(this) })); })), Yg = Yb, _g = function (e) { return "function" == typeof e ? e : void 0 }, Jg = function (e, t) { return arguments.length < 2 ? _g(Yg[e]) || _g(Yb[e]) : Yg[e] && Yg[e][t] || Yb[e] && Yb[e][t] }, Ug = Math.ceil, Qg = Math.floor, Kg = function (e) { return isNaN(e = +e) ? 0 : (e > 0 ? Qg : Ug)(e) }, qg = Math.min, $g = function (e) { return e > 0 ? qg(Kg(e), 9007199254740991) : 0 }, eh = Math.max, th = Math.min, nh = function (e) { return function (t, n, o) { var r, i = rg(t), a = $g(i.length), l = function (e, t) { var n = Kg(e); return n < 0 ? eh(n + t, 0) : th(n, t) }(o, a); if (e && n != n) { for (; a > l;)if ((r = i[l++]) != r) return !0 } else for (; a > l; l++)if ((e || l in i) && i[l] === n) return e || l || 0; return !e && -1 } }, oh = { includes: nh(!0), indexOf: nh(!1) }.indexOf, rh = function (e, t) { var n, o = rg(e), r = 0, i = []; for (n in o) !cg(Mg, n) && cg(o, n) && i.push(n); for (; t.length > r;)cg(o, n = t[r++]) && (~oh(i, n) || i.push(n)); return i }, ih = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"], ah = ih.concat("length", "prototype"), lh = { f: Object.getOwnPropertyNames || function (e) { return rh(e, ah) } }, sh = { f: Object.getOwnPropertySymbols }, ch = Jg("Reflect", "ownKeys") || function (e) { var t = lh.f(hg(e)), n = sh.f; return n ? t.concat(n(e)) : t }, ph = function (e, t) { for (var n = ch(t), o = vg.f, r = gg.f, i = 0; i < n.length; i++) { var a = n[i]; cg(e, a) || o(e, a, r(t, a)); } }, uh = /#|\.prototype\./, dh = function (e, t) { var n = bh[fh(e)]; return n == hh || n != gh && ("function" == typeof t ? _b$1(t) : !!t) }, fh = dh.normalize = function (e) { return String(e).replace(uh, ".").toLowerCase() }, bh = dh.data = {}, gh = dh.NATIVE = "N", hh = dh.POLYFILL = "P", mh = dh, vh = gg.f, yh = function (e, t, n) { if (function (e) { if ("function" != typeof e) throw TypeError(String(e) + " is not a function") }(e), void 0 === t) return e; switch (n) { case 0: return function () { return e.call(t) }; case 1: return function (n) { return e.call(t, n) }; case 2: return function (n, o) { return e.call(t, n, o) }; case 3: return function (n, o, r) { return e.call(t, n, o, r) } }return function () { return e.apply(t, arguments) } }, xh = Array.isArray || function (e) { return "Array" == eg(e) }, wh = Jg("navigator", "userAgent") || "", Ch = Yb.process, Ih = Ch && Ch.versions, Ah = Ih && Ih.v8; Ah ? zg = (Dg = Ah.split("."))[0] < 4 ? 1 : Dg[0] + Dg[1] : wh && (!(Dg = wh.match(/Edge\/(\d+)/)) || Dg[1] >= 74) && (Dg = wh.match(/Chrome\/(\d+)/)) && (zg = Dg[1]); var kh, Oh = zg && +zg, Th = !!Object.getOwnPropertySymbols && !_b$1((function () { return !String(Symbol()) || !Symbol.sham && Oh && Oh < 41 })), Eh = Th && !Symbol.sham && "symbol" == typeof Symbol.iterator, Sh = Sg("wks"), Bh = Yb.Symbol, Gh = Eh ? Bh : Bh && Bh.withoutSetter || Ng, Nh = function (e) { return cg(Sh, e) && (Th || "string" == typeof Sh[e]) || (Th && cg(Bh, e) ? Sh[e] = Bh[e] : Sh[e] = Gh("Symbol." + e)), Sh[e] }, Ph = Nh("species"), Rh = function (e, t) { var n; return xh(e) && ("function" != typeof (n = e.constructor) || n !== Array && !xh(n.prototype) ? ig(n) && null === (n = n[Ph]) && (n = void 0) : n = void 0), new (void 0 === n ? Array : n)(0 === t ? 0 : t) }, Mh = [].push, Lh = function (e) { var t = 1 == e, n = 2 == e, o = 3 == e, r = 4 == e, i = 6 == e, a = 7 == e, l = 5 == e || i; return function (s, c, p, u) { for (var d, f, b = lg(s), g = ng(b), h = yh(c, p, 3), m = $g(g.length), v = 0, y = u || Rh, x = t ? y(s, m) : n || a ? y(s, 0) : void 0; m > v; v++)if ((l || v in g) && (f = h(d = g[v], v, b), e)) if (t) x[v] = f; else if (f) switch (e) { case 3: return !0; case 5: return d; case 6: return v; case 2: Mh.call(x, d); } else switch (e) { case 4: return !1; case 7: Mh.call(x, d); }return i ? -1 : o || r ? r : x } }, Xh = { forEach: Lh(0), map: Lh(1), filter: Lh(2), some: Lh(3), every: Lh(4), find: Lh(5), findIndex: Lh(6), filterOut: Lh(7) }, Vh = Object.keys || function (e) { return rh(e, ih) }, Wh = Jb ? Object.defineProperties : function (e, t) { hg(e); for (var n, o = Vh(t), r = o.length, i = 0; r > i;)vg.f(e, n = o[i++], t[n]); return e }, Hh = Jg("document", "documentElement"), Fh = Rg("IE_PROTO"), Dh = function () { }, zh = function (e) { return "<script>" + e + "<\/script>" }, jh = function () { try { kh = document.domain && new ActiveXObject("htmlfile"); } catch (e) { } var e, t; jh = kh ? function (e) { e.write(zh("")), e.close(); var t = e.parentWindow.Object; return e = null, t }(kh) : ((t = dg("iframe")).style.display = "none", Hh.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(zh("document.F=Object")), e.close(), e.F); for (var n = ih.length; n--;)delete jh.prototype[ih[n]]; return jh() }; Mg[Fh] = !0; var Zh = Object.create || function (e, t) { var n; return null !== e ? (Dh.prototype = hg(e), n = new Dh, Dh.prototype = null, n[Fh] = e) : n = jh(), void 0 === t ? n : Wh(n, t) }, Yh = Nh("unscopables"), _h = Array.prototype; null == _h[Yh] && vg.f(_h, Yh, { configurable: !0, value: Zh(null) }); var Jh, Uh, Qh, Kh, qh = Xh.find, $h = !0; "find" in [] && Array(1).find((function () { $h = !1; })), function (e, t) { var n, o, r, i, a, l = e.target, s = e.global, c = e.stat; if (n = s ? Yb : c ? Yb[l] || xg(l, {}) : (Yb[l] || {}).prototype) for (o in t) { if (i = t[o], r = e.noTargetGet ? (a = vh(n, o)) && a.value : n[o], !mh(s ? o : l + (c ? "." : "#") + o, e.forced) && void 0 !== r) { if (typeof i == typeof r) continue; ph(i, r); } (e.sham || r && r.sham) && yg(i, "sham", !0), Zg(n, o, i, e); } }({ target: "Array", proto: !0, forced: $h }, { find: function (e) { return qh(this, e, arguments.length > 1 ? arguments[1] : void 0) } }), Jh = "find", _h[Yh][Jh] = !0; var em, tm, nm, om, rm, im = function (e) { e.hide = function (e) { kb(Ab.HIDE, { target: e }); }, e.rebuild = function () { kb(Ab.REBUILD); }, e.show = function (e) { kb(Ab.SHOW, { target: e }); }, e.prototype.globalRebuild = function () { this.mount && (this.unbindListener(), this.bindListener()); }, e.prototype.globalShow = function (e) { if (this.mount) { var t = !!(e && e.detail && e.detail.target); this.showTooltip({ currentTarget: t && e.detail.target }, !0); } }, e.prototype.globalHide = function (e) { if (this.mount) { var t = !!(e && e.detail && e.detail.target); this.hideTooltip({ currentTarget: t && e.detail.target }, t); } }; }(Uh = function (e) { e.prototype.bindWindowEvents = function (e) { window.removeEventListener(Ab.HIDE, this.globalHide), window.addEventListener(Ab.HIDE, this.globalHide, !1), window.removeEventListener(Ab.REBUILD, this.globalRebuild), window.addEventListener(Ab.REBUILD, this.globalRebuild, !1), window.removeEventListener(Ab.SHOW, this.globalShow), window.addEventListener(Ab.SHOW, this.globalShow, !1), e && (window.removeEventListener("resize", this.onWindowResize), window.addEventListener("resize", this.onWindowResize, !1)); }, e.prototype.unbindWindowEvents = function () { window.removeEventListener(Ab.HIDE, this.globalHide), window.removeEventListener(Ab.REBUILD, this.globalRebuild), window.removeEventListener(Ab.SHOW, this.globalShow), window.removeEventListener("resize", this.onWindowResize); }, e.prototype.onWindowResize = function () { this.mount && this.hideTooltip(); }; }(Uh = function (e) { e.prototype.isCustomEvent = function (e) { return this.state.event || !!e.getAttribute("data-event") }, e.prototype.customBindListener = function (e) { var t = this, n = this.state, o = n.event, r = n.eventOff, i = e.getAttribute("data-event") || o, a = e.getAttribute("data-event-off") || r; i.split(" ").forEach((function (n) { e.removeEventListener(n, Eb.get(e, n)); var o = Ob.bind(t, a); Eb.set(e, n, o), e.addEventListener(n, o, !1); })), a && a.split(" ").forEach((function (n) { e.removeEventListener(n, t.hideTooltip), e.addEventListener(n, t.hideTooltip, !1); })); }, e.prototype.customUnbindListener = function (e) { var t = this.state, n = t.event, o = t.eventOff, r = n || e.getAttribute("data-event"), i = o || e.getAttribute("data-event-off"); e.removeEventListener(r, Eb.get(e, n)), i && e.removeEventListener(i, this.hideTooltip); }; }(Uh = function (e) { e.prototype.isCapture = function (e) { return e && "true" === e.getAttribute("data-iscapture") || this.props.isCapture || !1 }; }(Uh = function (e) { e.prototype.getEffect = function (e) { return e.getAttribute("data-effect") || this.props.effect || "float" }; }(Uh = function (e) { e.prototype.isBodyMode = function () { return !!this.props.bodyMode }, e.prototype.bindBodyListener = function (e) { var t = this, n = this.state, o = n.event, r = n.eventOff, i = n.possibleCustomEvents, a = n.possibleCustomEventsOff, l = Gb(), s = Bb(e, "data-event"), c = Bb(e, "data-event-off"); null != o && (s[o] = !0), null != r && (c[r] = !0), i.split(" ").forEach((function (e) { return s[e] = !0 })), a.split(" ").forEach((function (e) { return c[e] = !0 })), this.unbindBodyListener(l); var p = this.bodyModeListeners = {}; for (var u in null == o && (p.mouseover = Sb.bind(this, this.showTooltip, {}), p.mousemove = Sb.bind(this, this.updateTooltip, { respectEffect: !0 }), p.mouseout = Sb.bind(this, this.hideTooltip, {})), s) p[u] = Sb.bind(this, (function (e) { var n = e.currentTarget.getAttribute("data-event-off") || r; Ob.call(t, n, e); }), { customEvent: !0 }); for (var d in c) p[d] = Sb.bind(this, this.hideTooltip, { customEvent: !0 }); for (var f in p) l.addEventListener(f, p[f]); }, e.prototype.unbindBodyListener = function (e) { e = e || Gb(); var t = this.bodyModeListeners; for (var n in t) e.removeEventListener(n, t[n]); }; }((Kh = Qh = function (e) { function t(e) { var n; return function (e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") }(this, t), (n = Ib(this, wb(t).call(this, e))).state = { uuid: e.uuid || "t" + bb(), place: e.place || "top", desiredPlace: e.place || "top", type: "dark", effect: "float", show: !1, border: !1, customColors: {}, offset: {}, extraClass: "", html: !1, delayHide: 0, delayShow: 0, event: e.event || null, eventOff: e.eventOff || null, currentEvent: null, currentTarget: null, ariaProps: Wb(e), isEmptyTip: !1, disable: !1, possibleCustomEvents: e.possibleCustomEvents || "", possibleCustomEventsOff: e.possibleCustomEventsOff || "", originTooltip: null, isMultiline: !1 }, n.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]), n.mount = !0, n.delayShowLoop = null, n.delayHideLoop = null, n.delayReshow = null, n.intervalUpdateContent = null, n } return function (e, t) { if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function"); e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Cb(e, t); }(t, React__default.Component), hb(t, null, [{ key: "propTypes", get: function () { return { uuid: gu.string, children: gu.any, place: gu.string, type: gu.string, effect: gu.string, offset: gu.object, multiline: gu.bool, border: gu.bool, textColor: gu.string, backgroundColor: gu.string, borderColor: gu.string, arrowColor: gu.string, insecure: gu.bool, class: gu.string, className: gu.string, id: gu.string, html: gu.bool, delayHide: gu.number, delayUpdate: gu.number, delayShow: gu.number, event: gu.string, eventOff: gu.string, isCapture: gu.bool, globalEventOff: gu.string, getContent: gu.any, afterShow: gu.func, afterHide: gu.func, overridePosition: gu.func, disable: gu.bool, scrollHide: gu.bool, resizeHide: gu.bool, wrapper: gu.string, bodyMode: gu.bool, possibleCustomEvents: gu.string, possibleCustomEventsOff: gu.string, clickable: gu.bool } } }]), hb(t, [{ key: "bind", value: function (e) { var t = this; e.forEach((function (e) { t[e] = t[e].bind(t); })); } }, { key: "componentDidMount", value: function () { var e = this.props; e.insecure; var t = e.resizeHide; this.bindListener(), this.bindWindowEvents(t), this.injectStyles(); } }, { key: "componentWillUnmount", value: function () { this.mount = !1, this.clearTimer(), this.unbindListener(), this.removeScrollListener(this.state.currentTarget), this.unbindWindowEvents(); } }, { key: "injectStyles", value: function () { var e = this.tooltipRef; if (e) { for (var t, n = e.parentNode; n.parentNode;)n = n.parentNode; switch (n.constructor.name) { case "Document": case "HTMLDocument": case void 0: t = n.head; break; default: t = n; }if (!t.querySelector("style[data-react-tooltip]")) { var o = document.createElement("style"); o.textContent = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}', o.setAttribute("data-react-tooltip", "true"), t.appendChild(o); } } } }, { key: "mouseOnToolTip", value: function () { return !(!this.state.show || !this.tooltipRef) && (this.tooltipRef.matches || (this.tooltipRef.msMatchesSelector ? this.tooltipRef.matches = this.tooltipRef.msMatchesSelector : this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector), this.tooltipRef.matches(":hover")) } }, { key: "getTargetArray", value: function (e) { var t, n = []; if (e) { var o = e.replace(/\\/g, "\\\\").replace(/"/g, '\\"'); t = '[data-tip][data-for="'.concat(o, '"]'); } else t = "[data-tip]:not([data-for])"; return Hb(document.getElementsByTagName("*")).filter((function (e) { return e.shadowRoot })).forEach((function (e) { n = n.concat(Hb(e.shadowRoot.querySelectorAll(t))); })), n.concat(Hb(document.querySelectorAll(t))) } }, { key: "bindListener", value: function () { var e = this, t = this.props, n = t.id, o = t.globalEventOff, r = t.isCapture, i = this.getTargetArray(n); i.forEach((function (t) { null === t.getAttribute("currentItem") && t.setAttribute("currentItem", "false"), e.unbindBasicListener(t), e.isCustomEvent(t) && e.customUnbindListener(t); })), this.isBodyMode() ? this.bindBodyListener(i) : i.forEach((function (t) { var n = e.isCapture(t), o = e.getEffect(t); e.isCustomEvent(t) ? e.customBindListener(t) : (t.addEventListener("mouseenter", e.showTooltip, n), t.addEventListener("focus", e.showTooltip, n), "float" === o && t.addEventListener("mousemove", e.updateTooltip, n), t.addEventListener("mouseleave", e.hideTooltip, n), t.addEventListener("blur", e.hideTooltip, n)); })), o && (window.removeEventListener(o, this.hideTooltip), window.addEventListener(o, this.hideTooltip, r)), this.bindRemovalTracker(); } }, { key: "unbindListener", value: function () { var e = this, t = this.props, n = t.id, o = t.globalEventOff; this.isBodyMode() ? this.unbindBodyListener() : this.getTargetArray(n).forEach((function (t) { e.unbindBasicListener(t), e.isCustomEvent(t) && e.customUnbindListener(t); })), o && window.removeEventListener(o, this.hideTooltip), this.unbindRemovalTracker(); } }, { key: "unbindBasicListener", value: function (e) { var t = this.isCapture(e); e.removeEventListener("mouseenter", this.showTooltip, t), e.removeEventListener("mousemove", this.updateTooltip, t), e.removeEventListener("mouseleave", this.hideTooltip, t); } }, { key: "getTooltipContent", value: function () { var e, t = this.props, n = t.getContent, o = t.children; return n && (e = Array.isArray(n) ? n[0] && n[0](this.state.originTooltip) : n(this.state.originTooltip)), Vb(this.state.originTooltip, o, e, this.state.isMultiline) } }, { key: "isEmptyTip", value: function (e) { return "string" == typeof e && "" === e || null === e } }, { key: "showTooltip", value: function (e, t) { if (this.tooltipRef) { if (t && !this.getTargetArray(this.props.id).some((function (t) { return t === e.currentTarget }))) return; var n = this.props, o = n.multiline, r = n.getContent, i = e.currentTarget.getAttribute("data-tip"), a = e.currentTarget.getAttribute("data-multiline") || o || !1, l = e instanceof window.FocusEvent || t, s = !0; e.currentTarget.getAttribute("data-scroll-hide") ? s = "true" === e.currentTarget.getAttribute("data-scroll-hide") : null != this.props.scrollHide && (s = this.props.scrollHide), e && e.currentTarget && e.currentTarget.setAttribute && e.currentTarget.setAttribute("aria-describedby", this.state.uuid); var c = e.currentTarget.getAttribute("data-place") || this.props.place || "top", p = l ? "solid" : this.getEffect(e.currentTarget), u = e.currentTarget.getAttribute("data-offset") || this.props.offset || {}, d = Nb(e, e.currentTarget, this.tooltipRef, c, c, p, u); d.position && this.props.overridePosition && (d.position = this.props.overridePosition(d.position, e, e.currentTarget, this.tooltipRef, c, c, p, u)); var f = d.isNewState ? d.newState.place : c; this.clearTimer(); var b = e.currentTarget, g = this.state.show ? b.getAttribute("data-delay-update") || this.props.delayUpdate : 0, h = this, m = function () { h.setState({ originTooltip: i, isMultiline: a, desiredPlace: c, place: f, type: b.getAttribute("data-type") || h.props.type || "dark", customColors: { text: b.getAttribute("data-text-color") || h.props.textColor || null, background: b.getAttribute("data-background-color") || h.props.backgroundColor || null, border: b.getAttribute("data-border-color") || h.props.borderColor || null, arrow: b.getAttribute("data-arrow-color") || h.props.arrowColor || null }, effect: p, offset: u, html: (b.getAttribute("data-html") ? "true" === b.getAttribute("data-html") : h.props.html) || !1, delayShow: b.getAttribute("data-delay-show") || h.props.delayShow || 0, delayHide: b.getAttribute("data-delay-hide") || h.props.delayHide || 0, delayUpdate: b.getAttribute("data-delay-update") || h.props.delayUpdate || 0, border: (b.getAttribute("data-border") ? "true" === b.getAttribute("data-border") : h.props.border) || !1, extraClass: b.getAttribute("data-class") || h.props.class || h.props.className || "", disable: (b.getAttribute("data-tip-disable") ? "true" === b.getAttribute("data-tip-disable") : h.props.disable) || !1, currentTarget: b }, (function () { s && h.addScrollListener(h.state.currentTarget), h.updateTooltip(e), r && Array.isArray(r) && (h.intervalUpdateContent = setInterval((function () { if (h.mount) { var e = h.props.getContent, t = Vb(i, "", e[0](), a), n = h.isEmptyTip(t); h.setState({ isEmptyTip: n }), h.updatePosition(); } }), r[1])); })); }; g ? this.delayReshow = setTimeout(m, g) : m(); } } }, { key: "updateTooltip", value: function (e) { var t = this, n = this.state, o = n.delayShow, r = n.disable, i = this.props.afterShow, a = this.getTooltipContent(), l = e.currentTarget || e.target; if (!this.mouseOnToolTip() && !this.isEmptyTip(a) && !r) { var s = this.state.show ? 0 : parseInt(o, 10), c = function () { if (Array.isArray(a) && a.length > 0 || a) { var n = !t.state.show; t.setState({ currentEvent: e, currentTarget: l, show: !0 }, (function () { t.updatePosition(), n && i && i(e); })); } }; clearTimeout(this.delayShowLoop), s ? this.delayShowLoop = setTimeout(c, s) : c(); } } }, { key: "listenForTooltipExit", value: function () { this.state.show && this.tooltipRef && this.tooltipRef.addEventListener("mouseleave", this.hideTooltip); } }, { key: "removeListenerForTooltipExit", value: function () { this.state.show && this.tooltipRef && this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip); } }, { key: "hideTooltip", value: function (e, t) { var n = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { isScroll: !1 }, r = this.state.disable, i = o.isScroll, a = i ? 0 : this.state.delayHide, l = this.props.afterHide, s = this.getTooltipContent(); if (this.mount && !this.isEmptyTip(s) && !r) { if (t) { var c = this.getTargetArray(this.props.id), p = c.some((function (t) { return t === e.currentTarget })); if (!p || !this.state.show) return } e && e.currentTarget && e.currentTarget.removeAttribute && e.currentTarget.removeAttribute("aria-describedby"); var u = function () { var t = n.state.show; n.mouseOnToolTip() ? n.listenForTooltipExit() : (n.removeListenerForTooltipExit(), n.setState({ show: !1 }, (function () { n.removeScrollListener(n.state.currentTarget), t && l && l(e); }))); }; this.clearTimer(), a ? this.delayHideLoop = setTimeout(u, parseInt(a, 10)) : u(); } } }, { key: "hideTooltipOnScroll", value: function (e, t) { this.hideTooltip(e, t, { isScroll: !0 }); } }, { key: "addScrollListener", value: function (e) { var t = this.isCapture(e); window.addEventListener("scroll", this.hideTooltipOnScroll, t); } }, { key: "removeScrollListener", value: function (e) { var t = this.isCapture(e); window.removeEventListener("scroll", this.hideTooltipOnScroll, t); } }, { key: "updatePosition", value: function () { var e = this, t = this.state, n = t.currentEvent, o = t.currentTarget, r = t.place, i = t.desiredPlace, a = t.effect, l = t.offset, s = this.tooltipRef, c = Nb(n, o, s, r, i, a, l); if (c.position && this.props.overridePosition && (c.position = this.props.overridePosition(c.position, n, o, s, r, i, a, l)), c.isNewState) return this.setState(c.newState, (function () { e.updatePosition(); })); s.style.left = c.position.left + "px", s.style.top = c.position.top + "px"; } }, { key: "clearTimer", value: function () { clearTimeout(this.delayShowLoop), clearTimeout(this.delayHideLoop), clearTimeout(this.delayReshow), clearInterval(this.intervalUpdateContent); } }, { key: "hasCustomColors", value: function () { var e = this; return Boolean(Object.keys(this.state.customColors).find((function (t) { return "border" !== t && e.state.customColors[t] })) || this.state.border && this.state.customColors.border) } }, { key: "render", value: function () { var e = this, n = this.state, o = n.extraClass, r = n.html, i = n.ariaProps, a = n.disable, l = n.uuid, c = this.getTooltipContent(), p = this.isEmptyTip(c), u = Db(this.state.uuid, this.state.customColors, this.state.type, this.state.border), d = "__react_component_tooltip" + " ".concat(this.state.uuid) + (!this.state.show || a || p ? "" : " show") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : ""), f = this.props.wrapper; t.supportedWrappers.indexOf(f) < 0 && (f = t.defaultProps.wrapper); var b = [d, o].filter(Boolean).join(" "); if (r) { var g = "".concat(c, '\n<style aria-hidden="true">').concat(u, "</style>"); return React__default.createElement(f, vb({ className: "".concat(b), id: this.props.id || l, ref: function (t) { return e.tooltipRef = t } }, i, { "data-id": "tooltip", dangerouslySetInnerHTML: { __html: g } })) } return React__default.createElement(f, vb({ className: "".concat(b), id: this.props.id || l }, i, { ref: function (t) { return e.tooltipRef = t }, "data-id": "tooltip" }), React__default.createElement("style", { dangerouslySetInnerHTML: { __html: u }, "aria-hidden": "true" }), c) } }], [{ key: "getDerivedStateFromProps", value: function (e, t) { var n = t.ariaProps, o = Wb(e); return Object.keys(o).some((function (e) { return o[e] !== n[e] })) ? xb({}, t, { ariaProps: o }) : null } }]), t }(), mb(Qh, "defaultProps", { insecure: !0, resizeHide: !0, wrapper: "div", clickable: !1 }), mb(Qh, "supportedWrappers", ["div", "span"]), mb(Qh, "displayName", "ReactTooltip"), (em = Uh = Kh).prototype.bindRemovalTracker = function () { var e = this, t = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver; if (null != t) { var n = new t((function (t) { for (var n = 0; n < t.length; n++)for (var o = t[n], r = 0; r < o.removedNodes.length; r++)if (o.removedNodes[r] === e.state.currentTarget) return void e.hideTooltip() })); n.observe(window.document, { childList: !0, subtree: !0 }), this.removalTracker = n; } }, Uh = void (em.prototype.unbindRemovalTracker = function () { this.removalTracker && (this.removalTracker.disconnect(), this.removalTracker = null); }) || Uh)) || Uh) || Uh) || Uh) || Uh) || Uh) || Uh, am = o$1.div(tm || (tm = E(["\n    .tooltip {\n        padding: 0px !important;\n        opacity: 1 !important;\n        border-radius: 4px;\n        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);\n        &__arrow {\n            box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);\n        }\n    }\n\n    .__react_component_tooltip.place-left::after {\n        // border-left: 8px solid ", " !important;\n    }\n\n    .__react_component_tooltip.place-right::after {\n        // border-right: 8px solid ", " !important;\n    }\n\n    .__react_component_tooltip.place-top::after {\n        border-top: 6px solid ", " !important;\n    }\n\n    .__react_component_tooltip.place-bottom::after {\n        // border-bottom: 8px solid ", " !important;\n    }\n"], ["\n    .tooltip {\n        padding: 0px !important;\n        opacity: 1 !important;\n        border-radius: 4px;\n        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);\n        &__arrow {\n            box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);\n        }\n    }\n\n    .__react_component_tooltip.place-left::after {\n        // border-left: 8px solid ", " !important;\n    }\n\n    .__react_component_tooltip.place-right::after {\n        // border-right: 8px solid ", " !important;\n    }\n\n    .__react_component_tooltip.place-top::after {\n        border-top: 6px solid ", " !important;\n    }\n\n    .__react_component_tooltip.place-bottom::after {\n        // border-bottom: 8px solid ", " !important;\n    }\n"])), Ee.toolTipTriggerBackgroundColor, Ee.toolTipTriggerBackgroundColor, Ee.white, Ee.toolTipTriggerBackgroundColor), lm = o$1.div(nm || (nm = E(["\n    color: black;\n"], ["\n    color: black;\n"]))), sm = o$1.div(om || (om = E(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    padding: 2px 9px;\n\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n\n    color: ", ";\n    font-size: 12px;\n    letter-spacing: -0.3px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    padding: 2px 9px;\n\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n\n    color: ", ";\n    font-size: 12px;\n    letter-spacing: -0.3px;\n"])), Ee.toolTipTriggerBackgroundColor, Ee.toolTipBorder, Ee.toolTipColor); o$1.div(rm || (rm = E(["\n    padding: 0px 9px;\n\n    font-size: 15px;\n    letter-spacing: -0.4px;\n"], ["\n    padding: 0px 9px;\n\n    font-size: 15px;\n    letter-spacing: -0.4px;\n"]))); Object.assign((function (n) { var o = n.header, r = n.children, i = n.borderColor, a = void 0 === i ? Ee.toolTipBorder : i, l = O(n, ["header", "children", "borderColor"]); return jsx(am, { children: jsx(im, k$1({ borderColor: a, border: !0 }, l, { backgroundColor: Ee.white, arrowColor: Ee.white }, { children: jsxs(lm, { children: [o, r] }, void 0) }), void 0) }, void 0) }), { Content: lm, Header: sm }); var um = function (t) { var n = t.fill, o = void 0 === n ? Ee.black : n, r = t.width, i = void 0 === r ? "16px" : r, a = t.margin, l = void 0 === a ? "0" : a, s = t.style, c = k$1(k$1({}, s), { flexShrink: 0, margin: l }); return jsx("svg", k$1({ viewBox: "0 0 12 12", width: i, height: i, style: c }, { children: jsx("circle", { cx: "6", cy: "6", r: "3", stroke: o, fill: o }, void 0) }), void 0) };

var useRepositoryUpdates = function (repo, cbId) {
    var _a = useState({}), state = _a[0], setValue = _a[1];
    var cb = useCallback(function (key, value) {
        var _a;
        setValue((_a = {},
            _a[key] = value,
            _a));
    }, []);
    useEffect(function () {
        repo.addListener(cb, cbId);
        return function () { return repo.removeListener(cb, cbId); };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- t
    }, [repo]);
    return state;
};

var reactIs$1 = { exports: {} };

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for, c$1 = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l$1 = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ?
    Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) { if ("object" === typeof a && null !== a) { var u = a.$$typeof; switch (u) { case c$1: switch (a = a.type, a) { case l$1: case m: case e: case g: case f: case p: return a; default: switch (a = a && a.$$typeof, a) { case k: case n: case t: case r: case h: return a; default: return u } }case d: return u } } } function A(a) { return z(a) === m } reactIs_production_min.AsyncMode = l$1; reactIs_production_min.ConcurrentMode = m; reactIs_production_min.ContextConsumer = k; reactIs_production_min.ContextProvider = h; reactIs_production_min.Element = c$1; reactIs_production_min.ForwardRef = n; reactIs_production_min.Fragment = e; reactIs_production_min.Lazy = t; reactIs_production_min.Memo = r; reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g; reactIs_production_min.StrictMode = f; reactIs_production_min.Suspense = p; reactIs_production_min.isAsyncMode = function (a) { return A(a) || z(a) === l$1 }; reactIs_production_min.isConcurrentMode = A; reactIs_production_min.isContextConsumer = function (a) { return z(a) === k }; reactIs_production_min.isContextProvider = function (a) { return z(a) === h }; reactIs_production_min.isElement = function (a) { return "object" === typeof a && null !== a && a.$$typeof === c$1 }; reactIs_production_min.isForwardRef = function (a) { return z(a) === n }; reactIs_production_min.isFragment = function (a) { return z(a) === e }; reactIs_production_min.isLazy = function (a) { return z(a) === t };
reactIs_production_min.isMemo = function (a) { return z(a) === r }; reactIs_production_min.isPortal = function (a) { return z(a) === d }; reactIs_production_min.isProfiler = function (a) { return z(a) === g }; reactIs_production_min.isStrictMode = function (a) { return z(a) === f }; reactIs_production_min.isSuspense = function (a) { return z(a) === p };
reactIs_production_min.isValidElementType = function (a) { return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v) }; reactIs_production_min.typeOf = z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
    (function () {

        // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.
        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
        // (unstable) APIs that have been removed. Can we remove the symbols?

        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

        function isValidElementType(type) {
            return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }

        function typeOf(object) {
            if (typeof object === 'object' && object !== null) {
                var $$typeof = object.$$typeof;

                switch ($$typeof) {
                    case REACT_ELEMENT_TYPE:
                        var type = object.type;

                        switch (type) {
                            case REACT_ASYNC_MODE_TYPE:
                            case REACT_CONCURRENT_MODE_TYPE:
                            case REACT_FRAGMENT_TYPE:
                            case REACT_PROFILER_TYPE:
                            case REACT_STRICT_MODE_TYPE:
                            case REACT_SUSPENSE_TYPE:
                                return type;

                            default:
                                var $$typeofType = type && type.$$typeof;

                                switch ($$typeofType) {
                                    case REACT_CONTEXT_TYPE:
                                    case REACT_FORWARD_REF_TYPE:
                                    case REACT_LAZY_TYPE:
                                    case REACT_MEMO_TYPE:
                                    case REACT_PROVIDER_TYPE:
                                        return $$typeofType;

                                    default:
                                        return $$typeof;
                                }

                        }

                    case REACT_PORTAL_TYPE:
                        return $$typeof;
                }
            }

            return undefined;
        } // AsyncMode is deprecated along with isAsyncMode

        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

        function isAsyncMode(object) {
            {
                if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                    hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

                    console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
                }
            }

            return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
            return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
            return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
            return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
            return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
            return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
            return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
            return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
            return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
            return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
            return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
            return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
            return typeOf(object) === REACT_SUSPENSE_TYPE;
        }

        reactIs_development.AsyncMode = AsyncMode;
        reactIs_development.ConcurrentMode = ConcurrentMode;
        reactIs_development.ContextConsumer = ContextConsumer;
        reactIs_development.ContextProvider = ContextProvider;
        reactIs_development.Element = Element;
        reactIs_development.ForwardRef = ForwardRef;
        reactIs_development.Fragment = Fragment;
        reactIs_development.Lazy = Lazy;
        reactIs_development.Memo = Memo;
        reactIs_development.Portal = Portal;
        reactIs_development.Profiler = Profiler;
        reactIs_development.StrictMode = StrictMode;
        reactIs_development.Suspense = Suspense;
        reactIs_development.isAsyncMode = isAsyncMode;
        reactIs_development.isConcurrentMode = isConcurrentMode;
        reactIs_development.isContextConsumer = isContextConsumer;
        reactIs_development.isContextProvider = isContextProvider;
        reactIs_development.isElement = isElement;
        reactIs_development.isForwardRef = isForwardRef;
        reactIs_development.isFragment = isFragment;
        reactIs_development.isLazy = isLazy;
        reactIs_development.isMemo = isMemo;
        reactIs_development.isPortal = isPortal;
        reactIs_development.isProfiler = isProfiler;
        reactIs_development.isStrictMode = isStrictMode;
        reactIs_development.isSuspense = isSuspense;
        reactIs_development.isValidElementType = isValidElementType;
        reactIs_development.typeOf = typeOf;
    })();
}

if (process.env.NODE_ENV === 'production') {
    reactIs$1.exports = reactIs_production_min;
} else {
    reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}

var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}

// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

// @generated from regex-gen.ts
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = __assign$1(__assign$1(__assign$1({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign$1(__assign$1({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = __assign$1(__assign$1(__assign$1({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign$1(__assign$1({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = __assign$1(__assign$1({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = __assign$1(__assign$1({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = __assign$1(__assign$1({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = __assign$1(__assign$1({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = __assign$1(__assign$1({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

var _a$2;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a$2 = re.exec('a')) === null || _a$2 === void 0 ? void 0 : _a$2[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
    function startsWith(s, search, position) {
        return s.startsWith(search, position);
    }
    : // For IE11
    function startsWith(s, search, position) {
        return s.slice(position, position + search.length) === search;
    };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
    function fromCodePoint() {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        var elements = '';
        var length = codePoints.length;
        var i = 0;
        var code;
        while (length > i) {
            code = codePoints[i++];
            if (code > 0x10ffff)
                throw RangeError(code + ' is not a valid code point');
            elements +=
                code < 0x10000
                    ? String.fromCharCode(code)
                    : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
        }
        return elements;
    };
var fromEntries =
    // native
    hasNativeFromEntries
        ? Object.fromEntries
        : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
    function codePointAt(s, index) {
        return s.codePointAt(index);
    }
    : // IE 11
    function codePointAt(s, index) {
        var size = s.length;
        if (index < 0 || index >= size) {
            return undefined;
        }
        var first = s.charCodeAt(index);
        var second;
        return first < 0xd800 ||
            first > 0xdbff ||
            index + 1 === size ||
            (second = s.charCodeAt(index + 1)) < 0xdc00 ||
            second > 0xdfff
            ? first
            : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
    };
var trimStart = hasTrimStart
    ? // Native
    function trimStart(s) {
        return s.trimStart();
    }
    : // Ponyfill
    function trimStart(s) {
        return s.replace(SPACE_SEPARATOR_START_REGEX, '');
    };
var trimEnd = hasTrimEnd
    ? // Native
    function trimEnd(s) {
        return s.trimEnd();
    }
    : // Ponyfill
    function trimEnd(s) {
        return s.replace(SPACE_SEPARATOR_END_REGEX, '');
    };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: skeleton,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(skeleton)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign$1({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+'));
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = __assign$1({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    __extends$3(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));
var InvalidValueError = /** @class */ (function (_super) {
    __extends$3(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));
var InvalidValueTypeError = /** @class */ (function (_super) {
    __extends$3(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));
var MissingValueError = /** @class */ (function (_super) {
    __extends$3(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));

var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue,
    // For debugging
    originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                    (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
// -- MessageFormat --------------------------------------------------------
function mergeConfig$3(c1, c2) {
    if (!c2) {
        return c1;
    }
    return __assign$1(__assign$1(__assign$1({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = __assign$1(__assign$1({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig$3(defaultConfig[k], configs[k]);
        return all;
    }, __assign$1({}, defaultConfig));
}
function createFastMemoizeCache$1(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) {
        cache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
    }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray$2([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache$1(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray$2([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache$1(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray$2([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache$1(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            return ({
                locale: Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    __extends$3(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));
var UnsupportedFormatterError = /** @class */ (function (_super) {
    __extends$3(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));
var InvalidConfigError = /** @class */ (function (_super) {
    __extends$3(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));
var MissingDataError = /** @class */ (function (_super) {
    __extends$3(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));
var IntlFormatError = /** @class */ (function (_super) {
    __extends$3(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError));
var MessageFormatError = /** @class */ (function (_super) {
    __extends$3(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));
var MissingTranslationError = /** @class */ (function (_super) {
    __extends$3(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));

function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (process.env.NODE_ENV !== 'production') {
        console.error(error);
    }
};
var DEFAULT_INTL_CONFIG$1 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = memoize(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray$2([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: strategies.variadic,
    });
    var getNumberFormat = memoize(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray$2([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: strategies.variadic,
    });
    var getPluralRules = memoize(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray$2([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: strategies.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: memoize(function (message, locales, overrideFormats, opts) {
            return new IntlMessageFormat(message, locales, overrideFormats, __assign$1({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                }
            }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: strategies.variadic,
        }),
        getRelativeTimeFormat: memoize(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, __spreadArray$2([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: memoize(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, __spreadArray$2([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: strategies.variadic,
        }),
        getDisplayNames: memoize(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, __spreadArray$2([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: strategies.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new UnsupportedFormatterError("No ".concat(type, " format named: ").concat(name)));
}

function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = __assign$1({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys(__assign$1(__assign$1({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = __assign$1(__assign$1({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = IntlMessageFormat.formats;
    return __assign$1(__assign$1(__assign$1({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
function formatMessage$1(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    invariant(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message =
        // In case messages is Object.create(null)
        // e.g import('foo.json') from webpack)
        // See https://github.com/formatjs/formatjs/issues/1914
        messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === TYPE.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = __assign$1(__assign$1({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new MissingTranslationError(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new MessageFormatError("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, __assign$1({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new MessageFormatError("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new MessageFormatError("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
}

var DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
];
function getFormatter$2(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = __assign$1(__assign$1({}, (timeZone && { timeZone: timeZone })), (format && getNamedFormat(formats, type, format, onError)));
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = __assign$1(__assign$1({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'date', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'time', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

var DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new FormatError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", ErrorCode.MISSING_INTL_API));
    }
    var filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

var LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new FormatError("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", ErrorCode.MISSING_INTL_API));
    }
    var filteredOptions = filterProps(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
                return part.type === 'literal'
                    ? part
                    : __assign$1(__assign$1({}, part), { value: richValues_1[part.value] || part.value });
            });
    }
    catch (e) {
        onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

var PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API));
    }
    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new IntlFormatError('Error formatting plural.', locale, e));
    }
    return 'other';
}

var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function getFormatter$1(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && getNamedFormat(formats, 'relative', format, onError)) || {};
    var filteredOptions = filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new FormatError("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", ErrorCode.MISSING_INTL_API));
    }
    try {
        return getFormatter$1(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

var NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        getNamedFormat(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new IntlError(IntlErrorCode.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        console.warn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl$1(config, cache) {
    var formatters = createFormatters(cache);
    var resolvedConfig = __assign$1(__assign$1({}, DEFAULT_INTL_CONFIG$1), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new InvalidConfigError("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new MissingDataError("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new MissingDataError("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return __assign$1(__assign$1({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: formatMessage$1.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

function invariantIntlContext(intl) {
    invariant(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = __assign$1(__assign$1({}, DEFAULT_INTL_CONFIG$1), { textComponent: React.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(React.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}

// TODO: We should provide initial value here
var IntlContext = React.createContext(null);
IntlContext.Consumer; var IntlProvider$2 = IntlContext.Provider;
var Provider = IntlProvider$2;
var Context = IntlContext;

function useIntl() {
    var intl = React.useContext(Context);
    invariantIntlContext(intl);
    return intl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = isFormatXMLElementFn(v)
            ? assignUniqueKeysToParts(v)
            : v;
        return acc;
    }, {});
}
var formatMessage = function (config, formatters, descriptor, rawValues) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
    }
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = formatMessage$1.apply(void 0, __spreadArray$2([config,
        formatters,
        descriptor,
        values], rest, false));
    if (Array.isArray(chunks)) {
        return React.Children.toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = __rest(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = createIntl$1(__assign$1(__assign$1(__assign$1({}, DEFAULT_INTL_CONFIG), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    return __assign$1(__assign$1({}, coreIntl), {
        formatMessage: formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements,
        }, coreIntl.formatters)
    });
};
var IntlProvider = /** @class */ (function (_super) {
    __extends$3(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = createIntlCache();
        _this.state = {
            cache: _this.cache,
            intl: createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!shallowEqual(prevConfig, config)) {
            return {
                intl: createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        invariantIntlContext(this.state.intl);
        return React.createElement(Provider, { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = DEFAULT_INTL_CONFIG;
    return IntlProvider;
}(React.PureComponent));
var IntlProvider$1 = IntlProvider;

var flat = flatten;
flatten.flatten = flatten;
flatten.unflatten = unflatten;

function isBuffer$1(obj) {
    return obj &&
        obj.constructor &&
        (typeof obj.constructor.isBuffer === 'function') &&
        obj.constructor.isBuffer(obj)
}

function keyIdentity(key) {
    return key
}

function flatten(target, opts) {
    opts = opts || {};

    const delimiter = opts.delimiter || '.';
    const maxDepth = opts.maxDepth;
    const transformKey = opts.transformKey || keyIdentity;
    const output = {};

    function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function (key) {
            const value = object[key];
            const isarray = opts.safe && Array.isArray(value);
            const type = Object.prototype.toString.call(value);
            const isbuffer = isBuffer$1(value);
            const isobject = (
                type === '[object Object]' ||
                type === '[object Array]'
            );

            const newKey = prev
                ? prev + delimiter + transformKey(key)
                : transformKey(key);

            if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
                (!opts.maxDepth || currentDepth < maxDepth)) {
                return step(value, newKey, currentDepth + 1)
            }

            output[newKey] = value;
        });
    }

    step(target);

    return output
}

function unflatten(target, opts) {
    opts = opts || {};

    const delimiter = opts.delimiter || '.';
    const overwrite = opts.overwrite || false;
    const transformKey = opts.transformKey || keyIdentity;
    const result = {};

    const isbuffer = isBuffer$1(target);
    if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
        return target
    }

    // safely ensure that the key is
    // an integer.
    function getkey(key) {
        const parsedKey = Number(key);

        return (
            isNaN(parsedKey) ||
            key.indexOf('.') !== -1 ||
            opts.object
        ) ? key
            : parsedKey
    }

    function addKeys(keyPrefix, recipient, target) {
        return Object.keys(target).reduce(function (result, key) {
            result[keyPrefix + delimiter + key] = target[key];

            return result
        }, recipient)
    }

    function isEmpty(val) {
        const type = Object.prototype.toString.call(val);
        const isArray = type === '[object Array]';
        const isObject = type === '[object Object]';

        if (!val) {
            return true
        } else if (isArray) {
            return !val.length
        } else if (isObject) {
            return !Object.keys(val).length
        }
    }

    target = Object.keys(target).reduce(function (result, key) {
        const type = Object.prototype.toString.call(target[key]);
        const isObject = (type === '[object Object]' || type === '[object Array]');
        if (!isObject || isEmpty(target[key])) {
            result[key] = target[key];
            return result
        } else {
            return addKeys(
                key,
                result,
                flatten(target[key], opts)
            )
        }
    }, {});

    Object.keys(target).forEach(function (key) {
        const split = key.split(delimiter).map(transformKey);
        let key1 = getkey(split.shift());
        let key2 = getkey(split[0]);
        let recipient = result;

        while (key2 !== undefined) {
            if (key1 === '__proto__') {
                return
            }

            const type = Object.prototype.toString.call(recipient[key1]);
            const isobject = (
                type === '[object Object]' ||
                type === '[object Array]'
            );

            // do not write over falsey, non-undefined values if overwrite is false
            if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
                return
            }

            if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
                recipient[key1] = (
                    typeof key2 === 'number' &&
                        !opts.object ? [] : {}
                );
            }

            recipient = recipient[key1];
            if (split.length > 0) {
                key1 = getkey(split.shift());
                key2 = getkey(split[0]);
            }
        }

        // unflatten again for 'messy objects'
        recipient[key1] = unflatten(target[key], opts);
    });

    return result
}

var components$2 = {
    CircuitComputationSidebar: {
        McCabeThiele: {
            title: "McCabe Thiele",
            "CurrentDataset.title": "Current Dataset",
            CompareWithOtherIsotherms: {
                title: "Compare with Other Isotherm(s)",
                titleOptional: "(optional)",
                "CircuitSelect.label": "Circuit",
                "CircuitSelect.placeholder": "Select...",
                "CircuitSelect.noCircuits": "No Circuits...",
                "DatasetRadioGroup.label": "Dataset",
                "DatasetRadioGroup.noDatasets": "No datasets..."
            },
            uncomputedDataset: "A computation must be performed before viewing the McCabe Thiele diagram.",
            noIsothermSaved: "No Isotherms have been saved for this dataset",
            generateDiagramButton: "Generate Diagram",
            updateDiagramButton: "Update Diagram"
        }
    },
    McCabeThieleFooter: {
        copyToClipboard: "Copy to clipboard"
    },
    McCabeThieleDiagram: {
        "Header.EXTRACT": "Extraction Section",
        "Header.STRIP": "Stripping Section",
        "Graph.xAxis.EXTRACT": "Cu in aqueous (g/L)",
        "Graph.xAxis.STRIP": "Cu in organic (g/L)",
        "Graph.yAxis.EXTRACT": "Cu in organic (g/L)",
        "Graph.yAxis.STRIP": "Cu in aqueous (g/L)",
        "Legend.IsothermCircuitWithDatasetName": "{circuitName} - {datasetName}",
        "Legend.CurrentDataset": "Current Dataset"
    },
    ComputationInstructions: {
        "McCabeThiele.selectCascades": "Select options in the left panel to determine which cascades should be displayed.",
        "McCabeThiele.blankDatasetUncomputed": "A computation must be performed in the Mimic Diagram tab before viewing McCabe-Thiele diagrams."
    }
};
var feedback$2 = {
    error: {
        computeMcCabeThieleFailed: "Could not generate McCabe Thiele diagram...",
        copyToClipboard: "An error occurred during the copying of the McCabe Thiele diagram"
    },
    success: {
        computeMcCabeThiele: "McCabe Thiele diagram successfully generated.",
        copyToClipboard: "McCabe Thiele diagram was copied to your clipboard."
    }
};
var common$2 = {
    none: "None"
};
var models$2 = {
    circuit: {
        notFound: "Circuit was not found"
    },
    dataset: {
        notProvided: "The dataset was not provided to McCabe Thiele."
    }
};
var enTranslationMessages = {
    components: components$2,
    feedback: feedback$2,
    common: common$2,
    models: models$2
};

var components$1 = {
    CircuitComputationSidebar: {
        McCabeThiele: {
            title: "McCabe Thiele",
            noIsothermSaved: "No se han guardado isotermas para estos datos",
            uncomputedDataset: "Se debe cálcular antes de ver el diagrama McCabe Thiele.",
            updateDiagramButton: "Actualizar Diagrama",
            CurrentDataset: {
                title: "Datos Actuales"
            },
            generateDiagramButton: "Generar diagrama",
            CompareWithOtherIsotherms: {
                title: "Comparar con otras isotermas",
                titleOptional: "(Opcional)",
                CircuitSelect: {
                    label: "Circuito",
                    noCircuits: "Sin circuitos...",
                    placeholder: "Seleccione..."
                },
                DatasetRadioGroup: {
                    label: "Datos",
                    noDatasets: "Sin datos"
                }
            }
        }
    },
    McCabeThieleFooter: {
        copyToClipboard: "Copiar al portapapeles"
    },
    McCabeThieleDiagram: {
        Header: {
            STRIP: "Sección de reextracción",
            EXTRACT: "Sección de extracción"
        },
        Graph: {
            xAxis: {
                STRIP: "Cu en orgánico (gpl)",
                EXTRACT: "Cu en acuoso (gpl)"
            },
            yAxis: {
                STRIP: "Cu en acuoso (gpl)",
                EXTRACT: "Cu en orgánico (gpl)"
            }
        },
        Legend: {
            CurrentDataset: "Conjunto de datos actual",
            IsothermCircuitWithDatasetName: "{circuitName} - {datasetName}"
        }
    },
    ComputationInstructions: {
        McCabeThiele: {
            selectCascades: "Seleccione las opciones en el panel izquierdo para determinar qué cascadas deben mostrarse.",
            blankDatasetUncomputed: "Se debe realizar un cálculo en la pestaña Diagrama Simulado antes de ver los diagramas de McCabe-Thiele."
        }
    }
};
var feedback$1 = {
    error: {
        computeMcCabeThieleFailed: "No se pudo generar el diagrama de McCabe Thiele...",
        copyToClipboard: "An error occurred during the copying of the McCabe Thiele diagram"
    },
    success: {
        computeMcCabeThiele: "Diagrama McCabe Thiele generado con éxito ...",
        copyToClipboard: "McCabe Thiele diagram was copied to your clipboard."
    }
};
var common$1 = {
    none: "Ninguna"
};
var models$1 = {
    circuit: {
        notFound: "Circuit was not found"
    },
    dataset: {
        notProvided: "The dataset was not provided to McCabe Thiele."
    }
};
var esTranslationMessages = {
    components: components$1,
    feedback: feedback$1,
    common: common$1,
    models: models$1
};

var components = {
    CircuitComputationSidebar: {
        McCabeThiele: {
            title: "McCabe Thiele",
            noIsothermSaved: "没有为该数据保存等温线。",
            uncomputedDataset: "在查看McCabe Thiele图之前，必须执行计算。",
            updateDiagramButton: "更新图",
            CurrentDataset: {
                title: "当前数据"
            },
            generateDiagramButton: "生成图",
            CompareWithOtherIsotherms: {
                title: "与其它等温线比较",
                titleOptional: "(可选的)",
                CircuitSelect: {
                    label: "流程",
                    noCircuits: "没有流程",
                    placeholder: "选择…"
                },
                DatasetRadioGroup: {
                    label: "数据",
                    noDatasets: "没有数据"
                }
            }
        }
    },
    McCabeThieleFooter: {
        copyToClipboard: "复制到剪贴板"
    },
    McCabeThieleDiagram: {
        Header: {
            STRIP: "反萃部分",
            EXTRACT: "萃取部分"
        },
        Graph: {
            xAxis: {
                STRIP: "有机相铜含量（g / L）",
                EXTRACT: "水溶液中的铜（g / L）"
            },
            yAxis: {
                STRIP: "水溶液中的铜（g / L）",
                EXTRACT: "有机铜含量（g / L）"
            }
        },
        Legend: {
            CurrentDataset: "当前数据",
            IsothermCircuitWithDatasetName: "{circuitName}-{datasetName}"
        }
    },
    ComputationInstructions: {
        McCabeThiele: {
            selectCascades: "在左面板中选择选项，以确定应显示哪些级联。",
            blankDatasetUncomputed: "在查看McCabe-Thiele图之前，必须在“模拟图”选项卡中执行计算。"
        }
    }
};
var feedback = {
    error: {
        computeMcCabeThieleFailed: "无法生成McCabe Thiele图...",
        copyToClipboard: "An error occurred during the copying of the McCabe Thiele diagram"
    },
    success: {
        computeMcCabeThiele: "McCabe Thiele图成功生成...",
        copyToClipboard: "McCabe Thiele diagram was copied to your clipboard."
    }
};
var common = {
    none: "没有"
};
var models = {
    circuit: {
        notFound: "Circuit was not found"
    },
    dataset: {
        notProvided: "The dataset was not provided to McCabe Thiele."
    }
};
var zhTranslationMessages = {
    components: components,
    feedback: feedback,
    common: common,
    models: models
};

/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
// import { addLocaleData } from 'react-intl';
var _a$1;
var AppLocales;
(function (AppLocales) {
    AppLocales["EN"] = "EN";
    AppLocales["ES"] = "ES";
    AppLocales["ZH"] = "ZH";
})(AppLocales || (AppLocales = {}));
var DEFAULT_LOCALE = AppLocales.EN;
var formatTranslationMessages = function (locale, messages) {
    var _a;
    var defaultFormattedMessages = locale !== DEFAULT_LOCALE
        ? // ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
        formatTranslationMessages(DEFAULT_LOCALE, flat(enTranslationMessages))
        : {};
    var formattedMessages = {};
    var messageKeys = Object.keys(messages);
    for (var _i = 0, messageKeys_1 = messageKeys; _i < messageKeys_1.length; _i++) {
        var messageKey = messageKeys_1[_i];
        if (locale === DEFAULT_LOCALE) {
            formattedMessages[messageKey] = messages[messageKey];
        }
        else {
            formattedMessages[messageKey] =
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- it is possible.
                (_a = messages[messageKey]) !== null && _a !== void 0 ? _a : defaultFormattedMessages[messageKey];
        }
    }
    return formattedMessages;
};
var translationMessages = (_a$1 = {},
    _a$1[AppLocales.EN] = formatTranslationMessages(AppLocales.EN, flat(enTranslationMessages)),
    _a$1[AppLocales.ES] = formatTranslationMessages(AppLocales.ES, flat(esTranslationMessages)),
    _a$1[AppLocales.ZH] = formatTranslationMessages(AppLocales.ZH, flat(zhTranslationMessages)),
    _a$1);

var LanguageProvider = function (_a) {
    var locale = _a.locale, children = _a.children;
    return (React__default.createElement(IntlProvider$1, { locale: locale.toLowerCase(), messages: translationMessages[locale] }, children));
};

/**
 * Renders an svg polygon
 */
var VictoryPolygon = function (props) {
    // scale is provided by VictoryChartProps
    var dataPoints = props.dataPoints, scale = props.scale, styles = props.styles;
    var getPoints = function (data, dpScale) {
        return data.reduce(function (pointStr, _a) {
            var x = _a.x, y = _a.y;
            return "".concat(pointStr, " ").concat(dpScale.x(x), ",").concat(dpScale.y(y));
        }, '');
    };
    var points = getPoints(dataPoints, scale);
    // @ts-expect-error -- styles is unknown :(
    return React__default.createElement("polygon", { points: points, style: styles });
};

var IsothermType;
(function (IsothermType) {
    IsothermType["EXTRACT"] = "EXTRACT";
    IsothermType["STRIP"] = "STRIP";
})(IsothermType || (IsothermType = {}));
var IsothermPolynomialType;
(function (IsothermPolynomialType) {
    IsothermPolynomialType["MINCHEM"] = "MINCHEM";
    IsothermPolynomialType["RATIONAL"] = "RATIONAL";
    IsothermPolynomialType["SIMPLE"] = "SIMPLE";
    IsothermPolynomialType["ARITHMETIC_INTERPOLATION"] = "ARITHMETIC_INTERPOLATION";
    IsothermPolynomialType["LOGARITHMIC_INTERPOLATION"] = "LOGARITHMIC_INTERPOLATION";
})(IsothermPolynomialType || (IsothermPolynomialType = {}));

var GRAPH_WIDTH = 720;
var GRAPH_HEIGHT = 720;
var GRAPH_HEIGHT_SMALL = 500;
var GRAPH_WIDTH_SMALL = 512;

var colors = {
    white: '#FFFFFF',
    greyF2: '#F2F2F2',
    greyE5: '#E5E5E5',
    greyE6: '#E6E6E6',
    greyDD: '#DDDDDD',
    greyBB: '#BBBBBB',
    greyAF: '#AFAFAF',
    grey7B: '#7B7C7E',
    grey75: '#757575',
    grey27: '#272727',
    orangeF6A: '#F6A906',
    orangeFEF: '#FEF7E7',
    orangeEB6: '#EB6B4A',
    purple99: '#99699B',
    purple94: '#9464A3',
    purpleF4: '#F4EFF6',
    turquoise2D: '#2DA9AC',
    turquoise25: '#25ADAD',
    turquoiseE9: '#E9F6F6',
    green007: '#007F33',
    redE20: '#E20031',
};
var isothermColors = {
    EXTRACT: {
        primary: ['#9464A3', '#25ADAD', '#E3435F', '#82CDED', '#F9C100'],
        accent: ['#B492BE', '#51DADA', '#EB7B8E', '#A7DBF2', '#FED548'],
    },
    STRIP: {
        primary: ['#FFAA4F', '#3F51B5', '#FF99D2', '#B1AAA3', '#95BD0C'],
        accent: ['#FEC383', '#7482CE', '#FEB7DF', '#C8C3BE', '#C7F233'],
    },
};

var GraphStyles = {
    mainGraph: {
        parent: {
            overflow: 'visible',
            boxSizing: 'border-box',
            fontFamily: 'Helvetica',
        },
    },
    mainGraphPadding: {
        top: 34,
        bottom: 100,
        left: 115,
        right: 0,
    },
    baseIsothermLine: function (color, index) {
        return ({
            data: {
                stroke: color.accent[index],
                strokeWidth: '4px',
            },
            labels: {
                fill: color.primary[index],
            },
        });
    },
    scatterSize: 7,
    scatterColor: function (color, index) {
        return ({
            data: {
                fill: color.primary[index],
                stroke: Ee.graphAxisGridStrokeColor,
                strokeWidth: 2,
            },
            labels: {
                fill: color.primary[index],
            },
        });
    },
    polygonStyles: function (color) {
        return ({
            stroke: color,
            strokeWidth: 2,
            fill: 'none',
        });
    },
    axisY: {
        axis: {
            stroke: Ee.graphAxisStrokeColor,
            strokeWidth: 1,
        },
        grid: {
            stroke: Ee.graphAxisStrokeColor,
            strokeWidth: 1,
        },
        ticks: {
            size: 55,
            strokeWidth: 1,
            stroke: Ee.graphAxisStrokeColor,
            padding: 30,
        },
        axisLabel: {
            fill: Ee.defaultSubtleColor,
            fontFamily: 'inherit',
            fontSize: 12,
            padding: 100,
        },
        tickLabels: {
            fill: Ee.defaultSubtleColor,
            fontFamily: 'inherit',
            fontSize: 12,
        },
        domainPadding: [0, 5], // if not, the global maxima  of the line will be clipped
    },
    axisYTickLabelTranslate: {
        dy: -20,
        dx: 40, // axisY.ticks.size - dx = spacing between axis and tick number.
    },
    axisX: {
        axis: {
            stroke: Ee.graphAxisStrokeColor,
            strokeWidth: 1,
        },
        grid: {
            stroke: Ee.graphAxisStrokeColor,
            strokeWidth: 1,
        },
        tickLabels: {
            fill: Ee.defaultSubtleColor,
            fontSize: 12,
            fontFamily: 'inherit',
        },
        axisLabel: {
            fill: Ee.defaultSubtleColor,
            fontSize: 12,
            fontFamily: 'inherit',
            padding: 74,
        },
        domainPadding: [0, 10],
    },
};

var Wrapper$2 = o$1.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n\n    padding: ", ";\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n\n    padding: ", ";\n"])), function (_a) {
    var isBothTypes = _a.isBothTypes;
    return (isBothTypes ? '80px 68px 48px 40px' : '31px 64px 27px 100px');
});
var CascadeWrapper = o$1.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: ", ";\n\n    height: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: ", ";\n\n    height: 100%;\n"])), function (_a) {
    var isBothTypes = _a.isBothTypes;
    return (isBothTypes ? 'center' : 'flex-start');
});
var ChartWrapper = o$1.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"])));
var GraphTitle = o$1.h1(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 24px;\n    color: ", ";\n\n    margin-left: ", "px;\n    margin-bottom: 0px;\n"], ["\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 24px;\n    color: ", ";\n\n    margin-left: ", "px;\n    margin-bottom: 0px;\n"])), Ee.black, GraphStyles.mainGraphPadding.left - GraphStyles.axisY.ticks.size);
var LegendWrapper = o$1.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    flex-grow: 0;\n    width: 100%;\n\n    margin-left: 35px;\n    margin-top: ", "px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    flex-grow: 0;\n    width: 100%;\n\n    margin-left: 35px;\n    margin-top: ", "px;\n"])), 32 + GraphStyles.mainGraphPadding.top - 10);
var LegendItem = o$1.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n\n    color: ", ";\n    font-size: 12px;\n\n    margin-bottom: 12px;\n\n    & + & {\n        margin-left: 34px;\n    }\n"], ["\n    display: flex;\n    flex-direction: row;\n\n    color: ", ";\n    font-size: 12px;\n\n    margin-bottom: 12px;\n\n    & + & {\n        margin-left: 34px;\n    }\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var LegendItemTextWrapper = o$1.div(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    color: currentColor;\n\n    > span {\n        max-width: 151px; // 175 px max width of legend wrapper - 8px margin of dot - 16px width of dot\n\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    color: currentColor;\n\n    > span {\n        max-width: 151px; // 175 px max width of legend wrapper - 8px margin of dot - 16px width of dot\n\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n"])));
var GraphWrapper = o$1.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n"], ["\n    width: ", "px;\n    height: ", "px;\n"])), function (_a) {
    var graphWidth = _a.graphWidth;
    return graphWidth;
}, function (_a) {
    var graphHeight = _a.graphHeight;
    return graphHeight;
});
var CascadeDescriptionSpan = o$1.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    color: currentColor;\n"], ["\n    display: flex;\n    align-items: center;\n    color: currentColor;\n"])));
var LoadingWrapper = o$1.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n"])));
var templateObject_1$5, templateObject_2$4, templateObject_3$2, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$2, templateObject_9, templateObject_10;

var CascadeArrow = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? colors.purple94 : _b, _c = _a.margin, margin = _c === void 0 ? 'auto' : _c, _d = _a.width, width = _d === void 0 ? 21 : _d, _e = _a.height, height = _e === void 0 ? 10 : _e, _f = _a.strokeWidth, strokeWidth = _f === void 0 ? 1 : _f, direction = _a.direction;
    return (React__default.createElement("svg", {
        viewBox: "0 0 21 10", width: "".concat(width, "px"), height: "".concat(height, "px"), style: {
            margin: margin,
        }
    },
        React__default.createElement("g", { stroke: "none", strokeWidth: strokeWidth, fill: "none", fillRule: "evenodd", transform: "rotate(".concat(direction === 'RIGHT' ? 180 : 0, " ").concat(width / 2, " ").concat(height / 2, ")") },
            React__default.createElement("g", { transform: "translate(-626.000000, -402.000000)", fill: fill, fillRule: "nonzero" },
                React__default.createElement("g", { transform: "translate(550.000000, 218.000000)" },
                    React__default.createElement("g", { transform: "translate(16.000000, 174.000000)" },
                        React__default.createElement("path", { d: "M69,14.75 L80.9260044,14.75 L80.9260044,15.75 L69,15.75 L69,19.75 L60,15.25 L69,10.75 L69,14.75 Z" })))))));
};

var CascadeDescriptionWrapper = o$1.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    ", "\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && "max-width: ".concat(maxWidth, "px;");
});
var templateObject_1$4;

var CascadeDescription = function (_a) {
    var cascade = _a.cascade, _b = _a.asString, asString = _b === void 0 ? false : _b, _c = _a.maxWidth, maxWidth = _c === void 0 ? null : _c;
    var cascadeDescription = cascade.getDescription();
    if (asString) {
        var description = cascadeDescription
            .map(function (partialCascade) {
                return partialCascade.map(function (stage) { return stage.getCode(); }).join('->');
            })
            .join(',');
        // eslint-disable-next-line react/jsx-no-useless-fragment -- necessary as a return type
        return React__default.createElement(React__default.Fragment, null, description);
    }
    return (React__default.createElement(React__default.Fragment, null, cascadeDescription.map(function (partialCascade, idx) {
        return (React__default.createElement(CascadeDescriptionWrapper, { key: partialCascade[0].getCode(), maxWidth: maxWidth, color: "currentColor" },
            partialCascade[0].getCode(),
            partialCascade.length > 1 && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(CascadeArrow, { fill: "currentColor", margin: "0 4 0 4", direction: "RIGHT" }),
                partialCascade[1].getCode())),
            idx !== cascadeDescription.length - 1 && ','));
    })));
};

var McCabeThieleDiagram = function (_a) {
    var diagramRef = _a.diagramRef, circuitId = _a.circuitId, datasetId = _a.datasetId, isLoading = _a.isLoading, mcCabeThiele = _a.mcCabeThiele;
    var intl = useIntl();
    /**
     * Get the name of the isotherm for the legend
     */
    var getCascadeOriginName = function (cascade) {
        if (cascade.datasetId === datasetId) {
            // Cascade is in our current dataset, we can omit the dataset name.
            return intl.formatMessage({
                id: 'components.McCabeThieleDiagram.Legend.CurrentDataset',
            });
        }
        if (cascade.circuitId === circuitId) {
            // Cascade is not in our current dataset, (from compare circuit, with same circuit selected.)
            return cascade.datasetName;
        }
        // Cascade is from compare circuit.
        return intl.formatMessage({
            id: 'components.McCabeThieleDiagram.Legend.IsothermCircuitWithDatasetName',
        }, {
            circuitName: cascade.circuitName,
            datasetName: cascade.datasetName,
        });
    };
    var renderCascadePolygon = function (polygon, type, index) {
        var color = isothermColors[type].primary[index]; // will there ever be a type that doesn't match ISOTHERM_BASE_CONSTANT here ?
        return (React__default.createElement(VictoryPolygon, { key: "".concat(type, "-").concat(index), dataPoints: polygon.dataPoints, styles: GraphStyles.polygonStyles(color) }));
    };
    var renderIsothermLine = function (isotherm, index) { return (React__default.createElement(VictoryLine, { key: "line", style: GraphStyles.baseIsothermLine(isothermColors[isotherm.isothermType], index), interpolation: "natural", data: isotherm.computedDataPoints })); };
    var renderIsothermScatter = function (isotherm, index) { return (React__default.createElement(VictoryScatter, { key: "scatterDots", name: "scatterDots", size: GraphStyles.scatterSize, style: GraphStyles.scatterColor(isothermColors[isotherm.isothermType], index), data: isotherm.referenceDataPoints })); };
    var renderCascadeLegends = function (cascades) {
        var sortedCascades = cascades.sort(function (cascadeA, cascadeB) {
            return cascadeA.getCascadeFirstStageLocation() - cascadeB.getCascadeFirstStageLocation();
        });
        return (React__default.createElement(LegendWrapper, null, sortedCascades.map(function (cascade, index) {
            return (React__default.createElement(LegendItem, { key: cascade.getCascadeLegendKey(), color: isothermColors[cascade.type].primary[index] },
                React__default.createElement(um, { fill: "currentColor", margin: "0 8px 0 0" }),
                React__default.createElement(LegendItemTextWrapper, null,
                    React__default.createElement("span", null, getCascadeOriginName(cascade)),
                    React__default.createElement("span", null,
                        React__default.createElement(CascadeDescriptionSpan, null,
                            React__default.createElement(CascadeDescription, { cascade: cascade.getMimicCascade(), asString: false }))))));
        })));
    };
    /**
     * Renders all the cascades for either Extract or Strip.
     */
    var renderCascades = function (cascades, stageType, isBothTypes) {
        var cascadePolygons = [];
        var cascadeIsothermLines = [];
        var cascadeIsothermScatters = [];
        cascades.forEach(function (cascade, index) {
            cascadePolygons.push.apply(cascadePolygons, cascade.stagePolygons.map(function (polygon) {
                return renderCascadePolygon(polygon, cascade.type, index);
            }));
            cascadeIsothermLines.push(renderIsothermLine(cascade.isotherm, index));
            cascadeIsothermScatters.push(renderIsothermScatter(cascade.isotherm, index));
        });
        return (React__default.createElement(CascadeWrapper, { isBothTypes: isBothTypes },
            React__default.createElement(ChartWrapper, null,
                React__default.createElement(GraphTitle, null, intl.formatMessage({
                    id: "components.McCabeThieleDiagram.Header.".concat(stageType),
                })),
                React__default.createElement(GraphWrapper, { graphHeight: isBothTypes ? GRAPH_HEIGHT_SMALL : GRAPH_HEIGHT, graphWidth: isBothTypes ? GRAPH_WIDTH_SMALL : GRAPH_WIDTH },
                    React__default.createElement(VictoryChart, {
                        height: isBothTypes ? GRAPH_HEIGHT_SMALL : GRAPH_HEIGHT, width: isBothTypes ? GRAPH_WIDTH_SMALL : GRAPH_WIDTH, style: GraphStyles.mainGraph, padding: GraphStyles.mainGraphPadding, domainPadding: {
                            x: GraphStyles.axisX.domainPadding,
                            y: GraphStyles.axisY.domainPadding,
                        }, domain: {
                            x: mcCabeThiele.getCascadesDomain(cascades),
                            y: mcCabeThiele.getCascadesRange(cascades),
                        }
                    },
                        renderXAxis(stageType),
                        renderYAxis(stageType),
                        cascadePolygons,
                        cascadeIsothermLines,
                        cascadeIsothermScatters))),
            renderCascadeLegends(cascades)));
    };
    /**
     * Renders the X axis
     */
    var renderXAxis = function (stageType) {
        return (React__default.createElement(VictoryAxis, {
            name: "xAxis", label: intl.formatMessage({
                id: "components.McCabeThieleDiagram.Graph.xAxis.".concat(stageType),
            }), style: GraphStyles.axisX
        }));
    };
    /**
     * Renders the Y axis.
     */
    var renderYAxis = function (stageType) {
        return (React__default.createElement(VictoryAxis, {
            name: "yAxis", label: intl.formatMessage({
                id: "components.McCabeThieleDiagram.Graph.yAxis.".concat(stageType),
            }), orientation: "left", style: GraphStyles.axisY, tickLabelComponent: React__default.createElement(VictoryLabel, { dy: GraphStyles.axisYTickLabelTranslate.dy, dx: GraphStyles.axisYTickLabelTranslate.dx, textAnchor: "start" }), crossAxis: true, dependentAxis: true
        }));
    };
    /**
     * If the circuit is still being loaded, display a spinner
     */
    var renderLoading = function () {
        return (React__default.createElement(LoadingWrapper, null,
            React__default.createElement(vc, { loading: isLoading })));
    };
    if (isLoading) {
        return renderLoading();
    }
    var extractCascades = mcCabeThiele.cascades.filter(function (cascade) { return cascade.type === IsothermType.EXTRACT; });
    var stripCascades = mcCabeThiele.cascades.filter(function (cascade) { return cascade.type === IsothermType.STRIP; });
    var hasExtractors = extractCascades.length > 0;
    var hasStrippers = stripCascades.length > 0;
    var isBoth = hasExtractors && hasStrippers;
    return (React__default.createElement(Wrapper$2, { ref: diagramRef, isBothTypes: isBoth },
        hasExtractors && renderCascades(extractCascades, IsothermType.EXTRACT, isBoth),
        hasStrippers && renderCascades(stripCascades, IsothermType.STRIP, isBoth)));
};

var ObservableTypes;
(function (ObservableTypes) {
    ObservableTypes["TOAST"] = "solvay_platform.toast";
    ObservableTypes["PAGE_TITLE"] = "solvay_platform.page.title";
    ObservableTypes["QUICK_NAVIGATOR"] = "solvay_platform.page.quickNavigator";
})(ObservableTypes || (ObservableTypes = {}));

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

var EVENTS = '__events__';
var SHARED = '__shared__';
var OBSERVERS = '__observers__';
var Observable = /*#__PURE__*/function () {
    function Observable(namespace) {
        this.dispatch = this.publish;
        Observable.initialize();
        this.namespace = namespace;
    } // istanbul ignore next


    Observable.initialize = function initialize() {
        if (!window[SHARED]) {
            var _window$SHARED;

            window[SHARED] = (_window$SHARED = {}, _window$SHARED[EVENTS] = {}, _window$SHARED[OBSERVERS] = {}, _window$SHARED);
        }

        if (!window[SHARED][EVENTS]) {
            window[SHARED][EVENTS] = {};
        }

        if (!window[SHARED][OBSERVERS]) {
            window[SHARED][OBSERVERS] = {};
        }
    };

    var _proto = Observable.prototype;

    _proto.getEvents = function getEvents() {
        return this.events;
    };

    _proto.getLastEvent = function getLastEvent() {
        var events = this.events;

        if (!events.length) {
            return;
        }

        var lastEvent = events[events.length - 1];
        return lastEvent;
    };

    _proto.publish = function publish(data) {
        var events = this.events;
        var lastEvent = this.getLastEvent();
        this.observers.forEach(function (observer) {
            return observer(data, {
                events: events,
                lastEvent: lastEvent
            });
        });
        this.events.push(data);
    };

    _proto.subscribe = function subscribe(observer) {
        this.observers = this.observers.concat(observer);
    };

    _proto.unsubscribe = function unsubscribe(observer) {
        this.observers = this.observers.filter(function (obs) {
            return obs !== observer;
        });
    };

    _proto.clear = function clear() {
        var events = this.events;
        var lastEvent = this.getLastEvent();
        this.observers.forEach(function (observer) {
            return observer(undefined, {
                events: events,
                lastEvent: lastEvent
            });
        });
        this.events = [];
        this.observers = [];
    };

    _createClass(Observable, [{
        key: "namespace",
        set: function set(namespace) {
            this._namespace = namespace; // istanbul ignore next

            if (!this.events) this.events = []; // istanbul ignore next

            if (!this.observers) this.observers = [];
        }
    }, {
        key: "events",
        get: function get() {
            return window[SHARED][EVENTS][this._namespace];
        },
        set: function set(newEvents) {
            window[SHARED][EVENTS][this._namespace] = newEvents;
        }
    }, {
        key: "observers",
        get: function get() {
            return window[SHARED][OBSERVERS][this._namespace];
        },
        set: function set(newObservers) {
            window[SHARED][OBSERVERS][this._namespace] = newObservers;
        }
    }]);

    return Observable;
}();

var pageTitleObservableId = ObservableTypes.PAGE_TITLE;
new Observable(pageTitleObservableId);

// NOTE: These should be EXACTLY the same as the MS_frontend/src/utils/quickNavigator.js file.
var QuickNavigatorTypes;
(function (QuickNavigatorTypes) {
    QuickNavigatorTypes["NOTHING"] = "NOTHING";
    QuickNavigatorTypes["QUICK_NAVIGATOR_BACK"] = "QUICK_NAVIGATOR_BACK";
    QuickNavigatorTypes["MINCHEM_QUICK_NAVIGATOR"] = "MINCHEM_QUICK_NAVIGATOR";
    QuickNavigatorTypes["SOLVEXTRACT_QUICK_NAVIGATOR"] = "SOLVEXTRACT_QUICK_NAVIGATOR";
    QuickNavigatorTypes["CUSTOM_QUICK_NAVIGATOR"] = "CUSTOM_QUICK_NAVIGATOR";
})(QuickNavigatorTypes || (QuickNavigatorTypes = {}));
var pageQuickNavigatorObservableId = ObservableTypes.QUICK_NAVIGATOR;
new Observable(pageQuickNavigatorObservableId);

var ToastType;
(function (ToastType) {
    ToastType["INFO"] = "INFO";
    ToastType["ERROR"] = "ERROR";
    ToastType["SUCCESS"] = "SUCCESS";
})(ToastType || (ToastType = {}));
var toastObservableId = ObservableTypes.TOAST;
var toastObservable = new Observable(toastObservableId);
var publishToast = function (toastType, message) {
    toastObservable.publish({ toastType: toastType, message: message });
};
var showErrorToast = function (errorMessage) {
    publishToast(ToastType.ERROR, errorMessage);
};
var showInfoToast = function (infoMessage) {
    publishToast(ToastType.INFO, infoMessage);
};
var showSuccessToast = function (successMessage) {
    publishToast(ToastType.SUCCESS, successMessage);
};
var ToastObservable = {
    showErrorToast: showErrorToast,
    showInfoToast: showInfoToast,
    showSuccessToast: showSuccessToast,
    observable: toastObservable,
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function o(e, t, n, r) { return new (n || (n = Promise))((function (o, i) { function u(e) { try { a(r.next(e)); } catch (e) { i(e); } } function c(e) { try { a(r.throw(e)); } catch (e) { i(e); } } function a(e) { var t; e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) { e(t); }))).then(u, c); } a((r = r.apply(e, t || [])).next()); })) } function i(e, t) { var n, r, o, i, u = { label: 0, sent: function () { if (1 & o[0]) throw o[1]; return o[1] }, trys: [], ops: [] }; return i = { next: c(0), throw: c(1), return: c(2) }, "function" == typeof Symbol && (i[Symbol.iterator] = function () { return this }), i; function c(i) { return function (c) { return function (i) { if (n) throw new TypeError("Generator is already executing."); for (; u;)try { if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o; switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) { case 0: case 1: o = i; break; case 4: return u.label++, { value: i[1], done: !1 }; case 5: u.label++, r = i[1], i = [0]; continue; case 7: i = u.ops.pop(), u.trys.pop(); continue; default: if (!(o = u.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) { u = 0; continue } if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) { u.label = i[1]; break } if (6 === i[0] && u.label < o[1]) { u.label = o[1], o = i; break } if (o && u.label < o[2]) { u.label = o[2], u.ops.push(i); break } o[2] && u.ops.pop(), u.trys.pop(); continue }i = t.call(e, u); } catch (e) { i = [6, e], r = 0; } finally { n = o = 0; } if (5 & i[0]) throw i[1]; return { value: i[0] ? i[1] : void 0, done: !0 } }([i, c]) } } } var u, c = { exports: {} }; u = c, function (e) { var t = function () { return { escape: function (e) { return e.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1") }, parseExtension: t, mimeType: function (e) { var n, r, o = t(e).toLowerCase(); return (n = "application/font-woff", r = "image/jpeg", { woff: n, woff2: n, ttf: "application/font-truetype", eot: "application/vnd.ms-fontobject", png: "image/png", jpg: r, jpeg: r, gif: "image/gif", tiff: "image/tiff", svg: "image/svg+xml" })[o] || "" }, dataAsUrl: function (e, t) { return "data:" + t + ";base64," + e }, isDataUrl: function (e) { return -1 !== e.search(/^(data:)/) }, canvasToBlob: function (e) { return e.toBlob ? new Promise((function (t) { e.toBlob(t); })) : function (e) { return new Promise((function (t) { for (var n = window.atob(e.toDataURL().split(",")[1]), r = n.length, o = new Uint8Array(r), i = 0; i < r; i++)o[i] = n.charCodeAt(i); t(new Blob([o], { type: "image/png" })); })) }(e) }, resolveUrl: function (e, t) { var n = document.implementation.createHTMLDocument(), r = n.createElement("base"); n.head.appendChild(r); var o = n.createElement("a"); return n.body.appendChild(o), r.href = t, o.href = e, o.href }, getAndEncode: function (e) { var t = 3e4; return c.impl.options.cacheBust && (e += (/\?/.test(e) ? "&" : "?") + (new Date).getTime()), new Promise((function (n) { var r, o = new XMLHttpRequest; if (o.onreadystatechange = u, o.ontimeout = a, o.responseType = "blob", o.timeout = t, o.open("GET", e, !0), o.send(), c.impl.options.imagePlaceholder) { var i = c.impl.options.imagePlaceholder.split(/,/); i && i[1] && (r = i[1]); } function u() { if (4 === o.readyState) if (200 === o.status) { var t = new FileReader; t.onloadend = function () { var e = t.result.split(/,/)[1]; n(e); }, t.readAsDataURL(o.response); } else r ? n(r) : l("cannot fetch resource: " + e + ", status: " + o.status); } function a() { r ? n(r) : l("timeout of " + t + "ms occured while fetching resource: " + e); } function l(e) { console.error(e), n(""); } })) }, uid: (e = 0, function () { return "u" + t() + e++; function t() { return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4) } }), delay: function (e) { return function (t) { return new Promise((function (n) { setTimeout((function () { n(t); }), e); })) } }, asArray: function (e) { for (var t = [], n = e.length, r = 0; r < n; r++)t.push(e[r]); return t }, escapeXhtml: function (e) { return e.replace(/#/g, "%23").replace(/\n/g, "%0A") }, makeImage: function (e) { return new Promise((function (t, n) { var r = new Image; r.onload = function () { t(r); }, r.onerror = n, r.src = e; })) }, width: function (e) { var t = n(e, "border-left-width"), r = n(e, "border-right-width"); return e.scrollWidth + t + r }, height: function (e) { var t = n(e, "border-top-width"), r = n(e, "border-bottom-width"); return e.scrollHeight + t + r } }; var e; function t(e) { var t = /\.([^\.\/]*?)$/g.exec(e); return t ? t[1] : "" } function n(e, t) { var n = window.getComputedStyle(e).getPropertyValue(t); return parseFloat(n.replace("px", "")) } }(), n = function () { var e = /url\(['"]?([^'"]+?)['"]?\)/g; return { inlineAll: function (e, t, i) { return u() ? Promise.resolve(e) : Promise.resolve(e).then(r).then((function (n) { var r = Promise.resolve(e); return n.forEach((function (e) { r = r.then((function (n) { return o(n, e, t, i) })); })), r })); function u() { return !n(e) } }, shouldProcess: n, impl: { readUrls: r, inline: o } }; function n(t) { return -1 !== t.search(e) } function r(n) { for (var r, o = []; null !== (r = e.exec(n));)o.push(r[1]); return o.filter((function (e) { return !t.isDataUrl(e) })) } function o(e, n, r, o) { return Promise.resolve(n).then((function (e) { return r ? t.resolveUrl(e, r) : e })).then(o || t.getAndEncode).then((function (e) { return t.dataAsUrl(e, t.mimeType(n)) })).then((function (r) { return e.replace(function (e) { return new RegExp("(url\\(['\"]?)(" + t.escape(e) + ")(['\"]?\\))", "g") }(n), "$1" + r + "$3") })) } }(), r = function () { return { resolveAll: function () { return e().then((function (e) { return Promise.all(e.map((function (e) { return e.resolve() }))) })).then((function (e) { return e.join("\n") })) }, impl: { readAll: e } }; function e() { return Promise.resolve(t.asArray(document.styleSheets)).then((function (e) { var n = []; return e.forEach((function (e) { try { t.asArray(e.cssRules || []).forEach(n.push.bind(n)); } catch (t) { console.log("Error while reading CSS rules from " + e.href, t.toString()); } })), n })).then((function (e) { return e.filter((function (e) { return e.type === CSSRule.FONT_FACE_RULE })).filter((function (e) { return n.shouldProcess(e.style.getPropertyValue("src")) })) })).then((function (t) { return t.map(e) })); function e(e) { return { resolve: function () { var t = (e.parentStyleSheet || {}).href; return n.inlineAll(e.cssText, t) }, src: function () { return e.style.getPropertyValue("src") } } } } }(), o = function () { return { inlineAll: function r(o) { return o instanceof Element ? i(o).then((function () { return o instanceof HTMLImageElement ? e(o).inline() : Promise.all(t.asArray(o.childNodes).map((function (e) { return r(e) }))) })) : Promise.resolve(o); function i(e) { var t = e.style.getPropertyValue("background"); return t ? n.inlineAll(t).then((function (t) { e.style.setProperty("background", t, e.style.getPropertyPriority("background")); })).then((function () { return e })) : Promise.resolve(e) } }, impl: { newImage: e } }; function e(e) { return { inline: function (n) { return t.isDataUrl(e.src) ? Promise.resolve() : Promise.resolve(e.src).then(n || t.getAndEncode).then((function (n) { return t.dataAsUrl(n, t.mimeType(e.src)) })).then((function (t) { return new Promise((function (n, r) { e.onload = n, e.onerror = r, e.src = t; })) })) } } } }(), i = { imagePlaceholder: void 0, cacheBust: !1 }, c = { toSvg: a, toPng: function (e, t) { return l(e, t || {}).then((function (e) { return e.toDataURL() })) }, toJpeg: function (e, t) { return l(e, t = t || {}).then((function (e) { return e.toDataURL("image/jpeg", t.quality || 1) })) }, toBlob: function (e, n) { return l(e, n || {}).then(t.canvasToBlob) }, toPixelData: function (e, n) { return l(e, n || {}).then((function (n) { return n.getContext("2d").getImageData(0, 0, t.width(e), t.height(e)).data })) }, impl: { fontFaces: r, images: o, util: t, inliner: n, options: {} } }; function a(e, n) { return function (e) { void 0 === e.imagePlaceholder ? c.impl.options.imagePlaceholder = i.imagePlaceholder : c.impl.options.imagePlaceholder = e.imagePlaceholder, void 0 === e.cacheBust ? c.impl.options.cacheBust = i.cacheBust : c.impl.options.cacheBust = e.cacheBust; }(n = n || {}), Promise.resolve(e).then((function (e) { return s(e, n.filter, !0) })).then(f).then(h).then((function (e) { return n.bgcolor && (e.style.backgroundColor = n.bgcolor), n.width && (e.style.width = n.width + "px"), n.height && (e.style.height = n.height + "px"), n.style && Object.keys(n.style).forEach((function (t) { e.style[t] = n.style[t]; })), e })).then((function (r) { return function (e, n, r) { return Promise.resolve(e).then((function (e) { return e.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), (new XMLSerializer).serializeToString(e) })).then(t.escapeXhtml).then((function (e) { return '<foreignObject x="0" y="0" width="100%" height="100%">' + e + "</foreignObject>" })).then((function (e) { return '<svg xmlns="http://www.w3.org/2000/svg" width="' + n + '" height="' + r + '">' + e + "</svg>" })).then((function (e) { return "data:image/svg+xml;charset=utf-8," + e })) }(r, n.width || t.width(e), n.height || t.height(e)) })) } function l(e, n) { return a(e, n).then(t.makeImage).then(t.delay(100)).then((function (r) { var o = function (e) { var r = document.createElement("canvas"); if (r.width = n.width || t.width(e), r.height = n.height || t.height(e), n.bgcolor) { var o = r.getContext("2d"); o.fillStyle = n.bgcolor, o.fillRect(0, 0, r.width, r.height); } return r }(e); return o.getContext("2d").drawImage(r, 0, 0), o })) } function s(e, n, r) { return r || !n || n(e) ? Promise.resolve(e).then((function (e) { return e instanceof HTMLCanvasElement ? t.makeImage(e.toDataURL()) : e.cloneNode(!1) })).then((function (r) { return function (e, n, r) { var o = e.childNodes; return 0 === o.length ? Promise.resolve(n) : i(n, t.asArray(o), r).then((function () { return n })); function i(e, t, n) { var r = Promise.resolve(); return t.forEach((function (t) { r = r.then((function () { return s(t, n) })).then((function (t) { t && e.appendChild(t); })); })), r } }(e, r, n) })).then((function (n) { return function (e, n) { return n instanceof Element ? Promise.resolve().then(r).then(o).then(i).then(u).then((function () { return n })) : n; function r() { function r(e, n) { function r(e, n) { t.asArray(e).forEach((function (t) { n.setProperty(t, e.getPropertyValue(t), e.getPropertyPriority(t)); })); } e.cssText ? n.cssText = e.cssText : r(e, n); } r(window.getComputedStyle(e), n.style); } function o() { function r(r) { var o = window.getComputedStyle(e, r), i = o.getPropertyValue("content"); if ("" !== i && "none" !== i) { var u = t.uid(); n.className = n.className + " " + u; var c = document.createElement("style"); c.appendChild(a(u, r, o)), n.appendChild(c); } function a(e, n, r) { var o = "." + e + ":" + n, i = r.cssText ? u(r) : c(r); return document.createTextNode(o + "{" + i + "}"); function u(e) { var t = e.getPropertyValue("content"); return e.cssText + " content: " + t + ";" } function c(e) { return t.asArray(e).map(n).join("; ") + ";"; function n(t) { return t + ": " + e.getPropertyValue(t) + (e.getPropertyPriority(t) ? " !important" : "") } } } } [":before", ":after"].forEach((function (e) { r(e); })); } function i() { e instanceof HTMLTextAreaElement && (n.innerHTML = e.value), e instanceof HTMLInputElement && n.setAttribute("value", e.value); } function u() { n instanceof SVGElement && (n.setAttribute("xmlns", "http://www.w3.org/2000/svg"), n instanceof SVGRectElement && ["width", "height"].forEach((function (e) { var t = n.getAttribute(e); t && n.style.setProperty(e, t); }))); } }(e, n) })) : Promise.resolve() } function f(e) { return r.resolveAll().then((function (t) { var n = document.createElement("style"); return e.appendChild(n), n.appendChild(document.createTextNode(t)), e })) } function h(e) { return o.inlineAll(e).then((function () { return e })) } u.exports = c; }(); var a = c.exports, l = function (e, t, n) { return o(void 0, void 0, void 0, (function () { var o, u, c, l, s, f, h, d; return i(this, (function (i) { switch (i.label) { case 0: if (i.trys.push([0, 3, , 4]), !e.current) throw new Error("No target provided"); return (o = document.createElement("div")).setAttribute("style", "\n            position: fixed;\n            top: 0;\n            left: 0;\n            z-index: -9999;\n            background-color: #fff;\n\n            padding: 20px;\n        "), u = e.current.cloneNode(!0), o.replaceChildren(u), document.body.appendChild(o), c = o.offsetWidth, l = o.offsetHeight, [4, a.toBlob(o, { quality: 1, width: c, height: l })]; case 1: return s = i.sent(), document.body.removeChild(o), f = new ClipboardItem(((d = {})[s.type] = s, d)), [4, navigator.clipboard.write([f]).then((function () { (null == t ? void 0 : t.successMessage) && ToastObservable.showSuccessToast(t.successMessage); })).then((function () { n && n(); }))]; case 2: return i.sent(), [3, 4]; case 3: return h = i.sent(), console.error(h), (null == t ? void 0 : t.errorMessage) && ToastObservable.showErrorToast(t.errorMessage), [3, 4]; case 4: return [2] } })) })) }, s = function (r) { var u = r.callback, c = r.disabled, a = void 0 !== c && c, s = r.copyElementRef, f = r.feedbackSettings, h = r.text, d = useState(!1), p = d[0], m = d[1]; return jsx(Ye, { loading: p, disabled: a || p, text: h, onClick: function () { return o(void 0, void 0, void 0, (function () { return i(this, (function (e) { switch (e.label) { case 0: m(!0), e.label = 1; case 1: return e.trys.push([1, , 3, 4]), [4, l(s, f, u)]; case 2: return e.sent(), [3, 4]; case 3: return m(!1), [7]; case 4: return [2] } })) })) } }) };

var Wrapper$1 = o$1.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: flex-end;\n    flex-shrink: 0;\n\n    padding: 8px 24px;\n\n    border-top: 1px solid ", ";\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: flex-end;\n    flex-shrink: 0;\n\n    padding: 8px 24px;\n\n    border-top: 1px solid ", ";\n"])), Ee.defaultBorder);
var ButtonWrapper = o$1.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n"])));
var templateObject_1$3, templateObject_2$3;

var TRANSLATION_IDS = {
    successMessage: 'feedback.success.copyToClipboard',
    errorMessage: 'feedback.error.copyToClipboard',
};
var McCabeThieleFooter = function (_a) {
    var copyToClipboardDisabled = _a.copyToClipboardDisabled, diagramRef = _a.diagramRef;
    var intl = useIntl();
    var feedbackSettings = {
        successMessage: intl.formatMessage({
            id: TRANSLATION_IDS.successMessage,
        }),
        errorMessage: intl.formatMessage({
            id: TRANSLATION_IDS.errorMessage,
        }),
    };
    return (React__default.createElement(Wrapper$1, null,
        React__default.createElement(ButtonWrapper, null,
            React__default.createElement(s, {
                text: intl.formatMessage({
                    id: 'components.McCabeThieleFooter.copyToClipboard',
                }), feedbackSettings: feedbackSettings, disabled: copyToClipboardDisabled, copyElementRef: diagramRef
            }))));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$2 = function (d, b) {
    extendStatics$2 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$2(d, b);
};

function __extends$2(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$2(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __spreadArray$1(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var DIAGRAM_DISPLAY_MODES;
(function (DIAGRAM_DISPLAY_MODES) {
    DIAGRAM_DISPLAY_MODES["SETUP"] = "SETUP";
    DIAGRAM_DISPLAY_MODES["COMPUTE"] = "COMPUTE";
    DIAGRAM_DISPLAY_MODES["COMPUTED"] = "COMPUTED";
})(DIAGRAM_DISPLAY_MODES || (DIAGRAM_DISPLAY_MODES = {}));

// Circuit Streams
var STREAM_WATER_TYPES;
(function (STREAM_WATER_TYPES) {
    STREAM_WATER_TYPES["AQUEOUS"] = "AQUEOUS";
    STREAM_WATER_TYPES["ORGANIC"] = "ORGANIC";
})(STREAM_WATER_TYPES || (STREAM_WATER_TYPES = {}));
var StreamTypes;
(function (StreamTypes) {
    StreamTypes["CONTINUE"] = "CONTINUE";
    StreamTypes["FEED"] = "FEED";
    StreamTypes["BLEED"] = "BLEED";
    StreamTypes["BLEND"] = "BLEND";
    StreamTypes["SKIP"] = "SKIP";
    StreamTypes["BYPASS_BLEND"] = "BYPASS_BLEND";
    StreamTypes["BYPASS_FEED"] = "BYPASS_FEED";
    StreamTypes["BYPASS_BLEED"] = "BYPASS_BLEED";
    StreamTypes["LEAN_FEED_BLEED"] = "LEAN_FEED_BLEED";
})(StreamTypes || (StreamTypes = {}));
var StreamCircuits;
(function (StreamCircuits) {
    StreamCircuits["AQUEOUS"] = "AQUEOUS";
    StreamCircuits["ORGANIC"] = "ORGANIC";
    StreamCircuits["ELECTROLYTE"] = "ELECTROLYTE";
})(StreamCircuits || (StreamCircuits = {}));
var STREAM_VALUE_TYPES;
(function (STREAM_VALUE_TYPES) {
    // METAL COMPOSITIONs =
    STREAM_VALUE_TYPES["COMPOSITION"] = "COMPOSITION";
    STREAM_VALUE_TYPES["PRE_COMPOSITION"] = "PRE_COMPOSITION";
    STREAM_VALUE_TYPES["POST_COMPOSITION"] = "POST_COMPOSITION";
    STREAM_VALUE_TYPES["PLS"] = "PLS";
    STREAM_VALUE_TYPES["PRE_PLS_CU"] = "PRE_PLS_CU";
    STREAM_VALUE_TYPES["RAFFINATE"] = "RAFFINATE";
    STREAM_VALUE_TYPES["SPENT"] = "SPENT";
    STREAM_VALUE_TYPES["ADVANCE"] = "ADVANCE";
    STREAM_VALUE_TYPES["PHYSICAL_FE_TRANSFER"] = "PHYSICAL_FE_TRANSFER";
    STREAM_VALUE_TYPES["CHEMICAL_FE_TRANSFER"] = "CHEMICAL_FE_TRANSFER";
    STREAM_VALUE_TYPES["LEAN_FE_MN_RATIO"] = "LEAN_FE_MN_RATIO";
    STREAM_VALUE_TYPES["STRIPPED_FE_MN_RATIO"] = "STRIPPED_FE_MN_RATIO";
    STREAM_VALUE_TYPES["ESTIMATED_ORGANIC_FE"] = "ESTIMATED_ORGANIC_FE";
    // View the self calling function = appendMetalsToStreamValueTypes
    // Flowrates =
    STREAM_VALUE_TYPES["FLOWRATE"] = "FLOWRATE";
    STREAM_VALUE_TYPES["FLOWRATE_PERCENT"] = "FLOWRATE_PERCENT";
    STREAM_VALUE_TYPES["ACID_MAKEUP"] = "ACID_MAKEUP";
    STREAM_VALUE_TYPES["WATER_MAKEUP"] = "WATER_MAKEUP";
    STREAM_VALUE_TYPES["ACID_MAKEUP_TREND"] = "ACID_MAKEUP_TREND";
    STREAM_VALUE_TYPES["WATER_MAKEUP_TREND"] = "WATER_MAKEUP_TREND";
    // Acids/pHs
    STREAM_VALUE_TYPES["ACID"] = "ACID";
    STREAM_VALUE_TYPES["PH"] = "PH";
    STREAM_VALUE_TYPES["PRE_PH"] = "PRE_PH";
    // Aggregates =
    STREAM_VALUE_TYPES["RECOVERY_PERCENT"] = "RECOVERY_PERCENT";
    STREAM_VALUE_TYPES["LOADED_PERCENT"] = "LOADED_PERCENT";
    STREAM_VALUE_TYPES["NET_TRANSFER"] = "NET_TRANSFER";
    STREAM_VALUE_TYPES["STRIPPED_PERCENT"] = "STRIPPED_PERCENT";
    STREAM_VALUE_TYPES["AINO_ENTRAINMENT_AVERAGE"] = "AINO_ENTRAINMENT_AVERAGE";
    STREAM_VALUE_TYPES["BARREN_ORGANIC_TANK_LEVEL"] = "BARREN_ORGANIC_TANK_LEVEL";
})(STREAM_VALUE_TYPES || (STREAM_VALUE_TYPES = {}));

var MimicStream = /** @class */ (function () {
    function MimicStream(data) {
        var _this = this;
        this.id = undefined;
        /**
         * Unique ID is required for the cases where a stream of the
         * exact same circuit, type and from/to stage exist.
         */
        this.___uniqueId = Math.random();
        this.siblings = [];
        this.children = [];
        this.parentStream = null;
        /**
         * In setup mode, when the user clicks on (X) to remove a stream.
         */
        this.onRemove = function () {
            if (!_this.isRemovable()) {
                return;
            }
            _this.__removeSelf();
        };
        this.streamType = data.streamType;
        this.streamCircuit = data.streamCircuit;
        this.id = data.id;
        this.fromStageId = data.fromStageId;
        this.toStageId = data.toStageId;
        this.toStageData = data.to;
        this.fromStageData = data.from;
    }
    /**
     * Format looks like: ORGANIC_CONTINUE_E4_E6
     * @returns the unique key for this stream.
     */
    MimicStream.prototype.getCode = function () {
        var _a, _b;
        var fromKey = (_a = this.fromStage) === null || _a === void 0 ? void 0 : _a.getCode();
        var toKey = (_b = this.toStage) === null || _b === void 0 ? void 0 : _b.getCode();
        var stageKeys = [fromKey, toKey].filter(Boolean).join('_');
        return "".concat(this.streamCircuit, "_").concat(this.streamType, "_").concat(stageKeys);
    };
    MimicStream.prototype.isAqueousStream = function () {
        return (this.streamCircuit === StreamCircuits.AQUEOUS ||
            this.streamCircuit === StreamCircuits.ELECTROLYTE);
    };
    MimicStream.prototype.isOrganicStream = function () {
        return this.streamCircuit === StreamCircuits.ORGANIC;
    };
    /**
     * ======================
     *  SETUP MODE FUNCTIONS:
     * ======================
     */
    /**
     * @returns true if the stream has an edit button and it should be displayed.
     */
    MimicStream.prototype.isEditable = function () {
        return false;
    };
    /**
     * @returns true if the stream's info box should be displayed
     */
    MimicStream.prototype.isLabeled = function () {
        return false;
    };
    /**
     * @returns true if the stream can be removed
     * from the info box (if there is one).
     */
    MimicStream.prototype.isRemovable = function () {
        return false;
    };
    /**
     * @returns the label that should be displayed in setup mode.
     */
    MimicStream.prototype.getLabel = function () {
        return this.streamType;
    };
    /**
     * ======================
     *  CONNECTIVITY w/ other entities:
     * ======================
     */
    /**
     * Links the fromStage and toStage
     */
    MimicStream.prototype.__linkStages = function () {
        if (this.fromStageData) {
            var fromStage = this.circuit.getStageByDescription(this.fromStageData.stageType, this.fromStageData.location);
            if (fromStage) {
                this.setStageFrom(fromStage);
            }
        }
        if (this.fromStageId) {
            var fromStage = this.circuit.getStageById(this.fromStageId);
            if (fromStage) {
                this.setStageFrom(fromStage);
            }
        }
        if (this.toStageData) {
            var toStage = this.circuit.getStageByDescription(this.toStageData.stageType, this.toStageData.location);
            if (toStage) {
                this.setStageTo(toStage);
            }
        }
        if (this.toStageId) {
            var toStage = this.circuit.getStageById(this.toStageId);
            if (toStage) {
                this.setStageTo(toStage);
            }
        }
    };
    /**
     * Sets the stage this stream originates from.
     */
    MimicStream.prototype.setStageFrom = function (fromStage) {
        this.fromStage = fromStage;
        this.fromStageId = fromStage.id;
        if (this.isAqueousStream()) {
            fromStage.addOutgoingAqueousStream(this);
        }
        else {
            fromStage.addOutgoingOrganicStream(this);
        }
    };
    /**
     * Sets the stage this stream goes into.
     */
    MimicStream.prototype.setStageTo = function (toStage) {
        this.toStage = toStage;
        this.toStageId = toStage.id;
        if (this.isAqueousStream()) {
            toStage.addIncomingAqueousStream(this);
        }
        else {
            toStage.addIncomingOrganicStream(this);
        }
    };
    /**
     * Sets the stream this stream splits into/from.
     */
    MimicStream.prototype.setParentStream = function (stream) {
        this.parentStream = stream;
    };
    /**
     * Adds a child stream
     */
    MimicStream.prototype.addChildStream = function (stream) {
        if (this.children.indexOf(stream) === -1) {
            this.children.push(stream);
        }
    };
    /**
     * Removes a child stream.
     */
    MimicStream.prototype.removeChildStream = function (stream) {
        var idx = this.children.indexOf(stream);
        if (idx !== -1) {
            this.children.splice(idx, 1);
        }
    };
    /**
     * Adds a sibling stream
     */
    MimicStream.prototype.addSibling = function (stream) {
        if (this.siblings.indexOf(stream) === -1) {
            this.siblings.push(stream);
        }
    };
    /**
     * Removes a sibling stream.
     */
    MimicStream.prototype.removeSibling = function (stream) {
        var idx = this.siblings.indexOf(stream);
        if (idx !== -1) {
            this.siblings.splice(idx, 1);
        }
    };
    /**
     * Finds and sets the
     *  - siblings
     *  - children
     *  - parent
     * streams of this stream.
     */
    MimicStream.prototype.findFamily = function () {
        this.siblings = this.findSiblings();
        this.children = this.findChildren();
        this.parentStream = this.findParent();
    };
    MimicStream.prototype.findSiblings = function () {
        var _this = this;
        var sameIn = [];
        var sameOut = [];
        if (this.isAqueousStream()) {
            if (this.toStage) {
                sameIn = this.toStage.getIncomingAqueousStreams();
            }
            if (this.fromStage) {
                sameOut = this.fromStage.getOutgoingAqueousStreams();
            }
        }
        else {
            if (this.toStage) {
                sameIn = this.toStage.getIncomingOrganicStreams();
            }
            if (this.fromStage) {
                sameOut = this.fromStage.getOutgoingOrganicStreams();
            }
        }
        var streams = sameIn.concat(sameOut);
        return streams.filter(function (stream) { return stream !== _this; });
    };
    MimicStream.prototype.findChildren = function () {
        return [];
    };
    MimicStream.prototype.findParent = function () {
        return null;
    };
    /**
     * Removes this stream.
     * Only use if you know what you're doing.
     *
     * This will:
     *  - remove the stream from the stages,
     *  - remove the family connectivity
     *  - remove all of the children.
     *  - delete the stream from the circuit
     */
    MimicStream.prototype.__removeSelf = function () {
        var _this = this;
        if (this.fromStage) {
            this.fromStage.removeStream(this);
        }
        if (this.toStage) {
            this.toStage.removeStream(this);
        }
        if (this.parentStream) {
            this.parentStream.removeChildStream(this);
        }
        // we need to create a temporary array because `child.__removeSelf`
        // might change the `this.children` array.
        __spreadArray$1([], this.children, true).forEach(function (child) {
            child.__removeSelf();
        });
        this.siblings.forEach(function (stream) {
            stream.removeSibling(_this);
        });
        this.circuit.deleteStream(this);
    };
    MimicStream.prototype.setCircuit = function (circuit) {
        this.circuit = circuit;
    };
    /**
     * @returns An object representing the stream of type StreamDTO.
     */
    MimicStream.prototype.toJSON = function () {
        var baseData = {
            streamType: this.streamType,
            streamCircuit: this.streamCircuit,
        };
        if (this.id) {
            baseData.id = this.id;
        }
        if (this.fromStage) {
            if (this.fromStage.id) {
                baseData.fromStageId = this.fromStage.id;
            }
            else {
                baseData.from = this.fromStage.toJSON();
            }
        }
        else {
            baseData.fromStageId = undefined;
            baseData.from = undefined;
        }
        if (this.toStage) {
            if (this.toStage.id) {
                baseData.toStageId = this.toStage.id;
            }
            else {
                baseData.to = this.toStage.toJSON();
            }
        }
        else {
            baseData.toStageId = undefined;
            baseData.to = undefined;
        }
        return baseData;
    };
    return MimicStream;
}());

var StageTypes;
(function (StageTypes) {
    StageTypes["EXTRACT"] = "EXTRACT";
    StageTypes["STRIP"] = "STRIP";
    StageTypes["ORGANIC_TANK"] = "ORGANIC_TANK";
    StageTypes["WASHER"] = "WASHER";
})(StageTypes || (StageTypes = {}));
// TODO: Replace for KPI_TYPES - still TODO ??
var STAGE_VALUE_TYPES;
(function (STAGE_VALUE_TYPES) {
    STAGE_VALUE_TYPES["OA_RATIO"] = "OA_RATIO";
    STAGE_VALUE_TYPES["STAGE_EFFICIENCY"] = "STAGE_EFFICIENCY";
    STAGE_VALUE_TYPES["ISOTHERM"] = "ISOTHERM";
    STAGE_VALUE_TYPES["ORGANIC_DEPTH"] = "ORGANIC_DEPTH";
    STAGE_VALUE_TYPES["PRIMARY_MIXER_SPEED"] = "PRIMARY_MIXER_SPEED";
    STAGE_VALUE_TYPES["PRIMARY_MIXER_OA_RATIO"] = "PRIMARY_MIXER_OA_RATIO";
    STAGE_VALUE_TYPES["PRIMARY_MIXER_RETENTION_TIME"] = "PRIMARY_MIXER_RETENTION_TIME";
    STAGE_VALUE_TYPES["SETTLER_ORGANIC_PHASE_VELOCITY"] = "SETTLER_ORGANIC_PHASE_VELOCITY";
    STAGE_VALUE_TYPES["SETTLER_AQUEOUS_PHASE_VELOCITY"] = "SETTLER_AQUEOUS_PHASE_VELOCITY";
    STAGE_VALUE_TYPES["SETTLER_ORGANIC_RETENTION_TIME"] = "SETTLER_ORGANIC_RETENTION_TIME";
    STAGE_VALUE_TYPES["SETTLER_AQUEOUS_RETENTION_TIME"] = "SETTLER_AQUEOUS_RETENTION_TIME";
    STAGE_VALUE_TYPES["SETTLER_SPECIFIC_FLOW"] = "SETTLER_SPECIFIC_FLOW";
    STAGE_VALUE_TYPES["CRUD_DEPTH"] = "CRUD_DEPTH";
    STAGE_VALUE_TYPES["TANK_CU_COMPOSITION"] = "TANK_CU_COMPOSITION";
    STAGE_VALUE_TYPES["TANK_FLOWRATE"] = "TANK_FLOWRATE";
    STAGE_VALUE_TYPES["TANK_LEVEL"] = "TANK_LEVEL";
    STAGE_VALUE_TYPES["PRE_WASH_COMPOSITION"] = "PRE_WASH_COMPOSITION";
    STAGE_VALUE_TYPES["POST_WASH_COMPOSITION"] = "POST_WASH_COMPOSITION";
    STAGE_VALUE_TYPES["WASH_OFFSET"] = "WASH_OFFSET";
    STAGE_VALUE_TYPES["WASH_WATER"] = "WASH_WATER";
})(STAGE_VALUE_TYPES || (STAGE_VALUE_TYPES = {}));
var MAX_STAGE_COUNT = 10;

var STREAM_LABELS = {
    NEW_FEED: 'NewFeed',
    BLEED: 'Bleed',
    RAFFINATE: 'Raffinate',
    BLEND: 'Blend',
    BYPASS_FEED: 'BypassFeed',
    BYPASS_BLEND: 'BypassBlend',
    SKIP: 'Skip',
};

var FeedStream = /** @class */ (function (_super) {
    __extends$2(FeedStream, _super);
    function FeedStream() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fromStage = undefined;
        _this.onRemove = function () {
            var bleedSibling = _this.findBleedSibling();
            if (!bleedSibling) {
                throw new Error('Cannot remove a feed stream without having a bleed stream sibling.');
            }
            var fromStage = bleedSibling.fromStage;
            if (!fromStage) {
                throw new Error('Bleed stream without from stage is not possible.');
            }
            var newContinue = new ContinueStream({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: _this.streamCircuit,
            });
            newContinue.setStageFrom(fromStage);
            newContinue.setStageTo(_this.toStage);
            _this.circuit.addStream(newContinue);
            _this.__removeSelf();
            bleedSibling.__removeSelf();
        };
        return _this;
    }
    FeedStream.prototype.isOnTheExtremitiesOfCircuit = function () {
        var edgeStage = this.toStage;
        var lastLocation = this.toStage.section.getLastStageLocation();
        if (edgeStage.stageType === StageTypes.EXTRACT) {
            return edgeStage.location === 1;
        }
        else if (edgeStage.stageType === StageTypes.STRIP) {
            return edgeStage.location === lastLocation;
        }
        return false;
    };
    /**
     * To be labeled, a feed stream must have a sibling.
     */
    FeedStream.prototype.isLabeled = function () {
        return this.siblings.length !== 0;
    };
    FeedStream.prototype.getLabel = function () {
        return STREAM_LABELS.NEW_FEED;
    };
    /**
     * To be removable, a feed stream must have a sibling.
     * A sibling of the bleed stream is:
     *  - pls bleed stream
     */
    FeedStream.prototype.isRemovable = function () {
        var hasSiblings = this.siblings.length !== 0;
        if (!hasSiblings) {
            return false;
        }
        // A feed stream with a skip sibling cannot be removed
        // the skip stream should be removed instead.
        var hasSkipSibling = Boolean(this.getSkipSibling());
        if (hasSkipSibling) {
            return false;
        }
        if (this.toStage.stageType === StageTypes.STRIP) {
            if (this.toStage.getOutgoingOrganicStreamOfType(StreamTypes.BYPASS_BLEED)) {
                return false; // Cannot remove parallel electrolyte if there is an organic bypass.
            }
        }
        return true;
    };
    /**
     * @returns the potential bleed stream related to this feed.
     */
    FeedStream.prototype.findBleedSibling = function () {
        var relatedStage = null;
        switch (this.streamCircuit) {
            case StreamCircuits.AQUEOUS: {
                relatedStage = this.toStage.getPreviousPhysicalStage();
                break;
            }
            case StreamCircuits.ORGANIC: {
                // Organic Streams cannot have new feeds mid section.
                return null;
            }
            case StreamCircuits.ELECTROLYTE: {
                relatedStage = this.toStage.getNextPhysicalStage();
                break;
            }
            default:
                throw new Error('Unknown stream circuit.');
        }
        if (!relatedStage) {
            return null;
        }
        return relatedStage.getOutgoingAqueousStreamOfType(StreamTypes.BLEED);
    };
    /**
     * Returns the siblings of the feed stream.
     * In PLS/Electrolyte this is the bleed opposite bleed.
     *
     */
    FeedStream.prototype.findSiblings = function () {
        return [this.findBleedSibling()].filter(Boolean);
    };
    /**
     * Returns the skip stream if it is found in our siblings array.
     */
    FeedStream.prototype.getSkipSibling = function () {
        var skipSibling = this.siblings.find(function (sibling) { return sibling.streamType === StreamTypes.SKIP; });
        if (!skipSibling) {
            return null;
        }
        return skipSibling;
    };
    return FeedStream;
}(MimicStream));

var BlendStream = /** @class */ (function (_super) {
    __extends$2(BlendStream, _super);
    function BlendStream() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * NOTE: Blend streams extend feed streams.
         * We must overwrite the IFeedStream `onRemove`
         * and go directly to the `MimicStream` implementation of `onRemove`.
         */
        _this.onRemove = function () {
            _this.__removeSelf();
        };
        return _this;
    }
    /**
     * Blend streams are always labeled
     */
    BlendStream.prototype.isLabeled = function () {
        return true;
    };
    BlendStream.prototype.getLabel = function () {
        return STREAM_LABELS.BLEND;
    };
    /**
     * Blend streams are always removable
     */
    BlendStream.prototype.isRemovable = function () {
        return true;
    };
    /**
     * A blend stream can only have a bleed sibling.
     */
    BlendStream.prototype.findPLSBleedSibling = function () {
        var previousStage = this.toStage.getPreviousPhysicalStage();
        if (!previousStage) {
            return null;
        }
        return previousStage.getOutgoingAqueousStreamOfType(StreamTypes.BLEED);
    };
    /**
     * The siblings of a blend stream are:
     *  - the related bleed stream.
     */
    BlendStream.prototype.findSiblings = function () {
        return [this.findPLSBleedSibling()].filter(Boolean);
    };
    /**
     * @returns the continue stream related to this stream.
     */
    BlendStream.prototype.findParent = function () {
        var continueStream = this.toStage.getIncomingAqueousStreamOfType(StreamTypes.CONTINUE);
        if (continueStream) {
            return continueStream;
        }
        var skipStream = this.toStage.getIncomingAqueousStreamOfType(StreamTypes.SKIP);
        if (skipStream) {
            return skipStream;
        }
        return null;
    };
    /**
     * @returns true if the parent stream is a skip stream
     */
    BlendStream.prototype.isParentSkipStream = function () {
        if (!this.parentStream) {
            return false;
        }
        return this.parentStream.streamType === StreamTypes.SKIP;
    };
    return BlendStream;
}(FeedStream));

var BleedStream = /** @class */ (function (_super) {
    __extends$2(BleedStream, _super);
    function BleedStream() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toStage = undefined;
        return _this;
    }
    BleedStream.prototype.isOnTheExtremitiesOfCircuit = function () {
        var edgeStage = this.fromStage;
        var lastLocation = this.fromStage.section.getLastStageLocation();
        if (edgeStage.stageType === StageTypes.EXTRACT) {
            return edgeStage.location === lastLocation;
        }
        else if (edgeStage.stageType === StageTypes.STRIP) {
            return edgeStage.location === 1;
        }
        return false;
    };
    /**
     * To be labeled, a bleed stream must have a sibling.
     * A sibling of the bleed stream is:
     *  - pls feed streams,
     *  - pls blend streams,
     */
    BleedStream.prototype.isLabeled = function () {
        var hasSiblings = this.siblings.length !== 0;
        var hasParent = Boolean(this.parentStream);
        return hasSiblings || hasParent;
    };
    /**
     * If the stream is a bleed coming from a continue stream,
     * that means it has a parent, and that the stream label must be bleed.
     * If it doesn't have a continue stream, then it is a raffinate.
     */
    BleedStream.prototype.getLabel = function () {
        if (this.parentStream) {
            return STREAM_LABELS.BLEED;
        }
        if (this.streamCircuit === StreamCircuits.AQUEOUS) {
            return STREAM_LABELS.RAFFINATE;
        }
        else {
            // TODO: Should there be different names for these?
            return STREAM_LABELS.BLEED;
        }
    };
    /**
     * To be removable, a bleed stream must have a parent
     */
    BleedStream.prototype.isRemovable = function () {
        return Boolean(this.parentStream);
    };
    /**
     * @returns the feed potential stream related to this bleed.
     */
    BleedStream.prototype.findFeedSibling = function () {
        switch (this.streamCircuit) {
            case StreamCircuits.AQUEOUS: {
                var nextStage = this.fromStage.getNextPhysicalStage();
                if (!nextStage) {
                    return null;
                }
                return nextStage.getIncomingAqueousStreamOfType(StreamTypes.FEED);
            }
            case StreamCircuits.ORGANIC: {
                // Organic Streams cannot have new feeds mid section.
                return null;
            }
            case StreamCircuits.ELECTROLYTE: {
                var previousStage = this.fromStage.getPreviousPhysicalStage();
                if (!previousStage) {
                    return null;
                }
                return previousStage.getIncomingAqueousStreamOfType(StreamTypes.FEED);
            }
            default:
                throw new Error('Unknown stream circuit.');
        }
    };
    /**
     * @returns the potential PLS blend stream in the PLS section
     */
    BleedStream.prototype.findPLSBlendSibling = function () {
        if (this.streamCircuit !== StreamCircuits.AQUEOUS) {
            return null;
        }
        var nextStage = this.fromStage.getNextPhysicalStage();
        if (!nextStage) {
            return null;
        }
        return nextStage.getIncomingAqueousStreamOfType(StreamTypes.BLEND);
    };
    /**
     * The siblings of a bleed stream are:
     *  - the related feed stream in PLS or Electrolyte section
     */
    BleedStream.prototype.findSiblings = function () {
        return [this.findFeedSibling(), this.findPLSBlendSibling()].filter(Boolean);
    };
    /**
     * @returns only possible in PLS section.
     */
    BleedStream.prototype.findParent = function () {
        if (this.streamCircuit !== StreamCircuits.AQUEOUS) {
            return null;
        }
        var continueStream = this.fromStage.getOutgoingAqueousStreamOfType(StreamTypes.CONTINUE);
        if (continueStream) {
            return continueStream;
        }
        var skipStream = this.fromStage.getOutgoingAqueousStreamOfType(StreamTypes.SKIP);
        if (skipStream) {
            return skipStream;
        }
        return null;
    };
    /**
     * @returns true if the parent stream is a skip stream
     */
    BleedStream.prototype.isParentSkipStream = function () {
        if (!this.parentStream) {
            return false;
        }
        return this.parentStream.streamType === StreamTypes.SKIP;
    };
    return BleedStream;
}(MimicStream));

var ContinueStream = /** @class */ (function (_super) {
    __extends$2(ContinueStream, _super);
    function ContinueStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContinueStream.prototype.isInterStageContinue = function () {
        return this.toStage.stageType !== this.fromStage.stageType;
    };
    ContinueStream.prototype.getSectionType = function () {
        if (this.isInterStageContinue()) {
            return StreamCircuits.ORGANIC; // YIKES?
        }
        else {
            // fromStage and toStage are of the same type.
            return this.fromStage.section.sectionType;
        }
    };
    /**
     * Circuit must be in setup mode.
     * The stream must be a pure continue stream.
     * The stream must not currently have children.
     */
    ContinueStream.prototype.isEditable = function () {
        if (this.circuit.mode !== DIAGRAM_DISPLAY_MODES.SETUP) {
            return false;
        }
        if (this.streamType !== StreamTypes.CONTINUE) {
            return false;
        }
        var isChildless = this.children.length === 0;
        if (!isChildless) {
            return false;
        }
        if (this.isInterStageContinue()) {
            return false;
        }
        return true;
    };
    /**
     * Continue streams do not have siblings.
     */
    ContinueStream.prototype.findSiblings = function () {
        return [];
    };
    /**
     * The children streams of a continue stream the:
     *  - PLS Blend stream in the extract section
     *  - PLS bleed stream in the extract section
     *  - Organic Bypass Blend stream in organic section
     *  - None in electrolyte.
     */
    ContinueStream.prototype.findChildren = function () {
        switch (this.streamCircuit) {
            case StreamCircuits.AQUEOUS: {
                return [this.findPLSBlendChild(), this.findPLSBleedChild()].filter(Boolean);
            }
            case StreamCircuits.ORGANIC: {
                return [this.findOrganicBlendChild()].filter(Boolean);
            }
            case StreamCircuits.ELECTROLYTE: {
                return [];
            }
            default:
                throw new Error("Unknown stream circuit.");
        }
    };
    /**
     * Returns the PLS blend stream to the toStage of this stream.
     */
    ContinueStream.prototype.findPLSBlendChild = function () {
        return this.toStage.getIncomingAqueousStreamOfType(StreamTypes.BLEND);
    };
    /**
     * Returns the organic blend stream to the toStage of this stream.
     */
    ContinueStream.prototype.findOrganicBlendChild = function () {
        return this.toStage.getIncomingOrganicStreamOfType(StreamTypes.BYPASS_BLEND);
    };
    /**
     * Returns the PLS bleed stream from the fromStage of this stream.
     */
    ContinueStream.prototype.findPLSBleedChild = function () {
        return this.fromStage.getOutgoingAqueousStreamOfType(StreamTypes.BLEED);
    };
    /***************************************
     *
     * STREAM CONVERSION HELPERS:
     *
     ***************************************/
    /**
     * Convert this continue stream into a new feed configuration.
     */
    ContinueStream.prototype.convertToPLSNewFeed = function () {
        if (this.streamCircuit !== StreamCircuits.AQUEOUS) {
            throw new Error('Cannot call this function from non-pls stream.');
        }
        var newFeed = new FeedStream({
            streamType: StreamTypes.FEED,
            streamCircuit: StreamCircuits.AQUEOUS,
        });
        newFeed.setStageTo(this.toStage);
        var newBleed = new BleedStream({
            streamType: StreamTypes.BLEED,
            streamCircuit: StreamCircuits.AQUEOUS,
        });
        newBleed.setStageFrom(this.fromStage);
        newFeed.addSibling(newBleed);
        newBleed.addSibling(newFeed);
        this.circuit.addStream(newFeed);
        this.circuit.addStream(newBleed);
        this.__removeSelf();
    };
    /**
     * Adds a new PLS blend stream into this continue stream.
     */
    ContinueStream.prototype.addPLSBlendChild = function () {
        if (this.streamCircuit !== StreamCircuits.AQUEOUS) {
            throw new Error('Cannot call this function from non-pls stream.');
        }
        var newBlend = new BlendStream({
            streamType: StreamTypes.BLEND,
            streamCircuit: StreamCircuits.AQUEOUS,
        });
        newBlend.setStageTo(this.toStage);
        newBlend.setParentStream(this);
        this.addChildStream(newBlend);
        this.circuit.addStream(newBlend);
        this.findFamily();
    };
    /**
     * Adds a new PLS bleed stream into this continue stream.
     */
    ContinueStream.prototype.addPLSBleedChild = function () {
        if (this.streamCircuit !== StreamCircuits.AQUEOUS) {
            throw new Error('Cannot call this function from non-pls stream.');
        }
        var newBleed = new BleedStream({
            streamType: StreamTypes.BLEED,
            streamCircuit: StreamCircuits.AQUEOUS,
        });
        newBleed.setStageFrom(this.fromStage);
        newBleed.setParentStream(this);
        this.addChildStream(newBleed);
        this.circuit.addStream(newBleed);
        this.findFamily();
    };
    /**
     * Converts this continue stream into a skip stream.
     */
    ContinueStream.prototype.convertToPLSSkipStream = function (selectedSkipStage) {
        if (this.streamCircuit !== StreamCircuits.AQUEOUS) {
            throw new Error('Cannot call this function from non-pls stream.');
        }
        // Delete the continue stream between selected skip stage and the next stage.
        selectedSkipStage.xpStreams.forEach(function (xpStream) {
            xpStream.__removeSelf();
        });
        // Make the new Skip
        // NOTE: We must pass through the circuit to resolve
        // a circular dependency in the imports of continue/skips
        // because skip streams imports the continue stream.
        var newSkip = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.SKIP,
            streamCircuit: StreamCircuits.AQUEOUS,
        });
        newSkip.setStageTo(this.toStage);
        newSkip.setStageFrom(selectedSkipStage);
        // Make the new feed
        var stageAfterSkip = selectedSkipStage.getNextPhysicalStage();
        if (!stageAfterSkip) {
            throw new Error('Continue stream could not be converted to PLS Skip stream, the selectedSkipStage does not have a next stage.');
        }
        var newFeed = new FeedStream({
            streamType: StreamTypes.FEED,
            streamCircuit: StreamCircuits.AQUEOUS,
        });
        newFeed.setStageTo(stageAfterSkip);
        // Make the new bleed
        var newBleed = new BleedStream({
            streamType: StreamTypes.BLEED,
            streamCircuit: StreamCircuits.AQUEOUS,
        });
        newBleed.setStageFrom(this.fromStage);
        // Set the stream family
        newBleed.addSibling(newSkip);
        newSkip.addSibling(newBleed);
        newFeed.addSibling(newSkip);
        newSkip.addSibling(newFeed);
        // Update circuit
        this.circuit.addStream(newBleed);
        this.circuit.addStream(newFeed);
        this.circuit.addStream(newSkip);
        this.__removeSelf();
    };
    /**
     * Convert this continue stream into a new feed configuration.
     */
    ContinueStream.prototype.convertToElectrolyteNewFeed = function () {
        if (this.streamCircuit !== StreamCircuits.ELECTROLYTE) {
            throw new Error('Cannot call this function from non electrolyte stream.');
        }
        var newFeed = new FeedStream({
            streamType: StreamTypes.FEED,
            streamCircuit: StreamCircuits.ELECTROLYTE,
        });
        newFeed.setStageTo(this.toStage);
        var newBleed = new BleedStream({
            streamType: StreamTypes.BLEED,
            streamCircuit: StreamCircuits.ELECTROLYTE,
        });
        newBleed.setStageFrom(this.fromStage);
        newFeed.addSibling(newBleed);
        newBleed.addSibling(newFeed);
        this.circuit.addStream(newFeed);
        this.circuit.addStream(newBleed);
        this.__removeSelf();
    };
    /**
     * Converts this organic continue stream in the PLS section
     * into an organic bypass
     */
    ContinueStream.prototype.convertToOrganicInPLSBypass = function () {
        if (this.streamCircuit !== StreamCircuits.ORGANIC) {
            throw new Error('Cannot call this function from non organic stream.');
        }
        if (this.getSectionType() !== StreamCircuits.AQUEOUS) {
            throw new Error('Cannot call this function from non extract section.');
        }
        var stripStages = this.circuit.getStrippers();
        if (stripStages.length === 0) {
            throw new Error('Cannot select organic bypassing without strip stages.');
        }
        var bypassFeed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.BYPASS_FEED,
            streamCircuit: StreamCircuits.ORGANIC,
        });
        bypassFeed.setStageFrom(stripStages[stripStages.length - 1]);
        bypassFeed.setStageTo(this.toStage);
        var bypassBleed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.BYPASS_BLEED,
            streamCircuit: StreamCircuits.ORGANIC,
        });
        bypassBleed.setStageFrom(this.fromStage);
        bypassBleed.setStageTo(stripStages[0]);
        bypassBleed.addSibling(bypassFeed);
        bypassFeed.addSibling(bypassBleed);
        this.circuit.addStream(bypassFeed);
        this.circuit.addStream(bypassBleed);
        this.__removeSelf();
    };
    /**
     * Converts this organic continue stream in the PLS section
     * into an organic bypass blend
     */
    ContinueStream.prototype.addOrganicInPLSBypassBlend = function () {
        if (this.streamCircuit !== StreamCircuits.ORGANIC) {
            throw new Error('Cannot call this function from non organic stream.');
        }
        if (this.getSectionType() !== StreamCircuits.AQUEOUS) {
            throw new Error('Cannot call this function from non extract section.');
        }
        var stripStages = this.circuit.getStrippers();
        if (stripStages.length === 0) {
            throw new Error('Cannot select organic bypassing without strip stages.');
        }
        var newBlend = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.BYPASS_BLEND,
            streamCircuit: StreamCircuits.ORGANIC,
        });
        newBlend.setStageTo(this.toStage);
        newBlend.setStageFrom(stripStages[stripStages.length - 1]);
        newBlend.setParentStream(this);
        this.addChildStream(newBlend);
        this.circuit.addStream(newBlend);
    };
    /**
     * Converts this organic continue stream in the electrolyte section
     * into an organic bypass
     */
    ContinueStream.prototype.convertToOrganicInElectrolyteBypass = function () {
        if (this.streamCircuit !== StreamCircuits.ORGANIC) {
            throw new Error('Cannot call this function from non organic stream.');
        }
        if (this.getSectionType() !== StreamCircuits.ELECTROLYTE) {
            throw new Error('Cannot call this function from non strip section.');
        }
        var currentSection = this.fromStage.section;
        var previousSection = currentSection.getPreviousSection();
        if (!previousSection || previousSection.stages.length === 0) {
            throw new Error('Cannot select organic bypassing without stages in the previous section.');
        }
        var previousSectionStages = previousSection.stages;
        var bypassFeed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.BYPASS_FEED,
            streamCircuit: StreamCircuits.ORGANIC,
        });
        bypassFeed.setStageFrom(previousSectionStages[0]);
        bypassFeed.setStageTo(this.toStage);
        var bypassBleed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.BYPASS_BLEED,
            streamCircuit: StreamCircuits.ORGANIC,
        });
        bypassBleed.setStageFrom(this.fromStage);
        bypassBleed.setStageTo(previousSectionStages[previousSectionStages.length - 1]);
        bypassBleed.addSibling(bypassFeed);
        bypassFeed.addSibling(bypassBleed);
        this.circuit.addStream(bypassFeed);
        this.circuit.addStream(bypassBleed);
        this.__removeSelf();
    };
    return ContinueStream;
}(MimicStream));

var SkipStream = /** @class */ (function (_super) {
    __extends$2(SkipStream, _super);
    function SkipStream() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRemove = function () {

            var feedSibling = _this.findFeedSibling();
            if (!feedSibling) {
                throw new Error('Skip streams must have a feed sibling.');
            }
            var bleedSibling = _this.findBleedSibling();
            if (!bleedSibling) {
                throw new Error('Skip streams must have a bleed sibling.');
            }

            if (feedSibling) {
                var continueFromFromStage = new ContinueStream({
                    streamType: StreamTypes.CONTINUE,
                    streamCircuit: StreamCircuits.AQUEOUS,
                });
                continueFromFromStage.setStageFrom(_this.fromStage);
                continueFromFromStage.setStageTo(feedSibling.toStage);
                _this.circuit.addStream(continueFromFromStage);

            }


            if (bleedSibling) {
                const continueToStage = new ContinueStream({
                    streamType: StreamTypes.CONTINUE,
                    streamCircuit: StreamCircuits.AQUEOUS,
                });
                continueToStage.setStageFrom(bleedSibling.fromStage);
                continueToStage.setStageTo(this.toStage);
                this.circuit.__addStream(continueToStage);
            }


            __spreadArray$1([], _this.siblings, true).forEach(function (sibling) {
                sibling.__removeSelf();
            });
            _this.__removeSelf();
        };
        return _this;
    }
    /**
     * Returns an array of stages that can have a skip coming out of it and going to the provided toStage
     * @toStage the stage the skip stream will enter
     * @returns array of possible source stages for the skip stream
     */
    SkipStream.getAllPossibleStagesFrom = function (toStage) {
        // it is impossible to add a skip stream on the first two stages, at least one stage must be skipped.
        if (toStage.location <= 2) {
            return [];
        }
        // Get all extract stages that come before the stage at provided location
        // A skip stream can only be added from previous stages to the toStage
        var priorExtractors = toStage.circuit
            .getExtractors()
            .filter(function (stage) { return stage.location < toStage.location - 1; });
        // Find all extractors that can be skipped from.
        // Starting at the last stage before our toStage
        var stagesForSkipLocations = priorExtractors.filter(function (stage) {
            // Make sure that the potential stage does not have a complex continue already configured.
            var continueStream = stage.getOutgoingAqueousStreamOfType(StreamTypes.CONTINUE);
            if (!continueStream) {
                // if the stage that we're at does not have a continue stream going out of it,
                // check if it has a bleed stream with no parent stream
                const bleedStream = stage.getOutgoingAqueousStreamOfType(StreamTypes.BLEED);
                if (bleedStream && !bleedStream.parentStream) {
                    return true;
                }
                // then it is not a candidate to be a skip source (it already has a configured feed or skip stream)
                return false;
            }
            if (continueStream.children.length > 0) {
                // Any continue stream that has children (a bleed or blend stream connected to it), makes the
                // stage a non-candidate for the potential skip stream.
                return false;
            }
            return true;
        });
        return stagesForSkipLocations;
    };
    /**
     * Skip streams can be nested; a skip stream can be within another skip stream.
     * This function returns the count of skip streams above itself.
     * @returns the number of skip streams nested by this skip
     */
    SkipStream.prototype.getSkipStreamCountBelow = function () {
        var stagesBetweenSelf = this.circuit.getStagesBetween(this.fromStage, this.toStage);
        var nestedSkips = 0;
        var openSkipCount = 0;
        stagesBetweenSelf.forEach(function (stage, idx) {
            var outgoingSkip = stage.getOutgoingAqueousStreamOfType(StreamTypes.SKIP);
            var incomingSkip = stage.getIncomingAqueousStreamOfType(StreamTypes.SKIP);
            if (outgoingSkip && idx !== stagesBetweenSelf.length - 1) {
                openSkipCount += 1;
            }
            if (incomingSkip && idx !== 0) {
                openSkipCount -= 1;
            }
            if (openSkipCount > nestedSkips) {
                nestedSkips = openSkipCount;
            }
        });
        return nestedSkips;
    };
    /**
     * Skip streams are always labeled in setup mode.
     */
    SkipStream.prototype.isLabeled = function () {
        return this.circuit.mode === DIAGRAM_DISPLAY_MODES.SETUP;
    };
    /**
     * If the stream is a Skip coming from a continue stream,
     * that means it has a parent, and that the stream label must be Skip.
     * If it doesn't have a continue stream, then it is a raffinate.
     */
    SkipStream.prototype.getLabel = function () {
        return STREAM_LABELS.SKIP;
    };
    /**
     * Skip streams are always removable.
     */
    SkipStream.prototype.isRemovable = function () {
        return true;
    };
    /**
     * A skip stream can be edited if it has no children yet.
     * @returns whether the skip stream can be edited
     */
    SkipStream.prototype.isEditable = function () {
        return this.children.length === 0;
    };
    /**
     * @returns the feed stream to the next stage of the fromStage.
     */
    SkipStream.prototype.findFeedSibling = function () {
        var afterFromStage = this.fromStage.getNextPhysicalStage();
        if (!afterFromStage) {
            throw new Error('Skip streams must have a previous physical stage...');
        }
        return afterFromStage.getIncomingAqueousStreamOfType(StreamTypes.FEED);
    };
    /**
     * @returns the bleed stream from the next stage of the fromStage.
     */
    SkipStream.prototype.findBleedSibling = function () {
        var beforeToStage = this.toStage.getPreviousPhysicalStage();
        if (!beforeToStage) {
            throw new Error('Skip streams must have a next physical stage...');
        }
        return beforeToStage.getOutgoingAqueousStreamOfType(StreamTypes.BLEED);
    };
    /**
     * The siblings of skip streams are:
     *  - the PLS feed in the next stage of the fromStage
     *  - the PLS bleed in the previous stage of the toStage.
     */
    SkipStream.prototype.findSiblings = function () {
        return [this.findFeedSibling(), this.findBleedSibling()].filter(Boolean);
    };
    /**
     * The children of skip streams are:
     *  - a potential blend stream to the toStage
     *  - a potential bleed stream from the fromStage
     */
    SkipStream.prototype.findChildren = function () {
        return [_super.prototype.findPLSBlendChild.call(this), _super.prototype.findPLSBleedChild.call(this)].filter(Boolean);
    };
    /**
     * Overrides the base method because skips cannot be converted to skip streams.
     */
    SkipStream.prototype.convertToPLSSkipStream = function (selectedSkipStage) {
        throw new Error('Cannot convert a skip to another skip.');
    };
    return SkipStream;
}(ContinueStream));

var BypassBleedStream = /** @class */ (function (_super) {
    __extends$2(BypassBleedStream, _super);
    function BypassBleedStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns true if this bypass bleed will "merge" with a
     * the LO or BO streams. This will occur once for the "last" bypass bleed in the circuit
     */
    BypassBleedStream.prototype.isConnectedToLOorBOStreams = function () {
        var stage = this.fromStage;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO VERIFY
        if (!stage) {
            throw new Error('Bypass bleed does not have a from stage?');
        }
        do {
            var nextStage = null;
            if (stage.stageType === StageTypes.EXTRACT) {
                nextStage = stage.getNextPhysicalStage();
            }
            else {
                nextStage = stage.getPreviousPhysicalStage();
            }
            if (nextStage) {
                var orgBypassBleed = nextStage.getOutgoingOrganicStreamOfType(StreamTypes.BYPASS_BLEED);
                if (orgBypassBleed) {
                    return false;
                }
            }
            else {
                return true; // if we don't have a next stage it MUST be a bypass bleed edge stream.
            }
            stage = nextStage;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO VERIFY
        } while (stage !== null);
        return true;
    };
    /**
     * Bypass bleeds streams are not labeled
     */
    BypassBleedStream.prototype.isLabeled = function () {
        return false;
    };
    /**
     * Bypass bleeds streams are not removable
     * To remove them you must remove the bypass feed.
     */
    BypassBleedStream.prototype.isRemovable = function () {
        return false;
    };
    /**
     * A bypass bleeds will always have a bypass feed sibling.
     */
    BypassBleedStream.prototype.findSiblingBypassFeed = function () {
        var relatedStage;
        if (this.fromStage.isExtract()) {
            relatedStage = this.fromStage.getPreviousPhysicalStage();
        }
        else if (this.fromStage.isStrip()) {
            relatedStage = this.fromStage.getNextPhysicalStage();
        }
        if (!relatedStage) {
            return null;
        }
        return relatedStage.getIncomingOrganicStreamOfType(StreamTypes.BYPASS_FEED);
    };
    /**
     * @returns the continue stream related to this stream.
     */
    BypassBleedStream.prototype.findSiblings = function () {
        return [this.findSiblingBypassFeed()].filter(Boolean);
    };
    return BypassBleedStream;
}(ContinueStream));

var BypassBlendStream = /** @class */ (function (_super) {
    __extends$2(BypassBlendStream, _super);
    function BypassBlendStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Blend streams are always labeled
     */
    BypassBlendStream.prototype.isLabeled = function () {
        return true;
    };
    BypassBlendStream.prototype.getLabel = function () {
        return STREAM_LABELS.BYPASS_BLEND;
    };
    /**
     * Blend streams are always removable
     */
    BypassBlendStream.prototype.isRemovable = function () {
        return true;
    };
    /**
     * Bypass blends should always take up their entire column span;
     */
    BypassBlendStream.prototype.isLabelHalfWidth = function () {
        return false;
    };
    /**
     * @returns the continue stream related to this stream.
     */
    BypassBlendStream.prototype.findParent = function () {
        return this.toStage.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
    };
    return BypassBlendStream;
}(ContinueStream));

var BypassFeedStream = /** @class */ (function (_super) {
    __extends$2(BypassFeedStream, _super);
    function BypassFeedStream() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Removes self and injects
         */
        _this.onRemove = function () {
            var bleedSibling = _this.findSiblingBypassBleed();
            if (!bleedSibling) {
                throw new Error('Cannot remove a bypass feed stream without having a bypass bleed stream sibling.');
            }
            var fromStage = bleedSibling.fromStage;
            if (!fromStage) {
                throw new Error('Bleed stream without from stage is not possible.');
            }
            var newContinue = new ContinueStream({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: _this.streamCircuit,
            });
            newContinue.setStageFrom(fromStage);
            newContinue.setStageTo(_this.toStage);
            _this.circuit.addStream(newContinue);
            _this.siblings.forEach(function (sibling) {
                sibling.__removeSelf();
            });
            _this.__removeSelf();
        };
        return _this;
    }
    /**
     * Bypass feed streams are always labeled
     */
    BypassFeedStream.prototype.isLabeled = function () {
        return true;
    };
    BypassFeedStream.prototype.getLabel = function () {
        return STREAM_LABELS.BYPASS_FEED;
    };
    /**
     * Bypass feed streams are always removable
     */
    BypassFeedStream.prototype.isRemovable = function () {
        return true;
    };
    /**
     * In electrolyte, removing a bypass should trigger an update on the parallel new feed.
     */
    BypassFeedStream.prototype.findElectrolyteParallelNewFeed = function () {
        if (!this.toStage.isStrip()) {
            return null;
        }
        var previousStage = this.toStage.getPreviousPhysicalStage();
        if (!previousStage) {
            throw new Error('Bypass feeds must have a previous stage.');
        }
        var electrolyteFeed = previousStage.getIncomingAqueousStreamOfType(StreamTypes.FEED);
        return electrolyteFeed;
    };
    /**
     * A bypass feed will always have a bypass bleed sibling.
     */
    BypassFeedStream.prototype.findSiblingBypassBleed = function () {
        var relatedStage;
        if (this.toStage.isExtract()) {
            relatedStage = this.toStage.getNextPhysicalStage();
        }
        else if (this.toStage.isStrip()) {
            relatedStage = this.toStage.getPreviousPhysicalStage();
        }
        if (!relatedStage) {
            return null;
        }
        return relatedStage.getOutgoingOrganicStreamOfType(StreamTypes.BYPASS_BLEED);
    };
    /**
     * @returns the continue stream related to this stream.
     */
    BypassFeedStream.prototype.findSiblings = function () {
        return [this.findSiblingBypassBleed()].filter(Boolean);
    };
    return BypassFeedStream;
}(ContinueStream));

var MimicStage = /** @class */ (function () {
    function MimicStage(stageType, location) {
        this.id = undefined;
        this.name = '';
        this.properties = undefined;
        this.xfStreams = [];
        this.xpStreams = [];
        this.yfStreams = [];
        this.ypStreams = [];
        this.stageType = stageType;
        this.location = location;
    }
    MimicStage.prototype.getCode = function () {
        return "".concat(this.stageType.charAt(0)).concat(this.location);
    };
    MimicStage.prototype.getName = function () {
        var nameDefault = this.getCode();
        if (this.properties && this.properties.name) {
            return this.properties.name;
        }
        return nameDefault;
    };
    MimicStage.prototype.isTank = function () {
        return [StageTypes.ORGANIC_TANK].includes(this.stageType);
    };
    MimicStage.prototype.isExtract = function () {
        return this.stageType === StageTypes.EXTRACT;
    };
    MimicStage.prototype.isStrip = function () {
        return this.stageType === StageTypes.STRIP;
    };
    MimicStage.prototype.isWasher = function () {
        return this.stageType === StageTypes.WASHER;
    };
    /**
     * ======================
     * STREAM FUNCTIONS:
     * ======================
     */
    MimicStage.prototype.addIncomingAqueousStream = function (stream) {
        var inAqStreams = this.getIncomingAqueousStreams();
        if (inAqStreams.indexOf(stream) === -1) {
            inAqStreams.push(stream);
        }
    };
    MimicStage.prototype.addOutgoingAqueousStream = function (stream) {
        var outAqStreams = this.getOutgoingAqueousStreams();
        if (outAqStreams.indexOf(stream) === -1) {
            outAqStreams.push(stream);
        }
    };
    MimicStage.prototype.addIncomingOrganicStream = function (stream) {
        var inOrgStreams = this.getIncomingOrganicStreams();
        if (inOrgStreams.indexOf(stream) === -1) {
            inOrgStreams.push(stream);
        }
    };
    MimicStage.prototype.addOutgoingOrganicStream = function (stream) {
        var outOrgStreams = this.getOutgoingOrganicStreams();
        if (outOrgStreams.indexOf(stream) === -1) {
            outOrgStreams.push(stream);
        }
    };
    MimicStage.prototype.getIncomingAqueousStreams = function () {
        throw new Error('This function must be overwritten by stage concrete implementations.');
    };
    MimicStage.prototype.getIncomingOrganicStreams = function () {
        throw new Error('This function must be overwritten by stage concrete implementations.');
    };
    MimicStage.prototype.getOutgoingAqueousStreams = function () {
        throw new Error('This function must be overwritten by stage concrete implementations.');
    };
    MimicStage.prototype.getOutgoingOrganicStreams = function () {
        throw new Error('This function must be overwritten by stage concrete implementations.');
    };
    MimicStage.prototype.getIncomingOrganicStreamOfType = function (streamType) {
        var streams = this.getIncomingOrganicStreams().filter(function (stream) { return stream.streamType === streamType; });
        if (streams.length === 0) {
            return null;
        }
        return streams[0];
    };
    MimicStage.prototype.getOutgoingOrganicStreamOfType = function (streamType) {
        var streams = this.getOutgoingOrganicStreams().filter(function (stream) { return stream.streamType === streamType; });
        if (streams.length === 0) {
            return null;
        }
        return streams[0];
    };
    MimicStage.prototype.getOutgoingAqueousStreamOfType = function (streamType) {
        var streams = this.getOutgoingAqueousStreams().filter(function (stream) { return stream.streamType === streamType; });
        if (streams.length === 0) {
            return null;
        }
        return streams[0];
    };
    MimicStage.prototype.getIncomingAqueousStreamOfType = function (streamType) {
        var streams = this.getIncomingAqueousStreams().filter(function (stream) { return stream.streamType === streamType; });
        if (streams.length === 0) {
            return null;
        }
        return streams[0];
    };
    MimicStage.prototype.removeStream = function (stream) {
        var allPortsStreams = [this.xfStreams, this.xpStreams, this.yfStreams, this.ypStreams];
        allPortsStreams.forEach(function (portStreams) {
            var idx = portStreams.indexOf(stream);
            if (idx !== -1) {
                portStreams.splice(idx, 1);
            }
        });
    };
    MimicStage.prototype.__createNewAqueousFeedStream = function () {
        var streamCircuit;
        if (this.stageType === StageTypes.EXTRACT) {
            streamCircuit = StreamCircuits.AQUEOUS;
        }
        else if (this.stageType === StageTypes.STRIP) {
            streamCircuit = StreamCircuits.ELECTROLYTE;
        }
        else {
            throw new Error('Cannot create new aqueous feed stream on a non mixer-settler');
        }
        var newAqueousFeed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.FEED,
            streamCircuit: streamCircuit,
        });
        newAqueousFeed.setStageTo(this);
        this.circuit.addStream(newAqueousFeed);
    };
    MimicStage.prototype.__createNewAqueousBleedStream = function () {
        var streamCircuit;
        if (this.stageType === StageTypes.EXTRACT) {
            streamCircuit = StreamCircuits.AQUEOUS;
        }
        else if (this.stageType === StageTypes.STRIP) {
            streamCircuit = StreamCircuits.ELECTROLYTE;
        }
        else {
            throw new Error('Cannot create new aqueous feed stream on a non mixer-settler');
        }
        var newAqueousBleed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.BLEED,
            streamCircuit: streamCircuit,
        });
        newAqueousBleed.setStageFrom(this);
        this.circuit.addStream(newAqueousBleed);
    };
    MimicStage.prototype.__createNewOrganicFeedStream = function () {
        var streamCircuit = StreamCircuits.ORGANIC;
        var newOrganicFeed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.FEED,
            streamCircuit: streamCircuit,
        });
        newOrganicFeed.setStageTo(this);
        this.circuit.addStream(newOrganicFeed);
    };
    MimicStage.prototype.__createNewOrganicBleedStream = function () {
        var streamCircuit = StreamCircuits.ORGANIC;
        var newOrganicBleed = this.circuit.makeStreamFromJSON({
            streamType: StreamTypes.BLEED,
            streamCircuit: streamCircuit,
        });
        newOrganicBleed.setStageFrom(this);
        this.circuit.addStream(newOrganicBleed);
    };
    /**
     * ======================
     * STAGE FUNCTIONS:
     * ======================
     */
    /**
     * Gets the previous stage in the same section regardless of stream configuration.
     */
    MimicStage.prototype.getPreviousPhysicalStage = function () {
        if (this.location <= 1) {
            return null; // no previous stage on first location
        }
        return this.circuit.getStageByDescription(this.stageType, this.location - 1);
    };
    /**
     * Gets the next stage in the same section regardless of stream configuration.
     */
    MimicStage.prototype.getNextPhysicalStage = function () {
        if (this.location >= MAX_STAGE_COUNT) {
            return null; // no next stage on last location
        }
        return this.circuit.getStageByDescription(this.stageType, this.location + 1);
    };
    /**
     * Get the previous stage connected via the respective stream.
     * @param {boolean} viaAqueous Whether it is going through the aqueous stream or organic stream.
     */
    MimicStage.prototype.getPreviousConnectedStage = function (viaAqueous) {
        if (viaAqueous === void 0) { viaAqueous = true; }
        var incomingStreams;
        if (viaAqueous) {
            incomingStreams = this.getIncomingAqueousStreams();
        }
        else {
            incomingStreams = this.getIncomingOrganicStreams();
        }
        var incomingStream = incomingStreams.find(function (stream) {
            return Boolean(stream.fromStage);
        });
        if (!incomingStream) {
            return null;
        }
        var fromStage = incomingStream.fromStage;
        if (!fromStage) {
            return null;
        }
        if (fromStage.stageType !== this.stageType) {
            return null;
        }
        return fromStage;
    };
    /**
     * Get the next stage connected via the respective stream.
     * @param {boolean} viaAqueous Whether it is going through the aqueous stream or organic stream.
     */
    MimicStage.prototype.getNextConnectedStage = function (viaAqueous) {
        if (viaAqueous === void 0) { viaAqueous = true; }
        var outgoingStreams;
        if (viaAqueous) {
            outgoingStreams = this.getOutgoingAqueousStreams();
        }
        else {
            outgoingStreams = this.getOutgoingOrganicStreams();
        }
        var outgoingStream = outgoingStreams.find(function (stream) {
            return Boolean(stream.toStage);
        });
        if (!outgoingStream) {
            return null;
        }
        var toStage = outgoingStream.toStage;
        if (!toStage) {
            return null;
        }
        if (toStage.stageType !== this.stageType) {
            return null;
        }
        return toStage;
    };
    /**
     * Removes connectivity with other entities as well as
     * destroys any remaining linked streams.
     */
    MimicStage.prototype.__removeSelf = function () {
        this.xpStreams.forEach(function (stream) {
            stream.__removeSelf();
        });
        this.yfStreams.forEach(function (stream) {
            stream.__removeSelf();
        });
        this.xfStreams.forEach(function (stream) {
            stream.__removeSelf();
        });
        this.ypStreams.forEach(function (stream) {
            stream.__removeSelf();
        });
        this.section.__removeStage(this);
        this.circuit.__removeStage(this);
    };
    /**
     * Converts a stage entity into a JSON object of type StageDTO.
     */
    MimicStage.prototype.toJSON = function () {
        var baseData = {
            circuitId: this.circuitId,
            stageType: this.stageType,
            location: this.location,
        };
        if (this.id) {
            baseData.id = this.id;
        }
        if (this.properties) {
            baseData.properties = this.properties;
        }
        return baseData;
    };
    MimicStage.prototype.setProperties = function (newProperties) {
        this.properties = newProperties;
    };
    /**
     * Adds a link to the circuit from the stage entity.
     * @param {IMimicCircuit} circuit
     */
    MimicStage.prototype.setCircuit = function (circuit) {
        this.circuit = circuit;
        if (this.circuit.id) {
            this.circuitId = this.circuit.id;
        }
    };
    MimicStage.prototype.linkSection = function () {
        var section = this.circuit.getSectionForStageType(this.stageType);
        if (!section) {
            throw new Error('Stage does not have a section?!');
        }
        this.section = section;
    };
    return MimicStage;
}());

var ExtractStage = /** @class */ (function (_super) {
    __extends$2(ExtractStage, _super);
    function ExtractStage(location) {
        var _this = _super.call(this, StageTypes.EXTRACT, location) || this;
        _this.properties = undefined;
        return _this;
    }
    ExtractStage.fromJSON = function (data) {
        var location = data.location;
        var stage = new ExtractStage(location);
        stage.id = data.id;
        stage.properties = data.properties;
        return stage;
    };
    ExtractStage.prototype.getIncomingAqueousStreams = function () {
        return this.xfStreams;
    };
    ExtractStage.prototype.getIncomingOrganicStreams = function () {
        return this.yfStreams;
    };
    ExtractStage.prototype.getOutgoingAqueousStreams = function () {
        return this.xpStreams;
    };
    ExtractStage.prototype.getOutgoingOrganicStreams = function () {
        return this.ypStreams;
    };
    ExtractStage.prototype.create = function () {
        var previousExtractor = this.getPreviousPhysicalStage();
        if (previousExtractor) {
            this.__rerouteStreamsFromPreviousStage(previousExtractor);
        }
        else {
            this.__createNewAqueousFeedStream();
        }
        // We always create a new bleed stream in Aqueous
        this.__createNewAqueousBleedStream();
        // Convert organic streams from/to the stripping section.
        var electrolyteSection = this.circuit.getSectionForStageType(StageTypes.STRIP);
        if (electrolyteSection) {
            var lastStripper = electrolyteSection.getLastStage();
            var firstStripper = electrolyteSection.getFirstStage();
            if (!previousExtractor) {
                // Lets remove the organic feed of the first stripper
                var oldBarrenOrganic = firstStripper.getIncomingOrganicStreamOfType(StreamTypes.FEED);
                if (!oldBarrenOrganic) {
                    throw new Error('A circuit with no extractors must have a barren organic feed stream in stripping.');
                }
                var toStage = oldBarrenOrganic.toStage;
                var newBarrenOrganic = this.circuit.makeStreamFromJSON({
                    streamType: StreamTypes.CONTINUE,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newBarrenOrganic.setStageFrom(this);
                newBarrenOrganic.setStageTo(toStage);
                this.circuit.addStream(newBarrenOrganic);
                oldBarrenOrganic.__removeSelf();
                // Lets remove the organic bleed of the last stripper
                var oldLoadedOrganic = lastStripper.getOutgoingOrganicStreamOfType(StreamTypes.BLEED);
                if (!oldLoadedOrganic) {
                    throw new Error('A circuit with no extractors must have a loaded organic bleed stream in stripping.');
                }
                var fromStage = oldLoadedOrganic.fromStage;
                var newLoadedOrganic = this.circuit.makeStreamFromJSON({
                    streamType: StreamTypes.CONTINUE,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newLoadedOrganic.setStageFrom(fromStage);
                newLoadedOrganic.setStageTo(this);
                this.circuit.addStream(newLoadedOrganic);
                oldLoadedOrganic.__removeSelf();
            }
        }
        else {
            // no strip section
            if (!previousExtractor) {
                // this indicates a mimic diagram with no stages
                this.__createNewOrganicFeedStream();
                this.__createNewOrganicBleedStream();
            }
        }
    };
    ExtractStage.prototype.__rerouteStreamsFromPreviousStage = function (previousExtractor) {
        // Remove the bleed stream in the previous extractor
        // and replace it with a continue stream to this stage.
        var previousAqueousBleed = previousExtractor.getOutgoingAqueousStreamOfType(StreamTypes.BLEED);
        if (previousAqueousBleed) {
            var fromStage = previousAqueousBleed.fromStage;
            var newAqueousContinue = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: StreamCircuits.AQUEOUS,
            });
            newAqueousContinue.setStageTo(this);
            newAqueousContinue.setStageFrom(fromStage);
            this.circuit.addStream(newAqueousContinue);
            previousAqueousBleed.__removeSelf();
        }
        // Reroute the organic continue into the previous extractor.
        // This stream is the connector stream with the last stripper.
        var previousLoadedOrganicContinue = previousExtractor.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
        if (previousLoadedOrganicContinue) {
            var toStage = previousLoadedOrganicContinue.toStage;
            var newOrganicContinue = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: StreamCircuits.ORGANIC,
            });
            newOrganicContinue.setStageTo(toStage);
            newOrganicContinue.setStageFrom(this);
            this.circuit.addStream(newOrganicContinue);
            previousLoadedOrganicContinue.setStageTo(this);
            previousExtractor.removeStream(previousLoadedOrganicContinue);
        }
        // If there was no stripper, it is possible that the previous extractor
        // had an organic feed going into it. Therefore, delete it and replace it with an organic continue stream.
        var previousLoadedOrganicFeed = previousExtractor.getIncomingOrganicStreamOfType(StreamTypes.FEED);
        if (previousLoadedOrganicFeed) {
            var toStage = previousLoadedOrganicFeed.toStage;
            var newOrganicContinue = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: StreamCircuits.ORGANIC,
            });
            newOrganicContinue.setStageTo(toStage);
            newOrganicContinue.setStageFrom(this);
            this.circuit.addStream(newOrganicContinue);
            previousLoadedOrganicFeed.setStageTo(this);
        }
    };
    /**
     * Deletes the current stage from the circuit.
     * In extract we must make sure to:
     *  - convert the pls continue to a new bleed
     *  - reroute the organic connector from stripping
     *      - or add an organic feed into the previous unit
     */
    ExtractStage.prototype.delete = function () {
        var aqueousContinue = this.getIncomingAqueousStreamOfType(StreamTypes.CONTINUE);
        if (aqueousContinue) {
            var newBleed = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.BLEED,
                streamCircuit: aqueousContinue.streamCircuit,
            });
            newBleed.setStageFrom(aqueousContinue.fromStage);
            this.circuit.addStream(newBleed);
            aqueousContinue.__removeSelf();
        }
        var previousStage = this.getPreviousPhysicalStage();
        var aqueousSkip = this.getIncomingAqueousStreamOfType(StreamTypes.SKIP);
        if (aqueousSkip) {
            aqueousSkip.onRemove();
        }
        // Organic on delete
        if (previousStage) {
            // remove bypass feeds
            var bypassFeed = previousStage.getOutgoingOrganicStreamOfType(StreamTypes.BYPASS_FEED);
            if (bypassFeed) {
                // will also remove the bypass bleed from the current stage.
                bypassFeed.onRemove();
            }
            // Remove the organic bypass blend
            var bypassBlend = previousStage.getOutgoingOrganicStreamOfType(StreamTypes.BYPASS_BLEND);
            if (bypassBlend) {
                bypassBlend.onRemove();
            }
            // reroute the organic continue stream from the stripping section
            var outgoingOrganicContinue = this.getOutgoingOrganicStreamOfType(StreamTypes.CONTINUE);
            var incomingOrganicContinue = this.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
            if (incomingOrganicContinue && outgoingOrganicContinue) {
                var toStage = outgoingOrganicContinue.toStage;
                incomingOrganicContinue.setStageTo(toStage);
                // remove the references that this stage has to the incoming since we diverted it.
                this.removeStream(incomingOrganicContinue);
            }
            // If our current stage currently has an org feed,
            // then the previous stage needs one too, and we will remove ours.
            var orgFeed = this.getIncomingOrganicStreamOfType(StreamTypes.FEED);
            if (orgFeed) {
                orgFeed.setStageTo(previousStage);
                this.removeStream(orgFeed);
            }
            else if (!incomingOrganicContinue) {
                var newOrgFeed = new FeedStream({
                    streamType: StreamTypes.FEED,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newOrgFeed.setStageTo(previousStage);
                this.circuit.addStream(newOrgFeed);
            }
        }
        else {
            // there are no previous extract stages.
            // Reroute the organic continue stream
            var outgoingOrganicContinue = this.getOutgoingOrganicStreamOfType(StreamTypes.CONTINUE);
            // Outgoing organic continue in an extract stage means it comes from extract and goes to strip.
            if (outgoingOrganicContinue) {
                var toStage = outgoingOrganicContinue.toStage;
                var newOrgFeed = new FeedStream({
                    streamType: StreamTypes.FEED,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newOrgFeed.setStageTo(toStage);
                this.circuit.addStream(newOrgFeed);
            }
            var incomingOrganicContinue = this.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
            // incoming organic continue in an extract stage means it comes from strip and goes to extract.
            if (incomingOrganicContinue) {
                var fromStage = incomingOrganicContinue.fromStage;
                var newOrgBleed = new BleedStream({
                    streamType: StreamTypes.BLEED,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newOrgBleed.setStageFrom(fromStage);
                this.circuit.addStream(newOrgBleed);
            }
        }
        this.__removeSelf();
    };
    return ExtractStage;
}(MimicStage));

var StripStage = /** @class */ (function (_super) {
    __extends$2(StripStage, _super);
    function StripStage(location) {
        var _this = _super.call(this, StageTypes.STRIP, location) || this;
        _this.properties = undefined;
        return _this;
    }
    StripStage.fromJSON = function (data) {
        var location = data.location;
        var stage = new StripStage(location);
        stage.id = data.id;
        stage.properties = data.properties;
        return stage;
    };
    StripStage.prototype.getIncomingAqueousStreams = function () {
        return this.yfStreams;
    };
    StripStage.prototype.getIncomingOrganicStreams = function () {
        return this.xfStreams;
    };
    StripStage.prototype.getOutgoingAqueousStreams = function () {
        return this.ypStreams;
    };
    StripStage.prototype.getOutgoingOrganicStreams = function () {
        return this.xpStreams;
    };
    StripStage.prototype.create = function () {
        var previousStripper = this.getPreviousPhysicalStage();
        if (previousStripper) {
            this.__rerouteStreamsFromPreviousStage(previousStripper);
        }
        else {
            this.__createNewAqueousBleedStream();
        }
        // We always create a new feed stream in Aqueous
        this.__createNewAqueousFeedStream();
        // Convert organic streams from/to the stripping section.
        var plsSection = this.circuit.getSectionForStageType(StageTypes.EXTRACT);
        if (plsSection) {
            var lastExtractor = plsSection.getLastStage();
            var firstExtractor = plsSection.getFirstStage();
            if (!previousStripper) {
                // Lets remove the organic feed of the last extractor
                var oldLoadedOrganic = lastExtractor.getIncomingOrganicStreamOfType(StreamTypes.FEED);
                if (!oldLoadedOrganic) {
                    throw new Error('A circuit with no strippers must have a loaded organic feed stream in extraction.');
                }
                var toStage = oldLoadedOrganic.toStage;
                var newLoadedOrganic = this.circuit.makeStreamFromJSON({
                    streamType: StreamTypes.CONTINUE,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newLoadedOrganic.setStageFrom(this);
                newLoadedOrganic.setStageTo(toStage);
                this.circuit.addStream(newLoadedOrganic);
                oldLoadedOrganic.__removeSelf();
                // Lets remove the organic bleed of the first extractor
                var oldBarrenOrganic = firstExtractor.getOutgoingOrganicStreamOfType(StreamTypes.BLEED);
                if (!oldBarrenOrganic) {
                    throw new Error('A circuit with no strippers must have a barren organic bleed stream in extraction.');
                }
                var fromStage = oldBarrenOrganic.fromStage;
                var newBarrenOrganic = this.circuit.makeStreamFromJSON({
                    streamType: StreamTypes.CONTINUE,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newBarrenOrganic.setStageTo(this);
                newBarrenOrganic.setStageFrom(fromStage);
                this.circuit.addStream(newBarrenOrganic);
                oldBarrenOrganic.__removeSelf();
            }
        }
        else {
            // no extract section
            if (!previousStripper) {
                // this indicates a mimic diagram with no stages
                this.__createNewOrganicFeedStream();
                this.__createNewOrganicBleedStream();
            }
        }
    };
    StripStage.prototype.__rerouteStreamsFromPreviousStage = function (previousStripper) {
        // Remove the bleed stream in the previous extractor
        // and replace it with a continue stream to this stage.
        var previousAqueousFeed = previousStripper.getIncomingAqueousStreamOfType(StreamTypes.FEED);
        if (previousAqueousFeed) {
            var toStage = previousAqueousFeed.toStage;
            var newAqueousContinue = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: StreamCircuits.ELECTROLYTE,
            });
            newAqueousContinue.setStageFrom(this);
            newAqueousContinue.setStageTo(toStage);
            this.circuit.addStream(newAqueousContinue);
            previousAqueousFeed.__removeSelf();
        }
        // Reroute the organic continue into the previous extractor.
        // This stream is the connector stream with the last stripper.
        var previousLoadedOrganicContinue = previousStripper.getOutgoingOrganicStreamOfType(StreamTypes.CONTINUE);
        if (previousLoadedOrganicContinue) {
            var fromStage = previousLoadedOrganicContinue.fromStage;
            var newOrganicContinue = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: StreamCircuits.ORGANIC,
            });
            newOrganicContinue.setStageFrom(fromStage);
            newOrganicContinue.setStageTo(this);
            this.circuit.addStream(newOrganicContinue);
            previousLoadedOrganicContinue.setStageFrom(this);
            previousStripper.removeStream(previousLoadedOrganicContinue);
        }
        // If there was no stripper, it is possible that the previous stripper
        // had an organic bleed leaving it. Therefore, delete it and replace it with an organic continue stream.
        var previousLoadedOrganicBleed = previousStripper.getOutgoingOrganicStreamOfType(StreamTypes.BLEED);
        if (previousLoadedOrganicBleed) {
            var fromStage = previousLoadedOrganicBleed.fromStage;
            var newOrganicContinue = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.CONTINUE,
                streamCircuit: StreamCircuits.ORGANIC,
            });
            newOrganicContinue.setStageTo(this);
            newOrganicContinue.setStageFrom(fromStage);
            this.circuit.addStream(newOrganicContinue);
            previousLoadedOrganicBleed.setStageFrom(this);
        }
    };
    /**
     * Deletes the current stage from the circuit.
     * In strip we must make sure to:
     *  - convert the electrolyte continue into a new feed
     *  - reroute the organic connector from extraction
     *      - or add an organic feed into the previous unit
     */
    StripStage.prototype.delete = function () {
        var aqueousContinue = this.getOutgoingAqueousStreamOfType(StreamTypes.CONTINUE);
        if (aqueousContinue) {
            var newFeed = this.circuit.makeStreamFromJSON({
                streamType: StreamTypes.FEED,
                streamCircuit: aqueousContinue.streamCircuit,
            });
            newFeed.setStageTo(aqueousContinue.toStage);
            this.circuit.addStream(newFeed);
            aqueousContinue.__removeSelf();
        }
        // Organic on delete
        var previousStage = this.getPreviousPhysicalStage();
        if (previousStage) {
            // remove bypass feeds
            var bypassFeed = previousStage.getOutgoingOrganicStreamOfType(StreamTypes.BYPASS_FEED);
            if (bypassFeed) {
                // will also remove the bypass bleed from the current stage.
                bypassFeed.onRemove();
            }
            // reroute the organic continue stream to the extraction section
            var incomingOrganicContinue = this.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
            var loadedOrganicContinue = this.getOutgoingOrganicStreamOfType(StreamTypes.CONTINUE);
            if (incomingOrganicContinue && loadedOrganicContinue) {
                // we have both an in and out org continue,
                // so we need to divert the incoming continue to the outgoing stream's to stage.
                var toStage = loadedOrganicContinue.toStage;
                incomingOrganicContinue.setStageTo(toStage);
                // remove the references that this stage has to the incoming since we diverted it.
                this.removeStream(incomingOrganicContinue);
            }
            // If our current stage currently has an org feed,
            // then the previous stage needs one too, and we will remove ours.
            var orgBleed = this.getOutgoingOrganicStreamOfType(StreamTypes.BLEED);
            if (orgBleed) {
                orgBleed.setStageFrom(previousStage);
                this.removeStream(orgBleed);
            }
            else if (!loadedOrganicContinue) {
                var newLoadedOrgBleed = new BleedStream({
                    streamType: StreamTypes.BLEED,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newLoadedOrgBleed.setStageFrom(previousStage);
                this.circuit.addStream(newLoadedOrgBleed);
            }
        }
        else {
            // there are no previous strip stages.
            // Reroute the organic continue stream
            var loadedOrganicContinue = this.getOutgoingOrganicStreamOfType(StreamTypes.CONTINUE);
            // Outgoing organic continue in an strip stage means it comes from strip and goes to extract.
            if (loadedOrganicContinue) {
                var toStage = loadedOrganicContinue.toStage;
                // Lets make a new feed for the extract stage.
                var newLoadedOrgFeed = new FeedStream({
                    streamType: StreamTypes.FEED,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newLoadedOrgFeed.setStageTo(toStage);
                this.circuit.addStream(newLoadedOrgFeed);
            }
            var barrenOrganicContinue = this.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
            // incoming organic continue in an strip stage means it comes from extract and goes to strip.
            if (barrenOrganicContinue) {
                var fromStage = barrenOrganicContinue.fromStage;
                var newBarrenOrgBleed = new BleedStream({
                    streamType: StreamTypes.BLEED,
                    streamCircuit: StreamCircuits.ORGANIC,
                });
                newBarrenOrgBleed.setStageFrom(fromStage);
                this.circuit.addStream(newBarrenOrgBleed);
            }
        }
        this.__removeSelf();
    };
    return StripStage;
}(MimicStage));

function StageSortComparator(aStage, bStage) {
    return aStage.location - bStage.location;
}

var LoadedOrganicTank = /** @class */ (function (_super) {
    __extends$2(LoadedOrganicTank, _super);
    function LoadedOrganicTank(location) {
        var _this = _super.call(this, StageTypes.ORGANIC_TANK, location) || this;
        _this.properties = undefined;
        return _this;
    }
    LoadedOrganicTank.fromJSON = function (data) {
        var location = data.location;
        var stage = new LoadedOrganicTank(location);
        stage.id = data.id;
        stage.properties = data.properties;
        return stage;
    };
    LoadedOrganicTank.prototype.getCode = function () {
        return "".concat(this.stageType.substring(0, 2), " TK").concat(this.location);
    };
    LoadedOrganicTank.prototype.getFirstConnectedFromStage = function () {
        // Tanks are not positioned relative to each other,
        // they are relative to the first connected stage
        var fromStages = this.yfStreams
            .map(function (yfStream) { return yfStream.fromStage; })
            .filter(Boolean); // remove nulls
        var sorted = fromStages.sort(StageSortComparator); // sort based on stages.
        if (sorted.length === 0) {
            throw new Error('Loaded organic tank without any from stages...');
        }
        return sorted[0];
    };
    LoadedOrganicTank.prototype.getFirstConnectedToExtractor = function () {
        // Tanks are not positioned relative to each other,
        // they are relative to the first connected stage
        var toStages = this.ypStreams
            .map(function (ypStream) { return ypStream.toStage; })
            .filter(Boolean) // remove nulls
            .sort(StageSortComparator); // sort based on stages.
        if (toStages.length === 0) {
            throw new Error('Loaded organic tank without any extract stages...');
        }
        return toStages[toStages.length - 1];
    };
    LoadedOrganicTank.prototype.getFirstConnectedStripper = function () {
        // Tanks are not positioned relative to each other,
        // they are relative to the first connected stage
        var stripStages = this.ypStreams
            .filter(function (ypStream) { return ypStream.streamType !== StreamTypes.BYPASS_BLEED; })
            .map(function (ypStream) { return ypStream.toStage; })
            .filter(Boolean) // remove nulls
            .sort(StageSortComparator); // sort based on stages.
        if (stripStages.length === 0) {
            throw new Error('Loaded organic tank without any strip stages...');
        }
        return stripStages[0];
    };
    LoadedOrganicTank.prototype.getIncomingAqueousStreams = function () {
        throw new Error('Loaded organic tanks do not have aqueous streams.');
    };
    LoadedOrganicTank.prototype.getIncomingOrganicStreams = function () {
        return this.yfStreams;
    };
    LoadedOrganicTank.prototype.getOutgoingAqueousStreams = function () {
        throw new Error('Loaded organic tanks do not have aqueous streams.');
    };
    LoadedOrganicTank.prototype.getOutgoingOrganicStreams = function () {
        return this.ypStreams;
    };
    LoadedOrganicTank.prototype.create = function () {
        throw new Error('Cannot create loaded organic tanks.');
    };
    LoadedOrganicTank.prototype.delete = function () {
        throw new Error('Cannot delete loaded organic tanks.');
    };
    return LoadedOrganicTank;
}(MimicStage));

var Washer = /** @class */ (function (_super) {
    __extends$2(Washer, _super);
    function Washer(location) {
        var _this = _super.call(this, StageTypes.WASHER, location) || this;
        _this.properties = undefined;
        return _this;
    }
    Washer.fromJSON = function (data) {
        var location = data.location;
        var stage = new Washer(location);
        stage.id = data.id;
        stage.properties = data.properties;
        return stage;
    };
    Washer.prototype.getCode = function () {
        return "W".concat(this.location);
    };
    Washer.prototype.getLastConnectedToStage = function () {
        // Washers are not positioned relative to each other,
        // they are relative to the first connected stage
        var stages = this.ypStreams
            .map(function (ypStream) { return ypStream.toStage; })
            .filter(Boolean) // remove nulls
            .sort(StageSortComparator) // sort based on stages.
            .reverse();
        if (stages.length === 0) {
            throw new Error('Washer without any to stages...');
        }
        return stages[0];
    };
    Washer.prototype.getFirstConnectedToStage = function () {
        // Washers are not positioned relative to each other,
        // they are relative to the first connected stage
        var stages = this.ypStreams
            .map(function (ypStream) { return ypStream.toStage; })
            .filter(Boolean) // remove nulls
            .sort(StageSortComparator) // sort based on stages.
            .reverse();
        if (stages.length === 0) {
            throw new Error('Washer without any to stages...');
        }
        return stages[stages.length - 1];
    };
    Washer.prototype.getFirstConnectedFromStage = function () {
        // Tanks are not positioned relative to each other,
        // they are relative to the first connected stage
        var stages = this.yfStreams
            .map(function (yfStream) { return yfStream.fromStage; })
            .filter(Boolean) // remove nulls
            .sort(StageSortComparator); // sort based on stages.
        if (stages.length === 0) {
            throw new Error('Washer without any from stages...');
        }
        return stages[0];
    };
    Washer.prototype.getLastConnectedFromStage = function () {
        // Tanks are not positioned relative to each other,
        // they are relative to the first connected stage
        var stages = this.yfStreams
            .map(function (yfStream) { return yfStream.fromStage; })
            .filter(Boolean) // remove nulls
            .sort(StageSortComparator); // sort based on stages.
        if (stages.length === 0) {
            throw new Error('Washer without any from stages...');
        }
        return stages[stages.length - 1];
    };
    Washer.prototype.getIncomingAqueousStreams = function () {
        throw new Error('Washers do not have aqueous streams.');
    };
    Washer.prototype.getIncomingOrganicStreams = function () {
        return this.yfStreams;
    };
    Washer.prototype.getOutgoingAqueousStreams = function () {
        throw new Error('Washers do not have aqueous streams.');
    };
    Washer.prototype.getOutgoingOrganicStreams = function () {
        return this.ypStreams;
    };
    Washer.prototype.create = function () {
        throw new Error('Cannot create washers.');
    };
    Washer.prototype.delete = function () {
        throw new Error('Cannot delete washers.');
    };
    return Washer;
}(MimicStage));

var MimicSection = /** @class */ (function () {
    function MimicSection(sectionType, circuit) {
        this.stages = [];
        this.sectionType = sectionType;
        this.circuit = circuit;
    }
    MimicSection.prototype.linkStages = function () {
        this.stages = this.circuit.getStagesBySectionType(this.sectionType);
    };
    MimicSection.prototype.getFirstStage = function () {
        if (this.stages.length === 0) {
            throw new Error('Section was not properly instantiated. No stages in section.');
        }
        return this.stages[0];
    };
    MimicSection.prototype.getLastStage = function () {
        if (this.stages.length === 0) {
            throw new Error('Section was not properly instantiated. No stages in section.');
        }
        return this.stages[this.stages.length - 1];
    };
    MimicSection.prototype.getLastStageLocation = function () {
        return this.getLastStage().location;
    };
    MimicSection.prototype.getPreviousSection = function () {
        var idx = this.circuit.sections.indexOf(this);
        if (idx === -1) {
            throw new Error('Section not added to circuit!?');
        }
        if (idx === 0) {
            return null;
        }
        return this.circuit.sections[idx - 1];
    };
    MimicSection.prototype.linkStage = function (stage) {
        var idx = this.stages.indexOf(stage);
        if (idx === -1) {
            this.stages.push(stage);
            stage.linkSection();
        }
    };
    MimicSection.prototype.__removeStage = function (stage) {
        var idx = this.stages.indexOf(stage);
        if (idx !== -1) {
            this.stages.splice(idx, 1);
            if (this.stages.length === 0) {
                this.circuit.__removeSection(this);
            }
        }
    };
    MimicSection.prototype.hasBypassingStreams = function () {
        var _this = this;
        var bypassStream = this.circuit.streams.find(function (stream) {
            var _a;
            if (stream.streamType === StreamTypes.BYPASS_FEED ||
                stream.streamType === StreamTypes.BYPASS_BLEND) {
                return ((_a = stream.toStage) === null || _a === void 0 ? void 0 : _a.section.sectionType) === _this.sectionType;
            }
            return false;
        });
        return Boolean(bypassStream);
    };
    return MimicSection;
}());

var MimicExtractSection = /** @class */ (function (_super) {
    __extends$2(MimicExtractSection, _super);
    function MimicExtractSection(circuit) {
        return _super.call(this, StreamCircuits.AQUEOUS, circuit) || this;
    }
    MimicExtractSection.prototype.getPreviousSection = function () {
        return null;
    };
    /**
     * Calculates and returns the starting row position of all extract stages in the section.
     * Handles both setup and compute modes.
     *
     * @param {*} grid : ;
     * @param {*} streamValues All stream values on the dataset
     * @returns The starting row of the extraction section in the Mimic Diagram grid
     */
    MimicExtractSection.prototype.getStartingRow = function (grid, streamValues) {
        if (streamValues === void 0) { streamValues = []; }
        var nestedSkips = this.getNestedSkipStreamCount();
        if (this.circuit.mode === DIAGRAM_DISPLAY_MODES.SETUP) {
            // @ts-expect-error -- todo
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- todo
            var stageStartingRow = grid.STAGE.STARTING_ROW;
            // @ts-expect-error -- todo
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- todo
            stageStartingRow += grid.SKIP.TOP_OFFSET * nestedSkips;
            if (this.hasAdvancedStreams()) {
                stageStartingRow += 1;
            }
            return stageStartingRow;
        }
        // else: compute mode.
        var maximumStreamValuesOnAllExtractorAqueousStreams = this.stages.map(function (stage) {
            var plsBleed = stage.getOutgoingAqueousStreamOfType(StreamTypes.BLEED);
            var plsFeed = stage.getIncomingAqueousStreamOfType(StreamTypes.FEED);
            var plsBlend = stage.getIncomingAqueousStreamOfType(StreamTypes.BLEND);
            // get all non-null feed,blend, or bleed streams on the mimic stage.
            // @ts-expect-error -- we are checking for null with Boolean call
            var nonNullStreams = [plsBleed, plsFeed, plsBlend].filter(Boolean);
            // Count the amount of stream values provided for each stream on the stage
            var streamValueCountForEachStreams = nonNullStreams.map(function (stream) {
                // First filter for stream values that matches our feed/blend/bleed stream
                return streamValues.filter(function (streamValue) { return streamValue.streamId === stream.id; }).length;
            });
            return Math.max.apply(Math, streamValueCountForEachStreams); // only return the maximum amount of stream values on the stream.
        });
        var overallStreamValueCount = 0;
        if (maximumStreamValuesOnAllExtractorAqueousStreams.length > 0) {
            overallStreamValueCount =
                1 + Math.max.apply(Math, maximumStreamValuesOnAllExtractorAqueousStreams);
        }
        // @ts-expect-error -- todo
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- todo
        var skipStreamsOffset = nestedSkips * grid.SKIP.TOP_OFFSET;
        return overallStreamValueCount + skipStreamsOffset;
    };
    /**
     * Calculates the number of skip streams in the Y axis of the mimic diagram.
     * @returns the amount of nested skip streams
     */
    MimicExtractSection.prototype.getNestedSkipStreamCount = function () {
        // Get all skip streams
        var skipStreams = this.circuit.streams.filter(function (stream) { return stream.streamType === StreamTypes.SKIP; });
        // for each skip stream, find the amount of skips below them
        var skipStreamNestedCounts = skipStreams.map(function (stream) {
            return stream.getSkipStreamCountBelow();
        });
        if (skipStreamNestedCounts.length === 0) {
            return 0;
        }
        // return the highest skip stream nested depth
        return Math.max.apply(Math, skipStreamNestedCounts);
    };
    MimicExtractSection.prototype.hasSkipStreams = function () {
        var skipStream = this.circuit.streams.find(function (stream) { return stream.streamType === StreamTypes.SKIP; });
        return Boolean(skipStream);
    };
    MimicExtractSection.prototype.hasAdvancedStreams = function () {
        var _this = this;
        var firstAdvancedStream = this.stages.find(function (stage) {
            var _a;
            var feedStream = stage.location !== 1
                ? stage.getIncomingAqueousStreamOfType(StreamTypes.FEED)
                : null;
            var blendStream = stage.getIncomingAqueousStreamOfType(StreamTypes.BLEND);
            var bleedStream = stage.location !== _this.getLastStageLocation()
                ? stage.getOutgoingAqueousStreamOfType(StreamTypes.BLEED)
                : null;
            return (_a = feedStream !== null && feedStream !== void 0 ? feedStream : blendStream) !== null && _a !== void 0 ? _a : bleedStream;
        });
        return Boolean(firstAdvancedStream);
    };
    return MimicExtractSection;
}(MimicSection));

var MimicStripSection = /** @class */ (function (_super) {
    __extends$2(MimicStripSection, _super);
    function MimicStripSection(circuit) {
        return _super.call(this, StreamCircuits.ELECTROLYTE, circuit) || this;
    }
    return MimicStripSection;
}(MimicSection));

var MimicOrganicSection = /** @class */ (function (_super) {
    __extends$2(MimicOrganicSection, _super);
    function MimicOrganicSection(circuit) {
        return _super.call(this, StreamCircuits.ORGANIC, circuit) || this;
    }
    MimicOrganicSection.prototype.getBarrenOrganicStream = function () {
        var boStream = null;
        var stripStages = this.circuit.getStrippers();
        var extractStages = this.circuit.getExtractors();
        if (stripStages.length > 0) {
            var lastStripper = stripStages[stripStages.length - 1];
            boStream = lastStripper.getOutgoingOrganicStreamOfType(StreamTypes.CONTINUE);
        }
        else {
            if (extractStages.length === 0) {
                throw new Error('Circuit does not have extract nor strip stages?');
            }
            // no extractors, only strippers
            var lastExtractor = extractStages[extractStages.length - 1];
            boStream = lastExtractor.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
        }
        if (!boStream) {
            throw new Error('Circuit does not have a Barren Organic stream?');
        }
        return boStream;
    };
    MimicOrganicSection.prototype.getLoadedOrganicStream = function () {
        var loStream = null;
        var stripStages = this.circuit.getStrippers();
        var extractStages = this.circuit.getExtractors();
        if (extractStages.length > 0) {
            var firstExtractor = extractStages[0];
            loStream = firstExtractor.getOutgoingOrganicStreamOfType(StreamTypes.CONTINUE);
        }
        else {
            if (stripStages.length === 0) {
                throw new Error('Circuit does not have extract nor strip stages?');
            }
            var firstStripper = stripStages[0];
            loStream = firstStripper.getIncomingOrganicStreamOfType(StreamTypes.CONTINUE);
        }
        if (!loStream) {
            throw new Error('Circuit does not have a Loaded Organic stream?');
        }
        return loStream;
    };
    return MimicOrganicSection;
}(MimicSection));

/**
 * A cascade is a list of stages that are connected via the aqueous stream
 * Cascades starts at the feed stream, and are broken when a blend enters.
 * A new cascade is started when a feed stream is encountered, and the previous cascade is ended.
 */
var MimicCascade = /** @class */ (function () {
    function MimicCascade(circuit, stages, cascadeLocation) {
        this.id = Math.random();
        if (!circuit.id) {
            throw new Error('[MimicCascade] Circuit provided to constructor must have a circuit ID.');
        }
        this.circuitId = circuit.id;
        this.stages = stages;
        this.type = stages[0].stageType;
        this.location = cascadeLocation;
    }
    MimicCascade.getCascades = function (circuit, stageType) {
        var stages = circuit.getStagesByType(stageType);
        if (stageType === StageTypes.STRIP) {
            stages = stages.reverse();
        }
        var unProcessed = __spreadArray$1([], stages, true);
        var cascades = [];
        var cascadeLocation = 0;
        var currentCascade = [];
        while (unProcessed.length !== 0) {
            var startStage = unProcessed[0];
            unProcessed.splice(0, 1);
            currentCascade.push(startStage);
            var nextStage = startStage;
            do {
                nextStage = nextStage.getNextConnectedStage();
                if (!nextStage) {
                    break;
                }
                var incomingAqFeed = nextStage.getIncomingAqueousStreamOfType(StreamTypes.FEED);
                var incomingAqBlend = nextStage.getIncomingAqueousStreamOfType(StreamTypes.BLEND);
                if (incomingAqFeed || incomingAqBlend) {
                    break;
                }
                var idx = unProcessed.indexOf(nextStage);
                unProcessed.splice(idx, 1);
                currentCascade.push(nextStage);
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- ?
            } while (nextStage !== null);
            cascadeLocation++;
            cascades.push(new MimicCascade(circuit, currentCascade, cascadeLocation));
            currentCascade = [];
        }
        if (stageType === StageTypes.STRIP) {
            return cascades.reverse();
        }
        return cascades;
    };
    MimicCascade.prototype.setIsotherm = function (isotherm) {
        this.isotherm = isotherm;
    };
    /**
     * The cascade description returns an array of arrays.
     * Ex: [[E1, E5], [E7,E10]]
     * Would be the cascade description representation of a circuit that:
     * E1 to E5 are connected via continuous Aqueous Streams
     * E5 and E7 is connected by a skip stream
     * E7 to E10 is connected via continuous Aqueous Streams
     * The resulting cascade description is then typically rendered as:
     * E1->E5, E7->E10
     */
    MimicCascade.prototype.getDescription = function () {
        var cascadeDescription = [];
        var previousLocation = this.stages[0].location;
        var currentDescription = [this.stages[0]];
        for (var i = 1; i < this.stages.length; i++) {
            var currentStage = this.stages[i];
            var currentLocation = currentStage.location;
            var locationCheckModifier = -1;
            if (this.type === StageTypes.STRIP) {
                locationCheckModifier = 1;
            }
            if (currentLocation + locationCheckModifier !== previousLocation) {
                cascadeDescription.push(currentDescription);
                currentDescription = [currentStage];
            }
            else {
                currentDescription[1] = currentStage;
            }
            previousLocation = currentLocation;
        }
        cascadeDescription.push(currentDescription);
        return cascadeDescription;
    };
    MimicCascade.prototype.toJson = function () {
        return {
            circuitId: this.circuitId,
            location: this.location,
            type: this.type,
            stages: this.stages.map(function (stage) { return stage.toJSON(); }),
        };
    };
    return MimicCascade;
}());

var WASH_POSITIONS = {
    ETS: 'ETS',
    STE: 'STE',
};
var WASH_POSITIONS_TO_LOCATION = {
    ETS: 1,
    STE: 2,
};

var MimicCircuit = /** @class */ (function () {
    function MimicCircuit(data) {
        var _this = this;
        this.__uniqueId = Math.random();
        this.stages = [];
        this.streams = [];
        this.sections = [];
        Object.assign(this, data);
        this.id = data.id;
        this.mode = DIAGRAM_DISPLAY_MODES.SETUP;
        this.stages = data.stages.map(function (stageData) { return _this.makeStageFromJSON(stageData); });
        this.initSections();
        this.linkStages();
        this.streams = data.streams.map(function (streamData) {
            return _this.makeStreamFromJSON(streamData);
        });
        this.linkStreams();
    }
    MimicCircuit.prototype.setMode = function (mode) {
        this.mode = mode;
    };
    MimicCircuit.prototype.initSections = function () {
        var sections = [];
        // extract must be before organic.
        if (this.getExtractors().length > 0) {
            var section = new MimicExtractSection(this);
            sections.push(section);
        }
        if (this.getTanks().length > 0 || this.getWashers().length > 0) {
            // organic must always be between extract and strip
            var section = new MimicOrganicSection(this);
            sections.push(section);
        }
        if (this.getStrippers().length > 0) {
            // strip must be last.
            var section = new MimicStripSection(this);
            sections.push(section);
        }
        this.sections = sections;
        this.sections.forEach(function (section) {
            section.linkStages();
        });
    };
    MimicCircuit.prototype.__removeSection = function (section) {
        if (section.stages.length !== 0) {
            throw new Error('Cannot remove section without removing all stages first.');
        }
        var idx = this.sections.indexOf(section);
        if (idx !== -1) {
            this.sections.splice(idx, 1);
        }
    };
    MimicCircuit.prototype.linkStages = function () {
        var _this = this;
        this.stages.forEach(function (stage) {
            stage.setCircuit(_this);
            stage.linkSection();
        });
    };
    MimicCircuit.prototype.linkStreams = function () {
        var _this = this;
        this.streams.forEach(function (stream) {
            stream.setCircuit(_this);
            stream.__linkStages();
        });
        this.streams.forEach(function (stream) {
            stream.findFamily();
        });
    };
    /***************************************
     *
     * CASCADE FUNCTIONS:
     *
     ***************************************/
    MimicCircuit.prototype.getCascades = function () {
        var extractCascades = MimicCascade.getCascades(this, StageTypes.EXTRACT);
        var stripCascades = MimicCascade.getCascades(this, StageTypes.STRIP);
        return __spreadArray$1(__spreadArray$1([], extractCascades, true), stripCascades, true);
    };
    /***************************************
     *
     * STAGE FUNCTIONS:
     *
     ***************************************/
    MimicCircuit.prototype.getETSWasher = function () {
        var etsWasher = this.getWashers().find(function (washer) {
            // @ts-expect-error -- t
            return washer.location === WASH_POSITIONS_TO_LOCATION[WASH_POSITIONS.ETS];
        });
        if (etsWasher) {
            return etsWasher;
        }
        return null;
    };
    MimicCircuit.prototype.getSTEWasher = function () {
        var steWasher = this.getWashers().find(function (washer) {
            // @ts-expect-error -- t
            return washer.location === WASH_POSITIONS_TO_LOCATION[WASH_POSITIONS.ETS];
        });
        if (steWasher) {
            return steWasher;
        }
        return null;
    };
    MimicCircuit.prototype.getExtractors = function () {
        return this.getStagesByType(StageTypes.EXTRACT).sort(StageSortComparator);
    };
    MimicCircuit.prototype.getStrippers = function () {
        return this.getStagesByType(StageTypes.STRIP).sort(StageSortComparator);
    };
    MimicCircuit.prototype.getMixerSettlers = function () {
        return this.getExtractors().concat(this.getStrippers());
    };
    MimicCircuit.prototype.getTanks = function () {
        return this.getStagesByType(StageTypes.ORGANIC_TANK).sort(StageSortComparator);
    };
    MimicCircuit.prototype.getWashers = function () {
        return this.getStagesByType(StageTypes.WASHER).sort(StageSortComparator);
    };
    MimicCircuit.prototype.getStageById = function (id) {
        var foundStage = this.stages.find(function (stage) { return stage.id === id; });
        if (!foundStage) {
            return null;
        }
        return foundStage;
    };
    MimicCircuit.prototype.getStageByCode = function (code) {
        var foundStage = this.stages.find(function (stage) { return stage.getCode() === code; });
        if (!foundStage) {
            return null;
        }
        return foundStage;
    };
    MimicCircuit.prototype.getStageByDescription = function (stageType, location) {
        var foundStage = this.stages.find(function (stage) { return stage.stageType === stageType && stage.location === location; });
        if (!foundStage) {
            return null;
        }
        return foundStage;
    };
    MimicCircuit.prototype.getStagesByType = function (stageType) {
        return this.stages.filter(function (stage) { return stage.stageType === stageType; });
    };
    MimicCircuit.prototype.getStagesBySectionType = function (sectionType) {
        var stageTypes = [];
        switch (sectionType) {
            case StreamCircuits.AQUEOUS: {
                stageTypes = [StageTypes.EXTRACT];
                break;
            }
            case StreamCircuits.ORGANIC: {
                stageTypes = [StageTypes.WASHER, StageTypes.ORGANIC_TANK];
                break;
            }
            case StreamCircuits.ELECTROLYTE: {
                stageTypes = [StageTypes.STRIP];
                break;
            }
            default:
                throw new Error('Unknown section type.');
        }
        return this.stages.filter(function (stage) { return stageTypes.includes(stage.stageType); });
    };
    MimicCircuit.prototype.getStageCircuitType = function (stageType) {
        switch (stageType) {
            case StageTypes.EXTRACT: {
                return StreamCircuits.AQUEOUS;
            }
            case StageTypes.WASHER:
            case StageTypes.ORGANIC_TANK: {
                return StreamCircuits.ORGANIC;
            }
            case StageTypes.STRIP: {
                return StreamCircuits.ELECTROLYTE;
            }
            default:
                throw new Error('Unknown stage type.');
        }
    };
    MimicCircuit.prototype.getSectionForStageType = function (stageType) {
        var sectionType = this.getStageCircuitType(stageType);
        var foundSection = this.sections.find(function (section) { return section.sectionType === sectionType; });
        if (!foundSection) {
            return null;
        }
        return foundSection;
    };
    /**
     * Creates a new section for the given stage type.
     */
    MimicCircuit.prototype.createSectionForStageType = function (stageType) {
        var section = this.getSectionForStageType(stageType);
        if (section) {
            return section;
        }
        switch (stageType) {
            case StageTypes.EXTRACT: {
                section = new MimicExtractSection(this);
                this.sections.unshift(section);
                return section;
            }
            case StageTypes.WASHER:
            case StageTypes.ORGANIC_TANK: {
                section = new MimicOrganicSection(this);
                if (this.sections.length !== 0) {
                    if (this.sections[0].sectionType === StreamCircuits.AQUEOUS) {
                        // insert the organic section after the extract section:
                        this.sections.splice(1, 0, section);
                    }
                    else {
                        // if there is no extract section
                        // then the organic section must be first
                        this.sections.unshift(section);
                    }
                }
                return section;
            }
            case StageTypes.STRIP: {
                section = new MimicStripSection(this);
                this.sections.push(section);
                return section;
            }
            default:
                throw new Error('Unknown stage type.');
        }
    };
    /**
     * @returns a list of stages before the provided @stage in the same section.
     */
    MimicCircuit.prototype.getStagesBefore = function (stage) {
        var idx = stage.section.stages.indexOf(stage);
        if (idx === -1) {
            throw new Error('Stage is not part of a circuit section!');
        }
        return stage.section.stages.slice(0, idx);
    };
    /**
     * @returns a list of stages after the provided @stage in the same section.
     */
    MimicCircuit.prototype.getStagesAfter = function (stage) {
        var idx = stage.section.stages.indexOf(stage);
        if (idx === -1) {
            throw new Error('Stage is not part of a circuit section!');
        }
        return stage.section.stages.slice(idx);
    };
    /**
     * @returns a list of stages after the provided @stage in the same section.
     */
    MimicCircuit.prototype.getStagesBetween = function (firstStage, lastStage, includeLast) {
        if (includeLast === void 0) { includeLast = true; }
        var idxFrom = firstStage.section.stages.indexOf(firstStage);
        var idxTo = lastStage.section.stages.indexOf(lastStage);
        if (idxFrom === -1 || idxTo === -1) {
            throw new Error('Stage is not part of a circuit section!');
        }
        return firstStage.section.stages.slice(idxFrom, idxTo + (includeLast ? 1 : 0));
    };
    /**
     * STREAM HELPERS:
     */
    MimicCircuit.prototype.getStreamConnecting = function (fromStage, toStage) {
        var _a;
        return ((_a = this.streams.find(function (stream) {
            return stream.fromStage === fromStage && stream.toStage === toStage;
        })) !== null && _a !== void 0 ? _a : null);
    };
    /**
     * Creates a new stage at the given location of the given stage type.
     * Note that the location must be valid (prevLocation + 1)
     */
    MimicCircuit.prototype.createStage = function (stageType, location) {
        var section = this.getSectionForStageType(stageType);
        // Validate the location versus the previous stage in the section:
        if (section) {
            var lastLocation = section.getLastStageLocation();
            if (lastLocation !== location - 1) {
                throw new Error('Location must be +1 from the last stage location in the section.');
            }
        }
        else {
            if (location !== 1) {
                throw new Error('Location must be 1 when no stages exist in section.');
            }
        }
        var stage = this.makeStageFromJSON({
            circuitId: this.id,
            stageType: stageType,
            location: location,
        });
        this.__addStage(stage);
        stage.create();
        return stage;
    };
    /**
     * Adds a new stage to the circuit, this will also add the stage to the
     * respective stage arrays (extract, strip, tanks etc)
     */
    MimicCircuit.prototype.__addStage = function (newStage) {
        var section = this.createSectionForStageType(newStage.stageType);
        section.linkStage(newStage);
        this.stages.push(newStage);
        newStage.setCircuit(this);
    };
    /**
     * Deletes a stage unlinks all the stages related to it.
     */
    MimicCircuit.prototype.__removeStage = function (stage) {
        var idx = this.stages.indexOf(stage);
        if (idx !== -1) {
            this.stages.splice(idx, 1);
        }
    };
    /**
     * Adds a new stream to the circuit.
     */
    MimicCircuit.prototype.addStream = function (newStream) {
        this.streams.push(newStream);
        newStream.setCircuit(this);
    };
    /**
     * Deletes a stream from the circuit.
     * Note that this function does not unlink the stream from the stages.
     */
    MimicCircuit.prototype.deleteStream = function (stream) {
        var idx = this.streams.indexOf(stream);
        if (idx !== -1) {
            this.streams.splice(idx, 1);
        }
    };
    /**
     * Returns true if there is at least 1 bypass feed going into the extraction section.
     */
    MimicCircuit.prototype.hasOrganicBypassingInExtraction = function () {
        var bypassFeedToExtract = this.streams.find(function (stream) {
            if (stream.streamType === StreamTypes.BYPASS_FEED) {
                var toStage = stream.toStage;
                if (toStage.stageType === StageTypes.EXTRACT) {
                    return true;
                }
            }
            return false;
        });
        return Boolean(bypassFeedToExtract);
    };
    /**
     * FACTORIES
     */
    MimicCircuit.prototype.makeStreamFromJSON = function (data) {
        switch (data.streamType) {
            case StreamTypes.CONTINUE:
                return new ContinueStream(data);
            case StreamTypes.FEED:
                return new FeedStream(data);
            case StreamTypes.BLEND:
                return new BlendStream(data);
            case StreamTypes.BLEED:
                return new BleedStream(data);
            case StreamTypes.SKIP:
                return new SkipStream(data);
            case StreamTypes.BYPASS_BLEED:
                return new BypassBleedStream(data);
            case StreamTypes.BYPASS_BLEND:
                return new BypassBlendStream(data);
            case StreamTypes.BYPASS_FEED:
                return new BypassFeedStream(data);
            default:
                throw new Error("Unknown stream type. Received ".concat(data.streamType));
        }
    };
    MimicCircuit.prototype.makeStageFromJSON = function (data) {
        var stage = null;
        switch (data.stageType) {
            case StageTypes.EXTRACT:
                stage = ExtractStage.fromJSON(data);
                break;
            case StageTypes.STRIP:
                stage = StripStage.fromJSON(data);
                break;
            case 'ORGANIC_TANK':
            case StageTypes.ORGANIC_TANK:
                stage = LoadedOrganicTank.fromJSON(data);
                break;
            case StageTypes.WASHER:
                stage = Washer.fromJSON(data);
                break;
            default:
                throw new Error("Unknown stage type. Received ".concat(data.stageType));
        }
        stage.circuit = this;
        return stage;
    };
    return MimicCircuit;
}());

var DATASET_MODES;
(function (DATASET_MODES) {
    DATASET_MODES["DESIGN_MODE"] = "DESIGN_MODE";
    DATASET_MODES["ANALYSIS_MODE"] = "ANALYSIS_MODE";
})(DATASET_MODES || (DATASET_MODES = {}));
var DATASET_STATUSES;
(function (DATASET_STATUSES) {
    DATASET_STATUSES["INVALID"] = "INVALID";
    DATASET_STATUSES["CONVERGED"] = "CONVERGED";
    DATASET_STATUSES["DIVERGED"] = "DIVERGED";
    DATASET_STATUSES["NOT_COMPUTED_YET"] = "NOT_COMPUTED_YET";
    DATASET_STATUSES["SOME_INVALID"] = "SOME_INVALID";
    DATASET_STATUSES["SOME_DIVERGED"] = "SOME_DIVERGED";
    DATASET_STATUSES["SOME_NOT_COMPUTED_YET"] = "SOME_NOT_COMPUTED_YET";
    DATASET_STATUSES["ALL_CONVERGED"] = "ALL_CONVERGED";
})(DATASET_STATUSES || (DATASET_STATUSES = {}));
var DATASET_VALUE_TYPES;
(function (DATASET_VALUE_TYPES) {
    // Reagent/oxime concentrations
    DATASET_VALUE_TYPES["REAGENT_CONCENTRATION"] = "REAGENT_CONCENTRATION";
    DATASET_VALUE_TYPES["OXIME_RATIO"] = "OXIME_RATIO";
    DATASET_VALUE_TYPES["OXIME_GPL"] = "OXIME_GPL";
    DATASET_VALUE_TYPES["MAX_LOAD"] = "MAX_LOAD";
    DATASET_VALUE_TYPES["MAX_LOAD_OFFSET"] = "MAX_LOAD_OFFSET";
    DATASET_VALUE_TYPES["ALDOXIME_PERCENT"] = "ALDOXIME_PERCENT";
    DATASET_VALUE_TYPES["KETOXIME_PERCENT"] = "KETOXIME_PERCENT";
    // Overall values =
    DATASET_VALUE_TYPES["CU_TRANSFERRED"] = "CU_TRANSFERRED";
    DATASET_VALUE_TYPES["OVERALL_RECOVERY"] = "OVERALL_RECOVERY";
    DATASET_VALUE_TYPES["ELECTROLYTE_MASS_BALANCE"] = "ELECTROLYTE_MASS_BALANCE";
    DATASET_VALUE_TYPES["ORGANIC_MASS_BALANCE"] = "ORGANIC_MASS_BALANCE";
    DATASET_VALUE_TYPES["PLS_MASS_BALANCE"] = "PLS_MASS_BALANCE";
    DATASET_VALUE_TYPES["TSS"] = "TSS";
})(DATASET_VALUE_TYPES || (DATASET_VALUE_TYPES = {}));

var VALUE_STATUS = {
    COMPUTE: 'COMPUTE',
    COMPUTE_USING: 'COMPUTE_USING',
    COMPUTE_USING_OPTIONAL: 'COMPUTE_USING_OPTIONAL',
    HIDDEN: 'HIDDEN',
};

var _a, _b, _c;
/**
 * Sidebar type variables
 */
(_a = {},
    _a[StageTypes.ORGANIC_TANK] = null,
    _a[StageTypes.WASHER] = null,
    _a[StageTypes.EXTRACT] = (_b = {},
        _b[VALUE_STATUS.COMPUTE] = {
            RECOVERY_RAFFINATE: 'RECOVERY_RAFFINATE',
            OA_RATIO: 'OA_RATIO',
            REAGENT_CONCENTRATION: 'REAGENT_CONCENTRATION',
        },
        _b[VALUE_STATUS.COMPUTE_USING] = {
            OA_RATIO: 'OA_RATIO',
            FLOWRATES: 'FLOWRATES',
            RECOVERY_PERCENT: 'RECOVERY_PERCENT',
            RAFFINATE: 'RAFFINATE',
        },
        _b),
    _a[StageTypes.STRIP] = (_c = {},
        _c[VALUE_STATUS.COMPUTE] = {
            ADVANCE: 'ADVANCE',
            OA_RATIO: 'OA_RATIO',
        },
        _c[VALUE_STATUS.COMPUTE_USING] = {
            OA_RATIO: 'OA_RATIO',
            FLOWRATES: 'FLOWRATES',
        },
        _c),
    _a);

// Circuit
var UNIT_TYPES;
(function (UNIT_TYPES) {
    UNIT_TYPES["US"] = "US";
    UNIT_TYPES["METRIC"] = "METRIC";
    UNIT_TYPES["LITRE"] = "LITRE";
})(UNIT_TYPES || (UNIT_TYPES = {}));
var PRODUCTION_UNIT_TYPES;
(function (PRODUCTION_UNIT_TYPES) {
    PRODUCTION_UNIT_TYPES["TONS_DAILY"] = "TONS_DAILY";
    PRODUCTION_UNIT_TYPES["THOUSAND_LBS_DAILY"] = "1000_LBS_DAILY";
})(PRODUCTION_UNIT_TYPES || (PRODUCTION_UNIT_TYPES = {}));

o$1.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n"], ["\n    border-bottom: 1px solid ", ";\n"])), Ee.defaultBorder);
o$1.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    max-width: 360px;\n    max-height: 100%;\n    overflow: auto;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    max-width: 360px;\n    max-height: 100%;\n    overflow: auto;\n"])));
var SidebarBody = o$1.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"])));
var SectionTitle = o$1.h3(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n    font-size: 15px;\n    color: ", ";\n    font-weight: normal;\n\n    ", ";\n"], ["\n    font-size: 15px;\n    color: ", ";\n    font-weight: normal;\n\n    ", ";\n"])), Ee.defaultColor, function (_a) {
    var withSubtitle = _a.withSubtitle;
    return withSubtitle && 'margin-bottom: 11px;';
});
var BodySection = o$1.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    padding: 0;\n    font-size: 12px;\n\n    & + & {\n        border-top: 1px solid ", ";\n        margin-top: ", ";\n        padding-top: 23px;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n\n    padding: 0;\n    font-size: 12px;\n\n    & + & {\n        border-top: 1px solid ", ";\n        margin-top: ", ";\n        padding-top: 23px;\n    }\n"])), function (_a) {
    var borderColor = _a.borderColor;
    return borderColor !== null && borderColor !== void 0 ? borderColor : Ee.defaultBorder;
}, function (_a) {
    var header = _a.header;
    return (header ? '20px' : '30px');
});
o$1.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n    margin-left: 30px;\n    margin-top: 16px;\n"], ["\n    margin-left: 30px;\n    margin-top: 16px;\n"])));
o$1.p(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n    font-size: 13px;\n    font-weight: normal;\n    margin: 0;\n    margin-left: 23px;\n    margin-top: 8px;\n    color: ", ";\n"], ["\n    font-size: 13px;\n    font-weight: normal;\n    margin: 0;\n    margin-left: 23px;\n    margin-top: 8px;\n    color: ", ";\n"])), Ee.defaultColor);
var FooterSection = o$1.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n\n    margin-top: 24px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n\n    margin-top: 24px;\n"])));
var templateObject_1$2, templateObject_2$2, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1;

var SectionSubtitle = o$1.h4(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    font-size: 13px;\n    color: ", ";\n    line-height: 16px;\n    font-weight: normal;\n\n    margin-top: 0;\n    margin-bottom: 8px;\n"], ["\n    font-size: 13px;\n    color: ", ";\n    line-height: 16px;\n    font-weight: normal;\n\n    margin-top: 0;\n    margin-bottom: 8px;\n"])), Ee.defaultSubtleColor7B);
var SectionTitleOptional = o$1.span(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    color: ", ";\n    margin-left: 8px;\n"], ["\n    color: ", ";\n    margin-left: 8px;\n"])), Ee.defaultSubtleColor7B);
var NoIsothermMessage = o$1.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    margin-left: 10px;\n    color: ", ";\n    font-size: 12px;\n    line-height: 16px;\n"], ["\n    margin: 0;\n    margin-left: 10px;\n    color: ", ";\n    font-size: 12px;\n    line-height: 16px;\n"])), Ee.defaultColor);
var NoCascadeMessage = o$1.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    color: ", ";\n    font-size: 12px;\n    line-height: 16px;\n"], ["\n    margin: 0;\n    color: ", ";\n    font-size: 12px;\n    line-height: 16px;\n"])), Ee.defaultColor);
var CheckBoxWrapper = o$1.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    margin-left: 10px;\n\n    > *:not(:last-child) {\n        margin-bottom: 7px;\n    }\n\n    > *:not(:first-child) {\n        margin-top: 7px;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n\n    margin-left: 10px;\n\n    > *:not(:last-child) {\n        margin-bottom: 7px;\n    }\n\n    > *:not(:first-child) {\n        margin-top: 7px;\n    }\n"])));
var RadioButtonSuffix = o$1.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: 8px;\n    margin-left: 11.5px;\n\n    > ", " {\n        margin-top: 7px;\n    }\n\n    > ", " {\n        margin-bottom: -7px;\n    }\n"], ["\n    margin-top: 8px;\n    margin-left: 11.5px;\n\n    > ", " {\n        margin-top: 7px;\n    }\n\n    > ", " {\n        margin-bottom: -7px;\n    }\n"])), CheckBoxWrapper, NoIsothermMessage);
var RadioButtonWrapper = o$1.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: 24px;\n    max-width: 360px;\n"], ["\n    margin-top: 24px;\n    max-width: 360px;\n"])));
var CheckboxAndRadioStyles = {
    fontSize: '13px',
    color: Ee.defaultColor,
};
var ErrorLabel = o$1.p(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 13px;\n    line-height: 16px;\n    color: ", ";\n    margin: 0;\n"], ["\n    width: 100%;\n    font-size: 13px;\n    line-height: 16px;\n    color: ", ";\n    margin: 0;\n"])), Ee.defaultWarningColor);
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function (d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var RGS_APP_CODE = 'RGS';
var SOLVEXTRACT_APP_CODE = 'SOLVEXTRACT';
var MINCHEM_APP_CODE = 'MINCHEM';
var SOLVAY_PLATFORM_CODE = 'SOLVAY';

var SolvayException = /** @class */ (function (_super) {
    __extends$1(SolvayException, _super);
    function SolvayException(errorCode, errorMessage, previousError) {
        var _newTarget = this.constructor;
        if (previousError === void 0) { previousError = null; }
        var _this = _super.call(this, errorMessage) || this;
        _this.appCode = SOLVAY_PLATFORM_CODE;
        _this.errorCode = errorCode;
        _this.message = errorMessage;
        _this.previousError = previousError;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.print();
        return _this;
    }
    SolvayException.prototype.print = function () {
        // eslint-disable-next-line no-console -- We want to log these :)
        console.error("[SolvayException][".concat(this.appCode, "] ").concat(this.errorCode, " - ").concat(this.message));
        if (this.previousError) {
            if (this.previousError instanceof SolvayException) {
                this.previousError.print();
            }
            else {
                // eslint-disable-next-line no-console -- We want to log these :)
                console.error('[SolvayException] Previous error: ', this.previousError);
            }
        }
    };
    return SolvayException;
}(Error));

var MinChemException = /** @class */ (function (_super) {
    __extends$1(MinChemException, _super);
    function MinChemException() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appCode = MINCHEM_APP_CODE;
        return _this;
    }
    return MinChemException;
}(SolvayException));

var SolvExtractException = /** @class */ (function (_super) {
    __extends$1(SolvExtractException, _super);
    function SolvExtractException() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appCode = SOLVEXTRACT_APP_CODE;
        return _this;
    }
    return SolvExtractException;
}(SolvayException));

var RGSException = /** @class */ (function (_super) {
    __extends$1(RGSException, _super);
    function RGSException() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appCode = RGS_APP_CODE;
        return _this;
    }
    return RGSException;
}(SolvayException));

var exceptionNamespace = 'Exceptions';
var DefaultErrorCodes = {
    UNKNOWN_EXCEPTION: "".concat(exceptionNamespace, ".unknown"),
    NETWORK_ERROR: "".concat(exceptionNamespace, ".networkError"),
};

var fromSolvayExceptionDTO = function (exceptionData) {
    switch (exceptionData.appCode) {
        case MINCHEM_APP_CODE:
            return new MinChemException(exceptionData.errorCode, exceptionData.message);
        case SOLVEXTRACT_APP_CODE:
            return new SolvExtractException(exceptionData.errorCode, exceptionData.message);
        case RGS_APP_CODE:
            return new RGSException(exceptionData.errorCode, exceptionData.message);
        default:
            return new SolvayException(exceptionData.errorCode, exceptionData.message);
    }
};
var toSolvayException = function (data) {
    if (!data) {
        // TODO: Should this be done here?
        return new SolvayException(DefaultErrorCodes.UNKNOWN_EXCEPTION, 'No data has been provided to parse exception');
    }
    // If its already a Solvay exception do nothing.
    if (data instanceof SolvayException) {
        return data;
    }
    // If its not an object, we don't know how to handle this error.
    if (!(data instanceof Object)) {
        return new SolvayException(DefaultErrorCodes.UNKNOWN_EXCEPTION, 'Exception data is not of type Object', data);
    }
    if (data.hasOwnProperty('appCode')) {
        var exceptionData = data;
        return fromSolvayExceptionDTO(exceptionData);
    }
    // Network errors have a name property.
    if (data.hasOwnProperty('name') && data.name === 'NetworkError') {
        return new SolvayException(DefaultErrorCodes.NETWORK_ERROR, 'A network error has occurred. Double check connections and server statuses.', data);
    }
    // Fallback to an unknown exception.
    return new SolvayException(DefaultErrorCodes.UNKNOWN_EXCEPTION, 'Unknown exception ocurred...', data);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var axios$2 = { exports: {} };

var bind$2 = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
    };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
    return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
    return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
        && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
    return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData$1(val) {
    return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
    var result;
    if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
        result = ArrayBuffer.isView(val);
    } else {
        result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
    }
    return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
    return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
    return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
    return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject$1(val) {
    if (toString.call(val) !== '[object Object]') {
        return false;
    }

    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
    return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
    return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
    return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
    return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams$1(val) {
    return toString.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
        navigator.product === 'NativeScript' ||
        navigator.product === 'NS')) {
        return false;
    }
    return (
        typeof window !== 'undefined' &&
        typeof document !== 'undefined'
    );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
        return;
    }

    // Force an array if not already something iterable
    if (typeof obj !== 'object') {
        /*eslint no-param-reassign:0*/
        obj = [obj];
    }

    if (isArray(obj)) {
        // Iterate over array values
        for (var i = 0, l = obj.length; i < l; i++) {
            fn.call(null, obj[i], i, obj);
        }
    } else {
        // Iterate over object keys
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                fn.call(null, obj[key], key, obj);
            }
        }
    }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
    var result = {};
    function assignValue(val, key) {
        if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
            result[key] = merge(result[key], val);
        } else if (isPlainObject$1(val)) {
            result[key] = merge({}, val);
        } else if (isArray(val)) {
            result[key] = val.slice();
        } else {
            result[key] = val;
        }
    }

    for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
    }
    return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') {
            a[key] = bind$1(val, thisArg);
        } else {
            a[key] = val;
        }
    });
    return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) {
        content = content.slice(1);
    }
    return content;
}

var utils$f = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData$1,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isPlainObject: isPlainObject$1,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams$1,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM
};

var utils$e = utils$f;

function encode(val) {
    return encodeURIComponent(val).
        replace(/%3A/gi, ':').
        replace(/%24/g, '$').
        replace(/%2C/gi, ',').
        replace(/%20/g, '+').
        replace(/%5B/gi, '[').
        replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$3 = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/
    if (!params) {
        return url;
    }

    var serializedParams;
    if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
    } else if (utils$e.isURLSearchParams(params)) {
        serializedParams = params.toString();
    } else {
        var parts = [];

        utils$e.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') {
                return;
            }

            if (utils$e.isArray(val)) {
                key = key + '[]';
            } else {
                val = [val];
            }

            utils$e.forEach(val, function parseValue(v) {
                if (utils$e.isDate(v)) {
                    v = v.toISOString();
                } else if (utils$e.isObject(v)) {
                    v = JSON.stringify(v);
                }
                parts.push(encode(key) + '=' + encode(v));
            });
        });

        serializedParams = parts.join('&');
    }

    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) {
            url = url.slice(0, hashmarkIndex);
        }

        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }

    return url;
};

var utils$d = utils$f;

function InterceptorManager$1() {
    this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
    if (this.handlers[id]) {
        this.handlers[id] = null;
    }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
    utils$d.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
            fn(h);
        }
    });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$c = utils$f;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
    utils$c.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$3 = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) {
        error.code = code;
    }

    error.request = request;
    error.response = response;
    error.isAxiosError = true;

    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

var enhanceError$2 = enhanceError$3;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError$3 = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return enhanceError$2(error, config, code, request, response);
};

var createError$2 = createError$3;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$2 = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
    } else {
        reject(createError$2(
            'Request failed with status code ' + response.status,
            response.config,
            null,
            response.request,
            response
        ));
    }
};

var utils$b = utils$f;

var cookies$1 = (
    utils$b.isStandardBrowserEnv() ?

        // Standard browser envs support document.cookie
        (function standardBrowserEnv() {
            return {
                write: function write(name, value, expires, path, domain, secure) {
                    var cookie = [];
                    cookie.push(name + '=' + encodeURIComponent(value));

                    if (utils$b.isNumber(expires)) {
                        cookie.push('expires=' + new Date(expires).toGMTString());
                    }

                    if (utils$b.isString(path)) {
                        cookie.push('path=' + path);
                    }

                    if (utils$b.isString(domain)) {
                        cookie.push('domain=' + domain);
                    }

                    if (secure === true) {
                        cookie.push('secure');
                    }

                    document.cookie = cookie.join('; ');
                },

                read: function read(name) {
                    var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
                    return (match ? decodeURIComponent(match[3]) : null);
                },

                remove: function remove(name) {
                    this.write(name, '', Date.now() - 86400000);
                }
            };
        })() :

        // Non standard browser env (web workers, react-native) lack needed support.
        (function nonStandardBrowserEnv() {
            return {
                write: function write() { },
                read: function read() { return null; },
                remove: function remove() { }
            };
        })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
    return relativeURL
        ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
        : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
};

var utils$a = utils$f;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
    'age', 'authorization', 'content-length', 'content-type', 'etag',
    'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
    'last-modified', 'location', 'max-forwards', 'proxy-authorization',
    'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;

    if (!headers) { return parsed; }

    utils$a.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = utils$a.trim(line.substr(0, i)).toLowerCase();
        val = utils$a.trim(line.substr(i + 1));

        if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
                return;
            }
            if (key === 'set-cookie') {
                parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
            } else {
                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
        }
    });

    return parsed;
};

var utils$9 = utils$f;

var isURLSameOrigin$1 = (
    utils$9.isStandardBrowserEnv() ?

        // Standard browser envs have full support of the APIs needed to test
        // whether the request URL is of the same origin as current location.
        (function standardBrowserEnv() {
            var msie = /(msie|trident)/i.test(navigator.userAgent);
            var urlParsingNode = document.createElement('a');
            var originURL;

            /**
          * Parse a URL to discover it's components
          *
          * @param {String} url The URL to be parsed
          * @returns {Object}
          */
            function resolveURL(url) {
                var href = url;

                if (msie) {
                    // IE needs attribute set twice to normalize properties
                    urlParsingNode.setAttribute('href', href);
                    href = urlParsingNode.href;
                }

                urlParsingNode.setAttribute('href', href);

                // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
                return {
                    href: urlParsingNode.href,
                    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
                    host: urlParsingNode.host,
                    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
                    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
                    hostname: urlParsingNode.hostname,
                    port: urlParsingNode.port,
                    pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                        urlParsingNode.pathname :
                        '/' + urlParsingNode.pathname
                };
            }

            originURL = resolveURL(window.location.href);

            /**
          * Determine if a URL shares the same origin as the current location
          *
          * @param {String} requestURL The URL to test
          * @returns {boolean} True if URL shares the same origin, otherwise false
          */
            return function isURLSameOrigin(requestURL) {
                var parsed = (utils$9.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
                return (parsed.protocol === originURL.protocol &&
                    parsed.host === originURL.host);
            };
        })() :

        // Non standard browser envs (web workers, react-native) lack needed support.
        (function nonStandardBrowserEnv() {
            return function isURLSameOrigin() {
                return true;
            };
        })()
);

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel$4(message) {
    this.message = message;
}

Cancel$4.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel$4.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel$4;

var utils$8 = utils$f;
var settle$1 = settle$2;
var cookies = cookies$1;
var buildURL$2 = buildURL$3;
var buildFullPath$1 = buildFullPath$2;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError$1 = createError$3;
var defaults$5 = defaults_1;
var Cancel$3 = Cancel_1;

var xhr = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) {
                config.cancelToken.unsubscribe(onCanceled);
            }

            if (config.signal) {
                config.signal.removeEventListener('abort', onCanceled);
            }
        }

        if (utils$8.isFormData(requestData)) {
            delete requestHeaders['Content-Type']; // Let the browser set it
        }

        var request = new XMLHttpRequest();

        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }

        var fullPath = buildFullPath$1(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL$2(fullPath, config.params, config.paramsSerializer), true);

        // Set the request timeout in MS
        request.timeout = config.timeout;

        function onloadend() {
            if (!request) {
                return;
            }
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ?
                request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };

            settle$1(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);

            // Clean up request
            request = null;
        }

        if ('onloadend' in request) {
            // Use onloadend if available
            request.onloadend = onloadend;
        } else {
            // Listen for ready state to emulate onloadend
            request.onreadystatechange = function handleLoad() {
                if (!request || request.readyState !== 4) {
                    return;
                }

                // The request errored out and we didn't get a response, this will be
                // handled by onerror instead
                // With one exception: request that using file: protocol, most browsers
                // will return status as 0 even though it's a successful request
                if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                    return;
                }
                // readystate handler is calling before onerror or ontimeout handlers,
                // so we should call onloadend on the next 'tick'
                setTimeout(onloadend);
            };
        }

        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) {
                return;
            }

            reject(createError$1('Request aborted', config, 'ECONNABORTED', request));

            // Clean up request
            request = null;
        };

        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(createError$1('Network Error', config, null, request));

            // Clean up request
            request = null;
        };

        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || defaults$5.transitional;
            if (config.timeoutErrorMessage) {
                timeoutErrorMessage = config.timeoutErrorMessage;
            }
            reject(createError$1(
                timeoutErrorMessage,
                config,
                transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
                request));

            // Clean up request
            request = null;
        };

        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if (utils$8.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
                cookies.read(config.xsrfCookieName) :
                undefined;

            if (xsrfValue) {
                requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
        }

        // Add headers to the request
        if ('setRequestHeader' in request) {
            utils$8.forEach(requestHeaders, function setRequestHeader(val, key) {
                if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                    // Remove Content-Type if data is undefined
                    delete requestHeaders[key];
                } else {
                    // Otherwise add header to the request
                    request.setRequestHeader(key, val);
                }
            });
        }

        // Add withCredentials to request if needed
        if (!utils$8.isUndefined(config.withCredentials)) {
            request.withCredentials = !!config.withCredentials;
        }

        // Add responseType to request if needed
        if (responseType && responseType !== 'json') {
            request.responseType = config.responseType;
        }

        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') {
            request.addEventListener('progress', config.onDownloadProgress);
        }

        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) {
            request.upload.addEventListener('progress', config.onUploadProgress);
        }

        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function (cancel) {
                if (!request) {
                    return;
                }
                reject(!cancel || (cancel && cancel.type) ? new Cancel$3('canceled') : cancel);
                request.abort();
                request = null;
            };

            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) {
                config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
            }
        }

        if (!requestData) {
            requestData = null;
        }

        // Send the request
        request.send(requestData);
    });
};

var followRedirects = { exports: {} };

var debug$1;

var debug_1 = function () {
    if (!debug$1) {
        try {
            /* eslint global-require: off */
            debug$1 = require("debug")("follow-redirects");
        }
        catch (error) { /* */ }
        if (typeof debug$1 !== "function") {
            debug$1 = function () { /* */ };
        }
    }
    debug$1.apply(null, arguments);
};

var url$1 = require$$0;
var URL = url$1.URL;
var http$1 = require$$1;
var https$1 = require$$2;
var Writable = require$$3.Writable;
var assert = require$$4;
var debug = debug_1;

// Create handlers that pass events from native requests
var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
var eventHandlers = Object.create(null);
events.forEach(function (event) {
    eventHandlers[event] = function (arg1, arg2, arg3) {
        this._redirectable.emit(event, arg1, arg2, arg3);
    };
});

// Error types with codes
var RedirectionError = createErrorType(
    "ERR_FR_REDIRECTION_FAILURE",
    "Redirected request failed"
);
var TooManyRedirectsError = createErrorType(
    "ERR_FR_TOO_MANY_REDIRECTS",
    "Maximum number of redirects exceeded"
);
var MaxBodyLengthExceededError = createErrorType(
    "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
    "Request body larger than maxBodyLength limit"
);
var WriteAfterEndError = createErrorType(
    "ERR_STREAM_WRITE_AFTER_END",
    "write after end"
);

// An HTTP(S) request that can be redirected
function RedirectableRequest(options, responseCallback) {
    // Initialize the request
    Writable.call(this);
    this._sanitizeOptions(options);
    this._options = options;
    this._ended = false;
    this._ending = false;
    this._redirectCount = 0;
    this._redirects = [];
    this._requestBodyLength = 0;
    this._requestBodyBuffers = [];

    // Attach a callback if passed
    if (responseCallback) {
        this.on("response", responseCallback);
    }

    // React to responses of native requests
    var self = this;
    this._onNativeResponse = function (response) {
        self._processResponse(response);
    };

    // Perform the first request
    this._performRequest();
}
RedirectableRequest.prototype = Object.create(Writable.prototype);

RedirectableRequest.prototype.abort = function () {
    abortRequest(this._currentRequest);
    this.emit("abort");
};

// Writes buffered data to the current native request
RedirectableRequest.prototype.write = function (data, encoding, callback) {
    // Writing is not allowed if end has been called
    if (this._ending) {
        throw new WriteAfterEndError();
    }

    // Validate input and shift parameters if necessary
    if (!(typeof data === "string" || typeof data === "object" && ("length" in data))) {
        throw new TypeError("data should be a string, Buffer or Uint8Array");
    }
    if (typeof encoding === "function") {
        callback = encoding;
        encoding = null;
    }

    // Ignore empty buffers, since writing them doesn't invoke the callback
    // https://github.com/nodejs/node/issues/22066
    if (data.length === 0) {
        if (callback) {
            callback();
        }
        return;
    }
    // Only write when we don't exceed the maximum body length
    if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
        this._requestBodyLength += data.length;
        this._requestBodyBuffers.push({ data: data, encoding: encoding });
        this._currentRequest.write(data, encoding, callback);
    }
    // Error when we exceed the maximum body length
    else {
        this.emit("error", new MaxBodyLengthExceededError());
        this.abort();
    }
};

// Ends the current native request
RedirectableRequest.prototype.end = function (data, encoding, callback) {
    // Shift parameters if necessary
    if (typeof data === "function") {
        callback = data;
        data = encoding = null;
    }
    else if (typeof encoding === "function") {
        callback = encoding;
        encoding = null;
    }

    // Write data if needed and end
    if (!data) {
        this._ended = this._ending = true;
        this._currentRequest.end(null, null, callback);
    }
    else {
        var self = this;
        var currentRequest = this._currentRequest;
        this.write(data, encoding, function () {
            self._ended = true;
            currentRequest.end(null, null, callback);
        });
        this._ending = true;
    }
};

// Sets a header value on the current native request
RedirectableRequest.prototype.setHeader = function (name, value) {
    this._options.headers[name] = value;
    this._currentRequest.setHeader(name, value);
};

// Clears a header value on the current native request
RedirectableRequest.prototype.removeHeader = function (name) {
    delete this._options.headers[name];
    this._currentRequest.removeHeader(name);
};

// Global timeout for all underlying requests
RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
    var self = this;

    // Destroys the socket on timeout
    function destroyOnTimeout(socket) {
        socket.setTimeout(msecs);
        socket.removeListener("timeout", socket.destroy);
        socket.addListener("timeout", socket.destroy);
    }

    // Sets up a timer to trigger a timeout event
    function startTimer(socket) {
        if (self._timeout) {
            clearTimeout(self._timeout);
        }
        self._timeout = setTimeout(function () {
            self.emit("timeout");
            clearTimer();
        }, msecs);
        destroyOnTimeout(socket);
    }

    // Stops a timeout from triggering
    function clearTimer() {
        // Clear the timeout
        if (self._timeout) {
            clearTimeout(self._timeout);
            self._timeout = null;
        }

        // Clean up all attached listeners
        self.removeListener("abort", clearTimer);
        self.removeListener("error", clearTimer);
        self.removeListener("response", clearTimer);
        if (callback) {
            self.removeListener("timeout", callback);
        }
        if (!self.socket) {
            self._currentRequest.removeListener("socket", startTimer);
        }
    }

    // Attach callback if passed
    if (callback) {
        this.on("timeout", callback);
    }

    // Start the timer if or when the socket is opened
    if (this.socket) {
        startTimer(this.socket);
    }
    else {
        this._currentRequest.once("socket", startTimer);
    }

    // Clean up on events
    this.on("socket", destroyOnTimeout);
    this.on("abort", clearTimer);
    this.on("error", clearTimer);
    this.on("response", clearTimer);

    return this;
};

// Proxy all other public ClientRequest methods
[
    "flushHeaders", "getHeader",
    "setNoDelay", "setSocketKeepAlive",
].forEach(function (method) {
    RedirectableRequest.prototype[method] = function (a, b) {
        return this._currentRequest[method](a, b);
    };
});

// Proxy all public ClientRequest properties
["aborted", "connection", "socket"].forEach(function (property) {
    Object.defineProperty(RedirectableRequest.prototype, property, {
        get: function () { return this._currentRequest[property]; },
    });
});

RedirectableRequest.prototype._sanitizeOptions = function (options) {
    // Ensure headers are always present
    if (!options.headers) {
        options.headers = {};
    }

    // Since http.request treats host as an alias of hostname,
    // but the url module interprets host as hostname plus port,
    // eliminate the host property to avoid confusion.
    if (options.host) {
        // Use hostname if set, because it has precedence
        if (!options.hostname) {
            options.hostname = options.host;
        }
        delete options.host;
    }

    // Complete the URL object when necessary
    if (!options.pathname && options.path) {
        var searchPos = options.path.indexOf("?");
        if (searchPos < 0) {
            options.pathname = options.path;
        }
        else {
            options.pathname = options.path.substring(0, searchPos);
            options.search = options.path.substring(searchPos);
        }
    }
};


// Executes the next native request (initial or redirect)
RedirectableRequest.prototype._performRequest = function () {
    // Load the native protocol
    var protocol = this._options.protocol;
    var nativeProtocol = this._options.nativeProtocols[protocol];
    if (!nativeProtocol) {
        this.emit("error", new TypeError("Unsupported protocol " + protocol));
        return;
    }

    // If specified, use the agent corresponding to the protocol
    // (HTTP and HTTPS use different types of agents)
    if (this._options.agents) {
        var scheme = protocol.substr(0, protocol.length - 1);
        this._options.agent = this._options.agents[scheme];
    }

    // Create the native request
    var request = this._currentRequest =
        nativeProtocol.request(this._options, this._onNativeResponse);
    this._currentUrl = url$1.format(this._options);

    // Set up event handlers
    request._redirectable = this;
    for (var e = 0; e < events.length; e++) {
        request.on(events[e], eventHandlers[events[e]]);
    }

    // End a redirected request
    // (The first request must be ended explicitly with RedirectableRequest#end)
    if (this._isRedirect) {
        // Write the request entity and end.
        var i = 0;
        var self = this;
        var buffers = this._requestBodyBuffers;
        (function writeNext(error) {
            // Only write if this request has not been redirected yet
            /* istanbul ignore else */
            if (request === self._currentRequest) {
                // Report any write errors
                /* istanbul ignore if */
                if (error) {
                    self.emit("error", error);
                }
                // Write the next buffer if there are still left
                else if (i < buffers.length) {
                    var buffer = buffers[i++];
                    /* istanbul ignore else */
                    if (!request.finished) {
                        request.write(buffer.data, buffer.encoding, writeNext);
                    }
                }
                // End the request if `end` has been called on us
                else if (self._ended) {
                    request.end();
                }
            }
        }());
    }
};

// Processes a response from the current native request
RedirectableRequest.prototype._processResponse = function (response) {
    // Store the redirected response
    var statusCode = response.statusCode;
    if (this._options.trackRedirects) {
        this._redirects.push({
            url: this._currentUrl,
            headers: response.headers,
            statusCode: statusCode,
        });
    }

    // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
    // that further action needs to be taken by the user agent in order to
    // fulfill the request. If a Location header field is provided,
    // the user agent MAY automatically redirect its request to the URI
    // referenced by the Location field value,
    // even if the specific status code is not understood.

    // If the response is not a redirect; return it as-is
    var location = response.headers.location;
    if (!location || this._options.followRedirects === false ||
        statusCode < 300 || statusCode >= 400) {
        response.responseUrl = this._currentUrl;
        response.redirects = this._redirects;
        this.emit("response", response);

        // Clean up
        this._requestBodyBuffers = [];
        return;
    }

    // The response is a redirect, so abort the current request
    abortRequest(this._currentRequest);
    // Discard the remainder of the response to avoid waiting for data
    response.destroy();

    // RFC7231§6.4: A client SHOULD detect and intervene
    // in cyclical redirections (i.e., "infinite" redirection loops).
    if (++this._redirectCount > this._options.maxRedirects) {
        this.emit("error", new TooManyRedirectsError());
        return;
    }

    // RFC7231§6.4: Automatic redirection needs to done with
    // care for methods not known to be safe, […]
    // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
    // the request method from POST to GET for the subsequent request.
    if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" ||
        // RFC7231§6.4.4: The 303 (See Other) status code indicates that
        // the server is redirecting the user agent to a different resource […]
        // A user agent can perform a retrieval request targeting that URI
        // (a GET or HEAD request if using HTTP) […]
        (statusCode === 303) && !/^(?:GET|HEAD)$/.test(this._options.method)) {
        this._options.method = "GET";
        // Drop a possible entity and headers related to it
        this._requestBodyBuffers = [];
        removeMatchingHeaders(/^content-/i, this._options.headers);
    }

    // Drop the Host header, as the redirect might lead to a different host
    var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);

    // If the redirect is relative, carry over the host of the last request
    var currentUrlParts = url$1.parse(this._currentUrl);
    var currentHost = currentHostHeader || currentUrlParts.host;
    var currentUrl = /^\w+:/.test(location) ? this._currentUrl :
        url$1.format(Object.assign(currentUrlParts, { host: currentHost }));

    // Determine the URL of the redirection
    var redirectUrl;
    try {
        redirectUrl = url$1.resolve(currentUrl, location);
    }
    catch (cause) {
        this.emit("error", new RedirectionError(cause));
        return;
    }

    // Create the redirected request
    debug("redirecting to", redirectUrl);
    this._isRedirect = true;
    var redirectUrlParts = url$1.parse(redirectUrl);
    Object.assign(this._options, redirectUrlParts);

    // Drop confidential headers when redirecting to a less secure protocol
    // or to a different domain that is not a superdomain
    if (redirectUrlParts.protocol !== currentUrlParts.protocol &&
        redirectUrlParts.protocol !== "https:" ||
        redirectUrlParts.host !== currentHost &&
        !isSubdomain(redirectUrlParts.host, currentHost)) {
        removeMatchingHeaders(/^(?:authorization|cookie)$/i, this._options.headers);
    }

    // Evaluate the beforeRedirect callback
    if (typeof this._options.beforeRedirect === "function") {
        var responseDetails = { headers: response.headers };
        try {
            this._options.beforeRedirect.call(null, this._options, responseDetails);
        }
        catch (err) {
            this.emit("error", err);
            return;
        }
        this._sanitizeOptions(this._options);
    }

    // Perform the redirected request
    try {
        this._performRequest();
    }
    catch (cause) {
        this.emit("error", new RedirectionError(cause));
    }
};

// Wraps the key/value object of protocols with redirect functionality
function wrap(protocols) {
    // Default settings
    var exports = {
        maxRedirects: 21,
        maxBodyLength: 10 * 1024 * 1024,
    };

    // Wrap each protocol
    var nativeProtocols = {};
    Object.keys(protocols).forEach(function (scheme) {
        var protocol = scheme + ":";
        var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
        var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol);

        // Executes a request, following redirects
        function request(input, options, callback) {
            // Parse parameters
            if (typeof input === "string") {
                var urlStr = input;
                try {
                    input = urlToOptions(new URL(urlStr));
                }
                catch (err) {
                    /* istanbul ignore next */
                    input = url$1.parse(urlStr);
                }
            }
            else if (URL && (input instanceof URL)) {
                input = urlToOptions(input);
            }
            else {
                callback = options;
                options = input;
                input = { protocol: protocol };
            }
            if (typeof options === "function") {
                callback = options;
                options = null;
            }

            // Set defaults
            options = Object.assign({
                maxRedirects: exports.maxRedirects,
                maxBodyLength: exports.maxBodyLength,
            }, input, options);
            options.nativeProtocols = nativeProtocols;

            assert.equal(options.protocol, protocol, "protocol mismatch");
            debug("options", options);
            return new RedirectableRequest(options, callback);
        }

        // Executes a GET request, following redirects
        function get(input, options, callback) {
            var wrappedRequest = wrappedProtocol.request(input, options, callback);
            wrappedRequest.end();
            return wrappedRequest;
        }

        // Expose the properties on the wrapped protocol
        Object.defineProperties(wrappedProtocol, {
            request: { value: request, configurable: true, enumerable: true, writable: true },
            get: { value: get, configurable: true, enumerable: true, writable: true },
        });
    });
    return exports;
}

/* istanbul ignore next */
function noop() { /* empty */ }

// from https://github.com/nodejs/node/blob/master/lib/internal/url.js
function urlToOptions(urlObject) {
    var options = {
        protocol: urlObject.protocol,
        hostname: urlObject.hostname.startsWith("[") ?
            /* istanbul ignore next */
            urlObject.hostname.slice(1, -1) :
            urlObject.hostname,
        hash: urlObject.hash,
        search: urlObject.search,
        pathname: urlObject.pathname,
        path: urlObject.pathname + urlObject.search,
        href: urlObject.href,
    };
    if (urlObject.port !== "") {
        options.port = Number(urlObject.port);
    }
    return options;
}

function removeMatchingHeaders(regex, headers) {
    var lastValue;
    for (var header in headers) {
        if (regex.test(header)) {
            lastValue = headers[header];
            delete headers[header];
        }
    }
    return (lastValue === null || typeof lastValue === "undefined") ?
        undefined : String(lastValue).trim();
}

function createErrorType(code, defaultMessage) {
    function CustomError(cause) {
        Error.captureStackTrace(this, this.constructor);
        if (!cause) {
            this.message = defaultMessage;
        }
        else {
            this.message = defaultMessage + ": " + cause.message;
            this.cause = cause;
        }
    }
    CustomError.prototype = new Error();
    CustomError.prototype.constructor = CustomError;
    CustomError.prototype.name = "Error [" + code + "]";
    CustomError.prototype.code = code;
    return CustomError;
}

function abortRequest(request) {
    for (var e = 0; e < events.length; e++) {
        request.removeListener(events[e], eventHandlers[events[e]]);
    }
    request.on("error", noop);
    request.abort();
}

function isSubdomain(subdomain, domain) {
    const dot = subdomain.length - domain.length - 1;
    return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
}

// Exports
followRedirects.exports = wrap({ http: http$1, https: https$1 });
followRedirects.exports.wrap = wrap;

var data = {
    "version": "0.26.0"
};

var utils$7 = utils$f;
var settle = settle$2;
var buildFullPath = buildFullPath$2;
var buildURL$1 = buildURL$3;
var http = require$$1;
var https = require$$2;
var httpFollow = followRedirects.exports.http;
var httpsFollow = followRedirects.exports.https;
var url = require$$0;
var zlib = require$$8;
var VERSION$1 = data.version;
var createError = createError$3;
var enhanceError$1 = enhanceError$3;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;

var isHttps = /https:?/;

/**
 *
 * @param {http.ClientRequestArgs} options
 * @param {AxiosProxyConfig} proxy
 * @param {string} location
 */
function setProxy(options, proxy, location) {
    options.hostname = proxy.host;
    options.host = proxy.host;
    options.port = proxy.port;
    options.path = location;

    // Basic proxy authorization
    if (proxy.auth) {
        var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
        options.headers['Proxy-Authorization'] = 'Basic ' + base64;
    }

    // If a proxy is used, any redirects must also pass through the proxy
    options.beforeRedirect = function beforeRedirect(redirection) {
        redirection.headers.host = redirection.host;
        setProxy(redirection, proxy, redirection.href);
    };
}

/*eslint consistent-return:0*/
var http_1 = function httpAdapter(config) {
    return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
        var onCanceled;
        function done() {
            if (config.cancelToken) {
                config.cancelToken.unsubscribe(onCanceled);
            }

            if (config.signal) {
                config.signal.removeEventListener('abort', onCanceled);
            }
        }
        var resolve = function resolve(value) {
            done();
            resolvePromise(value);
        };
        var rejected = false;
        var reject = function reject(value) {
            done();
            rejected = true;
            rejectPromise(value);
        };
        var data = config.data;
        var headers = config.headers;
        var headerNames = {};

        Object.keys(headers).forEach(function storeLowerName(name) {
            headerNames[name.toLowerCase()] = name;
        });

        // Set User-Agent (required by some servers)
        // See https://github.com/axios/axios/issues/69
        if ('user-agent' in headerNames) {
            // User-Agent is specified; handle case where no UA header is desired
            if (!headers[headerNames['user-agent']]) {
                delete headers[headerNames['user-agent']];
            }
            // Otherwise, use specified value
        } else {
            // Only set header if it hasn't been set in config
            headers['User-Agent'] = 'axios/' + VERSION$1;
        }

        if (data && !utils$7.isStream(data)) {
            if (Buffer.isBuffer(data)); else if (utils$7.isArrayBuffer(data)) {
                data = Buffer.from(new Uint8Array(data));
            } else if (utils$7.isString(data)) {
                data = Buffer.from(data, 'utf-8');
            } else {
                return reject(createError(
                    'Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream',
                    config
                ));
            }

            if (config.maxBodyLength > -1 && data.length > config.maxBodyLength) {
                return reject(createError('Request body larger than maxBodyLength limit', config));
            }

            // Add Content-Length header if data exists
            if (!headerNames['content-length']) {
                headers['Content-Length'] = data.length;
            }
        }

        // HTTP basic authentication
        var auth = undefined;
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            auth = username + ':' + password;
        }

        // Parse url
        var fullPath = buildFullPath(config.baseURL, config.url);
        var parsed = url.parse(fullPath);
        var protocol = parsed.protocol || 'http:';

        if (!auth && parsed.auth) {
            var urlAuth = parsed.auth.split(':');
            var urlUsername = urlAuth[0] || '';
            var urlPassword = urlAuth[1] || '';
            auth = urlUsername + ':' + urlPassword;
        }

        if (auth && headerNames.authorization) {
            delete headers[headerNames.authorization];
        }

        var isHttpsRequest = isHttps.test(protocol);
        var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;

        try {
            buildURL$1(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, '');
        } catch (err) {
            var customErr = new Error(err.message);
            customErr.config = config;
            customErr.url = config.url;
            customErr.exists = true;
            reject(customErr);
        }

        var options = {
            path: buildURL$1(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
            method: config.method.toUpperCase(),
            headers: headers,
            agent: agent,
            agents: { http: config.httpAgent, https: config.httpsAgent },
            auth: auth
        };

        if (config.socketPath) {
            options.socketPath = config.socketPath;
        } else {
            options.hostname = parsed.hostname;
            options.port = parsed.port;
        }

        var proxy = config.proxy;
        if (!proxy && proxy !== false) {
            var proxyEnv = protocol.slice(0, -1) + '_proxy';
            var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
            if (proxyUrl) {
                var parsedProxyUrl = url.parse(proxyUrl);
                var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
                var shouldProxy = true;

                if (noProxyEnv) {
                    var noProxy = noProxyEnv.split(',').map(function trim(s) {
                        return s.trim();
                    });

                    shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
                        if (!proxyElement) {
                            return false;
                        }
                        if (proxyElement === '*') {
                            return true;
                        }
                        if (proxyElement[0] === '.' &&
                            parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
                            return true;
                        }

                        return parsed.hostname === proxyElement;
                    });
                }

                if (shouldProxy) {
                    proxy = {
                        host: parsedProxyUrl.hostname,
                        port: parsedProxyUrl.port,
                        protocol: parsedProxyUrl.protocol
                    };

                    if (parsedProxyUrl.auth) {
                        var proxyUrlAuth = parsedProxyUrl.auth.split(':');
                        proxy.auth = {
                            username: proxyUrlAuth[0],
                            password: proxyUrlAuth[1]
                        };
                    }
                }
            }
        }

        if (proxy) {
            options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
            setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
        }

        var transport;
        var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
        if (config.transport) {
            transport = config.transport;
        } else if (config.maxRedirects === 0) {
            transport = isHttpsProxy ? https : http;
        } else {
            if (config.maxRedirects) {
                options.maxRedirects = config.maxRedirects;
            }
            transport = isHttpsProxy ? httpsFollow : httpFollow;
        }

        if (config.maxBodyLength > -1) {
            options.maxBodyLength = config.maxBodyLength;
        }

        if (config.insecureHTTPParser) {
            options.insecureHTTPParser = config.insecureHTTPParser;
        }

        // Create the request
        var req = transport.request(options, function handleResponse(res) {
            if (req.aborted) return;

            // uncompress the response body transparently if required
            var stream = res;

            // return the last request in case of redirects
            var lastRequest = res.req || req;


            // if no content, is HEAD request or decompress disabled we should not decompress
            if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
                switch (res.headers['content-encoding']) {
                    /*eslint default-case:0*/
                    case 'gzip':
                    case 'compress':
                    case 'deflate':
                        // add the unzipper to the body stream processing pipeline
                        stream = stream.pipe(zlib.createUnzip());

                        // remove the content-encoding in order to not confuse downstream operations
                        delete res.headers['content-encoding'];
                        break;
                }
            }

            var response = {
                status: res.statusCode,
                statusText: res.statusMessage,
                headers: res.headers,
                config: config,
                request: lastRequest
            };

            if (config.responseType === 'stream') {
                response.data = stream;
                settle(resolve, reject, response);
            } else {
                var responseBuffer = [];
                var totalResponseBytes = 0;
                stream.on('data', function handleStreamData(chunk) {
                    responseBuffer.push(chunk);
                    totalResponseBytes += chunk.length;

                    // make sure the content length is not over the maxContentLength if specified
                    if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
                        // stream.destoy() emit aborted event before calling reject() on Node.js v16
                        rejected = true;
                        stream.destroy();
                        reject(createError('maxContentLength size of ' + config.maxContentLength + ' exceeded',
                            config, null, lastRequest));
                    }
                });

                stream.on('aborted', function handlerStreamAborted() {
                    if (rejected) {
                        return;
                    }
                    stream.destroy();
                    reject(createError('error request aborted', config, 'ERR_REQUEST_ABORTED', lastRequest));
                });

                stream.on('error', function handleStreamError(err) {
                    if (req.aborted) return;
                    reject(enhanceError$1(err, config, null, lastRequest));
                });

                stream.on('end', function handleStreamEnd() {
                    try {
                        var responseData = responseBuffer.length === 1 ? responseBuffer[0] : Buffer.concat(responseBuffer);
                        if (config.responseType !== 'arraybuffer') {
                            responseData = responseData.toString(config.responseEncoding);
                            if (!config.responseEncoding || config.responseEncoding === 'utf8') {
                                responseData = utils$7.stripBOM(responseData);
                            }
                        }
                        response.data = responseData;
                    } catch (err) {
                        reject(enhanceError$1(err, config, err.code, response.request, response));
                    }
                    settle(resolve, reject, response);
                });
            }
        });

        // Handle errors
        req.on('error', function handleRequestError(err) {
            if (req.aborted && err.code !== 'ERR_FR_TOO_MANY_REDIRECTS') return;
            reject(enhanceError$1(err, config, null, req));
        });

        // set tcp keep alive to prevent drop connection by peer
        req.on('socket', function handleRequestSocket(socket) {
            // default interval of sending ack packet is 1 minute
            socket.setKeepAlive(true, 1000 * 60);
        });

        // Handle request timeout
        if (config.timeout) {
            // This is forcing a int timeout to avoid problems if the `req` interface doesn't handle other types.
            var timeout = parseInt(config.timeout, 10);

            if (isNaN(timeout)) {
                reject(createError(
                    'error trying to parse `config.timeout` to int',
                    config,
                    'ERR_PARSE_TIMEOUT',
                    req
                ));

                return;
            }

            // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
            // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
            // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
            // And then these socket which be hang up will devoring CPU little by little.
            // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.
            req.setTimeout(timeout, function handleRequestTimeout() {
                req.abort();
                var timeoutErrorMessage = '';
                if (config.timeoutErrorMessage) {
                    timeoutErrorMessage = config.timeoutErrorMessage;
                } else {
                    timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
                }
                var transitional = config.transitional || defaults$4.transitional;
                reject(createError(
                    timeoutErrorMessage,
                    config,
                    transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
                    req
                ));
            });
        }

        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function (cancel) {
                if (req.aborted) return;

                req.abort();
                reject(!cancel || (cancel && cancel.type) ? new Cancel$2('canceled') : cancel);
            };

            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) {
                config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
            }
        }


        // Send the request
        if (utils$7.isStream(data)) {
            data.on('error', function handleStreamError(err) {
                reject(enhanceError$1(err, config, null, req));
            }).pipe(req);
        } else {
            req.end(data);
        }
    });
};

var utils$6 = utils$f;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$3;

var DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
    if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers['Content-Type'])) {
        headers['Content-Type'] = value;
    }
}

function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use XHR adapter
        adapter = xhr;
    } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
        // For node use HTTP adapter
        adapter = http_1;
    }
    return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
    if (utils$6.isString(rawValue)) {
        try {
            (parser || JSON.parse)(rawValue);
            return utils$6.trim(rawValue);
        } catch (e) {
            if (e.name !== 'SyntaxError') {
                throw e;
            }
        }
    }

    return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },

    adapter: getDefaultAdapter(),

    transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, 'Accept');
        normalizeHeaderName(headers, 'Content-Type');

        if (utils$6.isFormData(data) ||
            utils$6.isArrayBuffer(data) ||
            utils$6.isBuffer(data) ||
            utils$6.isStream(data) ||
            utils$6.isFile(data) ||
            utils$6.isBlob(data)
        ) {
            return data;
        }
        if (utils$6.isArrayBufferView(data)) {
            return data.buffer;
        }
        if (utils$6.isURLSearchParams(data)) {
            setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
            return data.toString();
        }
        if (utils$6.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
            setContentTypeIfUnset(headers, 'application/json');
            return stringifySafely(data);
        }
        return data;
    }],

    transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults$3.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

        if (strictJSONParsing || (forcedJSONParsing && utils$6.isString(data) && data.length)) {
            try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') {
                        throw enhanceError(e, this, 'E_JSON_PARSE');
                    }
                    throw e;
                }
            }
        }

        return data;
    }],

    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    maxContentLength: -1,
    maxBodyLength: -1,

    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },

    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};

utils$6.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
    defaults$3.headers[method] = {};
});

utils$6.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$5 = utils$f;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
    var context = this || defaults$2;
    /*eslint no-param-reassign:0*/
    utils$5.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });

    return data;
};

var isCancel$1 = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

var utils$4 = utils$f;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
    }

    if (config.signal && config.signal.aborted) {
        throw new Cancel$1('canceled');
    }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
    throwIfCancellationRequested(config);

    // Ensure headers exist
    config.headers = config.headers || {};

    // Transform request data
    config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
    );

    // Flatten headers
    config.headers = utils$4.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
    );

    utils$4.forEach(
        ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
        function cleanHeaderConfig(method) {
            delete config.headers[method];
        }
    );

    var adapter = config.adapter || defaults$1.adapter;

    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);

        // Transform response data
        response.data = transformData.call(
            config,
            response.data,
            response.headers,
            config.transformResponse
        );

        return response;
    }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
            throwIfCancellationRequested(config);

            // Transform response data
            if (reason && reason.response) {
                reason.response.data = transformData.call(
                    config,
                    reason.response.data,
                    reason.response.headers,
                    config.transformResponse
                );
            }
        }

        return Promise.reject(reason);
    });
};

var utils$3 = utils$f;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};

    function getMergedValue(target, source) {
        if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
            return utils$3.merge(target, source);
        } else if (utils$3.isPlainObject(source)) {
            return utils$3.merge({}, source);
        } else if (utils$3.isArray(source)) {
            return source.slice();
        }
        return source;
    }

    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!utils$3.isUndefined(config2[prop])) {
            return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils$3.isUndefined(config1[prop])) {
            return getMergedValue(undefined, config1[prop]);
        }
    }

    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!utils$3.isUndefined(config2[prop])) {
            return getMergedValue(undefined, config2[prop]);
        }
    }

    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!utils$3.isUndefined(config2[prop])) {
            return getMergedValue(undefined, config2[prop]);
        } else if (!utils$3.isUndefined(config1[prop])) {
            return getMergedValue(undefined, config1[prop]);
        }
    }

    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) {
            return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
            return getMergedValue(undefined, config1[prop]);
        }
    }

    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };

    utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        (utils$3.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
    });

    return config;
};

var VERSION = data.version;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
    validators$1[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }

    // eslint-disable-next-line func-names
    return function (value, opt, opts) {
        if (validator === false) {
            throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        }

        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(
                formatMessage(
                    opt,
                    ' has been deprecated since v' + version + ' and will be removed in the near future'
                )
            );
        }

        return validator ? validator(value, opt, opts) : true;
    };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') {
        throw new TypeError('options must be an object');
    }
    var keys = Object.keys(options);
    var i = keys.length;
    while (i-- > 0) {
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) {
                throw new TypeError('option ' + opt + ' must be ' + result);
            }
            continue;
        }
        if (allowUnknown !== true) {
            throw Error('Unknown option ' + opt);
        }
    }
}

var validator$1 = {
    assertOptions: assertOptions,
    validators: validators$1
};

var utils$2 = utils$f;
var buildURL = buildURL$3;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
    };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else {
        config = configOrUrl || {};
    }

    config = mergeConfig$1(this.defaults, config);

    // Set config.method
    if (config.method) {
        config.method = config.method.toLowerCase();
    } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
    } else {
        config.method = 'get';
    }

    var transitional = config.transitional;

    if (transitional !== undefined) {
        validator.assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
    }

    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
            return;
        }

        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    var promise;

    if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, undefined];

        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);

        promise = Promise.resolve(config);
        while (chain.length) {
            promise = promise.then(chain.shift(), chain.shift());
        }

        return promise;
    }


    var newConfig = config;
    while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }

    try {
        promise = dispatchRequest(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }

    while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    }

    return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
    /*eslint func-names:0*/
    Axios$1.prototype[method] = function (url, config) {
        return this.request(mergeConfig$1(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});

utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    /*eslint func-names:0*/
    Axios$1.prototype[method] = function (url, data, config) {
        return this.request(mergeConfig$1(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});

var Axios_1 = Axios$1;

var Cancel = Cancel_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
    if (typeof executor !== 'function') {
        throw new TypeError('executor must be a function.');
    }

    var resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });

    var token = this;

    // eslint-disable-next-line func-names
    this.promise.then(function (cancel) {
        if (!token._listeners) return;

        var i;
        var l = token._listeners.length;

        for (i = 0; i < l; i++) {
            token._listeners[i](cancel);
        }
        token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = function (onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function (resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);

        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };

        return promise;
    };

    executor(function cancel(message) {
        if (token.reason) {
            // Cancellation has already been requested
            return;
        }

        token.reason = new Cancel(message);
        resolvePromise(token.reason);
    });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
        throw this.reason;
    }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }

    if (this._listeners) {
        this._listeners.push(listener);
    } else {
        this._listeners = [listener];
    }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) {
        return;
    }
    var index = this._listeners.indexOf(listener);
    if (index !== -1) {
        this._listeners.splice(index, 1);
    }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

var utils$1 = utils$f;

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
    return utils$1.isObject(payload) && (payload.isAxiosError === true);
};

var utils = utils$f;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);

    // Copy axios.prototype to instance
    utils.extend(instance, Axios.prototype, context);

    // Copy context to instance
    utils.extend(instance, context);

    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };

    return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;

// Expose all/spread
axios$1.all = function all(promises) {
    return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axios = axios$2.exports;

/**
 * A recursive function that will remove the `id` key from objects and nested objects
 * if the value of the `id` key is less than 1.
 *
 * @param obj
 * @returns
 */
var removeIdsFromObject = function (obj) {
    if (typeof obj !== 'object' || !obj) {
        return obj;
    }
    // if the object is an array, then map over each item in the array
    if (Array.isArray(obj)) {
        var newObj_1 = obj.map(function (arrItem) { return removeIdsFromObject(arrItem); });
        return newObj_1;
    }
    // Otherwise the object is a JS object and we will map over the entries
    var newObj = {};
    Object.entries(obj).map(function (_a) {
        var key = _a[0], value = _a[1];
        if (key === 'id') {
            if (value && typeof value === 'number' && value < 1) {
                return; // go to the next key in our object entries, without adding the `id` key to our newObj.
            }
            newObj.id = value;
        }
        newObj[key] = removeIdsFromObject(value);
    });
    return newObj;
};
/**
 * The RemoveFrontendTemporaryIDs middleware is only applied on POST or PUT requests.
 * @param req
 * @returns
 */
var removeFrontendTemporaryIds = function (req) {
    if (req.method && ['POST', 'PUT'].includes(req.method.toUpperCase())) {
        req.data = removeIdsFromObject(req.data);
    }
    return req;
};
/**
 * Adds a request interceptor to the axios instance for the `Remove Frontend Temporary Ids` middleware
 * This middleware removes all `id` keys that contain values less than 1.
 * Our frontend creates temporary IDs using Math.random().
 * Before sending the request to the backend, the temporary IDs are removed and the
 * backend creates new entities which assigns IDs according to our DB.
 *
 * @param axiosInstance The axios instance for which the middleware is applied
 */
var applyRemoveFrontendTemporaryIdsMiddleware = function (axiosInstance) {
    axiosInstance.interceptors.request.use(removeFrontendTemporaryIds);
};

/**
 * This middleware adds the Authorization bearer token to requests
 * @param req
 * @returns
 */
var addAuthorization = function (req) {
    var apiToken = localStorage.getItem('api_token');
    if (!apiToken) {
        return req;
    }
    var token = "Bearer ".concat(apiToken);
    if (!req.headers) {
        req.headers = {};
    }
    req.headers.Authorization = token;
    return req;
};
/**
 * Adds a request interceptor to add the authorization token to our requests.
 *
 * @param axiosInstance The axios instance for which the middleware is applied
 */
var applyAuthorizationMiddleware = function (axiosInstance) {
    axiosInstance.interceptors.request.use(addAuthorization);
};

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
/**
 * Lower case as a function.
 */
function lowerCase(str) {
    return str.toLowerCase();
}

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
}

function pascalCaseTransform(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") {
        return "_" + firstChar + lowerChars;
    }
    return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, __assign({ delimiter: "", transform: pascalCaseTransform }, options));
}

function camelCaseTransform(input, index) {
    if (index === 0)
        return input.toLowerCase();
    return pascalCaseTransform(input, index);
}
function camelCase(input, options) {
    if (options === void 0) { options = {}; }
    return pascalCase(input, __assign({ transform: camelCaseTransform }, options));
}

function dotCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, __assign({ delimiter: "." }, options));
}

function snakeCase(input, options) {
    if (options === void 0) { options = {}; }
    return dotCase(input, __assign({ delimiter: "_" }, options));
}

/**
 * Upper case the first character of an input string.
 */
function upperCaseFirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}

function capitalCaseTransform(input) {
    return upperCaseFirst(input.toLowerCase());
}
function capitalCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, __assign({ delimiter: " ", transform: capitalCaseTransform }, options));
}

function headerCase(input, options) {
    if (options === void 0) { options = {}; }
    return capitalCase(input, __assign({ delimiter: "-" }, options));
}

var applyCaseOptions = function (fn, defaultOptions) {
    return function (input, options) {
        return fn(input, __assign(__assign({}, defaultOptions), options));
    };
};
var preserveSpecificKeys = function (fn, keys) {
    var condition = typeof keys === 'function'
        ? keys
        : function (input) { return keys.includes(input); };
    return function (input, options) {
        return condition(input, options) ? input : fn(input, options);
    };
};

var isURLSearchParams = function (value) {
    return (typeof URLSearchParams !== 'undefined' && value instanceof URLSearchParams);
};
var isFormData = function (value) {
    return typeof FormData !== 'undefined' && value instanceof FormData;
};
var isPlainObject = function (value) {
    return (typeof value === 'object' &&
        value !== null &&
        Object.prototype.toString.call(value) === '[object Object]');
};
var isTransformable = function (value) {
    return (Array.isArray(value) ||
        isPlainObject(value) ||
        isFormData(value) ||
        isURLSearchParams(value));
};

var caseFunctions = {
    snake: snakeCase,
    camel: camelCase,
    header: headerCase,
};
var transformObjectUsingCallbackRecursive = function (data, fn, overwrite) {
    var e_1, _a, e_2, _b, e_3, _c;
    if (!isTransformable(data)) {
        return data;
    }
    /* eslint-disable no-console */
    // Check FormData/URLSearchParams compatibility
    if ((isFormData(data) || isURLSearchParams(data)) &&
        (!data.entries || (overwrite && !data.delete))) {
        var type = isFormData(data) ? 'FormData' : 'URLSearchParams';
        var polyfill = isFormData(data)
            ? 'https://github.com/jimmywarting/FormData'
            : 'https://github.com/jerrybendy/url-search-params-polyfill';
        if (typeof navigator !== 'undefined' &&
            navigator.product === 'ReactNative') {
            // You cannot transform FormData/URLSearchParams on React Native
            console.warn("Be careful that " + type + " cannot be transformed on React Native. If you intentionally implemented, ignore this kind of warning: https://facebook.github.io/react-native/docs/debugging.html");
        }
        else {
            if (!data.entries) {
                // You need to polyfill `entries` method
                console.warn("You must use polyfill of " + type + ".prototype.entries() on Internet Explorer or Safari: " + polyfill);
            }
            if (overwrite && !data.delete) {
                // You need to polyfill `delete` method for overwriting
                console.warn("You must use polyfill of " + type + ".prototype.delete() on Internet Explorer or Safari: " + polyfill);
            }
        }
        return data;
    }
    /* eslint-enable no-console */
    var prototype = Object.getPrototypeOf(data);
    // Storage of new values.
    // New instances are created when overwriting is disabled.
    var store = overwrite
        ? data
        : !prototype
            ? Object.create(null)
            : new prototype.constructor();
    // We need to clean up all entries before overwriting.
    var series;
    if (isFormData(data) || isURLSearchParams(data)) {
        // Create native iterator from FormData/URLSearchParams
        series = data.entries();
        if (overwrite) {
            // When overwriting, native iterator needs to be copied as array.
            series = __spreadArray([], __read(series), false);
            try {
                for (var series_1 = __values(series), series_1_1 = series_1.next(); !series_1_1.done; series_1_1 = series_1.next()) {
                    var _d = __read(series_1_1.value, 1), key = _d[0];
                    data.delete(key);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (series_1_1 && !series_1_1.done && (_a = series_1.return)) _a.call(series_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    }
    else {
        // Create array from objects
        series = Object.entries(data);
        // Array keys never change, so we don't need to clean up
        if (overwrite && !Array.isArray(data)) {
            try {
                for (var series_2 = __values(series), series_2_1 = series_2.next(); !series_2_1.done; series_2_1 = series_2.next()) {
                    var _e = __read(series_2_1.value, 1), key = _e[0];
                    delete data[key];
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (series_2_1 && !series_2_1.done && (_b = series_2.return)) _b.call(series_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    try {
        for (var series_3 = __values(series), series_3_1 = series_3.next(); !series_3_1.done; series_3_1 = series_3.next()) {
            var _f = __read(series_3_1.value, 2), key = _f[0], value = _f[1];
            if (isFormData(store) || isURLSearchParams(store)) {
                store.append(fn(key), value);
            }
            else if (key !== '__proto__') {
                store[fn(typeof key === 'string' ? key : "" + key)] =
                    transformObjectUsingCallbackRecursive(value, fn, overwrite);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (series_3_1 && !series_3_1.done && (_c = series_3.return)) _c.call(series_3);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return store;
};
var transformObjectUsingCallback = function (data, fn, options) {
    fn = applyCaseOptions(fn, __assign({ stripRegexp: /[^A-Z0-9[\]]+/gi }, options === null || options === void 0 ? void 0 : options.caseOptions));
    if (options === null || options === void 0 ? void 0 : options.preservedKeys) {
        fn = preserveSpecificKeys(fn, options.preservedKeys);
    }
    return transformObjectUsingCallbackRecursive(data, fn, (options === null || options === void 0 ? void 0 : options.overwrite) || false);
};
var createObjectTransformer = function (fn) {
    return function (data, options) {
        return transformObjectUsingCallback(data, fn, options);
    };
};
var createObjectTransformerOf = function (functionName, options) {
    return createObjectTransformer((options === null || options === void 0 ? void 0 : options[functionName]) || caseFunctions[functionName]);
};
var createObjectTransformers = function (options) {
    var e_4, _a;
    var functionNames = Object.keys(caseFunctions);
    var objectTransformers = {};
    try {
        for (var functionNames_1 = __values(functionNames), functionNames_1_1 = functionNames_1.next(); !functionNames_1_1.done; functionNames_1_1 = functionNames_1.next()) {
            var functionName = functionNames_1_1.value;
            objectTransformers[functionName] = createObjectTransformerOf(functionName, options);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (functionNames_1_1 && !functionNames_1_1.done && (_a = functionNames_1.return)) _a.call(functionNames_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return objectTransformers;
};

var createSnakeParamsInterceptor = function (options) {
    var snake = createObjectTransformers(options === null || options === void 0 ? void 0 : options.caseFunctions).snake;
    return function (config) {
        if (config.params) {
            config.params = snake(config.params, options);
        }
        return config;
    };
};
var createSnakeRequestTransformer = function (options) {
    var _a = createObjectTransformers(options === null || options === void 0 ? void 0 : options.caseFunctions), snake = _a.snake, header = _a.header;
    return function (data, headers) {
        var e_1, _a, _b;
        if (!(options === null || options === void 0 ? void 0 : options.ignoreHeaders) && isPlainObject(headers)) {
            try {
                for (var _c = __values(Object.entries(headers)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                    header(value, __assign({ overwrite: true }, options));
                    if (!['common', 'delete', 'get', 'head', 'post', 'put', 'patch'].includes(key)) {
                        delete headers[key];
                        headers[Object.keys(header((_b = {}, _b[key] = null, _b), options))[0]] = value;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return snake(data, options);
    };
};
var createCamelResponseTransformer = function (options) {
    var camel = createObjectTransformers(options === null || options === void 0 ? void 0 : options.caseFunctions).camel;
    return function (data, headers) {
        if (!(options === null || options === void 0 ? void 0 : options.ignoreHeaders)) {
            camel(headers, __assign({ overwrite: true }, options));
        }
        return camel(data, options);
    };
};
var applyCaseMiddleware$1 = function (axios, options) {
    var _a, _b, _c;
    axios.defaults.transformRequest = __spreadArray([
        ((_a = options === null || options === void 0 ? void 0 : options.caseMiddleware) === null || _a === void 0 ? void 0 : _a.requestTransformer) ||
        createSnakeRequestTransformer(options)
    ], __read((Array.isArray(axios.defaults.transformRequest)
        ? axios.defaults.transformRequest
        : axios.defaults.transformRequest !== undefined
            ? [axios.defaults.transformRequest]
            : [])), false);
    axios.defaults.transformResponse = __spreadArray(__spreadArray([], __read((Array.isArray(axios.defaults.transformResponse)
        ? axios.defaults.transformResponse
        : axios.defaults.transformResponse !== undefined
            ? [axios.defaults.transformResponse]
            : [])), false), [
        ((_b = options === null || options === void 0 ? void 0 : options.caseMiddleware) === null || _b === void 0 ? void 0 : _b.responseTransformer) ||
        createCamelResponseTransformer(options),
    ], false);
    axios.interceptors.request.use(((_c = options === null || options === void 0 ? void 0 : options.caseMiddleware) === null || _c === void 0 ? void 0 : _c.requestInterceptor) ||
        createSnakeParamsInterceptor(options));
    return axios;
};

var applyCaseMiddleware = applyCaseMiddleware$1;

var caseMiddlewareOptions = {
    ignoreHeaders: true,
};
var _applyCaseMiddleware = function (axiosInstance) {
    applyCaseMiddleware(axiosInstance, caseMiddlewareOptions);
};

var cache_node = { exports: {} };

(function (module, exports) {
    (function webpackUniversalModuleDefinition(root, factory) {
        module.exports = factory(axios);
    })(commonjsGlobal, function (__WEBPACK_EXTERNAL_MODULE_axios__) {
        return /******/ (function (modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if (installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
                    /******/
}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
                    /******/
};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
                /******/
}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function (exports, name, getter) {
/******/ 		if (!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
                    /******/
}
                /******/
};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function (exports) {
/******/ 		if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
                    /******/
}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
                /******/
};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function (value, mode) {
/******/ 		if (mode & 1) value = __webpack_require__(value);
/******/ 		if (mode & 8) return value;
/******/ 		if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
                /******/
};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function (module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
                /******/
};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.node.js");
            /******/
})
/************************************************************************/
/******/({

/***/ "./node_modules/cache-control-esm/index.js":
/*!*************************************************!*\
  !*** ./node_modules/cache-control-esm/index.js ***!
  \*************************************************/
/*! exports provided: CacheControl, parse, format, default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CacheControl", function () { return CacheControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function () { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "format", function () { return format; });
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.from */ "./node_modules/core-js/modules/es6.array.from.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.function.name */ "./node_modules/core-js/modules/es6.function.name.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.regexp.split */ "./node_modules/core-js/modules/es6.regexp.split.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.number.is-finite */ "./node_modules/core-js/modules/es6.number.is-finite.js");









                    function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

                    function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

                    function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

                    function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

                    function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

                    function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

                    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

                    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

                    var HEADER_REGEXP = /([a-zA-Z][a-zA-Z_-]*)\s*(?:=(?:"([^"]*)"|([^ \t",;]*)))?/g;
                    var STRINGS = {
                        maxAge: 'max-age',
                        sharedMaxAge: 's-maxage',
                        maxStale: 'max-stale',
                        minFresh: 'min-fresh',
                        immutable: 'immutable',
                        mustRevalidate: 'must-revalidate',
                        noCache: 'no-cache',
                        noStore: 'no-store',
                        noTransform: 'no-transform',
                        onlyIfCached: 'only-if-cached',
                        "private": 'private',
                        proxyRevalidate: 'proxy-revalidate',
                        "public": 'public'
                    };

                    function parseBooleanOnly(value) {
                        return value === null;
                    }

                    function parseDuration(value) {
                        if (!value) {
                            return null;
                        }

                        var duration = parseInt(value, 10);

                        if (!Number.isFinite(duration) || duration < 0) {
                            return null;
                        }

                        return duration;
                    }

                    var CacheControl = /*#__PURE__*/function () {
                        function CacheControl() {
                            _classCallCheck(this, CacheControl);

                            this.maxAge = null;
                            this.sharedMaxAge = null;
                            this.maxStale = null;
                            this.maxStaleDuration = null;
                            this.minFresh = null;
                            this.immutable = null;
                            this.mustRevalidate = null;
                            this.noCache = null;
                            this.noStore = null;
                            this.noTransform = null;
                            this.onlyIfCached = null;
                            this["private"] = null;
                            this.proxyRevalidate = null;
                            this["public"] = null;
                        }

                        _createClass(CacheControl, [{
                            key: "parse",
                            value: function parse(header) {
                                if (!header || header.length === 0) {
                                    return this;
                                }

                                var values = {};
                                var matches = header.match(HEADER_REGEXP) || [];
                                Array.prototype.forEach.call(matches, function (match) {
                                    var tokens = match.split('=', 2);

                                    var _tokens = _slicedToArray(tokens, 1),
                                        key = _tokens[0];

                                    var value = null;

                                    if (tokens.length > 1) {
                                        value = tokens[1].trim();
                                    }

                                    values[key.toLowerCase()] = value;
                                });
                                this.maxAge = parseDuration(values[STRINGS.maxAge]);
                                this.sharedMaxAge = parseDuration(values[STRINGS.sharedMaxAge]);
                                this.maxStale = parseBooleanOnly(values[STRINGS.maxStale]);
                                this.maxStaleDuration = parseDuration(values[STRINGS.maxStale]);

                                if (this.maxStaleDuration) {
                                    this.maxStale = true;
                                }

                                this.minFresh = parseDuration(values[STRINGS.minFresh]);
                                this.immutable = parseBooleanOnly(values[STRINGS.immutable]);
                                this.mustRevalidate = parseBooleanOnly(values[STRINGS.mustRevalidate]);
                                this.noCache = parseBooleanOnly(values[STRINGS.noCache]);
                                this.noStore = parseBooleanOnly(values[STRINGS.noStore]);
                                this.noTransform = parseBooleanOnly(values[STRINGS.noTransform]);
                                this.onlyIfCached = parseBooleanOnly(values[STRINGS.onlyIfCached]);
                                this["private"] = parseBooleanOnly(values[STRINGS["private"]]);
                                this.proxyRevalidate = parseBooleanOnly(values[STRINGS.proxyRevalidate]);
                                this["public"] = parseBooleanOnly(values[STRINGS["public"]]);
                                return this;
                            }
                        }, {
                            key: "format",
                            value: function format() {
                                var tokens = [];

                                if (this.maxAge) {
                                    tokens.push("".concat(STRINGS.maxAge, "=").concat(this.maxAge));
                                }

                                if (this.sharedMaxAge) {
                                    tokens.push("".concat(STRINGS.sharedMaxAge, "=").concat(this.sharedMaxAge));
                                }

                                if (this.maxStale) {
                                    if (this.maxStaleDuration) {
                                        tokens.push("".concat(STRINGS.maxStale, "=").concat(this.maxStaleDuration));
                                    } else {
                                        tokens.push(STRINGS.maxStale);
                                    }
                                }

                                if (this.minFresh) {
                                    tokens.push("".concat(STRINGS.minFresh, "=").concat(this.minFresh));
                                }

                                if (this.immutable) {
                                    tokens.push(STRINGS.immutable);
                                }

                                if (this.mustRevalidate) {
                                    tokens.push(STRINGS.mustRevalidate);
                                }

                                if (this.noCache) {
                                    tokens.push(STRINGS.noCache);
                                }

                                if (this.noStore) {
                                    tokens.push(STRINGS.noStore);
                                }

                                if (this.noTransform) {
                                    tokens.push(STRINGS.noTransform);
                                }

                                if (this.onlyIfCached) {
                                    tokens.push(STRINGS.onlyIfCached);
                                }

                                if (this["private"]) {
                                    tokens.push(STRINGS["private"]);
                                }

                                if (this.proxyRevalidate) {
                                    tokens.push(STRINGS.proxyRevalidate);
                                }

                                if (this["public"]) {
                                    tokens.push(STRINGS["public"]);
                                }

                                return tokens.join(', ');
                            }
                        }]);

                        return CacheControl;
                    }();

                    function parse(header) {
                        var cc = new CacheControl();
                        return cc.parse(header);
                    }

                    function format(cc) {
                        if (!(cc instanceof CacheControl)) {
                            return CacheControl.prototype.format.call(cc);
                        }

                        return cc.format();
                    }


/* harmony default export */ __webpack_exports__["default"] = ({
                        CacheControl: CacheControl,
                        parse: parse,
                        format: format
                    });

                    /***/
}),

/***/ "./node_modules/charenc/charenc.js":
/*!*****************************************!*\
  !*** ./node_modules/charenc/charenc.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    var charenc = {
                        // UTF-8 encoding
                        utf8: {
                            // Convert a string to a byte array
                            stringToBytes: function (str) {
                                return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
                            },

                            // Convert a byte array to a string
                            bytesToString: function (bytes) {
                                return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
                            }
                        },

                        // Binary encoding
                        bin: {
                            // Convert a string to a byte array
                            stringToBytes: function (str) {
                                for (var bytes = [], i = 0; i < str.length; i++)
                                    bytes.push(str.charCodeAt(i) & 0xFF);
                                return bytes;
                            },

                            // Convert a byte array to a string
                            bytesToString: function (bytes) {
                                for (var str = [], i = 0; i < bytes.length; i++)
                                    str.push(String.fromCharCode(bytes[i]));
                                return str.join('');
                            }
                        }
                    };

                    module.exports = charenc;


                    /***/
}),

/***/ "./node_modules/core-js/modules/_a-function.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_a-function.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = function (it) {
                        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
                        return it;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_add-to-unscopables.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/_add-to-unscopables.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 22.1.3.31 Array.prototype[@@unscopables]
                    var UNSCOPABLES = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('unscopables');
                    var ArrayProto = Array.prototype;
                    if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
                    module.exports = function (key) {
                        ArrayProto[UNSCOPABLES][key] = true;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_advance-string-index.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/_advance-string-index.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var at = __webpack_require__(/*! ./_string-at */ "./node_modules/core-js/modules/_string-at.js")(true);

                    // `AdvanceStringIndex` abstract operation
                    // https://tc39.github.io/ecma262/#sec-advancestringindex
                    module.exports = function (S, index, unicode) {
                        return index + (unicode ? at(S, index).length : 1);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_an-object.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_an-object.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/modules/_is-object.js");
                    module.exports = function (it) {
                        if (!isObject(it)) throw TypeError(it + ' is not an object!');
                        return it;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_array-includes.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/_array-includes.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // false -> Array#indexOf
                    // true  -> Array#includes
                    var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/modules/_to-iobject.js");
                    var toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/modules/_to-length.js");
                    var toAbsoluteIndex = __webpack_require__(/*! ./_to-absolute-index */ "./node_modules/core-js/modules/_to-absolute-index.js");
                    module.exports = function (IS_INCLUDES) {
                        return function ($this, el, fromIndex) {
                            var O = toIObject($this);
                            var length = toLength(O.length);
                            var index = toAbsoluteIndex(fromIndex, length);
                            var value;
                            // Array#includes uses SameValueZero equality algorithm
                            // eslint-disable-next-line no-self-compare
                            if (IS_INCLUDES && el != el) while (length > index) {
                                value = O[index++];
                                // eslint-disable-next-line no-self-compare
                                if (value != value) return true;
                                // Array#indexOf ignores holes, Array#includes - not
                            } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
                                if (O[index] === el) return IS_INCLUDES || index || 0;
                            } return !IS_INCLUDES && -1;
                        };
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_bind.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/modules/_bind.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/modules/_a-function.js");
                    var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/modules/_is-object.js");
                    var invoke = __webpack_require__(/*! ./_invoke */ "./node_modules/core-js/modules/_invoke.js");
                    var arraySlice = [].slice;
                    var factories = {};

                    var construct = function (F, len, args) {
                        if (!(len in factories)) {
                            for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
                            // eslint-disable-next-line no-new-func
                            factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
                        } return factories[len](F, args);
                    };

                    module.exports = Function.bind || function bind(that /* , ...args */) {
                        var fn = aFunction(this);
                        var partArgs = arraySlice.call(arguments, 1);
                        var bound = function (/* args... */) {
                            var args = partArgs.concat(arraySlice.call(arguments));
                            return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
                        };
                        if (isObject(fn.prototype)) bound.prototype = fn.prototype;
                        return bound;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_classof.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/modules/_classof.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // getting tag from 19.1.3.6 Object.prototype.toString()
                    var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/modules/_cof.js");
                    var TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('toStringTag');
                    // ES3 wrong here
                    var ARG = cof(function () { return arguments; }()) == 'Arguments';

                    // fallback for IE11 Script Access Denied error
                    var tryGet = function (it, key) {
                        try {
                            return it[key];
                        } catch (e) { /* empty */ }
                    };

                    module.exports = function (it) {
                        var O, T, B;
                        return it === undefined ? 'Undefined' : it === null ? 'Null'
                            // @@toStringTag case
                            : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
                                // builtinTag case
                                : ARG ? cof(O)
                                    // ES3 arguments fallback
                                    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_cof.js":
/*!**********************************************!*\
  !*** ./node_modules/core-js/modules/_cof.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    var toString = {}.toString;

                    module.exports = function (it) {
                        return toString.call(it).slice(8, -1);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_core.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/modules/_core.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    var core = module.exports = { version: '2.6.12' };
                    if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


                    /***/
}),

/***/ "./node_modules/core-js/modules/_create-property.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/_create-property.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var $defineProperty = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js");
                    var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/modules/_property-desc.js");

                    module.exports = function (object, index, value) {
                        if (index in object) $defineProperty.f(object, index, createDesc(0, value));
                        else object[index] = value;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_ctx.js":
/*!**********************************************!*\
  !*** ./node_modules/core-js/modules/_ctx.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // optional / simple context binding
                    var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/modules/_a-function.js");
                    module.exports = function (fn, that, length) {
                        aFunction(fn);
                        if (that === undefined) return fn;
                        switch (length) {
                            case 1: return function (a) {
                                return fn.call(that, a);
                            };
                            case 2: return function (a, b) {
                                return fn.call(that, a, b);
                            };
                            case 3: return function (a, b, c) {
                                return fn.call(that, a, b, c);
                            };
                        }
                        return function (/* ...args */) {
                            return fn.apply(that, arguments);
                        };
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_defined.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/modules/_defined.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    // 7.2.1 RequireObjectCoercible(argument)
                    module.exports = function (it) {
                        if (it == undefined) throw TypeError("Can't call method on  " + it);
                        return it;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_descriptors.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_descriptors.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // Thank's IE8 for his funny defineProperty
                    module.exports = !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/modules/_fails.js")(function () {
                        return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/_dom-create.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_dom-create.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/modules/_is-object.js");
                    var document = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js").document;
                    // typeof document.createElement is 'object' in old IE
                    var is = isObject(document) && isObject(document.createElement);
                    module.exports = function (it) {
                        return is ? document.createElement(it) : {};
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_enum-bug-keys.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/_enum-bug-keys.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    // IE 8- don't enum bug keys
                    module.exports = (
                        'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
                    ).split(',');


                    /***/
}),

/***/ "./node_modules/core-js/modules/_enum-keys.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_enum-keys.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // all enumerable object keys, includes symbols
                    var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/modules/_object-keys.js");
                    var gOPS = __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/modules/_object-gops.js");
                    var pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/modules/_object-pie.js");
                    module.exports = function (it) {
                        var result = getKeys(it);
                        var getSymbols = gOPS.f;
                        if (getSymbols) {
                            var symbols = getSymbols(it);
                            var isEnum = pIE.f;
                            var i = 0;
                            var key;
                            while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
                        } return result;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_export.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/modules/_export.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js");
                    var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/modules/_core.js");
                    var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js");
                    var redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/modules/_redefine.js");
                    var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/modules/_ctx.js");
                    var PROTOTYPE = 'prototype';

                    var $export = function (type, name, source) {
                        var IS_FORCED = type & $export.F;
                        var IS_GLOBAL = type & $export.G;
                        var IS_STATIC = type & $export.S;
                        var IS_PROTO = type & $export.P;
                        var IS_BIND = type & $export.B;
                        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
                        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
                        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
                        var key, own, out, exp;
                        if (IS_GLOBAL) source = name;
                        for (key in source) {
                            // contains in native
                            own = !IS_FORCED && target && target[key] !== undefined;
                            // export native or passed
                            out = (own ? target : source)[key];
                            // bind timers to global for call from export context
                            exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
                            // extend global
                            if (target) redefine(target, key, out, type & $export.U);
                            // export
                            if (exports[key] != out) hide(exports, key, exp);
                            if (IS_PROTO && expProto[key] != out) expProto[key] = out;
                        }
                    };
                    global.core = core;
                    // type bitmap
                    $export.F = 1;   // forced
                    $export.G = 2;   // global
                    $export.S = 4;   // static
                    $export.P = 8;   // proto
                    $export.B = 16;  // bind
                    $export.W = 32;  // wrap
                    $export.U = 64;  // safe
                    $export.R = 128; // real proto method for `library`
                    module.exports = $export;


                    /***/
}),

/***/ "./node_modules/core-js/modules/_fails-is-regexp.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/_fails-is-regexp.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var MATCH = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('match');
                    module.exports = function (KEY) {
                        var re = /./;
                        try {
                            '/./'[KEY](re);
                        } catch (e) {
                            try {
                                re[MATCH] = false;
                                return !'/./'[KEY](re);
                            } catch (f) { /* empty */ }
                        } return true;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_fails.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/modules/_fails.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = function (exec) {
                        try {
                            return !!exec();
                        } catch (e) {
                            return true;
                        }
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_fix-re-wks.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_fix-re-wks.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    __webpack_require__(/*! ./es6.regexp.exec */ "./node_modules/core-js/modules/es6.regexp.exec.js");
                    var redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/modules/_redefine.js");
                    var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js");
                    var fails = __webpack_require__(/*! ./_fails */ "./node_modules/core-js/modules/_fails.js");
                    var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/modules/_defined.js");
                    var wks = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js");
                    var regexpExec = __webpack_require__(/*! ./_regexp-exec */ "./node_modules/core-js/modules/_regexp-exec.js");

                    var SPECIES = wks('species');

                    var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
                        // #replace needs built-in support for named groups.
                        // #match works fine because it just return the exec results, even if it has
                        // a "grops" property.
                        var re = /./;
                        re.exec = function () {
                            var result = [];
                            result.groups = { a: '7' };
                            return result;
                        };
                        return ''.replace(re, '$<a>') !== '7';
                    });

                    var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
                        // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
                        var re = /(?:)/;
                        var originalExec = re.exec;
                        re.exec = function () { return originalExec.apply(this, arguments); };
                        var result = 'ab'.split(re);
                        return result.length === 2 && result[0] === 'a' && result[1] === 'b';
                    })();

                    module.exports = function (KEY, length, exec) {
                        var SYMBOL = wks(KEY);

                        var DELEGATES_TO_SYMBOL = !fails(function () {
                            // String methods call symbol-named RegEp methods
                            var O = {};
                            O[SYMBOL] = function () { return 7; };
                            return ''[KEY](O) != 7;
                        });

                        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
                            // Symbol-named RegExp methods call .exec
                            var execCalled = false;
                            var re = /a/;
                            re.exec = function () { execCalled = true; return null; };
                            if (KEY === 'split') {
                                // RegExp[@@split] doesn't call the regex's exec method, but first creates
                                // a new one. We need to return the patched regex when creating the new one.
                                re.constructor = {};
                                re.constructor[SPECIES] = function () { return re; };
                            }
                            re[SYMBOL]('');
                            return !execCalled;
                        }) : undefined;

                        if (
                            !DELEGATES_TO_SYMBOL ||
                            !DELEGATES_TO_EXEC ||
                            (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
                            (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
                        ) {
                            var nativeRegExpMethod = /./[SYMBOL];
                            var fns = exec(
                                defined,
                                SYMBOL,
                                ''[KEY],
                                function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
                                    if (regexp.exec === regexpExec) {
                                        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                                            // The native String method already delegates to @@method (this
                                            // polyfilled function), leasing to infinite recursion.
                                            // We avoid it by directly calling the native @@method method.
                                            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
                                        }
                                        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
                                    }
                                    return { done: false };
                                }
                            );
                            var strfn = fns[0];
                            var rxfn = fns[1];

                            redefine(String.prototype, KEY, strfn);
                            hide(RegExp.prototype, SYMBOL, length == 2
                                // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
                                // 21.2.5.11 RegExp.prototype[@@split](string, limit)
                                ? function (string, arg) { return rxfn.call(string, this, arg); }
                                // 21.2.5.6 RegExp.prototype[@@match](string)
                                // 21.2.5.9 RegExp.prototype[@@search](string)
                                : function (string) { return rxfn.call(string, this); }
                            );
                        }
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_flags.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/modules/_flags.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 21.2.5.3 get RegExp.prototype.flags
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    module.exports = function () {
                        var that = anObject(this);
                        var result = '';
                        if (that.global) result += 'g';
                        if (that.ignoreCase) result += 'i';
                        if (that.multiline) result += 'm';
                        if (that.unicode) result += 'u';
                        if (that.sticky) result += 'y';
                        return result;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_function-to-string.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/_function-to-string.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    module.exports = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);


                    /***/
}),

/***/ "./node_modules/core-js/modules/_global.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/modules/_global.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                    var global = module.exports = typeof window != 'undefined' && window.Math == Math
                        ? window : typeof self != 'undefined' && self.Math == Math ? self
                            // eslint-disable-next-line no-new-func
                            : Function('return this')();
                    if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


                    /***/
}),

/***/ "./node_modules/core-js/modules/_has.js":
/*!**********************************************!*\
  !*** ./node_modules/core-js/modules/_has.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    var hasOwnProperty = {}.hasOwnProperty;
                    module.exports = function (it, key) {
                        return hasOwnProperty.call(it, key);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_hide.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/modules/_hide.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js");
                    var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/modules/_property-desc.js");
                    module.exports = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
                        return dP.f(object, key, createDesc(1, value));
                    } : function (object, key, value) {
                        object[key] = value;
                        return object;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_html.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/modules/_html.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var document = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js").document;
                    module.exports = document && document.documentElement;


                    /***/
}),

/***/ "./node_modules/core-js/modules/_ie8-dom-define.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/_ie8-dom-define.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    module.exports = !__webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/modules/_fails.js")(function () {
                        return Object.defineProperty(__webpack_require__(/*! ./_dom-create */ "./node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/_invoke.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/modules/_invoke.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    // fast apply, http://jsperf.lnkit.com/fast-apply/5
                    module.exports = function (fn, args, that) {
                        var un = that === undefined;
                        switch (args.length) {
                            case 0: return un ? fn()
                                : fn.call(that);
                            case 1: return un ? fn(args[0])
                                : fn.call(that, args[0]);
                            case 2: return un ? fn(args[0], args[1])
                                : fn.call(that, args[0], args[1]);
                            case 3: return un ? fn(args[0], args[1], args[2])
                                : fn.call(that, args[0], args[1], args[2]);
                            case 4: return un ? fn(args[0], args[1], args[2], args[3])
                                : fn.call(that, args[0], args[1], args[2], args[3]);
                        } return fn.apply(that, args);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_iobject.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/modules/_iobject.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // fallback for non-array-like ES3 and non-enumerable old V8 strings
                    var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/modules/_cof.js");
                    // eslint-disable-next-line no-prototype-builtins
                    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
                        return cof(it) == 'String' ? it.split('') : Object(it);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_is-array-iter.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/_is-array-iter.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // check on default Array iterator
                    var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/modules/_iterators.js");
                    var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('iterator');
                    var ArrayProto = Array.prototype;

                    module.exports = function (it) {
                        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_is-array.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/modules/_is-array.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 7.2.2 IsArray(argument)
                    var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/modules/_cof.js");
                    module.exports = Array.isArray || function isArray(arg) {
                        return cof(arg) == 'Array';
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_is-object.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_is-object.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = function (it) {
                        return typeof it === 'object' ? it !== null : typeof it === 'function';
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_is-regexp.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_is-regexp.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 7.2.8 IsRegExp(argument)
                    var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/modules/_is-object.js");
                    var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/modules/_cof.js");
                    var MATCH = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('match');
                    module.exports = function (it) {
                        var isRegExp;
                        return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_iter-call.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_iter-call.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // call something on iterator step with safe closing on error
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    module.exports = function (iterator, fn, value, entries) {
                        try {
                            return entries ? fn(anObject(value)[0], value[1]) : fn(value);
                            // 7.4.6 IteratorClose(iterator, completion)
                        } catch (e) {
                            var ret = iterator['return'];
                            if (ret !== undefined) anObject(ret.call(iterator));
                            throw e;
                        }
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_iter-create.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_iter-create.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var create = __webpack_require__(/*! ./_object-create */ "./node_modules/core-js/modules/_object-create.js");
                    var descriptor = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/modules/_property-desc.js");
                    var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/modules/_set-to-string-tag.js");
                    var IteratorPrototype = {};

                    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
                    __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('iterator'), function () { return this; });

                    module.exports = function (Constructor, NAME, next) {
                        Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
                        setToStringTag(Constructor, NAME + ' Iterator');
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_iter-define.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_iter-define.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var LIBRARY = __webpack_require__(/*! ./_library */ "./node_modules/core-js/modules/_library.js");
                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");
                    var redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/modules/_redefine.js");
                    var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js");
                    var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/modules/_iterators.js");
                    var $iterCreate = __webpack_require__(/*! ./_iter-create */ "./node_modules/core-js/modules/_iter-create.js");
                    var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/modules/_set-to-string-tag.js");
                    var getPrototypeOf = __webpack_require__(/*! ./_object-gpo */ "./node_modules/core-js/modules/_object-gpo.js");
                    var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('iterator');
                    var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
                    var FF_ITERATOR = '@@iterator';
                    var KEYS = 'keys';
                    var VALUES = 'values';

                    var returnThis = function () { return this; };

                    module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
                        $iterCreate(Constructor, NAME, next);
                        var getMethod = function (kind) {
                            if (!BUGGY && kind in proto) return proto[kind];
                            switch (kind) {
                                case KEYS: return function keys() { return new Constructor(this, kind); };
                                case VALUES: return function values() { return new Constructor(this, kind); };
                            } return function entries() { return new Constructor(this, kind); };
                        };
                        var TAG = NAME + ' Iterator';
                        var DEF_VALUES = DEFAULT == VALUES;
                        var VALUES_BUG = false;
                        var proto = Base.prototype;
                        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
                        var $default = $native || getMethod(DEFAULT);
                        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
                        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
                        var methods, key, IteratorPrototype;
                        // Fix native
                        if ($anyNative) {
                            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
                            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                                // Set @@toStringTag to native iterators
                                setToStringTag(IteratorPrototype, TAG, true);
                                // fix for some old engines
                                if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
                            }
                        }
                        // fix Array#{values, @@iterator}.name in V8 / FF
                        if (DEF_VALUES && $native && $native.name !== VALUES) {
                            VALUES_BUG = true;
                            $default = function values() { return $native.call(this); };
                        }
                        // Define iterator
                        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
                            hide(proto, ITERATOR, $default);
                        }
                        // Plug for library
                        Iterators[NAME] = $default;
                        Iterators[TAG] = returnThis;
                        if (DEFAULT) {
                            methods = {
                                values: DEF_VALUES ? $default : getMethod(VALUES),
                                keys: IS_SET ? $default : getMethod(KEYS),
                                entries: $entries
                            };
                            if (FORCED) for (key in methods) {
                                if (!(key in proto)) redefine(proto, key, methods[key]);
                            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
                        }
                        return methods;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_iter-detect.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_iter-detect.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('iterator');
                    var SAFE_CLOSING = false;

                    try {
                        var riter = [7][ITERATOR]();
                        riter['return'] = function () { SAFE_CLOSING = true; };
                        // eslint-disable-next-line no-throw-literal
                        Array.from(riter, function () { throw 2; });
                    } catch (e) { /* empty */ }

                    module.exports = function (exec, skipClosing) {
                        if (!skipClosing && !SAFE_CLOSING) return false;
                        var safe = false;
                        try {
                            var arr = [7];
                            var iter = arr[ITERATOR]();
                            iter.next = function () { return { done: safe = true }; };
                            arr[ITERATOR] = function () { return iter; };
                            exec(arr);
                        } catch (e) { /* empty */ }
                        return safe;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_iter-step.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_iter-step.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = function (done, value) {
                        return { value: value, done: !!done };
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_iterators.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_iterators.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = {};


                    /***/
}),

/***/ "./node_modules/core-js/modules/_library.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/modules/_library.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = false;


                    /***/
}),

/***/ "./node_modules/core-js/modules/_meta.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/modules/_meta.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var META = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/modules/_uid.js")('meta');
                    var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/modules/_is-object.js");
                    var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/modules/_has.js");
                    var setDesc = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js").f;
                    var id = 0;
                    var isExtensible = Object.isExtensible || function () {
                        return true;
                    };
                    var FREEZE = !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/modules/_fails.js")(function () {
                        return isExtensible(Object.preventExtensions({}));
                    });
                    var setMeta = function (it) {
                        setDesc(it, META, {
                            value: {
                                i: 'O' + ++id, // object ID
                                w: {}          // weak collections IDs
                            }
                        });
                    };
                    var fastKey = function (it, create) {
                        // return primitive with prefix
                        if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                        if (!has(it, META)) {
                            // can't set metadata to uncaught frozen object
                            if (!isExtensible(it)) return 'F';
                            // not necessary to add metadata
                            if (!create) return 'E';
                            // add missing metadata
                            setMeta(it);
                            // return object ID
                        } return it[META].i;
                    };
                    var getWeak = function (it, create) {
                        if (!has(it, META)) {
                            // can't set metadata to uncaught frozen object
                            if (!isExtensible(it)) return true;
                            // not necessary to add metadata
                            if (!create) return false;
                            // add missing metadata
                            setMeta(it);
                            // return hash weak collections IDs
                        } return it[META].w;
                    };
                    // add metadata on freeze-family methods calling
                    var onFreeze = function (it) {
                        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
                        return it;
                    };
                    var meta = module.exports = {
                        KEY: META,
                        NEED: false,
                        fastKey: fastKey,
                        getWeak: getWeak,
                        onFreeze: onFreeze
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-create.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/_object-create.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    var dPs = __webpack_require__(/*! ./_object-dps */ "./node_modules/core-js/modules/_object-dps.js");
                    var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/modules/_enum-bug-keys.js");
                    var IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
                    var Empty = function () { /* empty */ };
                    var PROTOTYPE = 'prototype';

                    // Create object with fake `null` prototype: use iframe Object with cleared prototype
                    var createDict = function () {
                        // Thrash, waste and sodomy: IE GC bug
                        var iframe = __webpack_require__(/*! ./_dom-create */ "./node_modules/core-js/modules/_dom-create.js")('iframe');
                        var i = enumBugKeys.length;
                        var lt = '<';
                        var gt = '>';
                        var iframeDocument;
                        iframe.style.display = 'none';
                        __webpack_require__(/*! ./_html */ "./node_modules/core-js/modules/_html.js").appendChild(iframe);
                        iframe.src = 'javascript:'; // eslint-disable-line no-script-url
                        // createDict = iframe.contentWindow.Object;
                        // html.removeChild(iframe);
                        iframeDocument = iframe.contentWindow.document;
                        iframeDocument.open();
                        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
                        iframeDocument.close();
                        createDict = iframeDocument.F;
                        while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
                        return createDict();
                    };

                    module.exports = Object.create || function create(O, Properties) {
                        var result;
                        if (O !== null) {
                            Empty[PROTOTYPE] = anObject(O);
                            result = new Empty();
                            Empty[PROTOTYPE] = null;
                            // add "__proto__" for Object.getPrototypeOf polyfill
                            result[IE_PROTO] = O;
                        } else result = createDict();
                        return Properties === undefined ? result : dPs(result, Properties);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-dp.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_object-dp.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ "./node_modules/core-js/modules/_ie8-dom-define.js");
                    var toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/modules/_to-primitive.js");
                    var dP = Object.defineProperty;

                    exports.f = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
                        anObject(O);
                        P = toPrimitive(P, true);
                        anObject(Attributes);
                        if (IE8_DOM_DEFINE) try {
                            return dP(O, P, Attributes);
                        } catch (e) { /* empty */ }
                        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
                        if ('value' in Attributes) O[P] = Attributes.value;
                        return O;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-dps.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_object-dps.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js");
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/modules/_object-keys.js");

                    module.exports = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
                        anObject(O);
                        var keys = getKeys(Properties);
                        var length = keys.length;
                        var i = 0;
                        var P;
                        while (length > i) dP.f(O, P = keys[i++], Properties[P]);
                        return O;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-gopd.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_object-gopd.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/modules/_object-pie.js");
                    var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/modules/_property-desc.js");
                    var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/modules/_to-iobject.js");
                    var toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/modules/_to-primitive.js");
                    var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/modules/_has.js");
                    var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ "./node_modules/core-js/modules/_ie8-dom-define.js");
                    var gOPD = Object.getOwnPropertyDescriptor;

                    exports.f = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
                        O = toIObject(O);
                        P = toPrimitive(P, true);
                        if (IE8_DOM_DEFINE) try {
                            return gOPD(O, P);
                        } catch (e) { /* empty */ }
                        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-gopn-ext.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/_object-gopn-ext.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
                    var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/modules/_to-iobject.js");
                    var gOPN = __webpack_require__(/*! ./_object-gopn */ "./node_modules/core-js/modules/_object-gopn.js").f;
                    var toString = {}.toString;

                    var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
                        ? Object.getOwnPropertyNames(window) : [];

                    var getWindowNames = function (it) {
                        try {
                            return gOPN(it);
                        } catch (e) {
                            return windowNames.slice();
                        }
                    };

                    module.exports.f = function getOwnPropertyNames(it) {
                        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-gopn.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_object-gopn.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
                    var $keys = __webpack_require__(/*! ./_object-keys-internal */ "./node_modules/core-js/modules/_object-keys-internal.js");
                    var hiddenKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

                    exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                        return $keys(O, hiddenKeys);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-gops.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_object-gops.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    exports.f = Object.getOwnPropertySymbols;


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-gpo.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_object-gpo.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
                    var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/modules/_has.js");
                    var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/modules/_to-object.js");
                    var IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
                    var ObjectProto = Object.prototype;

                    module.exports = Object.getPrototypeOf || function (O) {
                        O = toObject(O);
                        if (has(O, IE_PROTO)) return O[IE_PROTO];
                        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
                            return O.constructor.prototype;
                        } return O instanceof Object ? ObjectProto : null;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-keys-internal.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/_object-keys-internal.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/modules/_has.js");
                    var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/modules/_to-iobject.js");
                    var arrayIndexOf = __webpack_require__(/*! ./_array-includes */ "./node_modules/core-js/modules/_array-includes.js")(false);
                    var IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

                    module.exports = function (object, names) {
                        var O = toIObject(object);
                        var i = 0;
                        var result = [];
                        var key;
                        for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
                        // Don't enum bug & hidden keys
                        while (names.length > i) if (has(O, key = names[i++])) {
                            ~arrayIndexOf(result, key) || result.push(key);
                        }
                        return result;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-keys.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_object-keys.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
                    var $keys = __webpack_require__(/*! ./_object-keys-internal */ "./node_modules/core-js/modules/_object-keys-internal.js");
                    var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/modules/_enum-bug-keys.js");

                    module.exports = Object.keys || function keys(O) {
                        return $keys(O, enumBugKeys);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_object-pie.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_object-pie.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    exports.f = {}.propertyIsEnumerable;


                    /***/
}),

/***/ "./node_modules/core-js/modules/_own-keys.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/modules/_own-keys.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // all object keys, includes non-enumerable and symbols
                    var gOPN = __webpack_require__(/*! ./_object-gopn */ "./node_modules/core-js/modules/_object-gopn.js");
                    var gOPS = __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/modules/_object-gops.js");
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    var Reflect = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js").Reflect;
                    module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
                        var keys = gOPN.f(anObject(it));
                        var getSymbols = gOPS.f;
                        return getSymbols ? keys.concat(getSymbols(it)) : keys;
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_property-desc.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/_property-desc.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = function (bitmap, value) {
                        return {
                            enumerable: !(bitmap & 1),
                            configurable: !(bitmap & 2),
                            writable: !(bitmap & 4),
                            value: value
                        };
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_redefine.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/modules/_redefine.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js");
                    var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js");
                    var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/modules/_has.js");
                    var SRC = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/modules/_uid.js")('src');
                    var $toString = __webpack_require__(/*! ./_function-to-string */ "./node_modules/core-js/modules/_function-to-string.js");
                    var TO_STRING = 'toString';
                    var TPL = ('' + $toString).split(TO_STRING);

                    __webpack_require__(/*! ./_core */ "./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
                        return $toString.call(it);
                    };

                    (module.exports = function (O, key, val, safe) {
                        var isFunction = typeof val == 'function';
                        if (isFunction) has(val, 'name') || hide(val, 'name', key);
                        if (O[key] === val) return;
                        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
                        if (O === global) {
                            O[key] = val;
                        } else if (!safe) {
                            delete O[key];
                            hide(O, key, val);
                        } else if (O[key]) {
                            O[key] = val;
                        } else {
                            hide(O, key, val);
                        }
                        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
                    })(Function.prototype, TO_STRING, function toString() {
                        return typeof this == 'function' && this[SRC] || $toString.call(this);
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/_regexp-exec-abstract.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/_regexp-exec-abstract.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {


                    var classof = __webpack_require__(/*! ./_classof */ "./node_modules/core-js/modules/_classof.js");
                    var builtinExec = RegExp.prototype.exec;

                    // `RegExpExec` abstract operation
                    // https://tc39.github.io/ecma262/#sec-regexpexec
                    module.exports = function (R, S) {
                        var exec = R.exec;
                        if (typeof exec === 'function') {
                            var result = exec.call(R, S);
                            if (typeof result !== 'object') {
                                throw new TypeError('RegExp exec method returned something other than an Object or null');
                            }
                            return result;
                        }
                        if (classof(R) !== 'RegExp') {
                            throw new TypeError('RegExp#exec called on incompatible receiver');
                        }
                        return builtinExec.call(R, S);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_regexp-exec.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/_regexp-exec.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {


                    var regexpFlags = __webpack_require__(/*! ./_flags */ "./node_modules/core-js/modules/_flags.js");

                    var nativeExec = RegExp.prototype.exec;
                    // This always refers to the native implementation, because the
                    // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
                    // which loads this file before patching the method.
                    var nativeReplace = String.prototype.replace;

                    var patchedExec = nativeExec;

                    var LAST_INDEX = 'lastIndex';

                    var UPDATES_LAST_INDEX_WRONG = (function () {
                        var re1 = /a/,
                            re2 = /b*/g;
                        nativeExec.call(re1, 'a');
                        nativeExec.call(re2, 'a');
                        return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
                    })();

                    // nonparticipating capturing group, copied from es5-shim's String#split patch.
                    var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

                    var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

                    if (PATCH) {
                        patchedExec = function exec(str) {
                            var re = this;
                            var lastIndex, reCopy, match, i;

                            if (NPCG_INCLUDED) {
                                reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
                            }
                            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

                            match = nativeExec.call(re, str);

                            if (UPDATES_LAST_INDEX_WRONG && match) {
                                re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
                            }
                            if (NPCG_INCLUDED && match && match.length > 1) {
                                // Fix browsers whose `exec` methods don't consistently return `undefined`
                                // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
                                // eslint-disable-next-line no-loop-func
                                nativeReplace.call(match[0], reCopy, function () {
                                    for (i = 1; i < arguments.length - 2; i++) {
                                        if (arguments[i] === undefined) match[i] = undefined;
                                    }
                                });
                            }

                            return match;
                        };
                    }

                    module.exports = patchedExec;


                    /***/
}),

/***/ "./node_modules/core-js/modules/_set-to-string-tag.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/_set-to-string-tag.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var def = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js").f;
                    var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/modules/_has.js");
                    var TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('toStringTag');

                    module.exports = function (it, tag, stat) {
                        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_shared-key.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_shared-key.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var shared = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/modules/_shared.js")('keys');
                    var uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/modules/_uid.js");
                    module.exports = function (key) {
                        return shared[key] || (shared[key] = uid(key));
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_shared.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/modules/_shared.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/modules/_core.js");
                    var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js");
                    var SHARED = '__core-js_shared__';
                    var store = global[SHARED] || (global[SHARED] = {});

                    (module.exports = function (key, value) {
                        return store[key] || (store[key] = value !== undefined ? value : {});
                    })('versions', []).push({
                        version: core.version,
                        mode: __webpack_require__(/*! ./_library */ "./node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
                        copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/_species-constructor.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/modules/_species-constructor.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 7.3.20 SpeciesConstructor(O, defaultConstructor)
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/modules/_a-function.js");
                    var SPECIES = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('species');
                    module.exports = function (O, D) {
                        var C = anObject(O).constructor;
                        var S;
                        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_string-at.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_string-at.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/modules/_to-integer.js");
                    var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/modules/_defined.js");
                    // true  -> String#at
                    // false -> String#codePointAt
                    module.exports = function (TO_STRING) {
                        return function (that, pos) {
                            var s = String(defined(that));
                            var i = toInteger(pos);
                            var l = s.length;
                            var a, b;
                            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
                            a = s.charCodeAt(i);
                            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
                                ? TO_STRING ? s.charAt(i) : a
                                : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
                        };
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_string-context.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/_string-context.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // helper for String#{startsWith, endsWith, includes}
                    var isRegExp = __webpack_require__(/*! ./_is-regexp */ "./node_modules/core-js/modules/_is-regexp.js");
                    var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/modules/_defined.js");

                    module.exports = function (that, searchString, NAME) {
                        if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
                        return String(defined(that));
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_to-absolute-index.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/_to-absolute-index.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/modules/_to-integer.js");
                    var max = Math.max;
                    var min = Math.min;
                    module.exports = function (index, length) {
                        index = toInteger(index);
                        return index < 0 ? max(index + length, 0) : min(index, length);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_to-integer.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_to-integer.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    // 7.1.4 ToInteger
                    var ceil = Math.ceil;
                    var floor = Math.floor;
                    module.exports = function (it) {
                        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_to-iobject.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_to-iobject.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // to indexed object, toObject with fallback for non-array-like ES3 strings
                    var IObject = __webpack_require__(/*! ./_iobject */ "./node_modules/core-js/modules/_iobject.js");
                    var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/modules/_defined.js");
                    module.exports = function (it) {
                        return IObject(defined(it));
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_to-length.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_to-length.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 7.1.15 ToLength
                    var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/modules/_to-integer.js");
                    var min = Math.min;
                    module.exports = function (it) {
                        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_to-object.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/_to-object.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 7.1.13 ToObject(argument)
                    var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/modules/_defined.js");
                    module.exports = function (it) {
                        return Object(defined(it));
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_to-primitive.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/_to-primitive.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 7.1.1 ToPrimitive(input [, PreferredType])
                    var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/modules/_is-object.js");
                    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
                    // and the second argument - flag - preferred type is a string
                    module.exports = function (it, S) {
                        if (!isObject(it)) return it;
                        var fn, val;
                        if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                        if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
                        if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                        throw TypeError("Can't convert object to primitive value");
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_uid.js":
/*!**********************************************!*\
  !*** ./node_modules/core-js/modules/_uid.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    var id = 0;
                    var px = Math.random();
                    module.exports = function (key) {
                        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_wks-define.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/_wks-define.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js");
                    var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/modules/_core.js");
                    var LIBRARY = __webpack_require__(/*! ./_library */ "./node_modules/core-js/modules/_library.js");
                    var wksExt = __webpack_require__(/*! ./_wks-ext */ "./node_modules/core-js/modules/_wks-ext.js");
                    var defineProperty = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js").f;
                    module.exports = function (name) {
                        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
                        if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/_wks-ext.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/modules/_wks-ext.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    exports.f = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js");


                    /***/
}),

/***/ "./node_modules/core-js/modules/_wks.js":
/*!**********************************************!*\
  !*** ./node_modules/core-js/modules/_wks.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var store = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/modules/_shared.js")('wks');
                    var uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/modules/_uid.js");
                    var Symbol = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js").Symbol;
                    var USE_SYMBOL = typeof Symbol == 'function';

                    var $exports = module.exports = function (name) {
                        return store[name] || (store[name] =
                            USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
                    };

                    $exports.store = store;


                    /***/
}),

/***/ "./node_modules/core-js/modules/core.get-iterator-method.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/modules/core.get-iterator-method.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var classof = __webpack_require__(/*! ./_classof */ "./node_modules/core-js/modules/_classof.js");
                    var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('iterator');
                    var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/modules/_iterators.js");
                    module.exports = __webpack_require__(/*! ./_core */ "./node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
                        if (it != undefined) return it[ITERATOR]
                            || it['@@iterator']
                            || Iterators[classof(it)];
                    };


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.array.from.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es6.array.from.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/modules/_ctx.js");
                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");
                    var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/modules/_to-object.js");
                    var call = __webpack_require__(/*! ./_iter-call */ "./node_modules/core-js/modules/_iter-call.js");
                    var isArrayIter = __webpack_require__(/*! ./_is-array-iter */ "./node_modules/core-js/modules/_is-array-iter.js");
                    var toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/modules/_to-length.js");
                    var createProperty = __webpack_require__(/*! ./_create-property */ "./node_modules/core-js/modules/_create-property.js");
                    var getIterFn = __webpack_require__(/*! ./core.get-iterator-method */ "./node_modules/core-js/modules/core.get-iterator-method.js");

                    $export($export.S + $export.F * !__webpack_require__(/*! ./_iter-detect */ "./node_modules/core-js/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
                        // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
                        from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
                            var O = toObject(arrayLike);
                            var C = typeof this == 'function' ? this : Array;
                            var aLen = arguments.length;
                            var mapfn = aLen > 1 ? arguments[1] : undefined;
                            var mapping = mapfn !== undefined;
                            var index = 0;
                            var iterFn = getIterFn(O);
                            var length, result, step, iterator;
                            if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
                            // if object isn't iterable or it's array with default iterator - use simple case
                            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
                                for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                                    createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
                                }
                            } else {
                                length = toLength(O.length);
                                for (result = new C(length); length > index; index++) {
                                    createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
                                }
                            }
                            result.length = index;
                            return result;
                        }
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.array.iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es6.array.iterator.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var addToUnscopables = __webpack_require__(/*! ./_add-to-unscopables */ "./node_modules/core-js/modules/_add-to-unscopables.js");
                    var step = __webpack_require__(/*! ./_iter-step */ "./node_modules/core-js/modules/_iter-step.js");
                    var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/modules/_iterators.js");
                    var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/modules/_to-iobject.js");

                    // 22.1.3.4 Array.prototype.entries()
                    // 22.1.3.13 Array.prototype.keys()
                    // 22.1.3.29 Array.prototype.values()
                    // 22.1.3.30 Array.prototype[@@iterator]()
                    module.exports = __webpack_require__(/*! ./_iter-define */ "./node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
                        this._t = toIObject(iterated); // target
                        this._i = 0;                   // next index
                        this._k = kind;                // kind
                        // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
                    }, function () {
                        var O = this._t;
                        var kind = this._k;
                        var index = this._i++;
                        if (!O || index >= O.length) {
                            this._t = undefined;
                            return step(1);
                        }
                        if (kind == 'keys') return step(0, index);
                        if (kind == 'values') return step(0, O[index]);
                        return step(0, [index, O[index]]);
                    }, 'values');

                    // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
                    Iterators.Arguments = Iterators.Array;

                    addToUnscopables('keys');
                    addToUnscopables('values');
                    addToUnscopables('entries');


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.function.bind.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es6.function.bind.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");

                    $export($export.P, 'Function', { bind: __webpack_require__(/*! ./_bind */ "./node_modules/core-js/modules/_bind.js") });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.function.name.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es6.function.name.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js").f;
                    var FProto = Function.prototype;
                    var nameRE = /^\s*function ([^ (]*)/;
                    var NAME = 'name';

                    // 19.2.4.2 name
                    NAME in FProto || __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
                        configurable: true,
                        get: function () {
                            try {
                                return ('' + this).match(nameRE)[1];
                            } catch (e) {
                                return '';
                            }
                        }
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.number.is-finite.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/modules/es6.number.is-finite.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 20.1.2.2 Number.isFinite(number)
                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");
                    var _isFinite = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js").isFinite;

                    $export($export.S, 'Number', {
                        isFinite: function isFinite(it) {
                            return typeof it == 'number' && _isFinite(it);
                        }
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.object.to-string.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/modules/es6.object.to-string.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // 19.1.3.6 Object.prototype.toString()
                    var classof = __webpack_require__(/*! ./_classof */ "./node_modules/core-js/modules/_classof.js");
                    var test = {};
                    test[__webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js")('toStringTag')] = 'z';
                    if (test + '' != '[object z]') {
                        __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/modules/_redefine.js")(Object.prototype, 'toString', function toString() {
                            return '[object ' + classof(this) + ']';
                        }, true);
                    }


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.regexp.exec.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es6.regexp.exec.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var regexpExec = __webpack_require__(/*! ./_regexp-exec */ "./node_modules/core-js/modules/_regexp-exec.js");
                    __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js")({
                        target: 'RegExp',
                        proto: true,
                        forced: regexpExec !== /./.exec
                    }, {
                        exec: regexpExec
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.regexp.split.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es6.regexp.split.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {


                    var isRegExp = __webpack_require__(/*! ./_is-regexp */ "./node_modules/core-js/modules/_is-regexp.js");
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    var speciesConstructor = __webpack_require__(/*! ./_species-constructor */ "./node_modules/core-js/modules/_species-constructor.js");
                    var advanceStringIndex = __webpack_require__(/*! ./_advance-string-index */ "./node_modules/core-js/modules/_advance-string-index.js");
                    var toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/modules/_to-length.js");
                    var callRegExpExec = __webpack_require__(/*! ./_regexp-exec-abstract */ "./node_modules/core-js/modules/_regexp-exec-abstract.js");
                    var regexpExec = __webpack_require__(/*! ./_regexp-exec */ "./node_modules/core-js/modules/_regexp-exec.js");
                    var fails = __webpack_require__(/*! ./_fails */ "./node_modules/core-js/modules/_fails.js");
                    var $min = Math.min;
                    var $push = [].push;
                    var $SPLIT = 'split';
                    var LENGTH = 'length';
                    var LAST_INDEX = 'lastIndex';
                    var MAX_UINT32 = 0xffffffff;

                    // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
                    var SUPPORTS_Y = !fails(function () { });

                    // @@split logic
                    __webpack_require__(/*! ./_fix-re-wks */ "./node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
                        var internalSplit;
                        if (
                            'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
                            'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
                            'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
                            '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
                            '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
                            ''[$SPLIT](/.?/)[LENGTH]
                        ) {
                            // based on es5-shim implementation, need to rework it
                            internalSplit = function (separator, limit) {
                                var string = String(this);
                                if (separator === undefined && limit === 0) return [];
                                // If `separator` is not a regex, use native split
                                if (!isRegExp(separator)) return $split.call(string, separator, limit);
                                var output = [];
                                var flags = (separator.ignoreCase ? 'i' : '') +
                                    (separator.multiline ? 'm' : '') +
                                    (separator.unicode ? 'u' : '') +
                                    (separator.sticky ? 'y' : '');
                                var lastLastIndex = 0;
                                var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
                                // Make `global` and avoid `lastIndex` issues by working with a copy
                                var separatorCopy = new RegExp(separator.source, flags + 'g');
                                var match, lastIndex, lastLength;
                                while (match = regexpExec.call(separatorCopy, string)) {
                                    lastIndex = separatorCopy[LAST_INDEX];
                                    if (lastIndex > lastLastIndex) {
                                        output.push(string.slice(lastLastIndex, match.index));
                                        if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                                        lastLength = match[0][LENGTH];
                                        lastLastIndex = lastIndex;
                                        if (output[LENGTH] >= splitLimit) break;
                                    }
                                    if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
                                }
                                if (lastLastIndex === string[LENGTH]) {
                                    if (lastLength || !separatorCopy.test('')) output.push('');
                                } else output.push(string.slice(lastLastIndex));
                                return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
                            };
                            // Chakra, V8
                        } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
                            internalSplit = function (separator, limit) {
                                return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
                            };
                        } else {
                            internalSplit = $split;
                        }

                        return [
                            // `String.prototype.split` method
                            // https://tc39.github.io/ecma262/#sec-string.prototype.split
                            function split(separator, limit) {
                                var O = defined(this);
                                var splitter = separator == undefined ? undefined : separator[SPLIT];
                                return splitter !== undefined
                                    ? splitter.call(separator, O, limit)
                                    : internalSplit.call(String(O), separator, limit);
                            },
                            // `RegExp.prototype[@@split]` method
                            // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
                            //
                            // NOTE: This cannot be properly polyfilled in engines that don't support
                            // the 'y' flag.
                            function (regexp, limit) {
                                var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
                                if (res.done) return res.value;

                                var rx = anObject(regexp);
                                var S = String(this);
                                var C = speciesConstructor(rx, RegExp);

                                var unicodeMatching = rx.unicode;
                                var flags = (rx.ignoreCase ? 'i' : '') +
                                    (rx.multiline ? 'm' : '') +
                                    (rx.unicode ? 'u' : '') +
                                    (SUPPORTS_Y ? 'y' : 'g');

                                // ^(? + rx + ) is needed, in combination with some S slicing, to
                                // simulate the 'y' flag.
                                var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
                                var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                                if (lim === 0) return [];
                                if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
                                var p = 0;
                                var q = 0;
                                var A = [];
                                while (q < S.length) {
                                    splitter.lastIndex = SUPPORTS_Y ? q : 0;
                                    var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
                                    var e;
                                    if (
                                        z === null ||
                                        (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
                                    ) {
                                        q = advanceStringIndex(S, q, unicodeMatching);
                                    } else {
                                        A.push(S.slice(p, q));
                                        if (A.length === lim) return A;
                                        for (var i = 1; i <= z.length - 1; i++) {
                                            A.push(z[i]);
                                            if (A.length === lim) return A;
                                        }
                                        q = p = e;
                                    }
                                }
                                A.push(S.slice(p));
                                return A;
                            }
                        ];
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.string.includes.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es6.string.includes.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {
                    // 21.1.3.7 String.prototype.includes(searchString, position = 0)

                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");
                    var context = __webpack_require__(/*! ./_string-context */ "./node_modules/core-js/modules/_string-context.js");
                    var INCLUDES = 'includes';

                    $export($export.P + $export.F * __webpack_require__(/*! ./_fails-is-regexp */ "./node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
                        includes: function includes(searchString /* , position = 0 */) {
                            return !!~context(this, searchString, INCLUDES)
                                .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
                        }
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es6.symbol.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/es6.symbol.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // ECMAScript 6 symbols shim
                    var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js");
                    var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/modules/_has.js");
                    var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/modules/_descriptors.js");
                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");
                    var redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/modules/_redefine.js");
                    var META = __webpack_require__(/*! ./_meta */ "./node_modules/core-js/modules/_meta.js").KEY;
                    var $fails = __webpack_require__(/*! ./_fails */ "./node_modules/core-js/modules/_fails.js");
                    var shared = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/modules/_shared.js");
                    var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/modules/_set-to-string-tag.js");
                    var uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/modules/_uid.js");
                    var wks = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js");
                    var wksExt = __webpack_require__(/*! ./_wks-ext */ "./node_modules/core-js/modules/_wks-ext.js");
                    var wksDefine = __webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/modules/_wks-define.js");
                    var enumKeys = __webpack_require__(/*! ./_enum-keys */ "./node_modules/core-js/modules/_enum-keys.js");
                    var isArray = __webpack_require__(/*! ./_is-array */ "./node_modules/core-js/modules/_is-array.js");
                    var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/modules/_an-object.js");
                    var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/modules/_is-object.js");
                    var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/modules/_to-object.js");
                    var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/modules/_to-iobject.js");
                    var toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/modules/_to-primitive.js");
                    var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/modules/_property-desc.js");
                    var _create = __webpack_require__(/*! ./_object-create */ "./node_modules/core-js/modules/_object-create.js");
                    var gOPNExt = __webpack_require__(/*! ./_object-gopn-ext */ "./node_modules/core-js/modules/_object-gopn-ext.js");
                    var $GOPD = __webpack_require__(/*! ./_object-gopd */ "./node_modules/core-js/modules/_object-gopd.js");
                    var $GOPS = __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/modules/_object-gops.js");
                    var $DP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/modules/_object-dp.js");
                    var $keys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/modules/_object-keys.js");
                    var gOPD = $GOPD.f;
                    var dP = $DP.f;
                    var gOPN = gOPNExt.f;
                    var $Symbol = global.Symbol;
                    var $JSON = global.JSON;
                    var _stringify = $JSON && $JSON.stringify;
                    var PROTOTYPE = 'prototype';
                    var HIDDEN = wks('_hidden');
                    var TO_PRIMITIVE = wks('toPrimitive');
                    var isEnum = {}.propertyIsEnumerable;
                    var SymbolRegistry = shared('symbol-registry');
                    var AllSymbols = shared('symbols');
                    var OPSymbols = shared('op-symbols');
                    var ObjectProto = Object[PROTOTYPE];
                    var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
                    var QObject = global.QObject;
                    // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
                    var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

                    // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
                    var setSymbolDesc = DESCRIPTORS && $fails(function () {
                        return _create(dP({}, 'a', {
                            get: function () { return dP(this, 'a', { value: 7 }).a; }
                        })).a != 7;
                    }) ? function (it, key, D) {
                        var protoDesc = gOPD(ObjectProto, key);
                        if (protoDesc) delete ObjectProto[key];
                        dP(it, key, D);
                        if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
                    } : dP;

                    var wrap = function (tag) {
                        var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
                        sym._k = tag;
                        return sym;
                    };

                    var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
                        return typeof it == 'symbol';
                    } : function (it) {
                        return it instanceof $Symbol;
                    };

                    var $defineProperty = function defineProperty(it, key, D) {
                        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
                        anObject(it);
                        key = toPrimitive(key, true);
                        anObject(D);
                        if (has(AllSymbols, key)) {
                            if (!D.enumerable) {
                                if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                                it[HIDDEN][key] = true;
                            } else {
                                if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                                D = _create(D, { enumerable: createDesc(0, false) });
                            } return setSymbolDesc(it, key, D);
                        } return dP(it, key, D);
                    };
                    var $defineProperties = function defineProperties(it, P) {
                        anObject(it);
                        var keys = enumKeys(P = toIObject(P));
                        var i = 0;
                        var l = keys.length;
                        var key;
                        while (l > i) $defineProperty(it, key = keys[i++], P[key]);
                        return it;
                    };
                    var $create = function create(it, P) {
                        return P === undefined ? _create(it) : $defineProperties(_create(it), P);
                    };
                    var $propertyIsEnumerable = function propertyIsEnumerable(key) {
                        var E = isEnum.call(this, key = toPrimitive(key, true));
                        if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
                        return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
                    };
                    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
                        it = toIObject(it);
                        key = toPrimitive(key, true);
                        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
                        var D = gOPD(it, key);
                        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
                        return D;
                    };
                    var $getOwnPropertyNames = function getOwnPropertyNames(it) {
                        var names = gOPN(toIObject(it));
                        var result = [];
                        var i = 0;
                        var key;
                        while (names.length > i) {
                            if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
                        } return result;
                    };
                    var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
                        var IS_OP = it === ObjectProto;
                        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
                        var result = [];
                        var i = 0;
                        var key;
                        while (names.length > i) {
                            if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
                        } return result;
                    };

                    // 19.4.1.1 Symbol([description])
                    if (!USE_NATIVE) {
                        $Symbol = function Symbol() {
                            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
                            var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
                            var $set = function (value) {
                                if (this === ObjectProto) $set.call(OPSymbols, value);
                                if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                                setSymbolDesc(this, tag, createDesc(1, value));
                            };
                            if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
                            return wrap(tag);
                        };
                        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
                            return this._k;
                        });

                        $GOPD.f = $getOwnPropertyDescriptor;
                        $DP.f = $defineProperty;
                        __webpack_require__(/*! ./_object-gopn */ "./node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
                        __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
                        $GOPS.f = $getOwnPropertySymbols;

                        if (DESCRIPTORS && !__webpack_require__(/*! ./_library */ "./node_modules/core-js/modules/_library.js")) {
                            redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
                        }

                        wksExt.f = function (name) {
                            return wrap(wks(name));
                        };
                    }

                    $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

                    for (var es6Symbols = (
                        // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
                        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
                    ).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

                    for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

                    $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
                        // 19.4.2.1 Symbol.for(key)
                        'for': function (key) {
                            return has(SymbolRegistry, key += '')
                                ? SymbolRegistry[key]
                                : SymbolRegistry[key] = $Symbol(key);
                        },
                        // 19.4.2.5 Symbol.keyFor(sym)
                        keyFor: function keyFor(sym) {
                            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
                            for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
                        },
                        useSetter: function () { setter = true; },
                        useSimple: function () { setter = false; }
                    });

                    $export($export.S + $export.F * !USE_NATIVE, 'Object', {
                        // 19.1.2.2 Object.create(O [, Properties])
                        create: $create,
                        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
                        defineProperty: $defineProperty,
                        // 19.1.2.3 Object.defineProperties(O, Properties)
                        defineProperties: $defineProperties,
                        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
                        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
                        // 19.1.2.7 Object.getOwnPropertyNames(O)
                        getOwnPropertyNames: $getOwnPropertyNames,
                        // 19.1.2.8 Object.getOwnPropertySymbols(O)
                        getOwnPropertySymbols: $getOwnPropertySymbols
                    });

                    // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
                    // https://bugs.chromium.org/p/v8/issues/detail?id=3443
                    var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

                    $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
                        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                            return $GOPS.f(toObject(it));
                        }
                    });

                    // 24.3.2 JSON.stringify(value [, replacer [, space]])
                    $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
                        var S = $Symbol();
                        // MS Edge converts symbol values to JSON as {}
                        // WebKit converts symbol values to JSON as null
                        // V8 throws on boxed symbols
                        return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
                    })), 'JSON', {
                        stringify: function stringify(it) {
                            var args = [it];
                            var i = 1;
                            var replacer, $replacer;
                            while (arguments.length > i) args.push(arguments[i++]);
                            $replacer = replacer = args[1];
                            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                            if (!isArray(replacer)) replacer = function (key, value) {
                                if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                                if (!isSymbol(value)) return value;
                            };
                            args[1] = replacer;
                            return _stringify.apply($JSON, args);
                        }
                    });

                    // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
                    $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
                    // 19.4.3.5 Symbol.prototype[@@toStringTag]
                    setToStringTag($Symbol, 'Symbol');
                    // 20.2.1.9 Math[@@toStringTag]
                    setToStringTag(Math, 'Math', true);
                    // 24.3.3 JSON[@@toStringTag]
                    setToStringTag(global.JSON, 'JSON', true);


                    /***/
}),

/***/ "./node_modules/core-js/modules/es7.array.includes.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es7.array.includes.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // https://github.com/tc39/Array.prototype.includes
                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");
                    var $includes = __webpack_require__(/*! ./_array-includes */ "./node_modules/core-js/modules/_array-includes.js")(true);

                    $export($export.P, 'Array', {
                        includes: function includes(el /* , fromIndex = 0 */) {
                            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
                        }
                    });

                    __webpack_require__(/*! ./_add-to-unscopables */ "./node_modules/core-js/modules/_add-to-unscopables.js")('includes');


                    /***/
}),

/***/ "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    // https://github.com/tc39/proposal-object-getownpropertydescriptors
                    var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/modules/_export.js");
                    var ownKeys = __webpack_require__(/*! ./_own-keys */ "./node_modules/core-js/modules/_own-keys.js");
                    var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/modules/_to-iobject.js");
                    var gOPD = __webpack_require__(/*! ./_object-gopd */ "./node_modules/core-js/modules/_object-gopd.js");
                    var createProperty = __webpack_require__(/*! ./_create-property */ "./node_modules/core-js/modules/_create-property.js");

                    $export($export.S, 'Object', {
                        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
                            var O = toIObject(object);
                            var getDesc = gOPD.f;
                            var keys = ownKeys(O);
                            var result = {};
                            var i = 0;
                            var key, desc;
                            while (keys.length > i) {
                                desc = getDesc(O, key = keys[i++]);
                                if (desc !== undefined) createProperty(result, key, desc);
                            }
                            return result;
                        }
                    });


                    /***/
}),

/***/ "./node_modules/core-js/modules/es7.symbol.async-iterator.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/modules/es7.symbol.async-iterator.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    __webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/modules/_wks-define.js")('asyncIterator');


                    /***/
}),

/***/ "./node_modules/core-js/modules/web.dom.iterable.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom.iterable.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    var $iterators = __webpack_require__(/*! ./es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
                    var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/modules/_object-keys.js");
                    var redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/modules/_redefine.js");
                    var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/modules/_global.js");
                    var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/modules/_hide.js");
                    var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/modules/_iterators.js");
                    var wks = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/modules/_wks.js");
                    var ITERATOR = wks('iterator');
                    var TO_STRING_TAG = wks('toStringTag');
                    var ArrayValues = Iterators.Array;

                    var DOMIterables = {
                        CSSRuleList: true, // TODO: Not spec compliant, should be false.
                        CSSStyleDeclaration: false,
                        CSSValueList: false,
                        ClientRectList: false,
                        DOMRectList: false,
                        DOMStringList: false,
                        DOMTokenList: true,
                        DataTransferItemList: false,
                        FileList: false,
                        HTMLAllCollection: false,
                        HTMLCollection: false,
                        HTMLFormElement: false,
                        HTMLSelectElement: false,
                        MediaList: true, // TODO: Not spec compliant, should be false.
                        MimeTypeArray: false,
                        NamedNodeMap: false,
                        NodeList: true,
                        PaintRequestList: false,
                        Plugin: false,
                        PluginArray: false,
                        SVGLengthList: false,
                        SVGNumberList: false,
                        SVGPathSegList: false,
                        SVGPointList: false,
                        SVGStringList: false,
                        SVGTransformList: false,
                        SourceBufferList: false,
                        StyleSheetList: true, // TODO: Not spec compliant, should be false.
                        TextTrackCueList: false,
                        TextTrackList: false,
                        TouchList: false
                    };

                    for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
                        var NAME = collections[i];
                        var explicit = DOMIterables[NAME];
                        var Collection = global[NAME];
                        var proto = Collection && Collection.prototype;
                        var key;
                        if (proto) {
                            if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
                            if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
                            Iterators[NAME] = ArrayValues;
                            if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
                        }
                    }


                    /***/
}),

/***/ "./node_modules/crypt/crypt.js":
/*!*************************************!*\
  !*** ./node_modules/crypt/crypt.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    (function () {
                        var base64map
                            = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

                            crypt = {
                                // Bit-wise rotation left
                                rotl: function (n, b) {
                                    return (n << b) | (n >>> (32 - b));
                                },

                                // Bit-wise rotation right
                                rotr: function (n, b) {
                                    return (n << (32 - b)) | (n >>> b);
                                },

                                // Swap big-endian to little-endian and vice versa
                                endian: function (n) {
                                    // If number given, swap endian
                                    if (n.constructor == Number) {
                                        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
                                    }

                                    // Else, assume array and swap all items
                                    for (var i = 0; i < n.length; i++)
                                        n[i] = crypt.endian(n[i]);
                                    return n;
                                },

                                // Generate an array of any length of random bytes
                                randomBytes: function (n) {
                                    for (var bytes = []; n > 0; n--)
                                        bytes.push(Math.floor(Math.random() * 256));
                                    return bytes;
                                },

                                // Convert a byte array to big-endian 32-bit words
                                bytesToWords: function (bytes) {
                                    for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
                                        words[b >>> 5] |= bytes[i] << (24 - b % 32);
                                    return words;
                                },

                                // Convert big-endian 32-bit words to a byte array
                                wordsToBytes: function (words) {
                                    for (var bytes = [], b = 0; b < words.length * 32; b += 8)
                                        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
                                    return bytes;
                                },

                                // Convert a byte array to a hex string
                                bytesToHex: function (bytes) {
                                    for (var hex = [], i = 0; i < bytes.length; i++) {
                                        hex.push((bytes[i] >>> 4).toString(16));
                                        hex.push((bytes[i] & 0xF).toString(16));
                                    }
                                    return hex.join('');
                                },

                                // Convert a hex string to a byte array
                                hexToBytes: function (hex) {
                                    for (var bytes = [], c = 0; c < hex.length; c += 2)
                                        bytes.push(parseInt(hex.substr(c, 2), 16));
                                    return bytes;
                                },

                                // Convert a byte array to a base-64 string
                                bytesToBase64: function (bytes) {
                                    for (var base64 = [], i = 0; i < bytes.length; i += 3) {
                                        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
                                        for (var j = 0; j < 4; j++)
                                            if (i * 8 + j * 6 <= bytes.length * 8)
                                                base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
                                            else
                                                base64.push('=');
                                    }
                                    return base64.join('');
                                },

                                // Convert a base-64 string to a byte array
                                base64ToBytes: function (base64) {
                                    // Remove non-base-64 characters
                                    base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

                                    for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
                                        imod4 = ++i % 4) {
                                        if (imod4 == 0) continue;
                                        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
                                            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
                                            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
                                    }
                                    return bytes;
                                }
                            };

                        module.exports = crypt;
                    })();


                    /***/
}),

/***/ "./node_modules/is-buffer/index.js":
/*!*****************************************!*\
  !*** ./node_modules/is-buffer/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    /*!
                     * Determine if an object is a Buffer
                     *
                     * @author   Feross Aboukhadijeh <https://feross.org>
                     * @license  MIT
                     */

                    // The _isBuffer check is for Safari 5-7 support, because it's missing
                    // Object.prototype.constructor. Remove this eventually
                    module.exports = function (obj) {
                        return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
                    };

                    function isBuffer(obj) {
                        return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
                    }

                    // For Node v0.10 support. Remove this eventually.
                    function isSlowBuffer(obj) {
                        return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
                    }


                    /***/
}),

/***/ "./node_modules/md5/md5.js":
/*!*********************************!*\
  !*** ./node_modules/md5/md5.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    (function () {
                        var crypt = __webpack_require__(/*! crypt */ "./node_modules/crypt/crypt.js"),
                            utf8 = __webpack_require__(/*! charenc */ "./node_modules/charenc/charenc.js").utf8,
                            isBuffer = __webpack_require__(/*! is-buffer */ "./node_modules/is-buffer/index.js"),
                            bin = __webpack_require__(/*! charenc */ "./node_modules/charenc/charenc.js").bin,

                            // The core
                            md5 = function (message, options) {
                                // Convert to byte array
                                if (message.constructor == String)
                                    if (options && options.encoding === 'binary')
                                        message = bin.stringToBytes(message);
                                    else
                                        message = utf8.stringToBytes(message);
                                else if (isBuffer(message))
                                    message = Array.prototype.slice.call(message, 0);
                                else if (!Array.isArray(message) && message.constructor !== Uint8Array)
                                    message = message.toString();
                                // else, assume byte array already

                                var m = crypt.bytesToWords(message),
                                    l = message.length * 8,
                                    a = 1732584193,
                                    b = -271733879,
                                    c = -1732584194,
                                    d = 271733878;

                                // Swap endian
                                for (var i = 0; i < m.length; i++) {
                                    m[i] = ((m[i] << 8) | (m[i] >>> 24)) & 0x00FF00FF |
                                        ((m[i] << 24) | (m[i] >>> 8)) & 0xFF00FF00;
                                }

                                // Padding
                                m[l >>> 5] |= 0x80 << (l % 32);
                                m[(((l + 64) >>> 9) << 4) + 14] = l;

                                // Method shortcuts
                                var FF = md5._ff,
                                    GG = md5._gg,
                                    HH = md5._hh,
                                    II = md5._ii;

                                for (var i = 0; i < m.length; i += 16) {

                                    var aa = a,
                                        bb = b,
                                        cc = c,
                                        dd = d;

                                    a = FF(a, b, c, d, m[i + 0], 7, -680876936);
                                    d = FF(d, a, b, c, m[i + 1], 12, -389564586);
                                    c = FF(c, d, a, b, m[i + 2], 17, 606105819);
                                    b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
                                    a = FF(a, b, c, d, m[i + 4], 7, -176418897);
                                    d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
                                    c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
                                    b = FF(b, c, d, a, m[i + 7], 22, -45705983);
                                    a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
                                    d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
                                    c = FF(c, d, a, b, m[i + 10], 17, -42063);
                                    b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
                                    a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
                                    d = FF(d, a, b, c, m[i + 13], 12, -40341101);
                                    c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
                                    b = FF(b, c, d, a, m[i + 15], 22, 1236535329);

                                    a = GG(a, b, c, d, m[i + 1], 5, -165796510);
                                    d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
                                    c = GG(c, d, a, b, m[i + 11], 14, 643717713);
                                    b = GG(b, c, d, a, m[i + 0], 20, -373897302);
                                    a = GG(a, b, c, d, m[i + 5], 5, -701558691);
                                    d = GG(d, a, b, c, m[i + 10], 9, 38016083);
                                    c = GG(c, d, a, b, m[i + 15], 14, -660478335);
                                    b = GG(b, c, d, a, m[i + 4], 20, -405537848);
                                    a = GG(a, b, c, d, m[i + 9], 5, 568446438);
                                    d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
                                    c = GG(c, d, a, b, m[i + 3], 14, -187363961);
                                    b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
                                    a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
                                    d = GG(d, a, b, c, m[i + 2], 9, -51403784);
                                    c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
                                    b = GG(b, c, d, a, m[i + 12], 20, -1926607734);

                                    a = HH(a, b, c, d, m[i + 5], 4, -378558);
                                    d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
                                    c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
                                    b = HH(b, c, d, a, m[i + 14], 23, -35309556);
                                    a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
                                    d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
                                    c = HH(c, d, a, b, m[i + 7], 16, -155497632);
                                    b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
                                    a = HH(a, b, c, d, m[i + 13], 4, 681279174);
                                    d = HH(d, a, b, c, m[i + 0], 11, -358537222);
                                    c = HH(c, d, a, b, m[i + 3], 16, -722521979);
                                    b = HH(b, c, d, a, m[i + 6], 23, 76029189);
                                    a = HH(a, b, c, d, m[i + 9], 4, -640364487);
                                    d = HH(d, a, b, c, m[i + 12], 11, -421815835);
                                    c = HH(c, d, a, b, m[i + 15], 16, 530742520);
                                    b = HH(b, c, d, a, m[i + 2], 23, -995338651);

                                    a = II(a, b, c, d, m[i + 0], 6, -198630844);
                                    d = II(d, a, b, c, m[i + 7], 10, 1126891415);
                                    c = II(c, d, a, b, m[i + 14], 15, -1416354905);
                                    b = II(b, c, d, a, m[i + 5], 21, -57434055);
                                    a = II(a, b, c, d, m[i + 12], 6, 1700485571);
                                    d = II(d, a, b, c, m[i + 3], 10, -1894986606);
                                    c = II(c, d, a, b, m[i + 10], 15, -1051523);
                                    b = II(b, c, d, a, m[i + 1], 21, -2054922799);
                                    a = II(a, b, c, d, m[i + 8], 6, 1873313359);
                                    d = II(d, a, b, c, m[i + 15], 10, -30611744);
                                    c = II(c, d, a, b, m[i + 6], 15, -1560198380);
                                    b = II(b, c, d, a, m[i + 13], 21, 1309151649);
                                    a = II(a, b, c, d, m[i + 4], 6, -145523070);
                                    d = II(d, a, b, c, m[i + 11], 10, -1120210379);
                                    c = II(c, d, a, b, m[i + 2], 15, 718787259);
                                    b = II(b, c, d, a, m[i + 9], 21, -343485551);

                                    a = (a + aa) >>> 0;
                                    b = (b + bb) >>> 0;
                                    c = (c + cc) >>> 0;
                                    d = (d + dd) >>> 0;
                                }

                                return crypt.endian([a, b, c, d]);
                            };

                        // Auxiliary functions
                        md5._ff = function (a, b, c, d, x, s, t) {
                            var n = a + (b & c | ~b & d) + (x >>> 0) + t;
                            return ((n << s) | (n >>> (32 - s))) + b;
                        };
                        md5._gg = function (a, b, c, d, x, s, t) {
                            var n = a + (b & d | c & ~d) + (x >>> 0) + t;
                            return ((n << s) | (n >>> (32 - s))) + b;
                        };
                        md5._hh = function (a, b, c, d, x, s, t) {
                            var n = a + (b ^ c ^ d) + (x >>> 0) + t;
                            return ((n << s) | (n >>> (32 - s))) + b;
                        };
                        md5._ii = function (a, b, c, d, x, s, t) {
                            var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
                            return ((n << s) | (n >>> (32 - s))) + b;
                        };

                        // Package private blocksize
                        md5._blocksize = 16;
                        md5._digestsize = 16;

                        module.exports = function (message, options) {
                            if (message === undefined || message === null)
                                throw new Error('Illegal argument ' + message);

                            var digestbytes = crypt.wordsToBytes(md5(message, options));
                            return options && options.asBytes ? digestbytes :
                                options && options.asString ? bin.bytesToString(digestbytes) :
                                    crypt.bytesToHex(digestbytes);
                        };

                    })();


                    /***/
}),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function (module, exports, __webpack_require__) {

                    /**
                     * Copyright (c) 2014-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     */

                    var runtime = (function (exports) {

                        var Op = Object.prototype;
                        var hasOwn = Op.hasOwnProperty;
                        var undefined$1; // More compressible than void 0.
                        var $Symbol = typeof Symbol === "function" ? Symbol : {};
                        var iteratorSymbol = $Symbol.iterator || "@@iterator";
                        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
                        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

                        function define(obj, key, value) {
                            Object.defineProperty(obj, key, {
                                value: value,
                                enumerable: true,
                                configurable: true,
                                writable: true
                            });
                            return obj[key];
                        }
                        try {
                            // IE 8 has a broken Object.defineProperty that only works on DOM objects.
                            define({}, "");
                        } catch (err) {
                            define = function (obj, key, value) {
                                return obj[key] = value;
                            };
                        }

                        function wrap(innerFn, outerFn, self, tryLocsList) {
                            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
                            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                            var generator = Object.create(protoGenerator.prototype);
                            var context = new Context(tryLocsList || []);

                            // The ._invoke method unifies the implementations of the .next,
                            // .throw, and .return methods.
                            generator._invoke = makeInvokeMethod(innerFn, self, context);

                            return generator;
                        }
                        exports.wrap = wrap;

                        // Try/catch helper to minimize deoptimizations. Returns a completion
                        // record like context.tryEntries[i].completion. This interface could
                        // have been (and was previously) designed to take a closure to be
                        // invoked without arguments, but in all the cases we care about we
                        // already have an existing method we want to call, so there's no need
                        // to create a new function object. We can even get away with assuming
                        // the method takes exactly one argument, since that happens to be true
                        // in every case, so we don't have to touch the arguments object. The
                        // only additional allocation required is the completion record, which
                        // has a stable shape and so hopefully should be cheap to allocate.
                        function tryCatch(fn, obj, arg) {
                            try {
                                return { type: "normal", arg: fn.call(obj, arg) };
                            } catch (err) {
                                return { type: "throw", arg: err };
                            }
                        }

                        var GenStateSuspendedStart = "suspendedStart";
                        var GenStateSuspendedYield = "suspendedYield";
                        var GenStateExecuting = "executing";
                        var GenStateCompleted = "completed";

                        // Returning this object from the innerFn has the same effect as
                        // breaking out of the dispatch switch statement.
                        var ContinueSentinel = {};

                        // Dummy constructor functions that we use as the .constructor and
                        // .constructor.prototype properties for functions that return Generator
                        // objects. For full spec compliance, you may wish to configure your
                        // minifier not to mangle the names of these two functions.
                        function Generator() { }
                        function GeneratorFunction() { }
                        function GeneratorFunctionPrototype() { }

                        // This is a polyfill for %IteratorPrototype% for environments that
                        // don't natively support it.
                        var IteratorPrototype = {};
                        IteratorPrototype[iteratorSymbol] = function () {
                            return this;
                        };

                        var getProto = Object.getPrototypeOf;
                        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
                        if (NativeIteratorPrototype &&
                            NativeIteratorPrototype !== Op &&
                            hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
                            // This environment has a native %IteratorPrototype%; use it instead
                            // of the polyfill.
                            IteratorPrototype = NativeIteratorPrototype;
                        }

                        var Gp = GeneratorFunctionPrototype.prototype =
                            Generator.prototype = Object.create(IteratorPrototype);
                        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
                        GeneratorFunctionPrototype.constructor = GeneratorFunction;
                        GeneratorFunction.displayName = define(
                            GeneratorFunctionPrototype,
                            toStringTagSymbol,
                            "GeneratorFunction"
                        );

                        // Helper for defining the .next, .throw, and .return methods of the
                        // Iterator interface in terms of a single ._invoke method.
                        function defineIteratorMethods(prototype) {
                            ["next", "throw", "return"].forEach(function (method) {
                                define(prototype, method, function (arg) {
                                    return this._invoke(method, arg);
                                });
                            });
                        }

                        exports.isGeneratorFunction = function (genFun) {
                            var ctor = typeof genFun === "function" && genFun.constructor;
                            return ctor
                                ? ctor === GeneratorFunction ||
                                // For the native GeneratorFunction constructor, the best we can
                                // do is to check its .name property.
                                (ctor.displayName || ctor.name) === "GeneratorFunction"
                                : false;
                        };

                        exports.mark = function (genFun) {
                            if (Object.setPrototypeOf) {
                                Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                            } else {
                                genFun.__proto__ = GeneratorFunctionPrototype;
                                define(genFun, toStringTagSymbol, "GeneratorFunction");
                            }
                            genFun.prototype = Object.create(Gp);
                            return genFun;
                        };

                        // Within the body of any async function, `await x` is transformed to
                        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
                        // `hasOwn.call(value, "__await")` to determine if the yielded value is
                        // meant to be awaited.
                        exports.awrap = function (arg) {
                            return { __await: arg };
                        };

                        function AsyncIterator(generator, PromiseImpl) {
                            function invoke(method, arg, resolve, reject) {
                                var record = tryCatch(generator[method], generator, arg);
                                if (record.type === "throw") {
                                    reject(record.arg);
                                } else {
                                    var result = record.arg;
                                    var value = result.value;
                                    if (value &&
                                        typeof value === "object" &&
                                        hasOwn.call(value, "__await")) {
                                        return PromiseImpl.resolve(value.__await).then(function (value) {
                                            invoke("next", value, resolve, reject);
                                        }, function (err) {
                                            invoke("throw", err, resolve, reject);
                                        });
                                    }

                                    return PromiseImpl.resolve(value).then(function (unwrapped) {
                                        // When a yielded Promise is resolved, its final value becomes
                                        // the .value of the Promise<{value,done}> result for the
                                        // current iteration.
                                        result.value = unwrapped;
                                        resolve(result);
                                    }, function (error) {
                                        // If a rejected Promise was yielded, throw the rejection back
                                        // into the async generator function so it can be handled there.
                                        return invoke("throw", error, resolve, reject);
                                    });
                                }
                            }

                            var previousPromise;

                            function enqueue(method, arg) {
                                function callInvokeWithMethodAndArg() {
                                    return new PromiseImpl(function (resolve, reject) {
                                        invoke(method, arg, resolve, reject);
                                    });
                                }

                                return previousPromise =
                                    // If enqueue has been called before, then we want to wait until
                                    // all previous Promises have been resolved before calling invoke,
                                    // so that results are always delivered in the correct order. If
                                    // enqueue has not been called before, then it is important to
                                    // call invoke immediately, without waiting on a callback to fire,
                                    // so that the async generator function has the opportunity to do
                                    // any necessary setup in a predictable way. This predictability
                                    // is why the Promise constructor synchronously invokes its
                                    // executor callback, and why async functions synchronously
                                    // execute code before the first await. Since we implement simple
                                    // async functions in terms of async generators, it is especially
                                    // important to get this right, even though it requires care.
                                    previousPromise ? previousPromise.then(
                                        callInvokeWithMethodAndArg,
                                        // Avoid propagating failures to Promises returned by later
                                        // invocations of the iterator.
                                        callInvokeWithMethodAndArg
                                    ) : callInvokeWithMethodAndArg();
                            }

                            // Define the unified helper method that is used to implement .next,
                            // .throw, and .return (see defineIteratorMethods).
                            this._invoke = enqueue;
                        }

                        defineIteratorMethods(AsyncIterator.prototype);
                        AsyncIterator.prototype[asyncIteratorSymbol] = function () {
                            return this;
                        };
                        exports.AsyncIterator = AsyncIterator;

                        // Note that simple async functions are implemented on top of
                        // AsyncIterator objects; they just return a Promise for the value of
                        // the final result produced by the iterator.
                        exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
                            if (PromiseImpl === void 0) PromiseImpl = Promise;

                            var iter = new AsyncIterator(
                                wrap(innerFn, outerFn, self, tryLocsList),
                                PromiseImpl
                            );

                            return exports.isGeneratorFunction(outerFn)
                                ? iter // If outerFn is a generator, return the full iterator.
                                : iter.next().then(function (result) {
                                    return result.done ? result.value : iter.next();
                                });
                        };

                        function makeInvokeMethod(innerFn, self, context) {
                            var state = GenStateSuspendedStart;

                            return function invoke(method, arg) {
                                if (state === GenStateExecuting) {
                                    throw new Error("Generator is already running");
                                }

                                if (state === GenStateCompleted) {
                                    if (method === "throw") {
                                        throw arg;
                                    }

                                    // Be forgiving, per 25.3.3.3.3 of the spec:
                                    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                                    return doneResult();
                                }

                                context.method = method;
                                context.arg = arg;

                                while (true) {
                                    var delegate = context.delegate;
                                    if (delegate) {
                                        var delegateResult = maybeInvokeDelegate(delegate, context);
                                        if (delegateResult) {
                                            if (delegateResult === ContinueSentinel) continue;
                                            return delegateResult;
                                        }
                                    }

                                    if (context.method === "next") {
                                        // Setting context._sent for legacy support of Babel's
                                        // function.sent implementation.
                                        context.sent = context._sent = context.arg;

                                    } else if (context.method === "throw") {
                                        if (state === GenStateSuspendedStart) {
                                            state = GenStateCompleted;
                                            throw context.arg;
                                        }

                                        context.dispatchException(context.arg);

                                    } else if (context.method === "return") {
                                        context.abrupt("return", context.arg);
                                    }

                                    state = GenStateExecuting;

                                    var record = tryCatch(innerFn, self, context);
                                    if (record.type === "normal") {
                                        // If an exception is thrown from innerFn, we leave state ===
                                        // GenStateExecuting and loop back for another invocation.
                                        state = context.done
                                            ? GenStateCompleted
                                            : GenStateSuspendedYield;

                                        if (record.arg === ContinueSentinel) {
                                            continue;
                                        }

                                        return {
                                            value: record.arg,
                                            done: context.done
                                        };

                                    } else if (record.type === "throw") {
                                        state = GenStateCompleted;
                                        // Dispatch the exception by looping back around to the
                                        // context.dispatchException(context.arg) call above.
                                        context.method = "throw";
                                        context.arg = record.arg;
                                    }
                                }
                            };
                        }

                        // Call delegate.iterator[context.method](context.arg) and handle the
                        // result, either by returning a { value, done } result from the
                        // delegate iterator, or by modifying context.method and context.arg,
                        // setting context.delegate to null, and returning the ContinueSentinel.
                        function maybeInvokeDelegate(delegate, context) {
                            var method = delegate.iterator[context.method];
                            if (method === undefined$1) {
                                // A .throw or .return when the delegate iterator has no .throw
                                // method always terminates the yield* loop.
                                context.delegate = null;

                                if (context.method === "throw") {
                                    // Note: ["return"] must be used for ES3 parsing compatibility.
                                    if (delegate.iterator["return"]) {
                                        // If the delegate iterator has a return method, give it a
                                        // chance to clean up.
                                        context.method = "return";
                                        context.arg = undefined$1;
                                        maybeInvokeDelegate(delegate, context);

                                        if (context.method === "throw") {
                                            // If maybeInvokeDelegate(context) changed context.method from
                                            // "return" to "throw", let that override the TypeError below.
                                            return ContinueSentinel;
                                        }
                                    }

                                    context.method = "throw";
                                    context.arg = new TypeError(
                                        "The iterator does not provide a 'throw' method");
                                }

                                return ContinueSentinel;
                            }

                            var record = tryCatch(method, delegate.iterator, context.arg);

                            if (record.type === "throw") {
                                context.method = "throw";
                                context.arg = record.arg;
                                context.delegate = null;
                                return ContinueSentinel;
                            }

                            var info = record.arg;

                            if (!info) {
                                context.method = "throw";
                                context.arg = new TypeError("iterator result is not an object");
                                context.delegate = null;
                                return ContinueSentinel;
                            }

                            if (info.done) {
                                // Assign the result of the finished delegate to the temporary
                                // variable specified by delegate.resultName (see delegateYield).
                                context[delegate.resultName] = info.value;

                                // Resume execution at the desired location (see delegateYield).
                                context.next = delegate.nextLoc;

                                // If context.method was "throw" but the delegate handled the
                                // exception, let the outer generator proceed normally. If
                                // context.method was "next", forget context.arg since it has been
                                // "consumed" by the delegate iterator. If context.method was
                                // "return", allow the original .return call to continue in the
                                // outer generator.
                                if (context.method !== "return") {
                                    context.method = "next";
                                    context.arg = undefined$1;
                                }

                            } else {
                                // Re-yield the result returned by the delegate method.
                                return info;
                            }

                            // The delegate iterator is finished, so forget it and continue with
                            // the outer generator.
                            context.delegate = null;
                            return ContinueSentinel;
                        }

                        // Define Generator.prototype.{next,throw,return} in terms of the
                        // unified ._invoke helper method.
                        defineIteratorMethods(Gp);

                        define(Gp, toStringTagSymbol, "Generator");

                        // A Generator should always return itself as the iterator object when the
                        // @@iterator function is called on it. Some browsers' implementations of the
                        // iterator prototype chain incorrectly implement this, causing the Generator
                        // object to not be returned from this call. This ensures that doesn't happen.
                        // See https://github.com/facebook/regenerator/issues/274 for more details.
                        Gp[iteratorSymbol] = function () {
                            return this;
                        };

                        Gp.toString = function () {
                            return "[object Generator]";
                        };

                        function pushTryEntry(locs) {
                            var entry = { tryLoc: locs[0] };

                            if (1 in locs) {
                                entry.catchLoc = locs[1];
                            }

                            if (2 in locs) {
                                entry.finallyLoc = locs[2];
                                entry.afterLoc = locs[3];
                            }

                            this.tryEntries.push(entry);
                        }

                        function resetTryEntry(entry) {
                            var record = entry.completion || {};
                            record.type = "normal";
                            delete record.arg;
                            entry.completion = record;
                        }

                        function Context(tryLocsList) {
                            // The root entry object (effectively a try statement without a catch
                            // or a finally block) gives us a place to store values thrown from
                            // locations where there is no enclosing try statement.
                            this.tryEntries = [{ tryLoc: "root" }];
                            tryLocsList.forEach(pushTryEntry, this);
                            this.reset(true);
                        }

                        exports.keys = function (object) {
                            var keys = [];
                            for (var key in object) {
                                keys.push(key);
                            }
                            keys.reverse();

                            // Rather than returning an object with a next method, we keep
                            // things simple and return the next function itself.
                            return function next() {
                                while (keys.length) {
                                    var key = keys.pop();
                                    if (key in object) {
                                        next.value = key;
                                        next.done = false;
                                        return next;
                                    }
                                }

                                // To avoid creating an additional object, we just hang the .value
                                // and .done properties off the next function object itself. This
                                // also ensures that the minifier will not anonymize the function.
                                next.done = true;
                                return next;
                            };
                        };

                        function values(iterable) {
                            if (iterable) {
                                var iteratorMethod = iterable[iteratorSymbol];
                                if (iteratorMethod) {
                                    return iteratorMethod.call(iterable);
                                }

                                if (typeof iterable.next === "function") {
                                    return iterable;
                                }

                                if (!isNaN(iterable.length)) {
                                    var i = -1, next = function next() {
                                        while (++i < iterable.length) {
                                            if (hasOwn.call(iterable, i)) {
                                                next.value = iterable[i];
                                                next.done = false;
                                                return next;
                                            }
                                        }

                                        next.value = undefined$1;
                                        next.done = true;

                                        return next;
                                    };

                                    return next.next = next;
                                }
                            }

                            // Return an iterator with no values.
                            return { next: doneResult };
                        }
                        exports.values = values;

                        function doneResult() {
                            return { value: undefined$1, done: true };
                        }

                        Context.prototype = {
                            constructor: Context,

                            reset: function (skipTempReset) {
                                this.prev = 0;
                                this.next = 0;
                                // Resetting context._sent for legacy support of Babel's
                                // function.sent implementation.
                                this.sent = this._sent = undefined$1;
                                this.done = false;
                                this.delegate = null;

                                this.method = "next";
                                this.arg = undefined$1;

                                this.tryEntries.forEach(resetTryEntry);

                                if (!skipTempReset) {
                                    for (var name in this) {
                                        // Not sure about the optimal order of these conditions:
                                        if (name.charAt(0) === "t" &&
                                            hasOwn.call(this, name) &&
                                            !isNaN(+name.slice(1))) {
                                            this[name] = undefined$1;
                                        }
                                    }
                                }
                            },

                            stop: function () {
                                this.done = true;

                                var rootEntry = this.tryEntries[0];
                                var rootRecord = rootEntry.completion;
                                if (rootRecord.type === "throw") {
                                    throw rootRecord.arg;
                                }

                                return this.rval;
                            },

                            dispatchException: function (exception) {
                                if (this.done) {
                                    throw exception;
                                }

                                var context = this;
                                function handle(loc, caught) {
                                    record.type = "throw";
                                    record.arg = exception;
                                    context.next = loc;

                                    if (caught) {
                                        // If the dispatched exception was caught by a catch block,
                                        // then let that catch block handle the exception normally.
                                        context.method = "next";
                                        context.arg = undefined$1;
                                    }

                                    return !!caught;
                                }

                                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                                    var entry = this.tryEntries[i];
                                    var record = entry.completion;

                                    if (entry.tryLoc === "root") {
                                        // Exception thrown outside of any try block that could handle
                                        // it, so set the completion value of the entire function to
                                        // throw the exception.
                                        return handle("end");
                                    }

                                    if (entry.tryLoc <= this.prev) {
                                        var hasCatch = hasOwn.call(entry, "catchLoc");
                                        var hasFinally = hasOwn.call(entry, "finallyLoc");

                                        if (hasCatch && hasFinally) {
                                            if (this.prev < entry.catchLoc) {
                                                return handle(entry.catchLoc, true);
                                            } else if (this.prev < entry.finallyLoc) {
                                                return handle(entry.finallyLoc);
                                            }

                                        } else if (hasCatch) {
                                            if (this.prev < entry.catchLoc) {
                                                return handle(entry.catchLoc, true);
                                            }

                                        } else if (hasFinally) {
                                            if (this.prev < entry.finallyLoc) {
                                                return handle(entry.finallyLoc);
                                            }

                                        } else {
                                            throw new Error("try statement without catch or finally");
                                        }
                                    }
                                }
                            },

                            abrupt: function (type, arg) {
                                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                                    var entry = this.tryEntries[i];
                                    if (entry.tryLoc <= this.prev &&
                                        hasOwn.call(entry, "finallyLoc") &&
                                        this.prev < entry.finallyLoc) {
                                        var finallyEntry = entry;
                                        break;
                                    }
                                }

                                if (finallyEntry &&
                                    (type === "break" ||
                                        type === "continue") &&
                                    finallyEntry.tryLoc <= arg &&
                                    arg <= finallyEntry.finallyLoc) {
                                    // Ignore the finally entry if control is not jumping to a
                                    // location outside the try/catch block.
                                    finallyEntry = null;
                                }

                                var record = finallyEntry ? finallyEntry.completion : {};
                                record.type = type;
                                record.arg = arg;

                                if (finallyEntry) {
                                    this.method = "next";
                                    this.next = finallyEntry.finallyLoc;
                                    return ContinueSentinel;
                                }

                                return this.complete(record);
                            },

                            complete: function (record, afterLoc) {
                                if (record.type === "throw") {
                                    throw record.arg;
                                }

                                if (record.type === "break" ||
                                    record.type === "continue") {
                                    this.next = record.arg;
                                } else if (record.type === "return") {
                                    this.rval = this.arg = record.arg;
                                    this.method = "return";
                                    this.next = "end";
                                } else if (record.type === "normal" && afterLoc) {
                                    this.next = afterLoc;
                                }

                                return ContinueSentinel;
                            },

                            finish: function (finallyLoc) {
                                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                                    var entry = this.tryEntries[i];
                                    if (entry.finallyLoc === finallyLoc) {
                                        this.complete(entry.completion, entry.afterLoc);
                                        resetTryEntry(entry);
                                        return ContinueSentinel;
                                    }
                                }
                            },

                            "catch": function (tryLoc) {
                                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                                    var entry = this.tryEntries[i];
                                    if (entry.tryLoc === tryLoc) {
                                        var record = entry.completion;
                                        if (record.type === "throw") {
                                            var thrown = record.arg;
                                            resetTryEntry(entry);
                                        }
                                        return thrown;
                                    }
                                }

                                // The context.catch method must only be called with a location
                                // argument that corresponds to a known catch block.
                                throw new Error("illegal catch attempt");
                            },

                            delegateYield: function (iterable, resultName, nextLoc) {
                                this.delegate = {
                                    iterator: values(iterable),
                                    resultName: resultName,
                                    nextLoc: nextLoc
                                };

                                if (this.method === "next") {
                                    // Deliberately forget the last sent value so that we don't
                                    // accidentally pass it on to the delegate.
                                    this.arg = undefined$1;
                                }

                                return ContinueSentinel;
                            }
                        };

                        // Regardless of whether this script is executing as a CommonJS module
                        // or not, return the runtime object so that we can declare the variable
                        // regeneratorRuntime in the outer scope, which allows this module to be
                        // injected easily by `bin/regenerator --include-runtime script.js`.
                        return exports;

                    }(
                        // If this script is executing as a CommonJS module, use module.exports
                        // as the regeneratorRuntime namespace. Otherwise create a new empty
                        // object. Either way, the resulting object will be used to initialize
                        // the regeneratorRuntime variable at the top of this file.
                        module.exports
                    ));

                    try {
                        regeneratorRuntime = runtime;
                    } catch (accidentalStrictMode) {
                        // This module should not be running in strict mode, so the above
                        // assignment should always work unless something is misconfigured. Just
                        // in case runtime.js accidentally runs in strict mode, we can escape
                        // strict mode using a global Function call. This could conceivably fail
                        // if a Content Security Policy forbids using Function, but in that case
                        // the proper solution is to fix the accidental strict mode problem. If
                        // you've misconfigured your bundler to force strict mode and applied a
                        // CSP to forbid Function, and you're not willing to fix either of those
                        // problems, please detail your unique predicament in a GitHub issue.
                        Function("r", "regeneratorRuntime = r")(runtime);
                    }


                    /***/
}),

/***/ "./src/api.js":
/*!********************!*\
  !*** ./src/api.js ***!
  \********************/
/*! exports provided: setup, setupCache, serializeQuery, default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setup", function () { return setup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setupCache", function () { return setupCache; });
/* harmony import */ __webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./request */ "./src/request.js");
/* harmony import */ var _cache__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cache */ "./src/cache.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "serializeQuery", function () { return _cache__WEBPACK_IMPORTED_MODULE_7__["serializeQuery"]; });

/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./config */ "./src/config.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utilities */ "./src/utilities.js");






                    function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

                    function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

                    function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

                    function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

                    function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






                    /**
                     * Configure cache adapter
                     *
                     * @param   {object} [config={}] Cache adapter options
                     * @returns {object} Object containing cache `adapter` and `store`
                     */

                    function setupCache() {
                        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        // Extend default configuration
                        config = Object(_config__WEBPACK_IMPORTED_MODULE_8__["makeConfig"])(config); // Axios adapter. Receives the axios request configuration as only parameter

                        function adapter(_x) {
                            return _adapter.apply(this, arguments);
                        } // Return adapter and store instance


                        function _adapter() {
                            _adapter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(req) {
                                var reqConfig, res, next, networkError, readOnError;
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                // Merge the per-request config with the instance config.
                                                reqConfig = Object(_config__WEBPACK_IMPORTED_MODULE_8__["mergeRequestConfig"])(config, req); // Execute request against local cache

                                                _context.next = 3;
                                                return Object(_request__WEBPACK_IMPORTED_MODULE_6__["default"])(reqConfig, req);

                                            case 3:
                                                res = _context.sent;
                                                next = res.next; // Response is not function, something was in cache, return it

                                                if (Object(_utilities__WEBPACK_IMPORTED_MODULE_9__["isFunction"])(next)) {
                                                    _context.next = 7;
                                                    break;
                                                }

                                                return _context.abrupt("return", next);

                                            case 7:
                                                _context.prev = 7;
                                                _context.next = 10;
                                                return reqConfig.adapter(req);

                                            case 10:
                                                res = _context.sent;
                                                _context.next = 16;
                                                break;

                                            case 13:
                                                _context.prev = 13;
                                                _context.t0 = _context["catch"](7);
                                                networkError = _context.t0;

                                            case 16:
                                                if (!networkError) {
                                                    _context.next = 31;
                                                    break;
                                                }

                                                // Check if we should attempt reading stale cache data
                                                readOnError = Object(_utilities__WEBPACK_IMPORTED_MODULE_9__["isFunction"])(reqConfig.readOnError) ? reqConfig.readOnError(networkError, req) : reqConfig.readOnError;

                                                if (!readOnError) {
                                                    _context.next = 30;
                                                    break;
                                                }

                                                _context.prev = 19;
                                                // Force cache tu return stale data
                                                reqConfig.acceptStale = true; // Try to read from cache again

                                                _context.next = 23;
                                                return Object(_request__WEBPACK_IMPORTED_MODULE_6__["default"])(reqConfig, req);

                                            case 23:
                                                res = _context.sent;
                                                // Signal that data is from stale cache
                                                res.next.request.stale = true; // No need to check if `next` is a function just return cache data

                                                return _context.abrupt("return", res.next);

                                            case 28:
                                                _context.prev = 28;
                                                _context.t1 = _context["catch"](19);

                                            case 30:
                                                throw networkError;

                                            case 31:
                                                return _context.abrupt("return", next(res));

                                            case 32:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, null, [[7, 13], [19, 28]]);
                            }));
                            return _adapter.apply(this, arguments);
                        }

                        return {
                            adapter: adapter,
                            config: config,
                            store: config.store
                        };
                    } // ---------------------
                    // Easy API Setup
                    // ---------------------

                    /**
                     * Setup an axios instance with the cache adapter pre-configured
                     *
                     * @param {object} [options={}] Axios and cache adapter options
                     * @returns {object} Instance of Axios
                     */


                    function setup() {
                        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        var instanceConfig = _objectSpread(_objectSpread(_objectSpread({}, _config__WEBPACK_IMPORTED_MODULE_8__["defaults"].axios), config), {}, {
                            cache: _objectSpread(_objectSpread({}, _config__WEBPACK_IMPORTED_MODULE_8__["defaults"].axios.cache), config.cache)
                        });

                        var cache = setupCache(instanceConfig.cache);

                        instanceConfig.cache;
                        var axiosConfig = _objectWithoutProperties(instanceConfig, ["cache"]);

                        var api = axios__WEBPACK_IMPORTED_MODULE_5___default.a.create(_objectSpread(_objectSpread({}, axiosConfig), {}, {
                            adapter: cache.adapter
                        }));
                        api.cache = cache.store;
                        return api;
                    }


/* harmony default export */ __webpack_exports__["default"] = ({
                        setup: setup,
                        setupCache: setupCache,
                        serializeQuery: _cache__WEBPACK_IMPORTED_MODULE_7__["serializeQuery"]
                    });

                    /***/
}),

/***/ "./src/cache.js":
/*!**********************!*\
  !*** ./src/cache.js ***!
  \**********************/
/*! exports provided: read, write, key, invalidate, serializeQuery, default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "read", function () { return read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "write", function () { return write; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "key", function () { return key; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invalidate", function () { return invalidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serializeQuery", function () { return serializeQuery; });
/* harmony import */ __webpack_require__(/*! core-js/modules/es7.array.includes */ "./node_modules/core-js/modules/es7.array.includes.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.string.includes */ "./node_modules/core-js/modules/es6.string.includes.js");
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utilities */ "./src/utilities.js");
/* harmony import */ var md5__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! md5 */ "./node_modules/md5/md5.js");
/* harmony import */ var md5__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(md5__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _serialize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./serialize */ "./src/serialize.js");






                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





                    function write(_x, _x2, _x3) {
                        return _write.apply(this, arguments);
                    }

                    function _write() {
                        _write = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config, req, res) {
                            var entry;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _context.prev = 0;
                                            entry = {
                                                expires: config.expires,
                                                data: Object(_serialize__WEBPACK_IMPORTED_MODULE_7__["default"])(config, req, res)
                                            };
                                            _context.next = 4;
                                            return config.store.setItem(config.uuid, entry);

                                        case 4:
                                            _context.next = 19;
                                            break;

                                        case 6:
                                            _context.prev = 6;
                                            _context.t0 = _context["catch"](0);
                                            config.debug('Could not store response', _context.t0);

                                            if (!config.clearOnError) {
                                                _context.next = 18;
                                                break;
                                            }

                                            _context.prev = 10;
                                            _context.next = 13;
                                            return config.store.clear();

                                        case 13:
                                            _context.next = 18;
                                            break;

                                        case 15:
                                            _context.prev = 15;
                                            _context.t1 = _context["catch"](10);
                                            config.debug('Could not clear store', _context.t1);

                                        case 18:
                                            return _context.abrupt("return", false);

                                        case 19:
                                            return _context.abrupt("return", true);

                                        case 20:
                                        case "end":
                                            return _context.stop();
                                    }
                                }
                            }, _callee, null, [[0, 6], [10, 15]]);
                        }));
                        return _write.apply(this, arguments);
                    }

                    function read(_x4, _x5) {
                        return _read.apply(this, arguments);
                    }

                    function _read() {
                        _read = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(config, req) {
                            var uuid, ignoreCache, entry, error, expires, data, offline, _error;

                            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                while (1) {
                                    switch (_context2.prev = _context2.next) {
                                        case 0:
                                            uuid = config.uuid, ignoreCache = config.ignoreCache;
                                            _context2.next = 3;
                                            return config.store.getItem(uuid);

                                        case 3:
                                            entry = _context2.sent;

                                            if (!(ignoreCache || !entry || !entry.data)) {
                                                _context2.next = 10;
                                                break;
                                            }

                                            config.debug('cache-miss', req.url);
                                            error = new Error();
                                            error.reason = 'cache-miss';
                                            error.message = 'Entry not found from cache';
                                            throw error;

                                        case 10:
                                            expires = entry.expires, data = entry.data; // Do not check for stale cache if offline on client-side

                                            offline = typeof navigator !== 'undefined' && 'onLine' in navigator && !navigator.onLine;

                                            if (!(!offline && !config.acceptStale && expires !== 0 && expires < Date.now())) {
                                                _context2.next = 18;
                                                break;
                                            }

                                            config.debug('cache-stale', req.url);
                                            _error = new Error();
                                            _error.reason = 'cache-stale';
                                            _error.message = 'Entry is stale';
                                            throw _error;

                                        case 18:
                                            config.debug(config.acceptStale ? 'cache-hit-stale' : 'cache-hit', req.url);
                                            return _context2.abrupt("return", data);

                                        case 20:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }
                            }, _callee2);
                        }));
                        return _read.apply(this, arguments);
                    }

                    function key(config) {
                        if (Object(_utilities__WEBPACK_IMPORTED_MODULE_5__["isFunction"])(config.key)) return config.key;
                        var cacheKey;

                        if (Object(_utilities__WEBPACK_IMPORTED_MODULE_5__["isString"])(config.key)) {
                            cacheKey = function cacheKey(req) {
                                var url = "".concat(req.baseURL ? req.baseURL : '').concat(req.url);
                                var key = "".concat(config.key, "/").concat(url).concat(serializeQuery(req));
                                return req.data ? key + md5__WEBPACK_IMPORTED_MODULE_6___default()(req.data) : key;
                            };
                        } else {
                            cacheKey = function cacheKey(req) {
                                var url = "".concat(req.baseURL ? req.baseURL : '').concat(req.url);
                                var key = url + serializeQuery(req);
                                return req.data ? key + md5__WEBPACK_IMPORTED_MODULE_6___default()(req.data) : key;
                            };
                        }

                        return cacheKey;
                    }

                    function defaultInvalidate(_x6, _x7) {
                        return _defaultInvalidate.apply(this, arguments);
                    }

                    function _defaultInvalidate() {
                        _defaultInvalidate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(config, req) {
                            var method;
                            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                while (1) {
                                    switch (_context3.prev = _context3.next) {
                                        case 0:
                                            method = req.method.toLowerCase();

                                            if (!config.exclude.methods.includes(method)) {
                                                _context3.next = 4;
                                                break;
                                            }

                                            _context3.next = 4;
                                            return config.store.removeItem(config.uuid);

                                        case 4:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }
                            }, _callee3);
                        }));
                        return _defaultInvalidate.apply(this, arguments);
                    }

                    function invalidate() {
                        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (Object(_utilities__WEBPACK_IMPORTED_MODULE_5__["isFunction"])(config.invalidate)) return config.invalidate;
                        return defaultInvalidate;
                    }

                    function serializeQuery(req) {
                        if (!req.params) return ''; // Probably server-side, just stringify the object

                        if (typeof URLSearchParams === 'undefined') return JSON.stringify(req.params);
                        var params = req.params;
                        var isInstanceOfURLSearchParams = req.params instanceof URLSearchParams; // Convert to an instance of URLSearchParams so it get serialized the same way

                        if (!isInstanceOfURLSearchParams) {
                            params = new URLSearchParams();
                            Object.keys(req.params).forEach(function (key) {
                                return params.append(key, req.params[key]);
                            });
                        }

                        return "?".concat(params.toString());
                    }


/* harmony default export */ __webpack_exports__["default"] = ({
                        read: read,
                        write: write,
                        key: key,
                        invalidate: invalidate,
                        serializeQuery: serializeQuery
                    });

                    /***/
}),

/***/ "./src/config.js":
/*!***********************!*\
  !*** ./src/config.js ***!
  \***********************/
/*! exports provided: defaults, makeConfig, mergeRequestConfig, default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function () { return defaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeConfig", function () { return makeConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeRequestConfig", function () { return mergeRequestConfig; });
/* harmony import */ __webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _memory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./memory */ "./src/memory.js");
/* harmony import */ var _cache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cache */ "./src/cache.js");





                    function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

                    function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

                    function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





                    var noop = function noop() { };

                    var debug = function debug() {
                        var _console;

                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }

                        return (_console = console).log.apply(_console, ['[axios-cache-adapter]'].concat(args));
                    };

                    var defaults = {
                        // Default settings when solely creating the cache adapter with setupCache.
                        cache: {
                            maxAge: 0,
                            limit: false,
                            store: null,
                            key: null,
                            invalidate: null,
                            exclude: {
                                paths: [],
                                query: true,
                                filter: null,
                                methods: ['post', 'patch', 'put', 'delete']
                            },
                            adapter: axios__WEBPACK_IMPORTED_MODULE_4___default.a.defaults.adapter,
                            clearOnStale: true,
                            clearOnError: true,
                            readOnError: false,
                            readHeaders: false,
                            debug: false,
                            ignoreCache: false
                        },
                        // Additional defaults when creating the axios instance with the cache adapter.
                        axios: {
                            cache: {
                                maxAge: 15 * 60 * 1000
                            }
                        }
                    }; // List of disallowed in the per-request config.

                    var disallowedPerRequestKeys = ['limit', 'store', 'adapter', 'uuid', 'acceptStale'];
                    /**
                     * Make a global config object.
                     *
                     * @param {Object} [override={}] Optional config override.
                     * @return {Object}
                     */

                    var makeConfig = function makeConfig() {
                        var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        var config = _objectSpread(_objectSpread(_objectSpread({}, defaults.cache), override), {}, {
                            exclude: _objectSpread(_objectSpread({}, defaults.cache.exclude), override.exclude)
                        }); // Create a cache key method


                        config.key = Object(_cache__WEBPACK_IMPORTED_MODULE_6__["key"])(config);
                        config.invalidate = Object(_cache__WEBPACK_IMPORTED_MODULE_6__["invalidate"])(config); // If debug mode is on, create a simple logger method

                        if (config.debug !== false) {
                            config.debug = typeof config.debug === 'function' ? config.debug : debug;
                        } else {
                            config.debug = noop;
                        } // Create an in memory store if none was given


                        if (!config.store) config.store = new _memory__WEBPACK_IMPORTED_MODULE_5__["default"]();
                        config.debug('Global cache config', config);
                        return config;
                    };
                    /**
                     * Merge the per-request config in another config.
                     *
                     * This method exists because not all keys should be allowed as it
                     * may lead to unexpected behaviours. For instance, setting another
                     * store or adapter per request is wrong, instead another instance
                     * axios, or the adapter, should be used.
                     *
                     * @param {Object} config Config object.
                     * @param {Object} req    The current axios request
                     * @return {Object}
                     */


                    var mergeRequestConfig = function mergeRequestConfig(config, req) {
                        var requestConfig = req.cache || {};

                        if (requestConfig) {
                            disallowedPerRequestKeys.forEach(function (key) {
                                return requestConfig[key] ? delete requestConfig[key] : undefined;
                            });
                        }

                        var mergedConfig = _objectSpread(_objectSpread(_objectSpread({}, config), requestConfig), {}, {
                            exclude: _objectSpread(_objectSpread({}, config.exclude), requestConfig.exclude)
                        });

                        if (mergedConfig.debug === true) {
                            mergedConfig.debug = debug;
                        } // Create a cache key method


                        if (requestConfig.key) {
                            mergedConfig.key = Object(_cache__WEBPACK_IMPORTED_MODULE_6__["key"])(requestConfig);
                        } // Generate request UUID


                        mergedConfig.uuid = mergedConfig.key(req);
                        config.debug("Request config for ".concat(req.url), mergedConfig);
                        return mergedConfig;
                    };


/* harmony default export */ __webpack_exports__["default"] = ({
                        defaults: defaults,
                        makeConfig: makeConfig,
                        mergeRequestConfig: mergeRequestConfig
                    });

                    /***/
}),

/***/ "./src/exclude.js":
/*!************************!*\
  !*** ./src/exclude.js ***!
  \************************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es7.array.includes */ "./node_modules/core-js/modules/es7.array.includes.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.string.includes */ "./node_modules/core-js/modules/es6.string.includes.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utilities */ "./src/utilities.js");






                    function exclude() {
                        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var req = arguments.length > 1 ? arguments[1] : undefined;
                        var _config$exclude = config.exclude,
                            exclude = _config$exclude === void 0 ? {} : _config$exclude,
                            debug = config.debug;
                        var method = req.method.toLowerCase();

                        if (method === 'head' || exclude.methods.includes(method)) {
                            debug("Excluding request by HTTP method ".concat(req.url));
                            return true;
                        }

                        if (typeof exclude.filter === 'function' && exclude.filter(req)) {
                            debug("Excluding request by filter ".concat(req.url));
                            return true;
                        } // do not cache request with query


                        var hasQueryParams = /\?.*$/.test(req.url) || Object(_utilities__WEBPACK_IMPORTED_MODULE_4__["isObject"])(req.params) && Object.keys(req.params).length !== 0 || typeof URLSearchParams !== 'undefined' && req.params instanceof URLSearchParams;

                        if (exclude.query && hasQueryParams) {
                            debug("Excluding request by query ".concat(req.url));
                            return true;
                        }

                        var paths = exclude.paths || [];
                        var found = paths.some(function (regexp) {
                            return req.url.match(regexp);
                        });

                        if (found) {
                            debug("Excluding request by url match ".concat(req.url));
                            return true;
                        }

                        return false;
                    }

/* harmony default export */ __webpack_exports__["default"] = (exclude);

                    /***/
}),

/***/ "./src/index.node.js":
/*!***************************!*\
  !*** ./src/index.node.js ***!
  \***************************/
/*! exports provided: setup, setupCache, serializeQuery, RedisStore, RedisDefaultStore, default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./api */ "./src/api.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setup", function () { return _api__WEBPACK_IMPORTED_MODULE_0__["setup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setupCache", function () { return _api__WEBPACK_IMPORTED_MODULE_0__["setupCache"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "serializeQuery", function () { return _api__WEBPACK_IMPORTED_MODULE_0__["serializeQuery"]; });

/* harmony import */ var _redis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./redis */ "./src/redis.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RedisStore", function () { return _redis__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _redis_default__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./redis-default */ "./src/redis-default.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RedisDefaultStore", function () { return _redis_default__WEBPACK_IMPORTED_MODULE_2__["default"]; });





/* harmony default export */ __webpack_exports__["default"] = ({
                        setup: _api__WEBPACK_IMPORTED_MODULE_0__["setup"],
                        setupCache: _api__WEBPACK_IMPORTED_MODULE_0__["setupCache"],
                        serializeQuery: _api__WEBPACK_IMPORTED_MODULE_0__["serializeQuery"],
                        RedisStore: _redis__WEBPACK_IMPORTED_MODULE_1__["default"],
                        RedisDefaultStore: _redis_default__WEBPACK_IMPORTED_MODULE_2__["default"]
                    });

                    /***/
}),

/***/ "./src/limit.js":
/*!**********************!*\
  !*** ./src/limit.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");



                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

                    function limit(_x) {
                        return _limit.apply(this, arguments);
                    }

                    function _limit() {
                        _limit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
                            var length, firstItem;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _context.next = 2;
                                            return config.store.length();

                                        case 2:
                                            length = _context.sent;

                                            if (!(length < config.limit)) {
                                                _context.next = 5;
                                                break;
                                            }

                                            return _context.abrupt("return");

                                        case 5:
                                            config.debug("Current store size: ".concat(length));
                                            _context.next = 8;
                                            return config.store.iterate(function (value, key) {
                                                if (!firstItem) firstItem = {
                                                    value: value,
                                                    key: key
                                                };
                                                if (value.expires < firstItem.value.expires) firstItem = {
                                                    value: value,
                                                    key: key
                                                };
                                            });

                                        case 8:
                                            if (!firstItem) {
                                                _context.next = 12;
                                                break;
                                            }

                                            config.debug("Removing item: ".concat(firstItem.key));
                                            _context.next = 12;
                                            return config.store.removeItem(firstItem.key);

                                        case 12:
                                        case "end":
                                            return _context.stop();
                                    }
                                }
                            }, _callee);
                        }));
                        return _limit.apply(this, arguments);
                    }

/* harmony default export */ __webpack_exports__["default"] = (limit);

                    /***/
}),

/***/ "./src/memory.js":
/*!***********************!*\
  !*** ./src/memory.js ***!
  \***********************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utilities */ "./src/utilities.js");




                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

                    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

                    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



                    var MemoryStore = /*#__PURE__*/function () {
                        function MemoryStore() {
                            _classCallCheck(this, MemoryStore);

                            this.store = {};
                        }

                        _createClass(MemoryStore, [{
                            key: "getItem",
                            value: function () {
                                var _getItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key) {
                                    var item;
                                    return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    item = this.store[key] || null;
                                                    return _context.abrupt("return", JSON.parse(item));

                                                case 2:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, this);
                                }));

                                function getItem(_x) {
                                    return _getItem.apply(this, arguments);
                                }

                                return getItem;
                            }()
                        }, {
                            key: "setItem",
                            value: function () {
                                var _setItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key, value) {
                                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    this.store[key] = JSON.stringify(value);
                                                    return _context2.abrupt("return", value);

                                                case 2:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, this);
                                }));

                                function setItem(_x2, _x3) {
                                    return _setItem.apply(this, arguments);
                                }

                                return setItem;
                            }()
                        }, {
                            key: "removeItem",
                            value: function () {
                                var _removeItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
                                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                        while (1) {
                                            switch (_context3.prev = _context3.next) {
                                                case 0:
                                                    delete this.store[key];

                                                case 1:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }
                                    }, _callee3, this);
                                }));

                                function removeItem(_x4) {
                                    return _removeItem.apply(this, arguments);
                                }

                                return removeItem;
                            }()
                        }, {
                            key: "clear",
                            value: function () {
                                var _clear = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    this.store = {};

                                                case 1:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, this);
                                }));

                                function clear() {
                                    return _clear.apply(this, arguments);
                                }

                                return clear;
                            }()
                        }, {
                            key: "length",
                            value: function () {
                                var _length = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                        while (1) {
                                            switch (_context5.prev = _context5.next) {
                                                case 0:
                                                    return _context5.abrupt("return", Object.keys(this.store).length);

                                                case 1:
                                                case "end":
                                                    return _context5.stop();
                                            }
                                        }
                                    }, _callee5, this);
                                }));

                                function length() {
                                    return _length.apply(this, arguments);
                                }

                                return length;
                            }()
                        }, {
                            key: "iterate",
                            value: function iterate(fn) {
                                return Promise.all(Object(_utilities__WEBPACK_IMPORTED_MODULE_3__["mapObject"])(this.store, fn));
                            }
                        }]);

                        return MemoryStore;
                    }();

/* harmony default export */ __webpack_exports__["default"] = (MemoryStore);

                    /***/
}),

/***/ "./src/redis-default.js":
/*!******************************!*\
  !*** ./src/redis-default.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.function.name */ "./node_modules/core-js/modules/es6.function.name.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! util */ "util");






                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

                    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

                    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



                    var RedisDefaultStore = /*#__PURE__*/function () {
                        function RedisDefaultStore(client) {
                            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                            _classCallCheck(this, RedisDefaultStore);

                            var invalidClientError = new TypeError('First parameter must be a valid RedisClient instance.');

                            try {
                                if (client.constructor.name !== 'RedisClient') {
                                    throw invalidClientError;
                                }
                            } catch (err) {
                                throw invalidClientError;
                            }

                            this.client = client;
                            this.prefix = options.prefix || 'axios-cache';
                            this.maxScanCount = options.maxScanCount || 1000;
                            this.getAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.get).bind(client);
                            this.psetexAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.psetex).bind(client);
                            this.delAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.del).bind(client);
                            this.scanAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.scan).bind(client);
                        }

                        _createClass(RedisDefaultStore, [{
                            key: "calculateTTL",
                            value: function calculateTTL(value) {
                                var now = Date.now();

                                if (value.expires && value.expires > now) {
                                    return value.expires - now;
                                } // If there is no expires in value or the provided expire is before the current time


                                return -1;
                            }
                        }, {
                            key: "transformKey",
                            value: function transformKey(key) {
                                return this.prefix + '_' + key;
                            }
                        }, {
                            key: "getItem",
                            value: function () {
                                var _getItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key) {
                                    var item;
                                    return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return this.getAsync(this.transformKey(key));

                                                case 2:
                                                    _context.t0 = _context.sent;

                                                    if (_context.t0) {
                                                        _context.next = 5;
                                                        break;
                                                    }

                                                    _context.t0 = null;

                                                case 5:
                                                    item = _context.t0;
                                                    return _context.abrupt("return", JSON.parse(item));

                                                case 7:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, this);
                                }));

                                function getItem(_x) {
                                    return _getItem.apply(this, arguments);
                                }

                                return getItem;
                            }()
                        }, {
                            key: "setItem",
                            value: function () {
                                var _setItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key, value) {
                                    var computedKey, ttl;
                                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    computedKey = this.transformKey(key);
                                                    ttl = this.calculateTTL(value);

                                                    if (!(ttl > 0)) {
                                                        _context2.next = 5;
                                                        break;
                                                    }

                                                    _context2.next = 5;
                                                    return this.psetexAsync(computedKey, ttl, JSON.stringify(value));

                                                case 5:
                                                    return _context2.abrupt("return", value);

                                                case 6:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, this);
                                }));

                                function setItem(_x2, _x3) {
                                    return _setItem.apply(this, arguments);
                                }

                                return setItem;
                            }()
                        }, {
                            key: "removeItem",
                            value: function () {
                                var _removeItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
                                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                        while (1) {
                                            switch (_context3.prev = _context3.next) {
                                                case 0:
                                                    _context3.next = 2;
                                                    return this.delAsync(this.transformKey(key));

                                                case 2:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }
                                    }, _callee3, this);
                                }));

                                function removeItem(_x4) {
                                    return _removeItem.apply(this, arguments);
                                }

                                return removeItem;
                            }()
                        }, {
                            key: "scan",
                            value: function () {
                                var _scan = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(operation) {
                                    var cursor, reply;
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    cursor = '0';

                                                case 1:
                                                    _context4.next = 3;
                                                    return this.scanAsync(cursor, 'MATCH', this.transformKey('*'), 'COUNT', this.maxScanCount);

                                                case 3:
                                                    reply = _context4.sent;
                                                    cursor = reply[0];
                                                    _context4.next = 7;
                                                    return operation(reply[1]);

                                                case 7:
                                                    if (cursor !== '0') {
                                                        _context4.next = 1;
                                                        break;
                                                    }

                                                case 8:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, this);
                                }));

                                function scan(_x5) {
                                    return _scan.apply(this, arguments);
                                }

                                return scan;
                            }()
                        }, {
                            key: "clear",
                            value: function () {
                                var _clear = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                                    var _this = this;

                                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                        while (1) {
                                            switch (_context5.prev = _context5.next) {
                                                case 0:
                                                    _context5.next = 2;
                                                    return this.scan(function (keys) {
                                                        return _this.delAsync(keys);
                                                    });

                                                case 2:
                                                case "end":
                                                    return _context5.stop();
                                            }
                                        }
                                    }, _callee5, this);
                                }));

                                function clear() {
                                    return _clear.apply(this, arguments);
                                }

                                return clear;
                            }()
                        }, {
                            key: "length",
                            value: function () {
                                var _length = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                                    var length;
                                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                        while (1) {
                                            switch (_context6.prev = _context6.next) {
                                                case 0:
                                                    length = 0;
                                                    _context6.next = 3;
                                                    return this.scan(function (keys) {
                                                        length += keys.length;
                                                    });

                                                case 3:
                                                    return _context6.abrupt("return", length);

                                                case 4:
                                                case "end":
                                                    return _context6.stop();
                                            }
                                        }
                                    }, _callee6, this);
                                }));

                                function length() {
                                    return _length.apply(this, arguments);
                                }

                                return length;
                            }()
                        }, {
                            key: "iterate",
                            value: function () {
                                var _iterate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(fn) {
                                    var _this2 = this;

                                    var runFunction, _runFunction;

                                    return regeneratorRuntime.wrap(function _callee8$(_context8) {
                                        while (1) {
                                            switch (_context8.prev = _context8.next) {
                                                case 0:
                                                    _runFunction = function _runFunction3() {
                                                        _runFunction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(key) {
                                                            var item, value;
                                                            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                                                                while (1) {
                                                                    switch (_context7.prev = _context7.next) {
                                                                        case 0:
                                                                            _context7.next = 2;
                                                                            return this.getAsync(key);

                                                                        case 2:
                                                                            _context7.t0 = _context7.sent;

                                                                            if (_context7.t0) {
                                                                                _context7.next = 5;
                                                                                break;
                                                                            }

                                                                            _context7.t0 = null;

                                                                        case 5:
                                                                            item = _context7.t0;
                                                                            value = JSON.parse(item);
                                                                            _context7.next = 9;
                                                                            return fn(value, key);

                                                                        case 9:
                                                                            return _context7.abrupt("return", _context7.sent);

                                                                        case 10:
                                                                        case "end":
                                                                            return _context7.stop();
                                                                    }
                                                                }
                                                            }, _callee7, this);
                                                        }));
                                                        return _runFunction.apply(this, arguments);
                                                    };

                                                    runFunction = function _runFunction2(_x7) {
                                                        return _runFunction.apply(this, arguments);
                                                    };

                                                    _context8.next = 4;
                                                    return this.scan(function (keys) {
                                                        return Promise.all(keys.map(runFunction.bind(_this2)));
                                                    });

                                                case 4:
                                                    return _context8.abrupt("return", Promise.resolve([]));

                                                case 5:
                                                case "end":
                                                    return _context8.stop();
                                            }
                                        }
                                    }, _callee8, this);
                                }));

                                function iterate(_x6) {
                                    return _iterate.apply(this, arguments);
                                }

                                return iterate;
                            }()
                        }]);

                        return RedisDefaultStore;
                    }();

/* harmony default export */ __webpack_exports__["default"] = (RedisDefaultStore);

                    /***/
}),

/***/ "./src/redis.js":
/*!**********************!*\
  !*** ./src/redis.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.function.name */ "./node_modules/core-js/modules/es6.function.name.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! util */ "util");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utilities */ "./src/utilities.js");






                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

                    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

                    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




                    var RedisStore = /*#__PURE__*/function () {
                        function RedisStore(client) {
                            var HASH_KEY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'axios-cache';

                            _classCallCheck(this, RedisStore);

                            var invalidClientError = new TypeError('First parameter must be a valid RedisClient instance.');

                            try {
                                if (client.constructor.name !== 'RedisClient') {
                                    throw invalidClientError;
                                }
                            } catch (err) {
                                throw invalidClientError;
                            }

                            this.client = client;
                            this.HASH_KEY = HASH_KEY;
                            this.hgetAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.hget).bind(client);
                            this.hsetAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.hset).bind(client);
                            this.hdelAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.hdel).bind(client);
                            this.delAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.del).bind(client);
                            this.hlenAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.hlen).bind(client);
                            this.hgetallAsync = Object(util__WEBPACK_IMPORTED_MODULE_5__["promisify"])(client.hgetall).bind(client);
                        }

                        _createClass(RedisStore, [{
                            key: "getItem",
                            value: function () {
                                var _getItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key) {
                                    var item;
                                    return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return this.hgetAsync(this.HASH_KEY, key);

                                                case 2:
                                                    _context.t0 = _context.sent;

                                                    if (_context.t0) {
                                                        _context.next = 5;
                                                        break;
                                                    }

                                                    _context.t0 = null;

                                                case 5:
                                                    item = _context.t0;
                                                    return _context.abrupt("return", JSON.parse(item));

                                                case 7:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, this);
                                }));

                                function getItem(_x) {
                                    return _getItem.apply(this, arguments);
                                }

                                return getItem;
                            }()
                        }, {
                            key: "setItem",
                            value: function () {
                                var _setItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key, value) {
                                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    _context2.next = 2;
                                                    return this.hsetAsync(this.HASH_KEY, key, JSON.stringify(value));

                                                case 2:
                                                    return _context2.abrupt("return", value);

                                                case 3:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, this);
                                }));

                                function setItem(_x2, _x3) {
                                    return _setItem.apply(this, arguments);
                                }

                                return setItem;
                            }()
                        }, {
                            key: "removeItem",
                            value: function () {
                                var _removeItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
                                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                        while (1) {
                                            switch (_context3.prev = _context3.next) {
                                                case 0:
                                                    _context3.next = 2;
                                                    return this.hdelAsync(this.HASH_KEY, key);

                                                case 2:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }
                                    }, _callee3, this);
                                }));

                                function removeItem(_x4) {
                                    return _removeItem.apply(this, arguments);
                                }

                                return removeItem;
                            }()
                        }, {
                            key: "clear",
                            value: function () {
                                var _clear = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    _context4.next = 2;
                                                    return this.delAsync(this.HASH_KEY);

                                                case 2:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, this);
                                }));

                                function clear() {
                                    return _clear.apply(this, arguments);
                                }

                                return clear;
                            }()
                        }, {
                            key: "length",
                            value: function () {
                                var _length = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                        while (1) {
                                            switch (_context5.prev = _context5.next) {
                                                case 0:
                                                    return _context5.abrupt("return", this.hlenAsync(this.HASH_KEY));

                                                case 1:
                                                case "end":
                                                    return _context5.stop();
                                            }
                                        }
                                    }, _callee5, this);
                                }));

                                function length() {
                                    return _length.apply(this, arguments);
                                }

                                return length;
                            }()
                        }, {
                            key: "iterate",
                            value: function () {
                                var _iterate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(fn) {
                                    var hashData;
                                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                        while (1) {
                                            switch (_context6.prev = _context6.next) {
                                                case 0:
                                                    _context6.next = 2;
                                                    return this.hgetallAsync(this.HASH_KEY);

                                                case 2:
                                                    hashData = _context6.sent;
                                                    return _context6.abrupt("return", Promise.all(Object(_utilities__WEBPACK_IMPORTED_MODULE_6__["mapObject"])(hashData, fn)));

                                                case 4:
                                                case "end":
                                                    return _context6.stop();
                                            }
                                        }
                                    }, _callee6, this);
                                }));

                                function iterate(_x5) {
                                    return _iterate.apply(this, arguments);
                                }

                                return iterate;
                            }()
                        }]);

                        return RedisStore;
                    }();

/* harmony default export */ __webpack_exports__["default"] = (RedisStore);

                    /***/
}),

/***/ "./src/request.js":
/*!************************!*\
  !*** ./src/request.js ***!
  \************************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ var _response__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./response */ "./src/response.js");
/* harmony import */ var _exclude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./exclude */ "./src/exclude.js");
/* harmony import */ var _cache__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./cache */ "./src/cache.js");



                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





                    function request(_x, _x2) {
                        return _request.apply(this, arguments);
                    }

                    function _request() {
                        _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config, req) {
                            var next, res, excludeFromCache;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            excludeFromCache = function _excludeFromCache() {
                                                config.excludeFromCache = true;
                                                return {
                                                    config: config,
                                                    next: next
                                                };
                                            };

                                            config.debug('uuid', config.uuid);

                                            next = function next() {
                                                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                                                    args[_key] = arguments[_key];
                                                }

                                                return _response__WEBPACK_IMPORTED_MODULE_2__["default"].apply(void 0, [config, req].concat(args));
                                            }; // run invalidate function to check if any cache items need to be invalidated.


                                            _context.next = 5;
                                            return config.invalidate(config, req);

                                        case 5:
                                            if (!Object(_exclude__WEBPACK_IMPORTED_MODULE_3__["default"])(config, req)) {
                                                _context.next = 7;
                                                break;
                                            }

                                            return _context.abrupt("return", excludeFromCache());

                                        case 7:
                                            _context.prev = 7;
                                            _context.next = 10;
                                            return Object(_cache__WEBPACK_IMPORTED_MODULE_4__["read"])(config, req);

                                        case 10:
                                            res = _context.sent;
                                            res.config = req;
                                            res.request = {
                                                fromCache: true
                                            };
                                            return _context.abrupt("return", {
                                                config: config,
                                                next: res
                                            });

                                        case 16:
                                            _context.prev = 16;
                                            _context.t0 = _context["catch"](7);

                                            if (!(config.clearOnStale && _context.t0.reason === 'cache-stale')) {
                                                _context.next = 21;
                                                break;
                                            }

                                            _context.next = 21;
                                            return config.store.removeItem(config.uuid);

                                        case 21:
                                            return _context.abrupt("return", {
                                                config: config,
                                                next: next
                                            });

                                        case 22:
                                        case "end":
                                            return _context.stop();
                                    }
                                }
                            }, _callee, null, [[7, 16]]);
                        }));
                        return _request.apply(this, arguments);
                    }

/* harmony default export */ __webpack_exports__["default"] = (request);

                    /***/
}),

/***/ "./src/response.js":
/*!*************************!*\
  !*** ./src/response.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");
/* harmony import */ var _limit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./limit */ "./src/limit.js");
/* harmony import */ var _cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./cache */ "./src/cache.js");
/* harmony import */ var cache_control_esm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! cache-control-esm */ "./node_modules/cache-control-esm/index.js");



                    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

                    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





                    function response(_x, _x2, _x3) {
                        return _response.apply(this, arguments);
                    }

                    function _response() {
                        _response = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config, req, res) {
                            var _res$request, request, _res$headers, headers, cacheControl;

                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _res$request = res.request, request = _res$request === void 0 ? {} : _res$request, _res$headers = res.headers, headers = _res$headers === void 0 ? {} : _res$headers; // exclude binary response from cache

                                            if (!(['arraybuffer', 'blob'].indexOf(request.responseType) > -1)) {
                                                _context.next = 3;
                                                break;
                                            }

                                            return _context.abrupt("return", res);

                                        case 3:
                                            cacheControl = {}; // Should we try to determine request cache expiration from headers or not

                                            if (config.readHeaders) {
                                                if (headers['cache-control']) {
                                                    // Try parsing `cache-control` header from response
                                                    cacheControl = Object(cache_control_esm__WEBPACK_IMPORTED_MODULE_4__["parse"])(headers['cache-control']); // Force cache exlcusion for `cache-control: no-cache` and `cache-control: no-store`

                                                    if (cacheControl.noCache || cacheControl.noStore) {
                                                        config.excludeFromCache = true;
                                                    }
                                                } else if (headers.expires) {
                                                    // Else try reading `expires` header
                                                    config.expires = new Date(headers.expires).getTime();
                                                } else {
                                                    config.expires = new Date().getTime();
                                                }
                                            }

                                            if (config.excludeFromCache) {
                                                _context.next = 15;
                                                break;
                                            }

                                            if (cacheControl.maxAge || cacheControl.maxAge === 0) {
                                                // Use `cache-control` header `max-age` value and convert to milliseconds
                                                config.expires = Date.now() + cacheControl.maxAge * 1000;
                                            } else if (!config.readHeaders) {
                                                // Use fixed `maxAge` defined in the global or per-request config
                                                config.expires = config.maxAge === 0 ? Date.now() : Date.now() + config.maxAge;
                                            } // Check if a cache limit has been configured


                                            if (!config.limit) {
                                                _context.next = 11;
                                                break;
                                            }

                                            config.debug("Detected limit: ".concat(config.limit));
                                            _context.next = 11;
                                            return Object(_limit__WEBPACK_IMPORTED_MODULE_2__["default"])(config);

                                        case 11:
                                            _context.next = 13;
                                            return Object(_cache__WEBPACK_IMPORTED_MODULE_3__["write"])(config, req, res);

                                        case 13:
                                            _context.next = 16;
                                            break;

                                        case 15:
                                            // Mark request as excluded from cache
                                            res.request.excludedFromCache = true;

                                        case 16:
                                            return _context.abrupt("return", res);

                                        case 17:
                                        case "end":
                                            return _context.stop();
                                    }
                                }
                            }, _callee);
                        }));
                        return _response.apply(this, arguments);
                    }

/* harmony default export */ __webpack_exports__["default"] = (response);

                    /***/
}),

/***/ "./src/serialize.js":
/*!**************************!*\
  !*** ./src/serialize.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");




                    function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

                    function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

                    function serialize(config, req, res) {
                        if (res.data) {
                            // FIXME: May be useless as localForage and axios already parse automatically
                            try {
                                res.data = JSON.parse(res.data);
                            } catch (err) {
                                config.debug('Could not parse data as JSON', err);
                            }
                        }

                        res.request;
                        res.config;
                        var serialized = _objectWithoutProperties(res, ["request", "config"]);

                        return serialized;
                    }

/* harmony default export */ __webpack_exports__["default"] = (serialize);

                    /***/
}),

/***/ "./src/utilities.js":
/*!**************************!*\
  !*** ./src/utilities.js ***!
  \**************************/
/*! exports provided: isObject, getTag, isFunction, isString, mapObject */
/***/ (function (module, __webpack_exports__, __webpack_require__) {
                    __webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function () { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTag", function () { return getTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function () { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function () { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapObject", function () { return mapObject; });
/* harmony import */ __webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ __webpack_require__(/*! core-js/modules/es6.object.to-string */ "./node_modules/core-js/modules/es6.object.to-string.js");





                    function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

                    // https://github.com/lodash/lodash/blob/master/isObject.js
                    function isObject(value) {
                        var type = _typeof(value);

                        return value != null && (type === 'object' || type === 'function');
                    } // https://github.com/lodash/lodash/blob/master/.internal/getTag.js

                    function getTag(value) {
                        if (value === null) {
                            return value === undefined ? '[object Undefined]' : '[object Null]';
                        }

                        return Object.prototype.toString.call(value);
                    } // https://github.com/lodash/lodash/blob/master/isFunction.js

                    function isFunction(value) {
                        if (!isObject(value)) {
                            return false;
                        }

                        var tag = getTag(value);
                        return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
                    } // https://github.com/lodash/lodash/blob/master/isString.js

                    function isString(value) {
                        var type = _typeof(value);

                        return type === 'string' || type === 'object' && value != null && !Array.isArray(value) && getTag(value) === '[object String]';
                    }
                    function mapObject(value, fn) {
                        if (!isObject(value)) {
                            return [];
                        }

                        return Object.keys(value).map(function (key) {
                            return fn(value[key], key);
                        });
                    }

                    /***/
}),

/***/ "axios":
/*!*************************************************************************************!*\
  !*** external {"umd":"axios","amd":"axios","commonjs":"axios","commonjs2":"axios"} ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = __WEBPACK_EXTERNAL_MODULE_axios__;

                    /***/
}),

/***/ "util":
/*!***********************!*\
  !*** external "util" ***!
  \***********************/
/*! no static exports found */
/***/ (function (module, exports) {

                    module.exports = require$$1$1;

                    /***/
})

            /******/
});
    });

}(cache_node));

var MAX_REQUEST_CACHE_AGE = 30 * 60 * 1000; // all requests will be cached for 30 minutes.
var createCache = function () {
    var cache = cache_node.exports.setupCache({
        maxAge: MAX_REQUEST_CACHE_AGE,
        exclude: {
            query: false, // allow requests with query parameters to be cached.
        },
    });
    return cache;
};

var defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

var create = function (apiConfig) {
    var apiBackend = axios.create({
        baseURL: apiConfig.getUrl(),
        headers: __assign({}, defaultHeaders),
        adapter: apiConfig.hasCache() ? createCache().adapter : undefined,
    });
    var middlewaresToApply = [
        applyRemoveFrontendTemporaryIdsMiddleware,
        applyAuthorizationMiddleware,
        _applyCaseMiddleware,
    ];
    middlewaresToApply.forEach(function (applyMiddleware) { return applyMiddleware(apiBackend); });
    return apiBackend;
};

var ApiConfig = /** @class */ (function () {
    function ApiConfig(env) {
        this.withCaching = false;
        this.env = env;
    }
    ApiConfig.prototype.enableCache = function () {
        this.withCaching = true;
    };
    ApiConfig.prototype.hasCache = function () {
        return this.withCaching;
    };
    ApiConfig.prototype.getUrl = function () {
        var baseUrl = this.apiUrls[this.env];
        var apiVer = this.apiVersion;
        return "".concat(baseUrl).concat(apiVer);
    };
    return ApiConfig;
}());

var MsApiConfig = /** @class */ (function (_super) {
    __extends(MsApiConfig, _super);
    function MsApiConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiUrls = {
            local: 'http://0.0.0.0:8000',
            development: 'https://ms-api-dot-dev-minchem-solvextract.appspot.com',
            'pre-production': 'https://ms-api-dot-pprd-minchem-solvextract.appspot.com',
            production: 'https://ms-api-dot-prd-minchem-solvextract.appspot.com',
            testing: 'http://0.0.0.0:8000',
        };
        _this.apiVersion = '/api/';
        return _this;
    }
    return MsApiConfig;
}(ApiConfig));

/** @class */ ((function (_super) {
    __extends(RgsApiConfig, _super);
    function RgsApiConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiUrls = {
            local: 'http://0.0.0.0:8844',
            development: 'https://rgs-api-dot-dev-minchem-solvextract.appspot.com',
            'pre-production': 'https://rgs-api-dot-pprd-minchem-solvextract.appspot.com',
            production: 'https://rgs-api-dot-prd-minchem-solvextract.appspot.com',
            testing: 'http://0.0.0.0:8844',
        };
        _this.apiVersion = '';
        return _this;
    }
    return RgsApiConfig;
})(ApiConfig));

var AppEnvironments;
(function (AppEnvironments) {
    AppEnvironments["local"] = "local";
    AppEnvironments["development"] = "development";
    AppEnvironments["pre-production"] = "pre-production";
    AppEnvironments["production"] = "production";
    AppEnvironments["testing"] = "testing";
})(AppEnvironments || (AppEnvironments = {}));

// eslint-disable-next-line import/no-mutable-exports -- Technically should be a getter?
var msBackend;
var setupApi = function (appEnvironment) {
    var apiConfig = new MsApiConfig(appEnvironment);
    // apiConfig.enableCache(); // TODO: NOTE: if circuits are created in-between McCabe creation this will fail.
    msBackend = create(apiConfig);
};

/* eslint-disable @typescript-eslint/no-unsafe-member-access -- t*/
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- t*/
var BaseModel = /** @class */ (function () {
    function BaseModel() {
        this.keyListeners = {};
        // eslint-disable-next-line @typescript-eslint/no-this-alias -- t
        var that = this;
        var proxy = new Proxy(this, {
            set: function (object, key, value) {
                var newValue = value;
                if (newValue instanceof Array) {
                    newValue = new Proxy(value, {
                        set: function (arr, arrKey, arrValue) {
                            arr[arrKey] = arrValue;
                            that.onModelUpdate(key, value, arrKey);
                            return true;
                        },
                    });
                }
                // @ts-expect-error -- t
                object[key] = newValue;
                that.onModelUpdate(key, value);
                return true;
            },
        });
        // eslint-disable-next-line no-constructor-return -- t
        return proxy;
    }
    BaseModel.prototype.addListener = function (cb, cbId) {
        this.keyListeners[cbId] = cb;
    };
    BaseModel.prototype.removeListener = function (cb, cbId) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- t
        delete this.keyListeners[cbId];
    };
    // private readonly onModelUpdate = throttle(this.__onModelUpdate.bind(this), 1);
    BaseModel.prototype.onModelUpdate = function (key, value, nestedKey) {
        if (nestedKey === void 0) { nestedKey = undefined; }
        // @ts-expect-error -- t
        var fullKey = key;
        if (nestedKey) {
            // @ts-expect-error -- t
            fullKey = "".concat(key, ".").concat(nestedKey);
        }
        Object.values(this.keyListeners).forEach(function (cb) {
            cb(fullKey, value);
        });
    };
    return BaseModel;
}());

var BaseRepository = /** @class */ (function (_super) {
    __extends$3(BaseRepository, _super);
    function BaseRepository() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseRepository;
}(BaseModel));

// Constants
var IsothermDataPoint = /** @class */ (function () {
    function IsothermDataPoint(json, isothermType) {
        this.id = json.id;
        this.isothermId = json.isothermId;
        this.isothermType = isothermType;
        this.isothermPointType = json.type;
        this.aqueousConcentration = json.aqueousConcentration;
        this.organicConcentration = json.organicConcentration;
        this.x = this.getX();
        this.y = this.getY();
    }
    IsothermDataPoint.prototype.getX = function () {
        if (this.isothermType === IsothermType.EXTRACT) {
            return this.aqueousConcentration;
        }
        else {
            return this.organicConcentration;
        }
    };
    IsothermDataPoint.prototype.getY = function () {
        if (this.isothermType === IsothermType.EXTRACT) {
            return this.organicConcentration;
        }
        else {
            return this.aqueousConcentration;
        }
    };
    return IsothermDataPoint;
}());

// Models
var Isotherm = /** @class */ (function () {
    function Isotherm(json) {
        var _this = this;
        this.id = json.id;
        this.createdAt = json.createdAt;
        this.updatedAt = json.updatedAt;
        this.shareAccess = json.shareAccess;
        this.userId = json.userId;
        this.reagentId = json.reagentId;
        this.oximeId = json.oximeId;
        this.metalId = json.metalId;
        this.name = json.name;
        this.polynomialType = json.polynomialType;
        this.isothermType = json.isothermType;
        this.reagentConcentration = json.reagentConcentration;
        this.oximeRatio = json.oximeRatio;
        this.oximeGpl = json.oximeGpl;
        this.plsCu = json.plsCu;
        this.plsPh = json.plsPh;
        this.isothermStoichiometryFactor = json.isothermStoichiometryFactor;
        this.spentMetal = json.spentMetal;
        this.spentAcid = json.spentAcid;
        this.referenceDataPoints = json.referenceDataPoints.map(function (dataPoint) { return new IsothermDataPoint(dataPoint, _this.isothermType); });
        this.computedDataPoints = json.computedDataPoints.map(function (dataPoint) { return new IsothermDataPoint(dataPoint, _this.isothermType); });
        this.coefficients = json.coefficients;
    }
    Isotherm.prototype.getIsothermPointMinOrMax = function (mathFunc, pointKey) {
        return mathFunc.apply(void 0, this.computedDataPoints
            .concat(this.referenceDataPoints)
            .map(function (point) { return point[pointKey]; }));
    };
    return Isotherm;
}());

var McCabeThieleDataPoint = /** @class */ (function () {
    function McCabeThieleDataPoint(json) {
        this.x = json.x;
        this.y = json.y;
    }
    return McCabeThieleDataPoint;
}());

// Models
var McCabeThielePolygon = /** @class */ (function () {
    function McCabeThielePolygon(json) {
        this.stageId = json.stageId;
        this.stageType = json.stageType;
        this.location = json.location;
        this.dataPoints = json.dataPoints.map(function (dataPointDto) { return new McCabeThieleDataPoint(dataPointDto); });
    }
    McCabeThielePolygon.prototype.getPointMinOrMax = function (mathFunc, pointKey) {
        return mathFunc.apply(void 0, this.dataPoints.map(function (dataPoint) { return dataPoint[pointKey]; }));
    };
    McCabeThielePolygon.prototype.getStage = function (circuit) {
        var stage;
        if (this.stageId) {
            stage = circuit.getStageById(this.stageId);
        }
        else {
            stage = circuit.getStageByDescription(this.stageType, this.location);
        }
        if (!stage) {
            throw new Error('[McCabeThielePolygon] Could not find stage from ID or description');
        }
        return stage;
    };
    return McCabeThielePolygon;
}());

var CircuitNotFoundException = /** @class */ (function (_super) {
    __extends$3(CircuitNotFoundException, _super);
    function CircuitNotFoundException(message) {
        return _super.call(this, 'models.circuit.notFound', message) || this;
    }
    return CircuitNotFoundException;
}(MinChemException));

var McCabeThieleCascade = /** @class */ (function () {
    function McCabeThieleCascade(json, circuits) {
        var _this = this;
        this.circuitId = json.circuitId;
        this.circuitName = json.circuitName;
        this.datasetId = json.datasetId;
        this.datasetName = json.datasetName;
        this.type = json.type;
        this.isotherm = new Isotherm(json.isotherm);
        this.stagePolygons = json.stagePolygons.map(function (stagePolygonDto) { return new McCabeThielePolygon(stagePolygonDto); });
        var potentialCircuit = circuits.find(function (circuit) { return circuit.id === _this.circuitId; });
        if (!potentialCircuit) {
            throw new CircuitNotFoundException("Circuit with id: ".concat(this.circuitId, " not found in McCabe Thiele"));
        }
        this.circuit = potentialCircuit;
    }
    /**
     * Returns location number of the first stage within a cascade, falls back to 0
     */
    McCabeThieleCascade.prototype.getCascadeFirstStageLocation = function () {
        return this.getCascadeFirstStage().location;
    };
    /**
     * Gets the legend item key for a cascade
     */
    McCabeThieleCascade.prototype.getCascadeLegendKey = function () {
        var firstStageId = this.getCascadeFirstStage().stageId;
        return "".concat(this.circuitId, "-").concat(this.datasetId, "-").concat(this.type, "-").concat(firstStageId);
    };
    McCabeThieleCascade.prototype.getStagePolygonsPointMinOrMax = function (mathFunc, pointKey) {
        return mathFunc.apply(void 0, this.stagePolygons.map(function (stagePolygon) {
            return stagePolygon.getPointMinOrMax(mathFunc, pointKey);
        }));
    };
    McCabeThieleCascade.prototype.getMimicCascade = function () {
        var _this = this;
        var stages = this.stagePolygons.map(function (polygon) { return polygon.getStage(_this.circuit); });
        return new MimicCascade(this.circuit, stages, stages[0].location);
    };
    McCabeThieleCascade.prototype.getCascadeMinOrMax = function (mathFunc, domainOrRange) {
        // shouldn't this const be minOrMaxPolygon ?
        var minPolygon = this.getStagePolygonsPointMinOrMax(mathFunc, this.getStagePolygonsPointKey(domainOrRange));
        // shouldn't this const be minOrMaxIsotherm ?
        var minIsotherm = this.isotherm.getIsothermPointMinOrMax(mathFunc, this.getIsothermDataPointKey(domainOrRange));
        return mathFunc(minPolygon, minIsotherm);
    };
    McCabeThieleCascade.prototype.getPrimaryConcentration = function (domainOrRange) {
        return domainOrRange === 'DOMAIN' ? 'aqueousConcentration' : 'organicConcentration';
    };
    McCabeThieleCascade.prototype.getSecondaryConcentration = function (domainOrRange) {
        return domainOrRange === 'DOMAIN' ? 'organicConcentration' : 'aqueousConcentration';
    };
    McCabeThieleCascade.prototype.getIsothermDataPointKey = function (domainOrRange) {
        var primaryConcentration = this.getPrimaryConcentration(domainOrRange);
        var secondaryConcentration = this.getSecondaryConcentration(domainOrRange);
        return this.type === IsothermType.EXTRACT ? primaryConcentration : secondaryConcentration;
    };
    McCabeThieleCascade.prototype.getStagePolygonsPointKey = function (domainOrRange) {
        return domainOrRange === 'DOMAIN' ? 'x' : 'y';
    };
    McCabeThieleCascade.prototype.getCascadeFirstStage = function () {
        return this.stagePolygons[0];
    };
    return McCabeThieleCascade;
}());

var McCabeThiele = /** @class */ (function () {
    // TODO: Remove circuits from here.
    function McCabeThiele(json, circuits) {
        this.cascades = json.cascades.map(function (cascadeDto) { return new McCabeThieleCascade(cascadeDto, circuits); });
    }
    McCabeThiele.prototype.getCascadesDomain = function (cascades) {
        var minX = 0;
        var maxX = 0;
        minX = Math.min.apply(Math, cascades.map(function (cascade) {
            return cascade.getCascadeMinOrMax(Math.min, 'DOMAIN');
        }));
        maxX = Math.max.apply(Math, cascades.map(function (cascade) {
            return cascade.getCascadeMinOrMax(Math.max, 'DOMAIN');
        }));
        return [minX, maxX];
    };
    McCabeThiele.prototype.getCascadesRange = function (cascades) {
        var minY = 0;
        var maxY = 0;
        minY = Math.min.apply(Math, cascades.map(function (cascade) {
            return cascade.getCascadeMinOrMax(Math.min, 'RANGE');
        }));
        maxY = Math.max.apply(Math, cascades.map(function (cascade) {
            return cascade.getCascadeMinOrMax(Math.max, 'RANGE');
        }));
        return [minY, maxY];
    };
    return McCabeThiele;
}());

var CircuitRepository = /** @class */ (function (_super) {
    __extends$3(CircuitRepository, _super);
    function CircuitRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isFetching = false;
        _this.fetchError = null;
        _this.circuits = [];
        return _this;
    }
    CircuitRepository.prototype.addAllCircuits = function (circuits) {
        var _this = this;
        this.circuits = circuits.map(function (circuit) {
            var found = _this.circuits.find(function (localCircuit) { return localCircuit.id === circuit.id; });
            if (found) {
                return found;
            }
            return new MimicCircuit(circuit);
        });
    };
    CircuitRepository.prototype.addMimicCircuit = function (circuit, replaceExisting) {
        if (replaceExisting === void 0) { replaceExisting = false; }
        var idx = this.circuits.findIndex(function (existingCircuit) { return existingCircuit.id === circuit.id; });
        if (idx === -1) {
            this.circuits.push(circuit);
        }
        else if (replaceExisting) {
            // If it exists already and we want to replace it
            this.circuits[idx] = circuit;
        }
    };
    CircuitRepository.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isFetching) {
                            return [2 /*return*/];
                        }
                        this.isFetching = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, msBackend.get(CircuitRepository.CIRCUIT_LIST_URL)];
                    case 2:
                        response = _a.sent();
                        this.addAllCircuits(response.data);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.fetchError = toSolvayException(err_1);
                        ToastObservable.showErrorToast(this.fetchError.errorCode);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isFetching = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CircuitRepository.CIRCUIT_LIST_URL = 'circuits';
    return CircuitRepository;
}(BaseRepository));
var circuitRepository = new CircuitRepository();

var FEEDBACK_CODES = {
    error: {
        computeMcCabeThieleFailed: 'feedback.error.computeMcCabeThieleFailed',
    },
    success: {
        computeMcCabeThiele: 'feedback.success.computeMcCabeThiele',
    },
};
var McCabeThieleRepository = /** @class */ (function (_super) {
    __extends$3(McCabeThieleRepository, _super);
    function McCabeThieleRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComputing = false;
        _this.computeError = null;
        _this.mcCabeThiele = null;
        return _this;
    }
    McCabeThieleRepository.prototype.computeMcCabeThiele = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isComputing = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, msBackend.post(McCabeThieleRepository.COMPUTE_MCCABE_THIELE_URL, data)];
                    case 2:
                        response = _a.sent();
                        this.mcCabeThiele = new McCabeThiele(response.data, circuitRepository.circuits);
                        ToastObservable.showSuccessToast(FEEDBACK_CODES.success.computeMcCabeThiele);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.computeError = toSolvayException(err_1);
                        ToastObservable.showErrorToast(FEEDBACK_CODES.error.computeMcCabeThieleFailed);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isComputing = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    McCabeThieleRepository.prototype.removeMcCabeThiele = function () {
        this.mcCabeThiele = null;
    };
    McCabeThieleRepository.COMPUTE_MCCABE_THIELE_URL = 'datasets/sensitivity/mccabe';
    return McCabeThieleRepository;
}(BaseRepository));
var mcCabeThieleRepository = new McCabeThieleRepository();

// Mimic Engine
// Types
var MAX_MENU_HEIGHT = 140;
var CHECKBOX_TYPES;
(function (CHECKBOX_TYPES) {
    CHECKBOX_TYPES["CURRENT"] = "CURRENT";
    CHECKBOX_TYPES["COMPARE"] = "COMPARE";
})(CHECKBOX_TYPES || (CHECKBOX_TYPES = {}));
var MAX_SELECTED_CASCADE_COUNT = 5;
var McCabeThieleSidebarSection = function (_a) {
    var circuit = _a.circuit, datasetId = _a.datasetId, isDisabled = _a.isDisabled, isGenerated = _a.isGenerated, onHandleGenerateDiagramClicked = _a.onHandleGenerateDiagramClicked;
    var intl = useIntl();
    var _b = useState([]), selectedCurrentCheckboxes = _b[0], setSelectedCurrentCheckboxes = _b[1];
    var _c = useState([]), selectedCompareCheckboxes = _c[0], setSelectedCompareCheckboxes = _c[1];
    var _d = useState(null), compareCircuit = _d[0], setCompareCircuit = _d[1];
    var _e = useState(null), compareDataset = _e[0], setCompareDataset = _e[1];
    var _f = useState(false), isModified = _f[0], setIsModified = _f[1];
    useRepositoryUpdates(mcCabeThieleRepository, 'sidebar');
    useRepositoryUpdates(circuitRepository, 'sidebar');
    var isComputing = mcCabeThieleRepository.isComputing;
    var circuits = circuitRepository.circuits;
    var isLoadingCircuits = circuitRepository.isFetching;
    // On Mount Hook, fetch circuits on mount.
    useEffect(function () {
        // eslint-disable-next-line no-void -- yes
        void circuitRepository.fetchAll();
    }, []);
    var resetStates = function () {
        setSelectedCurrentCheckboxes([]);
        setSelectedCompareCheckboxes([]);
        setCompareCircuit(null);
        setCompareDataset(null);
        setIsModified(false);
    };
    useEffect(function () {
        // If the current dataset has changed reset our state.
        resetStates();
    }, [datasetId]);
    /**
     * Convert the circuit to a drop down select object
     */
    var itemToReactSelectObject = function (itemCircuit) {
        return ({
            value: itemCircuit.id,
            label: itemCircuit.name,
        });
    };
    /**
     * The dropdown select option for unselecting a circuit.
     */
    var getCircuitUnselectOption = function () {
        return ({
            value: -1,
            label: intl.formatMessage({
                id: 'common.none',
            }),
        });
    };
    /**
     * Get the drop down options for selecting a circuit
     */
    var getCircuitOptions = function () {
        if (circuits.length === 0)
            return [];
        return __spreadArray$2([getCircuitUnselectOption()], circuits.map(itemToReactSelectObject), true);
    };
    /**
     * Get the available datasets from the selected circuit in the Circuit Dropdown.
     */
    var getDatasetOptions = function () {
        if (!compareCircuit) {
            return [];
        }
        return compareCircuit.datasets
            .filter(function (dataset) { return dataset.id !== null; })
            .map(function (dataset) {
                return ({
                    value: dataset.id !== null ? String(dataset.id) : '',
                    label: dataset.name,
                    // disable dataset if it is the current dataset
                    disabled: datasetId === dataset.id,
                });
            });
    };
    /**
     * Get the available isotherms for the given dataset (either current dataset or the compare dataset)
     */
    var getCascadeOptions = function (type) {
        if (type === CHECKBOX_TYPES.CURRENT) {
            return circuit.getCascades();
        }
        else {
            if (!compareDataset || !compareCircuit)
                return null;
            return compareCircuit.getCascades();
        }
    };
    /**
     * Do we have any cascades/isotherms selected for the current dataset?
     */
    var hasCurrentCascades = function () { return selectedCurrentCheckboxes.length > 0; };
    /**
     * Get whether we've reached the max amount of isotherms of the given type.
     */
    // const isBelowOrMaxCascadeSelected = (type: StageTypeConstant): boolean =>
    var isBelowOrMaxCascadeSelected = function (type) {
        return selectedCurrentCheckboxes
            .concat(selectedCompareCheckboxes)
            .filter(function (cascade) { return cascade.type === type; }).length <=
            MAX_SELECTED_CASCADE_COUNT;
    };
    /**
     * Get whether the given isotherm is selected in either the current dataset or the compare dataset.
     */
    var isCascadeSelected = function (type, cascade) {
        return Boolean((type === CHECKBOX_TYPES.CURRENT
            ? selectedCurrentCheckboxes
            : selectedCompareCheckboxes).find(function (stateCascade) {
                return stateCascade.type === cascade.type &&
                    stateCascade.location === cascade.location;
            }));
    };
    /**
     * If we don't have a selected compare dataset, return true.
     * Otherwise, check if we have 1 or more selected compare dataset.
     */
    var isCompareDatasetCascadeOK = function () {
        return !compareCircuit || (compareDataset && selectedCompareCheckboxes.length > 0);
    };
    /**
     * Is the generate diagram button selected?
     */
    var isGenerateButtonEnabled = function () {
        return hasCurrentCascades() &&
            isBelowOrMaxCascadeSelected(StageTypes.EXTRACT) &&
            isBelowOrMaxCascadeSelected(StageTypes.STRIP) &&
            isCompareDatasetCascadeOK() &&
            isModified;
    };
    /**
     * Change the value of the dropdown circuit
     */
    var handleCircuitSelected = function (selectedOption) {
        var newCompareCircuit = null; // null means unselected circuit.
        if (selectedOption && selectedOption.value !== getCircuitUnselectOption().value) {
            var matchingCircuit = circuits.find(function (matchCircuit) { return matchCircuit.id === selectedOption.value; });
            if (matchingCircuit) {
                newCompareCircuit = matchingCircuit;
            }
        }
        setCompareCircuit(newCompareCircuit);
        // As soon as the compareCircuit changes,
        // reset the selected dataset
        setCompareDataset(null);
        // and unselect all of the selected checkboxes
        setSelectedCompareCheckboxes([]);
        setIsModified(true); // If a user selects no circuit
    };
    /**
     * When a dataset is selected in the radio button group
     */
    var handleDatasetSelected = function (selectedOptionValue) {
        var _a;
        if (!compareDataset || ((_a = compareDataset.id) === null || _a === void 0 ? void 0 : _a.toString()) !== selectedOptionValue) {
            // Only change our compareDataset, if it is different than the one currently selected.
            // This prevents compare checkboxes from being cleared when we click on the same dataset option.
            if (!compareCircuit) {
                return;
            }
            var matchingDataset = compareCircuit.datasets.find(function (dataset) { return String(dataset.id) === selectedOptionValue; });
            setCompareDataset(matchingDataset !== null && matchingDataset !== void 0 ? matchingDataset : null);
            // Reset the selected compare cascades when we change the dataset.
            setSelectedCompareCheckboxes([]);
        }
    };
    /**
     * Handles a checkbox being clicked.
     * Call the appropriate handler depending on the type of checkboxes (current, or a compare dataset)
     */
    var handleCheckboxClicked = function (type, cascade) {
        return function (event) {
            var isChecked = event.target.checked;
            var checkboxes = type === CHECKBOX_TYPES.CURRENT
                ? selectedCurrentCheckboxes
                : selectedCompareCheckboxes;
            var _setCheckboxesState = function (newState) {
                if (type === CHECKBOX_TYPES.CURRENT) {
                    setSelectedCurrentCheckboxes(newState);
                }
                else {
                    setSelectedCompareCheckboxes(newState);
                }
            };
            if (!isChecked) {
                // unselect cascade by removing it from state.
                _setCheckboxesState(checkboxes.filter(
                    // filter all cascades that matches the checkbox cascade id.
                    function (stateCascade) {
                        return !(stateCascade.location === cascade.location &&
                            stateCascade.type === cascade.type);
                    }));
            }
            else {
                // cascade was checked, while it is currently unchecked.
                _setCheckboxesState(checkboxes.concat(cascade)); // add the cascade to our selected list.
            }
            setIsModified(true);
        };
    };
    /**
     * When the generate diagram button is clicked, call our parent with the required info.
     */
    var handleGenerateDiagramClicked = function () {
        setIsModified(false);
        onHandleGenerateDiagramClicked(selectedCurrentCheckboxes, compareDataset, compareDataset ? selectedCompareCheckboxes : []);
    };
    /**
     * Render the isotherm checkboxes from a list of isotherm checkboxes.
     */
    var renderCascadeCheckboxes = function (type) {
        var cascades = getCascadeOptions(type);
        if (!cascades || cascades.length === 0) {
            return (React__default.createElement(NoCascadeMessage, null, intl.formatMessage({
                id: 'components.CircuitComputationSidebar.McCabeThiele.noIsothermSaved',
            })));
        }
        return (React__default.createElement(CheckBoxWrapper, null, cascades.map(function (cascade) {
            var stages = cascade.stages;
            if (stages.length === 0) {
                return null;
            }
            var description = React__default.createElement(CascadeDescription, { cascade: cascade, asString: true });
            var key = "".concat(type, "-").concat(cascade.type, "-").concat(cascade.location);
            var isSelected = isCascadeSelected(type, cascade);
            var isCascadeDisabled = isComputing ||
                (!isSelected && !isBelowOrMaxCascadeSelected(cascade.type));
            return (React__default.createElement(In, { key: key, name: key, checked: isSelected, disabled: isCascadeDisabled, label: description, onClickHandler: handleCheckboxClicked(type, cascade), styles: CheckboxAndRadioStyles }));
        })));
    };
    var renderDatasetSuffix = function (_, isActive) {
        if (!isActive) {
            return null;
        }
        return (React__default.createElement(RadioButtonSuffix, null, renderCascadeCheckboxes(CHECKBOX_TYPES.COMPARE)));
    };
    if (isDisabled) {
        return (React__default.createElement(ErrorLabel, null, intl.formatMessage({
            id: 'components.CircuitComputationSidebar.McCabeThiele.uncomputedDataset',
        })));
    }
    return (React__default.createElement(SidebarBody, null,
        React__default.createElement(BodySection, null,
            React__default.createElement(SectionTitle, null, intl.formatMessage({
                id: 'components.CircuitComputationSidebar.McCabeThiele.CurrentDataset.title',
            })),
            renderCascadeCheckboxes(CHECKBOX_TYPES.CURRENT)),
        React__default.createElement(BodySection, null,
            React__default.createElement(SectionTitle, { withSubtitle: true },
                intl.formatMessage({
                    id: 'components.CircuitComputationSidebar.McCabeThiele.CompareWithOtherIsotherms.title',
                }),
                React__default.createElement(SectionTitleOptional, null, intl.formatMessage({
                    id: 'components.CircuitComputationSidebar.McCabeThiele.CompareWithOtherIsotherms.titleOptional',
                }))),
            React__default.createElement(SectionSubtitle, null, intl.formatMessage({
                id: 'components.CircuitComputationSidebar.McCabeThiele.CompareWithOtherIsotherms.CircuitSelect.label',
            })),
            React__default.createElement(Ws, {
                selectedOption: compareCircuit ? itemToReactSelectObject(compareCircuit) : undefined, options: getCircuitOptions(), onChange: handleCircuitSelected, isLoading: isLoadingCircuits, isDisabled: isLoadingCircuits || isComputing,
                // onScrollToBottom={onHandleRequestMoreCircuits}
                noOptionsMessage: function () {
                    return intl.formatMessage({
                        id: 'components.CircuitComputationSidebar.McCabeThiele.CompareWithOtherIsotherms.CircuitSelect.noCircuits',
                    });
                }, placeholder: intl.formatMessage({
                    id: 'components.CircuitComputationSidebar.McCabeThiele.CompareWithOtherIsotherms.CircuitSelect.placeholder',
                }), maxMenuHeight: MAX_MENU_HEIGHT, controlShouldRenderValue: true
            }),
            compareCircuit && (React__default.createElement(RadioButtonWrapper, null,
                React__default.createElement(SectionSubtitle, null, intl.formatMessage({
                    id: 'components.CircuitComputationSidebar.McCabeThiele.CompareWithOtherIsotherms.DatasetRadioGroup.label',
                })),
                React__default.createElement(Ff, {
                    value: (compareDataset === null || compareDataset === void 0 ? void 0 : compareDataset.id) ? String(compareDataset.id) : undefined, options: getDatasetOptions(), onClick: handleDatasetSelected, renderSuffix: renderDatasetSuffix, noOptionsBody: React__default.createElement(NoCascadeMessage, null, intl.formatMessage({
                        id: 'components.CircuitComputationSidebar.McCabeThiele.CompareWithOtherIsotherms.DatasetRadioGroup.noDatasets',
                    })), disabled: isComputing, styles: CheckboxAndRadioStyles, wrapperOverflow: "hidden"
                })))),
        React__default.createElement(FooterSection, null,
            React__default.createElement(je, {
                text: intl.formatMessage({
                    id: "components.CircuitComputationSidebar.McCabeThiele.".concat(isGenerated ? 'updateDiagramButton' : 'generateDiagramButton'),
                }), loading: isComputing, disabled: !isGenerateButtonEnabled() || isComputing, onClick: handleGenerateDiagramClicked
            }))));
};

var Wrapper = o$1.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    margin-top: 29px;\n    margin-left: 40px;\n"], ["\n    display: flex;\n    flex-direction: column;\n\n    margin-top: 29px;\n    margin-left: 40px;\n"])));
var Message = o$1.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 17px;\n    line-height: 20px;\n    margin: 0;\n"], ["\n    color: ", ";\n    font-size: 17px;\n    line-height: 20px;\n    margin: 0;\n"])), Ee.defaultSubtleColor7B);
var templateObject_1, templateObject_2;

var ComputationInstructions = function (_a) {
    var messageId = _a.messageId;
    var intl = useIntl();
    return (React__default.createElement(Wrapper, null,
        React__default.createElement(Message, null, intl.formatMessage({
            id: "components.ComputationInstructions.".concat(messageId),
        }))));
};

var DatasetMustBeProvidedException = /** @class */ (function (_super) {
    __extends$3(DatasetMustBeProvidedException, _super);
    function DatasetMustBeProvidedException(message) {
        return _super.call(this, 'models.dataset.notProvided', message) || this;
    }
    return DatasetMustBeProvidedException;
}(MinChemException));

var McCabeThieleContainer = function (_a) {
    var circuitId = _a.circuitId, circuit = _a.circuit, datasetId = _a.datasetId, computedDataset = _a.computedDataset, sidebarDOMElement = _a.sidebarDOMElement, locale = _a.locale;
    var diagramRef = useRef(null);
    var _b = useState(false), isDiagramGenerated = _b[0], setDiagramIsGenerated = _b[1];
    var _c = useState(datasetId), previousDatasetId = _c[0], setPreviousDatasetId = _c[1];
    useRepositoryUpdates(mcCabeThieleRepository, 'container');
    var mcCabeThiele = mcCabeThieleRepository.mcCabeThiele;
    var isComputingMcCabeThiele = mcCabeThieleRepository.isComputing;
    // On Mount Hook
    useEffect(function () {
        circuitRepository.addMimicCircuit(circuit);
        // On unmount, remove McCabeThiele
        return function () { return mcCabeThieleRepository.removeMcCabeThiele(); };
    }, [circuit]);
    // When McCabe Thiele is generated from backend, show the diagram on success only
    useEffect(function () {
        setDiagramIsGenerated(Boolean(mcCabeThiele));
    }, [mcCabeThiele]);
    // When the dataset id is changed, remove the diagrams.
    useEffect(function () {
        if (previousDatasetId !== datasetId) {
            setPreviousDatasetId(datasetId);
            setDiagramIsGenerated(false);
            mcCabeThieleRepository.removeMcCabeThiele();
        }
    }, [datasetId, previousDatasetId]);
    var handleGenerateDiagramClicked = function (selectedCascades, compareDataset, compareCascades) {
        if (compareDataset === void 0) { compareDataset = null; }
        if (compareCascades === void 0) { compareCascades = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var cascades, mcCabeThieleArgs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cascades = selectedCascades.map(function (cascade) { var _a; return (_a = cascade.stages[0].id) !== null && _a !== void 0 ? _a : 0; });
                        if (computedDataset) {
                            // it should always use the computedDataset if it's available - data could have been changed in the mimic diagram without saving it.
                            mcCabeThieleArgs = {
                                cascades: cascades,
                                computedDataset: computedDataset,
                            };
                        }
                        else if (datasetId) {
                            mcCabeThieleArgs = {
                                cascades: cascades,
                                datasetId: datasetId,
                            };
                        }
                        else {
                            throw new DatasetMustBeProvidedException('DatasetId or computedDataset must be provided to McCabe Thiele generate diagram.');
                        }
                        if (compareDataset && compareCascades) {
                            if (!compareDataset.id) {
                                throw new DatasetMustBeProvidedException('Dataset used as compare must have an ID.');
                            }
                            mcCabeThieleArgs = __assign$1(__assign$1({}, mcCabeThieleArgs), {
                                compareDatasetId: compareDataset.id,
                                // TODO: ID Cannot be null in this part of the application. inappropriate types elsewhere.
                                compareCascades: compareCascades.map(function (cascade) { var _a; return (_a = cascade.stages[0].id) !== null && _a !== void 0 ? _a : 0; })
                            });
                        }
                        return [4 /*yield*/, mcCabeThieleRepository.computeMcCabeThiele(mcCabeThieleArgs)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    var renderSidebar = function () {
        return w$1.createPortal(React__default.createElement(McCabeThieleSidebarSection, {
            circuit: circuit, datasetId: datasetId, isDisabled: !datasetId && !computedDataset,
            // onHandleRequestMoreCircuits={this.handleRequestMoreCircuits}
            onHandleGenerateDiagramClicked: handleGenerateDiagramClicked, isGenerated: isDiagramGenerated && !isComputingMcCabeThiele
        }), sidebarDOMElement);
    };
    var renderContent = function () {
        if (!datasetId && !computedDataset) {
            return React__default.createElement(ComputationInstructions, { messageId: "McCabeThiele.blankDatasetUncomputed" });
        }
        // Did the user ask the diagram to be generated?
        if (!isDiagramGenerated) {
            return React__default.createElement(ComputationInstructions, { messageId: "McCabeThiele.selectCascades" });
        }
        if (!mcCabeThiele) {
            // Diagram has not yet been generated
            return null;
        }
        return (React__default.createElement(xe, null,
            React__default.createElement(we, null,
                React__default.createElement(McCabeThieleDiagram, { diagramRef: diagramRef, circuitId: circuitId, datasetId: datasetId, isLoading: isComputingMcCabeThiele, mcCabeThiele: mcCabeThiele })),
            React__default.createElement(Ce, null,
                React__default.createElement(McCabeThieleFooter, { copyToClipboardDisabled: !isDiagramGenerated, diagramRef: diagramRef }))));
    };
    return (React__default.createElement(LanguageProvider, { locale: locale },
        renderSidebar(),
        renderContent()));
};

export { McCabeThieleContainer, setupApi };
export {
    MimicCircuit,
    SkipStream,
};
//# sourceMappingURL=index.js.map
